/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
  '/api/files/{bucket}/{file}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Stream Local File */
    get: operations['stream_local_file_api_files__bucket___file__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/users': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Users List */
    get: operations['users_list_api_admin_users_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/users/{user_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** User Details */
    get: operations['user_details_api_admin_users__user_id__get'];
    /** User Update Handler */
    put: operations['user_update_handler_api_admin_users__user_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/users/{user_id}/impersonate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** User Impersonate Handler */
    post: operations['user_impersonate_handler_api_admin_users__user_id__impersonate_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/connections/{connection_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Connection Handler */
    get: operations['get_connection_handler_api_admin_connections__connection_id__get'];
    /** Update Connection Handler */
    put: operations['update_connection_handler_api_admin_connections__connection_id__put'];
    post?: never;
    /** Delete Connection Handler */
    delete: operations['delete_connection_handler_api_admin_connections__connection_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/connections': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Connections List */
    get: operations['connections_list_api_admin_connections_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/integrations': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Integrations Handler */
    get: operations['list_integrations_handler_api_admin_integrations_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/tags': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Tags Handler */
    get: operations['list_tags_handler_api_admin_tags_get'];
    put?: never;
    /** Create Tag Handler */
    post: operations['create_tag_handler_api_admin_tags_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/tags/{tag_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /** Delete Tag Handler */
    delete: operations['delete_tag_handler_api_admin_tags__tag_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/tags_by_name': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Tags By Name Handler */
    get: operations['list_tags_by_name_handler_api_admin_tags_by_name_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/commands': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Command Executions */
    get: operations['command_executions_api_admin_commands_get'];
    put?: never;
    /**
     * Command Exec
     * @description Run the command
     */
    post: operations['command_exec_api_admin_commands_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/commands/all': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Command List
     * @description List all admin commands
     */
    get: operations['command_list_api_admin_commands_all_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/commands/{command_run_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Command Show
     * @description Command detail
     */
    get: operations['command_show_api_admin_commands__command_run_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/legal_entity_refs': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Legal Entity Refs Handler
     * @description List all legal entity refs (only id and name).
     */
    get: operations['list_legal_entity_refs_handler_api_admin_legal_entity_refs_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/legal_entities': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Legal Entities Handler
     * @description List all legal entities.
     */
    get: operations['list_legal_entities_handler_api_admin_legal_entities_get'];
    put?: never;
    /**
     * Create Legal Entity Handler
     * @description Create a legal entity. If the request does not include an Account
     *     ID to associate the legal entity to, a new Account will be
     *     created and the legal entity will be linked to it.
     */
    post: operations['create_legal_entity_handler_api_admin_legal_entities_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/legal_entities/{legal_entity_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Legal Entity Handler
     * @description Get a legal entity.
     */
    get: operations['get_legal_entity_handler_api_admin_legal_entities__legal_entity_id__get'];
    /**
     * Update Legal Entity Handler
     * @description Update a legal entity
     */
    put: operations['update_legal_entity_handler_api_admin_legal_entities__legal_entity_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/legal_entities/{legal_entity_id}/business_information': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Get Legal Entity Business Information Handler */
    post: operations['get_legal_entity_business_information_handler_api_admin_legal_entities__legal_entity_id__business_information_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/legal_entities/{legal_entity_id}/integration_emails': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Legal Entity Integration Emails */
    get: operations['get_legal_entity_integration_emails_api_admin_legal_entities__legal_entity_id__integration_emails_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/legal_entities/{legal_entity_id}/generate_integrations_email': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Legal Entity Integrations Email Handler */
    get: operations['get_legal_entity_integrations_email_handler_api_admin_legal_entities__legal_entity_id__generate_integrations_email_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/legal_entities/{legal_entity_id}/customer_success_user': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Legal Entity Customer Success User */
    get: operations['get_legal_entity_customer_success_user_api_admin_legal_entities__legal_entity_id__customer_success_user_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/legal_entity_requirements': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Legal Entity Requirement List */
    get: operations['legal_entity_requirement_list_api_admin_legal_entity_requirements_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/legal_entity_requirements/{task_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Legal Entity Requirement Show */
    get: operations['legal_entity_requirement_show_api_admin_legal_entity_requirements__task_id__get'];
    /** Legal Entity Requirement Update */
    put: operations['legal_entity_requirement_update_api_admin_legal_entity_requirements__task_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/legal_entity_regions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Legal Entity Regions List
     * @description Get all list of all legal entity regions.
     */
    get: operations['legal_entity_regions_list_api_admin_legal_entity_regions_get'];
    put?: never;
    /**
     * Legal Entity Requirement Create
     * @description Create a legal entity requirement.
     */
    post: operations['legal_entity_requirement_create_api_admin_legal_entity_regions_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/legal_entity_regions/{legal_entity_region_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Legal Entity Regions Show
     * @description Show a specific legal entity region.
     */
    get: operations['legal_entity_regions_show_api_admin_legal_entity_regions__legal_entity_region_id__get'];
    /**
     * Legal Entity Requirement Update
     * @description Update a legal entity requirement.
     */
    put: operations['legal_entity_requirement_update_api_admin_legal_entity_regions__legal_entity_region_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/record_types/{unique_field}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Record Type */
    get: operations['get_record_type_api_admin_record_types__unique_field__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/legal_entity_addresses': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Legal Entity Addresses
     * @description Get all legal entity addresses.
     */
    get: operations['legal_entity_addresses_api_admin_legal_entity_addresses_get'];
    put?: never;
    /**
     * Create Legal Entity Address Handler
     * @description Create a legal entity address.
     */
    post: operations['create_legal_entity_address_handler_api_admin_legal_entity_addresses_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/legal_entity_addresses/{legal_entity_address_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Legal Entity Address Show
     * @description Get legal entity address by id.
     */
    get: operations['legal_entity_address_show_api_admin_legal_entity_addresses__legal_entity_address_id__get'];
    /**
     * Legal Entity Address Update
     * @description Update a legal entity address
     */
    put: operations['legal_entity_address_update_api_admin_legal_entity_addresses__legal_entity_address_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/legal_entity_persons': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Legal Entity Persons
     * @description Get all legal entity persons.
     */
    get: operations['legal_entity_persons_api_admin_legal_entity_persons_get'];
    put?: never;
    /**
     * Create Legal Entity Person Handler
     * @description Create a legal entity person.
     */
    post: operations['create_legal_entity_person_handler_api_admin_legal_entity_persons_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/legal_entity_persons/{legal_entity_person_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Legal Entity Person Show
     * @description Get legal entity person by id.
     */
    get: operations['legal_entity_person_show_api_admin_legal_entity_persons__legal_entity_person_id__get'];
    /**
     * Legal Entity Person Update
     * @description Update a legal entity person
     */
    put: operations['legal_entity_person_update_api_admin_legal_entity_persons__legal_entity_person_id__put'];
    post?: never;
    /**
     * Legal Entity Person Delete
     * @description Delete a legal entity person
     */
    delete: operations['legal_entity_person_delete_api_admin_legal_entity_persons__legal_entity_person_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/legal_entity_persons/{legal_entity_person_id}/reference_check': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Legal Entity Person Reference Check
     * @description Returns fields that need to be updated before the
     *     legal entity person can be deleted
     */
    get: operations['legal_entity_person_reference_check_api_admin_legal_entity_persons__legal_entity_person_id__reference_check_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/legal_entity_users': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Legal Entity Users */
    get: operations['list_legal_entity_users_api_admin_legal_entity_users_get'];
    put?: never;
    /** Post Legal Entity Users */
    post: operations['post_legal_entity_users_api_admin_legal_entity_users_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/legal_entity_users/{legal_entity_user_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Legal Entity User */
    get: operations['get_legal_entity_user_api_admin_legal_entity_users__legal_entity_user_id__get'];
    /** Put Legal Entity Users */
    put: operations['put_legal_entity_users_api_admin_legal_entity_users__legal_entity_user_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/regions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Regions Handler */
    get: operations['list_regions_handler_api_admin_regions_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/regions/{region_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Region Handler */
    get: operations['get_region_handler_api_admin_regions__region_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/regions/code/{region_code}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Region By Code Handler */
    get: operations['get_region_by_code_handler_api_admin_regions_code__region_code__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/requirements/refs': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Handle Get Requirement Ref By Filtering */
    get: operations['handle_get_requirement_ref_by_filtering_api_admin_requirements_refs_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/requirements/to-review': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Handle List Requirements To Review */
    get: operations['handle_list_requirements_to_review_api_admin_requirements_to_review_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/requirements': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Handle List Requirements */
    get: operations['handle_list_requirements_api_admin_requirements_get'];
    put?: never;
    /** Requirement Create */
    post: operations['requirement_create_api_admin_requirements_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/requirements/{requirement_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Handle Get Requirement */
    get: operations['handle_get_requirement_api_admin_requirements__requirement_id__get'];
    /** Handle Save Requirement */
    put: operations['handle_save_requirement_api_admin_requirements__requirement_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/requirements/pending/{pending_change_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Handle Get Pending Requirement */
    get: operations['handle_get_pending_requirement_api_admin_requirements_pending__pending_change_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/requirement_summary_templates': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Requirement Summarry Templates */
    get: operations['list_requirement_summarry_templates_api_admin_requirement_summary_templates_get'];
    put?: never;
    /** Create Requirement Summary Template */
    post: operations['create_requirement_summary_template_api_admin_requirement_summary_templates_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/requirement_summary_templates/{summary_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Requirement Summary Template */
    get: operations['get_requirement_summary_template_api_admin_requirement_summary_templates__summary_id__get'];
    put?: never;
    post?: never;
    /** Delete Requirement Summary Template */
    delete: operations['delete_requirement_summary_template_api_admin_requirement_summary_templates__summary_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/form_files': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Forms Handler */
    get: operations['list_forms_handler_api_admin_form_files_get'];
    put?: never;
    /** Create Form Handler */
    post: operations['create_form_handler_api_admin_form_files_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/form_files/{form_spec_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Form Handler */
    get: operations['get_form_handler_api_admin_form_files__form_spec_id__get'];
    /** Update Form Handler */
    put: operations['update_form_handler_api_admin_form_files__form_spec_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/registered_agent_transfers': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Registered Agents Handler */
    get: operations['list_registered_agents_handler_api_admin_registered_agent_transfers_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/registered_agent_transfers/{registered_agent_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Registered Agent Transfer Handler */
    get: operations['get_registered_agent_transfer_handler_api_admin_registered_agent_transfers__registered_agent_id__get'];
    /** Update Registered Agent Handler */
    put: operations['update_registered_agent_handler_api_admin_registered_agent_transfers__registered_agent_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/invites': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Invites Handler
     * @description List all invites.
     */
    get: operations['list_invites_handler_api_admin_invites_get'];
    put?: never;
    /**
     * Create Invite Handler
     * @description Create an invite.
     */
    post: operations['create_invite_handler_api_admin_invites_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/invites/{invite_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Invite Handler
     * @description Get an invite.
     */
    get: operations['get_invite_handler_api_admin_invites__invite_id__get'];
    /**
     * Update Invite Handler
     * @description Update an invite.
     */
    put: operations['update_invite_handler_api_admin_invites__invite_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/invites/verify': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Verify Invite Handler
     * @description Verify an agent invite.
     */
    post: operations['verify_invite_handler_api_admin_invites_verify_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/invites/accept': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Accept Invite Handler
     * @description Accept an agent invite.
     */
    post: operations['accept_invite_handler_api_admin_invites_accept_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/email_captures': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Email Capture Handler
     * @description List all email captures
     */
    get: operations['list_email_capture_handler_api_admin_email_captures_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/email_captures/{email_capture_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Email Capture Handler
     * @description Get an email capture
     */
    get: operations['get_email_capture_handler_api_admin_email_captures__email_capture_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/form_captures': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Form Capture Handler
     * @description List all form captures
     */
    get: operations['list_form_capture_handler_api_admin_form_captures_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/form_captures/{form_capture_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Form Capture Handler
     * @description Get an form capture
     */
    get: operations['get_form_capture_handler_api_admin_form_captures__form_capture_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/form_captures/legal_entity/{legal_entity_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Form Capture By Legal Entity Handler
     * @description Get a form capture from the legal_entity_id
     */
    get: operations['get_form_capture_by_legal_entity_handler_api_admin_form_captures_legal_entity__legal_entity_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/form_captures/workflow_instance/{workflow_instance_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Form Capture By Workflow Instance Handler
     * @description This endpoint is mostly deprecated. It's still used for showing payroll setup and local payroll setup data in the workflow app. We should not add any new dependencies to it. This endpoint filters the response down to just the form capture that led to this workflow.
     */
    get: operations['get_form_capture_by_workflow_instance_handler_api_admin_form_captures_workflow_instance__workflow_instance_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/guests': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Guests Handler */
    get: operations['list_guests_handler_api_admin_guests_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/guests/{guest_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Guest Handler */
    get: operations['get_guest_handler_api_admin_guests__guest_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/guest_documents/{document_id}/download': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Guest Document Stream Download Handler */
    get: operations['get_guest_document_stream_download_handler_api_admin_guest_documents__document_id__download_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/guest_documents': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Guest Documents Handler */
    get: operations['list_guest_documents_handler_api_admin_guest_documents_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/guest_documents/{document_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Guest Handler */
    get: operations['get_guest_handler_api_admin_guest_documents__document_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/agencies/to-review': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Agencies Handler To Review */
    get: operations['list_agencies_handler_to_review_api_admin_agencies_to_review_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/agencies': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Agencies Handler */
    get: operations['list_agencies_handler_api_admin_agencies_get'];
    put?: never;
    /** Create Agency Handler */
    post: operations['create_agency_handler_api_admin_agencies_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/agencies/by_id': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Agencies By Id Handler */
    get: operations['list_agencies_by_id_handler_api_admin_agencies_by_id_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/agencies/{agency_public_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Agency Handler */
    get: operations['get_agency_handler_api_admin_agencies__agency_public_id__get'];
    /** Update Agency Handler */
    put: operations['update_agency_handler_api_admin_agencies__agency_public_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/agency_accounts': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Agency Accounts Handler */
    get: operations['list_agency_accounts_handler_api_admin_agency_accounts_get'];
    put?: never;
    /** Create Agency Account Handler */
    post: operations['create_agency_account_handler_api_admin_agency_accounts_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/agency_accounts/{agency_account_public_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Agency Accounts Handler */
    get: operations['get_agency_accounts_handler_api_admin_agency_accounts__agency_account_public_id__get'];
    /** Update Agency Handler */
    put: operations['update_agency_handler_api_admin_agency_accounts__agency_account_public_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/legal_entities/{legal_entity_id}/logins/{account_login_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Login
     * @description get a Login by the title.
     */
    get: operations['get_login_api_admin_legal_entities__legal_entity_id__logins__account_login_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/legal_entities/{legal_entity_id}/logins': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Create Login */
    post: operations['create_login_api_admin_legal_entities__legal_entity_id__logins_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/attributes': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Attributes */
    get: operations['list_attributes_api_admin_attributes_get'];
    put?: never;
    /** Create Attribute */
    post: operations['create_attribute_api_admin_attributes_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/attributes/to-review': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Attributes To Review */
    get: operations['list_attributes_to_review_api_admin_attributes_to_review_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/attributes/public_id': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Attributes Public Id */
    get: operations['list_attributes_public_id_api_admin_attributes_public_id_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/attributes/{attribute_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Attribute */
    get: operations['get_attribute_api_admin_attributes__attribute_id__get'];
    /** Update Attribute */
    put: operations['update_attribute_api_admin_attributes__attribute_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/datums': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Datums Handler */
    get: operations['list_datums_handler_api_admin_datums_get'];
    put?: never;
    /** Create Datum Handler */
    post: operations['create_datum_handler_api_admin_datums_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/datums/{datum_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Datum Handler */
    get: operations['get_datum_handler_api_admin_datums__datum_id__get'];
    /** Update Datum Handler */
    put: operations['update_datum_handler_api_admin_datums__datum_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/datums/bulk': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Create Bulk Datum Handler */
    post: operations['create_bulk_datum_handler_api_admin_datums_bulk_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/workflows': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Workflows Handler */
    get: operations['list_workflows_handler_api_admin_workflows_get'];
    put?: never;
    /** Create Workflow Handler */
    post: operations['create_workflow_handler_api_admin_workflows_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/workflow_refs': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Workflow Refs Handler */
    get: operations['list_workflow_refs_handler_api_admin_workflow_refs_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/workflows/{workflow_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Workflow Handler */
    get: operations['get_workflow_handler_api_admin_workflows__workflow_id__get'];
    /** Update Workflow Handler */
    put: operations['update_workflow_handler_api_admin_workflows__workflow_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/workflows/{workflow_id}/{step_id}/render_action_template': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Get Workflow Step Rendered Template */
    post: operations['get_workflow_step_rendered_template_api_admin_workflows__workflow_id___step_id__render_action_template_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/workflow/tags': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get All Tags Handler */
    get: operations['get_all_tags_handler_api_admin_workflow_tags_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/workflow/{workflow_id}/template_data_types': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Workflow Template Data Types Handler */
    get: operations['get_workflow_template_data_types_handler_api_admin_workflow__workflow_id__template_data_types_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/workflow/{workflow_id}/legal_entity/{legal_entity_id}/prompt': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Generate Workflow Prompt Handler
     * @description Generate a workflow prompt for a specific workflow and legal entity.
     */
    get: operations['generate_workflow_prompt_handler_api_admin_workflow__workflow_id__legal_entity__legal_entity_id__prompt_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/workflow_step_prompt_override': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Workflow Step Prompt Override
     * @description Create or update a workflow step prompt override.
     */
    post: operations['create_workflow_step_prompt_override_api_admin_workflow_step_prompt_override_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/workflow/{workflow_id}/prompt_overrides': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Workflow Prompt Overrides Handler
     * @description Get prompt overrides for a specific workflow and legal entity.
     */
    get: operations['get_workflow_prompt_overrides_handler_api_admin_workflow__workflow_id__prompt_overrides_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/files/with_url': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Files Handler With Url
     * @description Signing the download_url of a file is expensive, so we only do it if the preview of the file list must be shown,
     *     in which case you can call this endpoint
     */
    get: operations['list_files_handler_with_url_api_admin_files_with_url_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/files': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Files Handler */
    get: operations['list_files_handler_api_admin_files_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/files/{file_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List File Handler */
    get: operations['list_file_handler_api_admin_files__file_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/workflow_instances/legal_entities': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get All Legal Entities */
    get: operations['get_all_legal_entities_api_admin_workflow_instances_legal_entities_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/workflow_instances': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Workflow Instances Flat Handler */
    get: operations['list_workflow_instances_flat_handler_api_admin_workflow_instances_get'];
    put?: never;
    /** Create Workflow Instance Handler */
    post: operations['create_workflow_instance_handler_api_admin_workflow_instances_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/workflow_app/workflow_instances': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Workflow Instances Handler */
    get: operations['list_workflow_instances_handler_api_admin_workflow_app_workflow_instances_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/workflow_app/workflow_instances/metadata': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Workflow Instance Metadata Handler */
    get: operations['list_workflow_instance_metadata_handler_api_admin_workflow_app_workflow_instances_metadata_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/workflow_instances/{workflow_instance_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Workflow Instance Handler */
    get: operations['get_workflow_instance_handler_api_admin_workflow_instances__workflow_instance_id__get'];
    /** Update Workflow Instance Handler */
    put: operations['update_workflow_instance_handler_api_admin_workflow_instances__workflow_instance_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/workflow_instances/{workflow_instance_id}/mail': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Workflow Instance Mail Handler */
    get: operations['get_workflow_instance_mail_handler_api_admin_workflow_instances__workflow_instance_id__mail_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/workflow_instances/{workflow_instance_id}/mail/{mail_public_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Legal Entity Mail By Public Id Handler */
    get: operations['get_legal_entity_mail_by_public_id_handler_api_admin_workflow_instances__workflow_instance_id__mail__mail_public_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/workflow_instances/{workflow_instance_id}/start': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    /** Update Workflow Instance Start Handler */
    put: operations['update_workflow_instance_start_handler_api_admin_workflow_instances__workflow_instance_id__start_put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/workflow_instances/{workflow_instance_id}/block': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    /** Update Workflow Instance Block Handler */
    put: operations['update_workflow_instance_block_handler_api_admin_workflow_instances__workflow_instance_id__block_put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/workflow_instances/{workflow_instance_id}/unblock': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    /** Update Workflow Instance Unblock Handler */
    put: operations['update_workflow_instance_unblock_handler_api_admin_workflow_instances__workflow_instance_id__unblock_put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/workflow_instances/{workflow_instance_id}/assign': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    /** Assign Workflow Instance */
    put: operations['assign_workflow_instance_api_admin_workflow_instances__workflow_instance_id__assign_put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/workflow_instances/{workflow_instance_id}/reminder': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    /** Update Workflow Instance Reminder Handler */
    put: operations['update_workflow_instance_reminder_handler_api_admin_workflow_instances__workflow_instance_id__reminder_put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/workflow_instances/{workflow_instance_id}/next_step': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    /** Update Workflow Instance Next Step Handler */
    put: operations['update_workflow_instance_next_step_handler_api_admin_workflow_instances__workflow_instance_id__next_step_put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/workflow_instances/{workflow_instance_id}/upload_file': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Update Workflow Instance Next Step Handler File Upload */
    post: operations['update_workflow_instance_next_step_handler_file_upload_api_admin_workflow_instances__workflow_instance_id__upload_file_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/workflow_instances/{workflow_instance_id}/previous_step': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    /** Update Workflow Instance Previous Step Handler */
    put: operations['update_workflow_instance_previous_step_handler_api_admin_workflow_instances__workflow_instance_id__previous_step_put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/workflow_instances/{workflow_instance_id}/skip_step': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    /** Update Workflow Instance Skip Step Handler */
    put: operations['update_workflow_instance_skip_step_handler_api_admin_workflow_instances__workflow_instance_id__skip_step_put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/workflow_instances/{workflow_instance_id}/cancel': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    /** Update Workflow Instance Cancel Handler */
    put: operations['update_workflow_instance_cancel_handler_api_admin_workflow_instances__workflow_instance_id__cancel_put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/workflow_instances/{workflow_instance_id}/state': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    /** Update Workflow Instance Set State Handler */
    put: operations['update_workflow_instance_set_state_handler_api_admin_workflow_instances__workflow_instance_id__state_put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/workflow_instances/{workflow_instance_id}/simulate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    /** Update Workflow Instance Simulate Handler */
    put: operations['update_workflow_instance_simulate_handler_api_admin_workflow_instances__workflow_instance_id__simulate_put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/workflow_instances/{workflow_instance_id}/comments': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Workflow Instance Comments Handler */
    get: operations['get_workflow_instance_comments_handler_api_admin_workflow_instances__workflow_instance_id__comments_get'];
    put?: never;
    /** Create Workflow Instance Comment Handler */
    post: operations['create_workflow_instance_comment_handler_api_admin_workflow_instances__workflow_instance_id__comments_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/workflow_instances/{workflow_instance_id}/legalinc_docs/{legal_entity_document_type_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Workflow Legalinc Docs */
    get: operations['get_workflow_legalinc_docs_api_admin_workflow_instances__workflow_instance_id__legalinc_docs__legal_entity_document_type_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/workflow_instances/{workflow_instance_id}/template_data': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Workflow Instance Template Data Handler */
    get: operations['get_workflow_instance_template_data_handler_api_admin_workflow_instances__workflow_instance_id__template_data_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/workflow_instances/{workflow_instance_id}/stale_logins': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Workflow Instance Stale Logins */
    get: operations['get_workflow_instance_stale_logins_api_admin_workflow_instances__workflow_instance_id__stale_logins_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/workflow_instances/{workflow_instance_id}/stale_login/{login_public_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    /** Update Workflow Instance Stale Logins */
    put: operations['update_workflow_instance_stale_logins_api_admin_workflow_instances__workflow_instance_id__stale_login__login_public_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/workflow_instance_stats': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Workflow Instance Stats */
    get: operations['get_workflow_instance_stats_api_admin_workflow_instance_stats_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/managed_providers': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Managed Providers List
     * @description List all managed providers
     */
    get: operations['managed_providers_list_api_admin_managed_providers_get'];
    put?: never;
    /**
     * Managed Providers Create
     * @description Create managed provider
     */
    post: operations['managed_providers_create_api_admin_managed_providers_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/managed_provider_requirements/{managed_provider_requirement_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Managed Provider Requirement
     * @description Get a managed provider requirement
     */
    get: operations['managed_provider_requirement_api_admin_managed_provider_requirements__managed_provider_requirement_id__get'];
    put?: never;
    post?: never;
    /** Delete Managed Provider Requirement Handler */
    delete: operations['delete_managed_provider_requirement_handler_api_admin_managed_provider_requirements__managed_provider_requirement_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/managed_provider_requirements': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Managed Provider Requirements List
     * @description List all managed provider requirements
     */
    get: operations['managed_provider_requirements_list_api_admin_managed_provider_requirements_get'];
    put?: never;
    /**
     * Managed Providers Create
     * @description Create a mapping for managed_provider_requirements.
     */
    post: operations['managed_providers_create_api_admin_managed_provider_requirements_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/entity_types': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Entity Types Handler
     * @description List all entity types.
     */
    get: operations['list_entity_types_handler_api_admin_entity_types_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/entity_types/{entity_type_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Show Entity Types Handler
     * @description Show one entity type.
     */
    get: operations['show_entity_types_handler_api_admin_entity_types__entity_type_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/tax_classes': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Tax Classes Handler
     * @description List all tax classes.
     */
    get: operations['list_tax_classes_handler_api_admin_tax_classes_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/tax_classes/{tax_class_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Show Tax Class Handler
     * @description Show one tax class.
     */
    get: operations['show_tax_class_handler_api_admin_tax_classes__tax_class_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/wizards': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Wizard Handler
     * @description List all wizards.
     */
    get: operations['list_wizard_handler_api_admin_wizards_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/mailroom_mail': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Mailroom Mail Handler */
    get: operations['list_mailroom_mail_handler_api_admin_mailroom_mail_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/mailroom_mail/{mail_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Mailroom Mail Handler */
    get: operations['get_mailroom_mail_handler_api_admin_mailroom_mail__mail_id__get'];
    /** Update Mailroom Mail Handler */
    put: operations['update_mailroom_mail_handler_api_admin_mailroom_mail__mail_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/mailroom_mail/{mail_id}/scan/{sequence_number}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Mailroom Mail Scan Handler */
    get: operations['get_mailroom_mail_scan_handler_api_admin_mailroom_mail__mail_id__scan__sequence_number__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/notices': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Notice List */
    get: operations['notice_list_api_admin_notices_get'];
    put?: never;
    /** Notice Create */
    post: operations['notice_create_api_admin_notices_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/notices/{notice_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Notice Details */
    get: operations['notice_details_api_admin_notices__notice_id__get'];
    /** Notice Update */
    put: operations['notice_update_api_admin_notices__notice_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/pending_changes/{pending_compliance_change_id}/comment': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Pending Changes Comments */
    get: operations['list_pending_changes_comments_api_admin_pending_changes__pending_compliance_change_id__comment_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/pending_changes': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Changes */
    get: operations['list_changes_api_admin_pending_changes_get'];
    put?: never;
    /** Submit Prompt */
    post: operations['submit_prompt_api_admin_pending_changes_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/pending_changes/{change_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Change */
    get: operations['get_change_api_admin_pending_changes__change_id__get'];
    put?: never;
    post?: never;
    /** Delete Change */
    delete: operations['delete_change_api_admin_pending_changes__change_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/pending_changes/{change_id}/apply': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Apply Change */
    post: operations['apply_change_api_admin_pending_changes__change_id__apply_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/pending_changes/apply': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Bulk Approve Change */
    post: operations['bulk_approve_change_api_admin_pending_changes_apply_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/pending_changes/{change_id}/comment': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Add Comment */
    post: operations['add_comment_api_admin_pending_changes__change_id__comment_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/change_log': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Change Logs */
    get: operations['list_change_logs_api_admin_change_log_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/history_changes': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List History Change Logs */
    get: operations['list_history_change_logs_api_admin_history_changes_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/images/{image_name}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Image */
    get: operations['get_image_api_admin_images__image_name__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/images': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Create Image */
    post: operations['create_image_api_admin_images_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/account_login_refs': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Account Logins Handler */
    get: operations['list_account_logins_handler_api_admin_account_login_refs_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/account_logins': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Account Login Refs Handler */
    get: operations['list_account_login_refs_handler_api_admin_account_logins_get'];
    put?: never;
    /** Create Account Login Handler */
    post: operations['create_account_login_handler_api_admin_account_logins_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/account_logins/{account_login_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Account Login Handler */
    get: operations['get_account_login_handler_api_admin_account_logins__account_login_id__get'];
    /** Update Account Login Handler */
    put: operations['update_account_login_handler_api_admin_account_logins__account_login_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/legal_entity_account_logins': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Legal Entity Account Logins Handler */
    get: operations['list_legal_entity_account_logins_handler_api_admin_legal_entity_account_logins_get'];
    put?: never;
    /** Create Legal Entity Account Login Handler */
    post: operations['create_legal_entity_account_login_handler_api_admin_legal_entity_account_logins_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/legal_entity_account_logins/{legal_entity_account_login_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Legal Entity Account Login Handler */
    get: operations['get_legal_entity_account_login_handler_api_admin_legal_entity_account_logins__legal_entity_account_login_id__get'];
    /** Update Legal Entity Account Login Handler */
    put: operations['update_legal_entity_account_login_handler_api_admin_legal_entity_account_logins__legal_entity_account_login_id__put'];
    post?: never;
    /** Delete Legal Entity Account Login Handler */
    delete: operations['delete_legal_entity_account_login_handler_api_admin_legal_entity_account_logins__legal_entity_account_login_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/upcoming_legislations': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Upcoming Legislation Handler */
    get: operations['list_upcoming_legislation_handler_api_admin_upcoming_legislations_get'];
    put?: never;
    /** Create Upcoming Legislation Handler */
    post: operations['create_upcoming_legislation_handler_api_admin_upcoming_legislations_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/upcoming_legislations/{upcoming_legislation_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Upcoming Legislation Handler */
    get: operations['get_upcoming_legislation_handler_api_admin_upcoming_legislations__upcoming_legislation_id__get'];
    /** Update Upcoming Legislation Handler */
    put: operations['update_upcoming_legislation_handler_api_admin_upcoming_legislations__upcoming_legislation_id__put'];
    post?: never;
    /** Delete Upcoming Legislation Handler */
    delete: operations['delete_upcoming_legislation_handler_api_admin_upcoming_legislations__upcoming_legislation_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/referrals': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Referrals Handler */
    get: operations['list_referrals_handler_api_admin_referrals_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/referral_sources': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Referral Sources Handler */
    get: operations['list_referral_sources_handler_api_admin_referral_sources_get'];
    put?: never;
    /** Create Referral Source Handler */
    post: operations['create_referral_source_handler_api_admin_referral_sources_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/referral_sources/{referral_source_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Referral Source Handler */
    get: operations['get_referral_source_handler_api_admin_referral_sources__referral_source_id__get'];
    /** Update Referral Source Handler */
    put: operations['update_referral_source_handler_api_admin_referral_sources__referral_source_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/stripe_coupons': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Stripe Coupons Handler */
    get: operations['list_stripe_coupons_handler_api_admin_stripe_coupons_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/stripe_coupons/{stripe_coupon_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Stripe Coupon Handler */
    get: operations['get_stripe_coupon_handler_api_admin_stripe_coupons__stripe_coupon_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/stripe/invoice/{legal_entity_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Create Stripe Invoice */
    post: operations['create_stripe_invoice_api_admin_stripe_invoice__legal_entity_id__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/training_workflow_legal_entities': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Training Workflow Legal Entities Handler */
    get: operations['list_training_workflow_legal_entities_handler_api_admin_training_workflow_legal_entities_get'];
    put?: never;
    /** Create Idtype Handler */
    post: operations['create_idtype_handler_api_admin_training_workflow_legal_entities_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/training_workflow_legal_entities/{id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /** Remove Platform Legal Entity Association */
    delete: operations['remove_platform_legal_entity_association_api_admin_training_workflow_legal_entities__id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/platforms': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Platforms List */
    get: operations['platforms_list_api_admin_platforms_get'];
    put?: never;
    /** Platform Create */
    post: operations['platform_create_api_admin_platforms_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/platforms/{platform_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Platform Show */
    get: operations['platform_show_api_admin_platforms__platform_id__get'];
    /** Platform Update */
    put: operations['platform_update_api_admin_platforms__platform_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/api_keys': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Api Keys List */
    get: operations['api_keys_list_api_admin_api_keys_get'];
    put?: never;
    /** Api Keys Create */
    post: operations['api_keys_create_api_admin_api_keys_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/api_keys/{id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Api Keys Show */
    get: operations['api_keys_show_api_admin_api_keys__id__get'];
    /** Api Keys Update */
    put: operations['api_keys_update_api_admin_api_keys__id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/platform_resolutions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Platform Resolutions Handler */
    get: operations['list_platform_resolutions_handler_api_admin_platform_resolutions_get'];
    put?: never;
    /** Create Platform Resolution Handler */
    post: operations['create_platform_resolution_handler_api_admin_platform_resolutions_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/platform_resolutions/{platform_resolution_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Show Platform Resolution Handler */
    get: operations['show_platform_resolution_handler_api_admin_platform_resolutions__platform_resolution_id__get'];
    /** Update Platform Resolution Handler */
    put: operations['update_platform_resolution_handler_api_admin_platform_resolutions__platform_resolution_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/platform_resolutions/import': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Custom Resolution Import */
    post: operations['custom_resolution_import_api_admin_platform_resolutions_import_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/accounts': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Accounts Handler
     * @description List all accounts.
     */
    get: operations['list_accounts_handler_api_admin_accounts_get'];
    put?: never;
    /**
     * Create Account Handler
     * @description Create an account.
     */
    post: operations['create_account_handler_api_admin_accounts_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/accounts/{account_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Account Handler
     * @description Get an account.
     */
    get: operations['get_account_handler_api_admin_accounts__account_id__get'];
    /**
     * Update Account Handler
     * @description Update an account.
     */
    put: operations['update_account_handler_api_admin_accounts__account_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/legal_entity_document_types': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Legal Entity Document Type List */
    get: operations['legal_entity_document_type_list_api_admin_legal_entity_document_types_get'];
    put?: never;
    /** Create Legal Entity Document Type */
    post: operations['create_legal_entity_document_type_api_admin_legal_entity_document_types_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/legal_entity_document_types/{legal_entity_document_type_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Legal Entity Document Type */
    get: operations['get_legal_entity_document_type_api_admin_legal_entity_document_types__legal_entity_document_type_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/legal_entity_document_types/{document_type_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    /** Legal Entity Document Type Update */
    put: operations['legal_entity_document_type_update_api_admin_legal_entity_document_types__document_type_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/legal_entity_documents/email/{workflow_instance_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Legal Entity Document Get Email Data */
    get: operations['legal_entity_document_get_email_data_api_admin_legal_entity_documents_email__workflow_instance_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/policy_sections': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Policy Sections */
    get: operations['list_policy_sections_api_admin_policy_sections_get'];
    put?: never;
    /** Create Policy Section */
    post: operations['create_policy_section_api_admin_policy_sections_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/policy_categories': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Policy Categories */
    get: operations['list_policy_categories_api_admin_policy_categories_get'];
    put?: never;
    /** Create Policy Category */
    post: operations['create_policy_category_api_admin_policy_categories_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/policy_categories/{public_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Policy Category */
    get: operations['get_policy_category_api_admin_policy_categories__public_id__get'];
    /** Update Policy Category */
    put: operations['update_policy_category_api_admin_policy_categories__public_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/policy_sections/{public_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Policy Section */
    get: operations['get_policy_section_api_admin_policy_sections__public_id__get'];
    /** Update Policy Section */
    put: operations['update_policy_section_api_admin_policy_sections__public_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/policies': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Policies */
    get: operations['list_policies_api_admin_policies_get'];
    put?: never;
    /** Create Policy */
    post: operations['create_policy_api_admin_policies_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/policy_categories/{public_category_id}/policies': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Policies By Category */
    get: operations['list_policies_by_category_api_admin_policy_categories__public_category_id__policies_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/policies/{public_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Policy */
    get: operations['get_policy_api_admin_policies__public_id__get'];
    /** Update Policy */
    put: operations['update_policy_api_admin_policies__public_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/handbook_legal_entities/{legal_entity_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Handbook Legal Entity */
    get: operations['get_handbook_legal_entity_api_admin_handbook_legal_entities__legal_entity_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/handbook_legal_entities': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Handbook Legal Entities */
    get: operations['get_handbook_legal_entities_api_admin_handbook_legal_entities_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/handbook_stats': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Stats */
    get: operations['get_stats_api_admin_handbook_stats_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/legal_entity_integration_emails/{id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Legal Entity Integration Email */
    get: operations['get_legal_entity_integration_email_api_admin_legal_entity_integration_emails__id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/legal_entity_integration_emails': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Integration Email */
    get: operations['list_integration_email_api_admin_legal_entity_integration_emails_get'];
    put?: never;
    /** Create Integration Email */
    post: operations['create_integration_email_api_admin_legal_entity_integration_emails_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/emailroom/{mailroom_email_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Emailroom Email */
    get: operations['get_emailroom_email_api_admin_emailroom__mailroom_email_id__get'];
    /** Update Emailroom Email */
    put: operations['update_emailroom_email_api_admin_emailroom__mailroom_email_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/emailroom': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Emailroom Emails */
    get: operations['list_emailroom_emails_api_admin_emailroom_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/emailroom/bulk-status-change': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Bulk Update Emailroom Email Status */
    post: operations['bulk_update_emailroom_email_status_api_admin_emailroom_bulk_status_change_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/forms': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Forms */
    get: operations['list_forms_api_admin_forms_get'];
    put?: never;
    /** Create Form */
    post: operations['create_form_api_admin_forms_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/forms/{form_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Form */
    get: operations['get_form_api_admin_forms__form_id__get'];
    /** Update Form */
    put: operations['update_form_api_admin_forms__form_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/form_attributes': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Form Attributes */
    get: operations['list_form_attributes_api_admin_form_attributes_get'];
    put?: never;
    /** Create Form Attribute */
    post: operations['create_form_attribute_api_admin_form_attributes_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/form_attributes/{form_attribute_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Form Attribute */
    get: operations['get_form_attribute_api_admin_form_attributes__form_attribute_id__get'];
    /** Update Form Attribute */
    put: operations['update_form_attribute_api_admin_form_attributes__form_attribute_id__put'];
    post?: never;
    /** Delete Form Attribute */
    delete: operations['delete_form_attribute_api_admin_form_attributes__form_attribute_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/workflow_attributes': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Workflow Attributes */
    get: operations['list_workflow_attributes_api_admin_workflow_attributes_get'];
    put?: never;
    /** Create Workflow Attribute */
    post: operations['create_workflow_attribute_api_admin_workflow_attributes_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/workflow_attributes/{workflow_attribute_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Workflow Attribute */
    get: operations['get_workflow_attribute_api_admin_workflow_attributes__workflow_attribute_id__get'];
    /** Update Workflow Attribute */
    put: operations['update_workflow_attribute_api_admin_workflow_attributes__workflow_attribute_id__put'];
    post?: never;
    /** Remove Workflow Attribute */
    delete: operations['remove_workflow_attribute_api_admin_workflow_attributes__workflow_attribute_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/workflow_attributes/{workflow_id}/count': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Count Workflow Attributes */
    get: operations['count_workflow_attributes_api_admin_workflow_attributes__workflow_id__count_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/zip_code_groups': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Zip Code Groups Handler */
    get: operations['list_zip_code_groups_handler_api_admin_zip_code_groups_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/question_tasks': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Question Tasks */
    get: operations['get_question_tasks_api_admin_question_tasks_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/question_tasks/{question_task_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Question Task */
    get: operations['get_question_task_api_admin_question_tasks__question_task_id__get'];
    /** Put Question Task */
    put: operations['put_question_task_api_admin_question_tasks__question_task_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/notifications': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Handle List Notifications */
    get: operations['handle_list_notifications_api_admin_notifications_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/notifications/{notification_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Handle Get Notification */
    get: operations['handle_get_notification_api_admin_notifications__notification_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/sso_token': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Sso Login
     * @description This endpoint should be called after the frontend receives the SSO callback
     *     @param response:
     *     @param code: this is a parameter that SSO will return to the callback and should be forwarded as-is to this endpoint
     *     @param state: this is a parameter that SSO will return to the callback and should be forwarded as-is to this endpoint
     *     @param db:
     *     @return: The authenticated session for the SSO-enabled user
     */
    post: operations['sso_login_api_sso_token_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/sso_test_callback': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Sso Test Callback */
    get: operations['sso_test_callback_api_sso_test_callback_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/sso_auth_url': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Sso Auth Url */
    post: operations['sso_auth_url_api_sso_auth_url_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/token': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Login
     * @description Upon successful auth, returns an access token and sets a httponly
     *     cookie with the refresh token (to prevent XSS).
     *
     *     This should only be used by the application and using CORS that
     *     restricts requests in the same domain (to prevent CSRF attacks).
     *
     *     If the email is associated with SSO, redirects the user to the SSO's authorization url.
     */
    post: operations['login_api_token_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/platform_token': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Login Platform User
     * @description Upon successful auth, returns an access token and sets a httponly
     *     cookie with the refresh token (to prevent XSS).
     *
     *     This should only be used by the application and using CORS that
     *     restricts requests in the same domain (to prevent CSRF attacks).
     */
    post: operations['login_platform_user_api_platform_token_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/logout': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Logout */
    post: operations['logout_api_logout_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/refresh_token': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Refresh
     * @description Returns a new access token for valid refresh tokens.
     *
     *     Note: Refresh tokens are stored in HttpOnly cookies to prevent CSRF
     *     attacks.
     */
    post: operations['refresh_api_refresh_token_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/impersonate/token': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Token For Impersonator
     * @description Returns a new access token for impersonators when switching legal_entities.
     */
    post: operations['token_for_impersonator_api_impersonate_token_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/refresh_platform_token': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Refresh Platform Token
     * @description Returns a new platform access token for valid refresh tokens.
     *
     *     Note: Refresh tokens are stored in HttpOnly cookies to prevent CSRF
     *     attacks.
     */
    post: operations['refresh_platform_token_api_refresh_platform_token_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/signup': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Signup */
    post: operations['signup_api_signup_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/users': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Users
     * @description Gets users for the currently logged in user's legal entity.
     */
    get: operations['get_users_api_users_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/users/me': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    /**
     * User Update Handler
     * @description Update user first name and last name.
     */
    put: operations['user_update_handler_api_users_me_put'];
    /**
     * Current User
     * @description Get the currently logged in user. The user does not need to be
     *     active. Use the selected legal entity (or the default if none is
     *     provided) as the one that is to be loaded.
     */
    post: operations['current_user_api_users_me_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/regions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Regions
     * @description DEPRECATED, just returns a static list of the 50 US states
     */
    get: operations['get_regions_api_regions_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/regions/{region_code}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Region
     * @description Returns the requested region.
     */
    get: operations['get_region_api_regions__region_code__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/invites': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Invites Handler
     * @description List all invites for the legal entity.
     */
    get: operations['get_invites_handler_api_invites_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/invites/verify': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Verify Invite Handler */
    post: operations['verify_invite_handler_api_invites_verify_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/invites/accept': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Accept Invite Handler */
    post: operations['accept_invite_handler_api_invites_accept_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/invites/send': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Send Invite Handler */
    post: operations['send_invite_handler_api_invites_send_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/invites/{invite_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /** Revoke Invite */
    delete: operations['revoke_invite_api_invites__invite_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/legal_entity/locations': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Legal Entity Region Handler
     * @description Returns all the LegalEntityRegions associated with the LegalEntity for the logged in User.
     */
    get: operations['list_legal_entity_region_handler_api_legal_entity_locations_get'];
    put?: never;
    /**
     * Add Legal Entity Location Handler
     * @description Adds a new (if it doesn't exist) LegalEntityRegion to the LegalEntity for the logged in User.
     */
    post: operations['add_legal_entity_location_handler_api_legal_entity_locations_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/legal_entity/locations/summary/{region_code}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Summary For Location */
    get: operations['get_summary_for_location_api_legal_entity_locations_summary__region_code__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/legal_entity/locations/summary': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Summary For All Locations */
    get: operations['get_summary_for_all_locations_api_legal_entity_locations_summary_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/legal_entity/locations/{region_code}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Legal Entity Region Handler */
    get: operations['get_legal_entity_region_handler_api_legal_entity_locations__region_code__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/legal_entity/locations/{region_code}/agencies': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Legal Entity Agencies Region Handler */
    get: operations['get_legal_entity_agencies_region_handler_api_legal_entity_locations__region_code__agencies_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/legal_entity/locations/{region_code}/has_employees': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /** Patch Legal Entity Region Has Employees Handler */
    patch: operations['patch_legal_entity_region_has_employees_handler_api_legal_entity_locations__region_code__has_employees_patch'];
    trace?: never;
  };
  '/api/legal_entity/locations/{region_code}/configuration': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /** Patch Legal Entity Region Configuration Handler */
    patch: operations['patch_legal_entity_region_configuration_handler_api_legal_entity_locations__region_code__configuration_patch'];
    trace?: never;
  };
  '/api/legal_entity/locations/{region_code}/setup_complete': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    /** Update Legal Entity Region Setup Complete */
    put: operations['update_legal_entity_region_setup_complete_api_legal_entity_locations__region_code__setup_complete_put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/legal_entity/locations/{region_code}/certificate_of_good_standing': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Certificate Of Good Standing Handler */
    post: operations['certificate_of_good_standing_handler_api_legal_entity_locations__region_code__certificate_of_good_standing_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/legal_entity/locations/{region_code}/risk': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Location Risk Handler */
    get: operations['get_location_risk_handler_api_legal_entity_locations__region_code__risk_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/legal_entity/locations/{region_code}/mail': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Legal Entity Mail By Region Handler */
    get: operations['get_legal_entity_mail_by_region_handler_api_legal_entity_locations__region_code__mail_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/legal_entity/locations/{region_code}/annual_report/estimate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Calculate Annual Report Estimate Handler */
    post: operations['calculate_annual_report_estimate_handler_api_legal_entity_locations__region_code__annual_report_estimate_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/legal_entity/locations/{region_code}/requirements': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Generate Legal Entity Region Requirements Handler */
    post: operations['generate_legal_entity_region_requirements_handler_api_legal_entity_locations__region_code__requirements_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/legal_entity/mailroom_address': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Legal Entity Mailroom Address Handler */
    get: operations['get_legal_entity_mailroom_address_handler_api_legal_entity_mailroom_address_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/legal_entity/mail': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Legal Entity Mail Handler */
    get: operations['get_legal_entity_mail_handler_api_legal_entity_mail_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/legal_entity/mail/{mail_public_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Legal Entity Mail By Public Id Handler */
    get: operations['get_legal_entity_mail_by_public_id_handler_api_legal_entity_mail__mail_public_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /** Get Legal Entity Mail Patch Handler */
    patch: operations['get_legal_entity_mail_patch_handler_api_legal_entity_mail__mail_public_id__patch'];
    trace?: never;
  };
  '/api/legal_entity/profile': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Create Legal Entity Profile */
    post: operations['create_legal_entity_profile_api_legal_entity_profile_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/legal_entity/submitter': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Legal Entity Submitter Handler */
    get: operations['get_legal_entity_submitter_handler_api_legal_entity_submitter_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/legal_entity/submitter/{legal_entity_person_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    /** Update Legal Entity Submitter Handler */
    put: operations['update_legal_entity_submitter_handler_api_legal_entity_submitter__legal_entity_person_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/legal_entity/primary_contact': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Legal Entity Primary Contact Handler */
    get: operations['get_legal_entity_primary_contact_handler_api_legal_entity_primary_contact_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/legal_entity/primary_contact/{user_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    /** Update Legal Entity Primary Contact Handler */
    put: operations['update_legal_entity_primary_contact_handler_api_legal_entity_primary_contact__user_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/legal_entity/people': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Legal Entity People Handler */
    get: operations['get_legal_entity_people_handler_api_legal_entity_people_get'];
    put?: never;
    /** Create Legal Entity Person Handler */
    post: operations['create_legal_entity_person_handler_api_legal_entity_people_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/legal_entity/businesses': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Legal Entity Businesses Handler */
    get: operations['get_legal_entity_businesses_handler_api_legal_entity_businesses_get'];
    put?: never;
    /** Create Legal Entity Business Handler */
    post: operations['create_legal_entity_business_handler_api_legal_entity_businesses_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/legal_entity/owners': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Legal Entity Owners Handler */
    get: operations['get_legal_entity_owners_handler_api_legal_entity_owners_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/legal_entity/person/{legal_entity_person_public_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Legal Entity Person Handler */
    get: operations['get_legal_entity_person_handler_api_legal_entity_person__legal_entity_person_public_id__get'];
    /** Update Legal Entity Person Handler */
    put: operations['update_legal_entity_person_handler_api_legal_entity_person__legal_entity_person_public_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/legal_entity/business/{legal_entity_business_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Legal Entity Business Handler */
    get: operations['get_legal_entity_business_handler_api_legal_entity_business__legal_entity_business_id__get'];
    /** Update Legal Entity Business Handler */
    put: operations['update_legal_entity_business_handler_api_legal_entity_business__legal_entity_business_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/legal_entity/entity_information': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Legal Entity Information Handler */
    get: operations['get_legal_entity_information_handler_api_legal_entity_entity_information_get'];
    /** Update Legal Entity Information Handler */
    put: operations['update_legal_entity_information_handler_api_legal_entity_entity_information_put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/requirements': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Get Requirements Handler */
    post: operations['get_requirements_handler_api_requirements_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/requirements/calendar': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Get Calendar Requirements Handler */
    post: operations['get_calendar_requirements_handler_api_requirements_calendar_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/requirements/overviews': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Requirement Overviews */
    get: operations['list_requirement_overviews_api_requirements_overviews_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/requirements/{region_code}/navigator': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Navigator Requirements Handler */
    get: operations['get_navigator_requirements_handler_api_requirements__region_code__navigator_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/requirements/{legal_entity_requirement_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    /** Update Requirement Handler */
    put: operations['update_requirement_handler_api_requirements__legal_entity_requirement_id__put'];
    /** Get Requirement Handler */
    post: operations['get_requirement_handler_api_requirements__legal_entity_requirement_id__post'];
    delete?: never;
    options?: never;
    head?: never;
    /** Patch Requirement Handler */
    patch: operations['patch_requirement_handler_api_requirements__legal_entity_requirement_id__patch'];
    trace?: never;
  };
  '/api/requirements/{legal_entity_requirement_public_id}/automate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Automate Legal Entity Requirement Handler */
    post: operations['automate_legal_entity_requirement_handler_api_requirements__legal_entity_requirement_public_id__automate_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/requirements/': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    /** Batch Update Requirements Handler */
    put: operations['batch_update_requirements_handler_api_requirements__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/requirements/batch': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /** Batch Patch Requirement Handler */
    patch: operations['batch_patch_requirement_handler_api_requirements_batch_patch'];
    trace?: never;
  };
  '/api/requirements/{legal_entity_requirement_id}/remediation/{legal_entity_remediation_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    /** Update Remediation Handler */
    put: operations['update_remediation_handler_api_requirements__legal_entity_requirement_id__remediation__legal_entity_remediation_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/connect/gusto/authorize/confirm': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Gusto Authorize Confirm */
    post: operations['gusto_authorize_confirm_api_connect_gusto_authorize_confirm_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/connect/gusto/authorize': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Gusto Authorize */
    post: operations['gusto_authorize_api_connect_gusto_authorize_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/connect/gusto/onboard': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Gusto Onboard */
    post: operations['gusto_onboard_api_connect_gusto_onboard_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/connections': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Connections */
    get: operations['list_connections_api_connections_get'];
    put?: never;
    /** Create Connection Handler */
    post: operations['create_connection_handler_api_connections_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/form_captures': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Create Form Capture Handler */
    post: operations['create_form_capture_handler_api_form_captures_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/form_captures/{data_key}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Update Form Capture Handler */
    post: operations['update_form_capture_handler_api_form_captures__data_key__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/form_captures/view/{form_spec_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Get Form Handler */
    post: operations['get_form_handler_api_form_captures_view__form_spec_id__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/form_captures/save/{form_spec_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Save Form Handler */
    post: operations['save_form_handler_api_form_captures_save__form_spec_id__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/pending_changes/{change_id}/preview': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Preview Change */
    get: operations['preview_change_api_pending_changes__change_id__preview_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/search': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Get Search Results */
    post: operations['get_search_results_api_search_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/datums/{attribute_public_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Set Datum Handler */
    post: operations['set_datum_handler_api_datums__attribute_public_id__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/datums': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Bulk Set Datums Handler */
    post: operations['bulk_set_datums_handler_api_datums_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/public/compliance_check/lead': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Create Lead Contact */
    post: operations['create_lead_contact_api_public_compliance_check_lead_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/public/compliance_check/summary': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Get Summary Handler */
    post: operations['get_summary_handler_api_public_compliance_check_summary_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/onboarding': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Create Business Profile Handler */
    post: operations['create_business_profile_handler_api_onboarding_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/onboarding/configure_business_profile': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Configure Business Profile Handler */
    post: operations['configure_business_profile_handler_api_onboarding_configure_business_profile_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/onboarding/basic': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Basic Legal Entity Region And Requirements Handler */
    post: operations['basic_legal_entity_region_and_requirements_handler_api_onboarding_basic_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/notices/summary/{public_key}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Notices */
    get: operations['get_notices_api_notices_summary__public_key__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/notices/view/{public_key}/{file_name}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Notices File */
    get: operations['get_notices_file_api_notices_view__public_key___file_name__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/notices/enrollment/{region_code}/{legal_entity_requirement_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Post Notice Enrollment */
    post: operations['post_notice_enrollment_api_notices_enrollment__region_code___legal_entity_requirement_id__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/notices/enrollment': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Notice Enrollment */
    get: operations['get_notice_enrollment_api_notices_enrollment_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/verify/resend': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Resend Verification */
    post: operations['resend_verification_api_verify_resend_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/subscription/checkout/{plan_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Checkout Link */
    get: operations['get_checkout_link_api_subscription_checkout__plan_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/subscription/activate/{plan_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Activate Subscription */
    post: operations['activate_subscription_api_subscription_activate__plan_id__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/subscription/plans': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Plans */
    get: operations['get_plans_api_subscription_plans_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/subscription/billing': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Customer Portal Link
     * @description Returns a link to the Stripe Billing Portal. If there is
     *     a Stripe Customer ID associated with their account then generate a
     *     session and return the link to instantly access the portal. If
     *     there isn't a Stripe Customer ID for this account then return a
     *     fallback link which will ask the user to enter the email address
     *     associated with their billing information (the email used during
     *     checkout).
     */
    get: operations['get_customer_portal_link_api_subscription_billing_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/workflows': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Auto Start Workflow Handler
     * @deprecated
     */
    post: operations['auto_start_workflow_handler_api_workflows_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/accounts': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Get Accounts Handler */
    post: operations['get_accounts_handler_api_accounts_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/accounts/otp/{public_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Otp Handler */
    get: operations['get_otp_handler_api_accounts_otp__public_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/accounts/otp/{public_id}/email': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Email Otp Handler */
    get: operations['get_email_otp_handler_api_accounts_otp__public_id__email_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/legislation': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Upcoming Legislations Handler */
    get: operations['get_upcoming_legislations_handler_api_legislation_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/payroll/import/email': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Payroll Import Email */
    post: operations['payroll_import_email_api_payroll_import_email_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/payroll/import/csv': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Payroll Import Csv
     * @description This endpoint is not used in production. It is used for testing and manual uploads
     */
    post: operations['payroll_import_csv_api_payroll_import_csv_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/automation/registered-agent-transfer/{region_code}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Registered Agent Automation */
    get: operations['get_registered_agent_automation_api_automation_registered_agent_transfer__region_code__get'];
    put?: never;
    /** Submit Registered Agent Automation */
    post: operations['submit_registered_agent_automation_api_automation_registered_agent_transfer__region_code__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/automation/{legal_entity_requirement_public_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Automation */
    get: operations['get_automation_api_automation__legal_entity_requirement_public_id__get'];
    put?: never;
    /** Automate */
    post: operations['automate_api_automation__legal_entity_requirement_public_id__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/compliance/tasks': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Tasks */
    get: operations['get_tasks_api_compliance_tasks_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/compliance/tasks/{region_code}/configuration': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Tasks Region Configuration */
    get: operations['get_tasks_region_configuration_api_compliance_tasks__region_code__configuration_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/compliance/tasks/{task_public_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Task */
    get: operations['get_task_api_compliance_tasks__task_public_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /** Patch Task */
    patch: operations['patch_task_api_compliance_tasks__task_public_id__patch'];
    trace?: never;
  };
  '/api/compliance/tasks/batch_status': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Update Requirement Task Batch Status */
    post: operations['update_requirement_task_batch_status_api_compliance_tasks_batch_status_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/compliance/tasks/filter_preference': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Update Tasks Filter Preference */
    post: operations['update_tasks_filter_preference_api_compliance_tasks_filter_preference_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/compliance/tasks/{task_public_id}/status': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Update Requirement Task Status */
    post: operations['update_requirement_task_status_api_compliance_tasks__task_public_id__status_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/compliance/bulk_tasks/{task_public_id}/answer': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Answer Bulk Question Task */
    post: operations['answer_bulk_question_task_api_compliance_bulk_tasks__task_public_id__answer_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/compliance/tasks/{task_public_id}/answer': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Answer Question Task */
    post: operations['answer_question_task_api_compliance_tasks__task_public_id__answer_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/compliance/tasks/{task_public_id}/policy_instances': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Policy Instances For Task */
    get: operations['get_policy_instances_for_task_api_compliance_tasks__task_public_id__policy_instances_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/wizard/{wizard_slug}/step/{wizard_step_slug}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Tasks For Wizard */
    get: operations['get_tasks_for_wizard_api_wizard__wizard_slug__step__wizard_step_slug__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/wizard/{wizard_slug}/config': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Wizard Config */
    get: operations['get_wizard_config_api_wizard__wizard_slug__config_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/handbook/request-access': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Request Access To Handbook */
    post: operations['request_access_to_handbook_api_handbook_request_access_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/handbook/auth/refresh_token': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Refresh Platform Token
     * @description Returns a new handbook access token for valid refresh tokens.
     *
     *     Note: Refresh tokens are stored in HttpOnly cookies to prevent CSRF
     *     attacks.
     */
    post: operations['refresh_platform_token_api_handbook_auth_refresh_token_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/handbook/auth/redeem_token': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Redeem Handbook Login Token
     * @description Attempts to redeem a login token for a handbook user. This would
     *     have come from the magic link provided to them via email.
     *
     *     Upon successful auth, returns an access token and sets a httponly
     *     cookie with the refresh token (to prevent XSS).
     *
     *     This should only be used by the application and using CORS that
     *     restricts requests in the same domain (to prevent CSRF attacks).
     */
    post: operations['redeem_handbook_login_token_api_handbook_auth_redeem_token_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/handbook/auth/resend_link': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Resend Handbook Link */
    post: operations['resend_handbook_link_api_handbook_auth_resend_link_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/handbook/auth/email': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Request Handbook Link */
    post: operations['request_handbook_link_api_handbook_auth_email_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/handbook/auth/logout': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Logout */
    post: operations['logout_api_handbook_auth_logout_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/handbook/policies': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Policies */
    get: operations['list_policies_api_handbook_policies_get'];
    put?: never;
    /** Create Custom Policy In Section */
    post: operations['create_custom_policy_in_section_api_handbook_policies_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/handbook/policy_sections': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Policy Sections */
    get: operations['list_policy_sections_api_handbook_policy_sections_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/handbook/policy_categories/{category_id}/policies': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Create Policy In Category */
    post: operations['create_policy_in_category_api_handbook_policy_categories__category_id__policies_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/handbook/policies/{policy_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    /** Update Custom Policy */
    put: operations['update_custom_policy_api_handbook_policies__policy_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/handbook/policies/{policy_id}/form': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Policy Form */
    get: operations['get_policy_form_api_handbook_policies__policy_id__form_get'];
    put?: never;
    /** Submit Policy Form */
    post: operations['submit_policy_form_api_handbook_policies__policy_id__form_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/handbook/policy_section/{policy_section_public_id}/forms': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Policy Forms For Policy Section */
    get: operations['get_policy_forms_for_policy_section_api_handbook_policy_section__policy_section_public_id__forms_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/handbook/policies/{policy_id}/adopt': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Adopt Policy */
    post: operations['adopt_policy_api_handbook_policies__policy_id__adopt_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/handbook/policies/adopt': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Adopt Policies */
    post: operations['adopt_policies_api_handbook_policies_adopt_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/handbook/policy_section/{policy_section_public_id}/adopt': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Adopt Section Policies */
    post: operations['adopt_section_policies_api_handbook_policy_section__policy_section_public_id__adopt_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/handbook/policy_section/{policy_section_public_id}/attribute_values': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Policy Section Attribute Values */
    get: operations['get_policy_section_attribute_values_api_handbook_policy_section__policy_section_public_id__attribute_values_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/handbook/draft': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Draft */
    get: operations['get_draft_api_handbook_draft_get'];
    put?: never;
    /** Create Draft */
    post: operations['create_draft_api_handbook_draft_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/handbook/published': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Published Handbook */
    get: operations['get_published_handbook_api_handbook_published_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/handbook/publish': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Publish Handbook */
    post: operations['publish_handbook_api_handbook_publish_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/handbook/stats': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Handbook Stats */
    get: operations['handbook_stats_api_handbook_stats_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/handbook/employees': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Handbook Employee Acknowledgements */
    get: operations['get_handbook_employee_acknowledgements_api_handbook_employees_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/handbook/employees/{employee_id}/reminder': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Send Reminder */
    post: operations['send_reminder_api_handbook_employees__employee_id__reminder_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/handbook/employees/{employee_id}/download_signature': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Download Signature */
    get: operations['download_signature_api_handbook_employees__employee_id__download_signature_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/handbook/employees/download_signatures': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Download Signatures */
    post: operations['download_signatures_api_handbook_employees_download_signatures_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/handbook/employees/send_employees_signature_reminder': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Send Employees Signature Reminder */
    post: operations['send_employees_signature_reminder_api_handbook_employees_send_employees_signature_reminder_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/handbook/preview': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Preview Handbook */
    get: operations['get_preview_handbook_api_handbook_preview_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/handbook/has_pending_changes': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Handbook Has Pending Changes */
    get: operations['get_handbook_has_pending_changes_api_handbook_has_pending_changes_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/handbook/latest': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Latest Handbook */
    get: operations['get_latest_handbook_api_handbook_latest_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/handbook/{handbook_id}/acknowledge': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Acknowledge Handbook */
    post: operations['acknowledge_handbook_api_handbook__handbook_id__acknowledge_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/handbook/acknowledge_legal_notice': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Acknowledge Tos */
    post: operations['acknowledge_tos_api_handbook_acknowledge_legal_notice_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/handbook/users/me': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Handbook User */
    get: operations['get_handbook_user_api_handbook_users_me_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/documents': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Documents */
    get: operations['list_documents_api_documents_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/documents/from_local/{path}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Document Local */
    get: operations['get_document_local_api_documents_from_local__path__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/documents/get_from_request/{workflow_document_share_public_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Document From Request */
    get: operations['get_document_from_request_api_documents_get_from_request__workflow_document_share_public_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/documents/download/{document_public_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Download Url */
    get: operations['get_download_url_api_documents_download__document_public_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/accounts/signup': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Embedded Signup */
    post: operations['embedded_signup_handler_accounts_signup_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/accounts/signup/sessions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Hosted Signup Session
     * @description Provides a URL for directing a user through the hosted signup experience. Upon successful completion the user will be redirected to the callback_url. The returned legal entity id will not be active until the user has completed their signup. If a subsequent signup needs to be generated for a user the returned legal_entity_id from the first should be included in the request.
     */
    post: operations['Create_Hosted_Signup_Session_accounts_signup_sessions_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/accounts/auth': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Authenticate Legal Entity
     * @description Provides a short-lived authentication token scoped to the requested legal entity. Tokens must be included as an Authorization header for all API requests on behalf of the legal entity. They are valid for 10 minutes. Your API key will be provided to you by Mosey.
     */
    post: operations['account_authenticate_accounts_auth_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/locations': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Locations
     * @description Returns the list of locations associated with the authenticated legal entity.
     */
    get: operations['list_locations_handler_locations_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/locations/{location_public_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    /**
     * Add Location
     * @description Returns the specified location that is associated with the authenticated legal entity.
     *     An optional configuration can be provided to help decide if some tasks should be included or not.
     *
     *     <table>
     *     <tr><td>has_employees</td><td>Include or filter out tasks that are applicable when employees are living or working in the location. Once payroll is connected for the legal entity, this value will be kept in sync.</td></tr>
     *     <tr><td>has_physical_location</td><td>Include or filter out tasks that are applicable when the legal entity has a physical presence (such as an office) in the location.</td></tr>
     *     </table>
     *
     *     This table maps Location IDs to the state abbreviation code it represents. The IDs are globally unique and are used regardless of which legal entity is authenticated.
     *
     *     <table>
     *     <tr><td>e5aa6d3222d22de2</td><td>AL</td></tr>
     *     <tr><td>86e384ec4456dd93</td><td>AK</td></tr>
     *     <tr><td>43c2b058fdc38bd0</td><td>AZ</td></tr>
     *     <tr><td>8a3248de4ff636d4</td><td>AR</td></tr>
     *     <tr><td>99be5e8f54c4680d</td><td>CA</td></tr>
     *     <tr><td>e8239e013ff4cde4</td><td>CO</td></tr>
     *     <tr><td>e69817cba25a7fa6</td><td>CT</td></tr>
     *     <tr><td>1f1cc147c009b409</td><td>DE</td></tr>
     *     <tr><td>afb903b3dcbe23fc</td><td>DC</td></tr>
     *     <tr><td>33cf440c464d38f5</td><td>FL</td></tr>
     *     <tr><td>5c392fde8d78eb3c</td><td>GA</td></tr>
     *     <tr><td>dcb44d856176eb43</td><td>HI</td></tr>
     *     <tr><td>a71f627b1843088a</td><td>ID</td></tr>
     *     <tr><td>30c18f24ba96c1e2</td><td>IL</td></tr>
     *     <tr><td>fbe3a2db6d46f2fe</td><td>IN</td></tr>
     *     <tr><td>81fb4925ba83f81b</td><td>IA</td></tr>
     *     <tr><td>f60f094906bf6e61</td><td>KS</td></tr>
     *     <tr><td>0fced19468cca680</td><td>KY</td></tr>
     *     <tr><td>b51b14eb685c802f</td><td>LA</td></tr>
     *     <tr><td>50b6e06268188bff</td><td>ME</td></tr>
     *     <tr><td>784c3796c1f6931f</td><td>MD</td></tr>
     *     <tr><td>d26e531db2dcbb50</td><td>MA</td></tr>
     *     <tr><td>b07e8933d62889e9</td><td>MI</td></tr>
     *     <tr><td>2577a77a916b01bd</td><td>MN</td></tr>
     *     <tr><td>4641d29a7416dae8</td><td>MS</td></tr>
     *     <tr><td>4eecb1031e0ecc97</td><td>MO</td></tr>
     *     <tr><td>3c6de0a85af1153b</td><td>MT</td></tr>
     *     <tr><td>47b790d36c9135fe</td><td>NE</td></tr>
     *     <tr><td>c2473d37f8547551</td><td>NV</td></tr>
     *     <tr><td>e4656a4c283b7c15</td><td>NH</td></tr>
     *     <tr><td>a3cc7e50a63fb347</td><td>NJ</td></tr>
     *     <tr><td>43ca15ae2aa526e9</td><td>NM</td></tr>
     *     <tr><td>5894aa7b4729ed13</td><td>NY</td></tr>
     *     <tr><td>aa79248e404b74d2</td><td>NC</td></tr>
     *     <tr><td>5528e71a2a626676</td><td>ND</td></tr>
     *     <tr><td>ff6fec03fcfaa7d1</td><td>OH</td></tr>
     *     <tr><td>36552f81875623ad</td><td>OK</td></tr>
     *     <tr><td>e3fd17f3f015b908</td><td>OR</td></tr>
     *     <tr><td>1c96f4e30d829772</td><td>PA</td></tr>
     *     <tr><td>1e58e23ec4a87036</td><td>RI</td></tr>
     *     <tr><td>d2bbb1305f460a69</td><td>SC</td></tr>
     *     <tr><td>4e4a5bc7fcf5abd2</td><td>SD</td></tr>
     *     <tr><td>13f00f61a16fdabd</td><td>TN</td></tr>
     *     <tr><td>7dac61e5b25e151a</td><td>TX</td></tr>
     *     <tr><td>5da0217cd400f37a</td><td>UT</td></tr>
     *     <tr><td>3683a6d2eec6b45c</td><td>VT</td></tr>
     *     <tr><td>f568e8571666ccd6</td><td>VA</td></tr>
     *     <tr><td>05a2dfcf81d37e7d</td><td>WA</td></tr>
     *     <tr><td>aa5a1dfcbdd37d25</td><td>WV</td></tr>
     *     <tr><td>920abf5751681231</td><td>WI</td></tr>
     *     <tr><td>0132461d340cded0</td><td>WY</td></tr>
     *     </table>
     */
    put: operations['add_location_handler_locations__location_public_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/locations/{region_platform_public_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Location Configuration
     * @description Updates the configuration for the specified legal entity and region.
     *     An optional configuration can be provided to help decide if some tasks should be included or not.
     *
     *     <table>
     *     <tr><td>has_employees</td><td>Include or filter out tasks that are applicable when employees are living or working in the location. Once payroll is connected for the legal entity, this value will be kept in sync. <b>This cannot be updated once payroll is connected."</b></td></tr>
     *     <tr><td>has_physical_location</td><td>Include or filter out tasks that are applicable when the legal entity has a physical presence (such as an office) in the location.</td></tr>
     *     </table>
     */
    patch: operations['update_location_handler_locations__region_platform_public_id__patch'];
    trace?: never;
  };
  '/tasks': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Tasks
     * @description Returns a list of tasks relevant for the authenticated legal entity. Tasks are sorted algorithmically by importance. To filter by status include a `status` parameter for each status you wish to be included in the response.
     */
    get: operations['list_tasks_handler_tasks_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/locations/{region_platform_public_id}/tasks': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Tasks for Location
     * @description Returns a list of tasks relevant for the authenticated legal entity for the specified location. Tasks are sorted by their due date in ascending order, where tasks without a due date are first.
     */
    get: operations['list_location_tasks_handler_locations__region_platform_public_id__tasks_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/tasks/{task_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Task
     * @description Returns the specified task.
     */
    get: operations['get_task_handler_tasks__task_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Task Status
     * @description Updates the status for the specified task. Returns the updated task.
     */
    patch: operations['patch_task_handler_tasks__task_id__patch'];
    trace?: never;
  };
  '/tasks/{task_id}/automate/sessions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Hosted Session to Automate Task
     * @description Starts the Mosey automation for the task. If the automation  requires input from the user, the response will include a URL that will redirect them to a form to collect it.
     */
    post: operations['automate_task_handler_tasks__task_id__automate_sessions_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/tasks/sessions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Hosted Session to View Tasks
     * @description Returns a URL with session, where the tasks are hosted at Mosey. Users can filter tasks based on location and status. Users can also act on these tasks
     */
    post: operations['hosted_task_tasks_sessions_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/legal_entity': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Legal Entity
     * @description Returns information for the authorized legal entity
     */
    get: operations['get_legal_entity_handler_legal_entity_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/locations/{location_public_id}/logins': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Account Logins for Location
     * @description Lists _Account Login_ for the current _Legal Entity_ and location id.
     */
    get: operations['list_account_logins_for_location_locations__location_public_id__logins_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/logins': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Legal Entity's Account Logins
     * @description Lists _Account Login_ for the current _Legal Entity_.
     *
     *     Retrieving a login's information is a **three-step process**:
     *     1. the returned objects will contain, amongst other information, the `id` of the Account Login.
     *     1. the hosted url can be obtained by calling `/logins/<id>/sessions`
     *     1. the Account Login data will be available following the previous response's `url`
     *
     *     ### Example
     *
     *     1. Request all logins for the current Legal Entity: `/logins`
     *     1. Response:
     *        ```
     *        [
     *           {
     *             "id": "abc1234",
     *             "name": "Account for Tax Office in Nevada",
     *             "region_code": "NV",
     *             "login_url": "https://tax.neveda.gov/login",
     *             "url": "https://tax.neveda.gov/login",
     *             "is_supported": true,
     *           },
     *           ...
     *       ]
     *        ```
     */
    get: operations['list_account_logins_logins_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/logins/{legal_entity_account_login_public_id}/sessions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Account Login Session
     * @description Returns the url the end-user should follow to retrieve the Account Login secrets and data
     */
    post: operations['make_account_login_hosted_url_logins__legal_entity_account_login_public_id__sessions_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/mail': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Mail
     * @description Returns mail information received by the authorized legal entity
     *
     *     Follow each returned `url` in order to download the mail content in PDF format
     */
    get: operations['get_legal_entity_mail_handler_mail_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/locations/{region_platform_public_id}/mail': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Mail by Location
     * @description Returns mail information received by the authorized legal entity in the specified region
     *
     *     Follow each returned `url` in order to download the mail content in PDF format
     */
    get: operations['get_legal_entity_mail_handler_for_location_locations__region_platform_public_id__mail_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/agency_accounts': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Agency Accounts */
    get: operations['get_agency_accounts_for_legal_entity_agency_accounts_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/locations/{region_platform_public_id}/agency_accounts': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Agency Accounts for Location */
    get: operations['get_agency_accounts_for_legal_entity_and_location_locations__region_platform_public_id__agency_accounts_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/accounts/connect': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Connect Account
     * @description Returns a hosted connection URL, which allows the user to connect to a specific account in the state agency such as accessing Employer Services Online Account in California Employment Development Department. This endpoint returns the connection_id which can be used to query the current status of the connection.
     */
    post: operations['create_connection_handler_accounts_connect_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/accounts/connections/{connection_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Account Connection
     * @description Returns the current status of connection. The statuses can be - Pending/Authenticating/Registering/Connected/Disconnected/Canceled.
     */
    get: operations['get_connection_handler_accounts_connections__connection_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/accounts/connections/{connection_id}/cancel': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Cancel Account Connection
     * @description Cancels a pending, registering, or authenticating connection for the given connection_id.
     */
    post: operations['cancel_connection_handler_accounts_connections__connection_id__cancel_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/guest/validate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Get Guest Details */
    post: operations['get_guest_details_api_guest_validate_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/guest': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Register Guest */
    post: operations['register_guest_api_guest_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/guest/document': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Upload Document */
    post: operations['upload_document_api_guest_document_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/notifications/topics': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Notification Topics */
    get: operations['list_notification_topics_api_notifications_topics_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/notifications/user/preferences': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Notification User Preferences */
    get: operations['list_notification_user_preferences_api_notifications_user_preferences_get'];
    put?: never;
    /** Save Notification User Preferences */
    post: operations['save_notification_user_preferences_api_notifications_user_preferences_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/criteria/meta': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Handle List Criteria Meta */
    get: operations['handle_list_criteria_meta_api_admin_criteria_meta_get'];
    put?: never;
    /** Handle Post Criteria Meta */
    post: operations['handle_post_criteria_meta_api_admin_criteria_meta_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/criteria/meta/{criteria_meta_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Handle Get Criteria Meta */
    get: operations['handle_get_criteria_meta_api_admin_criteria_meta__criteria_meta_id__get'];
    /** Handle Put Criteria Meta */
    put: operations['handle_put_criteria_meta_api_admin_criteria_meta__criteria_meta_id__put'];
    post?: never;
    /** Handle Delete Criteria Meta */
    delete: operations['handle_delete_criteria_meta_api_admin_criteria_meta__criteria_meta_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/admin/criteria/types': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Handle List Criteria Types */
    get: operations['handle_list_criteria_types_api_admin_criteria_types_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
}
export type webhooks = Record<string, never>;
export interface components {
  schemas: {
    /** AcceptInviteRequest */
    AcceptInviteRequest: {
      /** Token */
      token: string;
      /** Password */
      password: string;
      /** First Name */
      first_name?: string | null;
      /** Last Name */
      last_name?: string | null;
      /** Email */
      email?: string | null;
    };
    /** AccountCreateRequest */
    AccountCreateRequest: {
      /** Name */
      name: string;
      /** Agency Name */
      agency_name: string;
      /** Agency Url */
      agency_url: string;
      /**
       * New Attributes
       * @default []
       */
      new_attributes: components['schemas']['AttributeCreateRequest'][];
      /**
       * Attribute Ids
       * @default []
       */
      attribute_ids: number[];
    };
    /** AccountLegalEntity */
    AccountLegalEntity: {
      /** Id */
      id: string;
      /** Name */
      name: string;
      /** Notices Url */
      notices_url: string | null;
      /** User Email */
      user_email: string | null;
      /** Business Name */
      business_name: string | null;
      entity_type: components['schemas']['EntityTypeEnum'] | null;
      tax_classification: components['schemas']['TaxClassEnum'] | null;
      /** Incorporation Location */
      incorporation_location: string | null;
      /** Incorporation Date */
      incorporation_date: string | null;
      /** Ein */
      ein?: string | null;
      llc_managed_type?: components['schemas']['LLCManagedTypeEnum'] | null;
      /** Business Purpose */
      business_purpose?: string | null;
      /** Business Phone */
      business_phone?: string | null;
      /** Business Email */
      business_email?: string | null;
      business_address?: components['schemas']['app__public__Address'] | null;
      mailing_address?: components['schemas']['app__public__Address'] | null;
      /** Naics Code */
      naics_code?: string | null;
      accounting_method?: components['schemas']['AccountingMethod'] | null;
      accounting_period?: components['schemas']['AccountingPeriod'] | null;
      accounting_year_end?:
        | components['schemas']['AccountingYearEndMonthNumber']
        | null;
      /** Futa Liability Year */
      futa_liability_year?: string | null;
    };
    /** AccountLegalEntityLocation */
    AccountLegalEntityLocation: {
      location: components['schemas']['app__api__platform__account_locations__LocationRef'];
    };
    /** AccountLegalEntityLocationRef */
    AccountLegalEntityLocationRef: {
      location: components['schemas']['app__api__platform__account_locations__LocationRef'];
      config: components['schemas']['LocationConfig'];
    };
    /** AccountLoginCreateRequest */
    AccountLoginCreateRequest: {
      /** Region Id */
      region_id: number;
      /** Name */
      name: string;
      /** Login Url */
      login_url: string;
      /**
       * Is Supported
       * @default false
       */
      is_supported: boolean;
      /** Otp Sender Email */
      otp_sender_email?: string | null;
      /** Otp Subject Line */
      otp_subject_line?: string | null;
      /** Otp Format */
      otp_format?: AccountLoginCreateRequestOtp_format | null;
      /**
       * New Accounts
       * @default []
       */
      new_accounts: components['schemas']['AccountCreateRequest'][];
      /**
       * Agency Accounts
       * @default []
       */
      agency_accounts: string[];
      /** Reviewer Email */
      reviewer_email?: string | null;
    };
    /** AccountManagedProvider */
    AccountManagedProvider: {
      /** Id */
      id: string;
      /** Name */
      name: string;
    };
    /** AccountTask */
    AccountTask: {
      /** Id */
      id: string;
      /** Context */
      context:
        | components['schemas']['TaskContextEmployee']
        | components['schemas']['TaskContextLegalEntity'];
      definition: components['schemas']['AccountTaskDefinition'];
      /** Resolutions */
      resolutions: {
        [key: string]:
          | components['schemas']['AccountTaskResolutionAction']
          | components['schemas']['AccountTaskResolutionAutomate']
          | components['schemas']['AccountTaskResolutionManual']
          | components['schemas']['AccountTaskResolutionRedirect'];
      };
      /** Default Resolution Name */
      default_resolution_name: string;
      managed_provider?: components['schemas']['AccountManagedProvider'] | null;
      status: components['schemas']['AccountTaskStatus'];
      /** Period Start Date */
      period_start_date?: string | null;
      /** Period End Date */
      period_end_date?: string | null;
      /** Due Date */
      due_date?: string | null;
      /** Unblocks */
      unblocks: components['schemas']['AccountTaskDefinition'][];
      /** Fee */
      fee?:
        | (
            | components['schemas']['FeeFixed']
            | components['schemas']['FeeRange']
            | components['schemas']['FeeVariable']
          )
        | null;
      eta?: components['schemas']['AccountTaskETA'] | null;
      /** @default medium */
      priority: components['schemas']['TaskPriority'];
      /** Criteria Met */
      criteria_met: components['schemas']['AccountTaskCriteria'][];
      /** Tags */
      tags?: string[] | null;
    };
    /** AccountTaskAutomationFormSpec */
    AccountTaskAutomationFormSpec: Record<string, never>;
    /** AccountTaskCriteria */
    AccountTaskCriteria: {
      /** Key */
      key: string;
      /** Reason */
      reason: string;
      /**
       * Data
       * @default {}
       */
      data:
        | {
            [key: string]: unknown;
          }
        | unknown;
    };
    /** AccountTaskDefinition */
    AccountTaskDefinition: {
      /** Id */
      id: string;
      /** Title */
      title: string;
      /** Summary */
      summary?: string | null;
      /** Description */
      description: string;
      type: components['schemas']['TaskDefinitionType'];
      /** Resources */
      resources: {
        [key: string]: string;
      }[];
      location: components['schemas']['app__api__platform__account_locations__LocationRef'];
    };
    /** AccountTaskETA */
    AccountTaskETA: {
      estimation: components['schemas']['AccountTaskEstimation'];
      /** Earliest Date */
      earliest_date?: string | null;
      /** Latest Date */
      latest_date?: string | null;
    };
    /** AccountTaskEstimation */
    AccountTaskEstimation: {
      /** Min */
      min: number;
      /** Max */
      max: number;
      unit: components['schemas']['ETAUnit'];
    };
    /** AccountTaskResolutionAction */
    AccountTaskResolutionAction: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: AccountTaskResolutionActionType;
      /** Description */
      description: string;
      /** Method */
      method: string;
      /** Url */
      url: string;
      /** Content Type */
      content_type: string;
      /** Fields */
      fields: components['schemas']['ActionField'][];
    };
    /** AccountTaskResolutionAutomate */
    AccountTaskResolutionAutomate: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: AccountTaskResolutionAutomateType;
      form_spec: components['schemas']['AccountTaskAutomationFormSpec'];
      /** Submit Url */
      submit_url: string;
      /** Hosted Url */
      hosted_url: string;
    };
    /** AccountTaskResolutionManual */
    AccountTaskResolutionManual: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: AccountTaskResolutionManualType;
      /** Steps */
      steps: components['schemas']['AccountTaskResolutionManualStep'][];
    };
    /** AccountTaskResolutionManualStep */
    AccountTaskResolutionManualStep: {
      /** Id */
      id: string;
      /** Title */
      title: string;
      /** Description */
      description: string;
      /** Paths */
      paths: components['schemas']['AccountTaskResolutionManualStepPath'][];
      /** Order */
      order: number;
    };
    /** AccountTaskResolutionManualStepPath */
    AccountTaskResolutionManualStepPath: {
      /** Type */
      type: string;
      /** Value */
      value: string;
      /** Text */
      text?: string | null;
    };
    /** AccountTaskResolutionRedirect */
    AccountTaskResolutionRedirect: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: AccountTaskResolutionRedirectType;
      /** Url */
      url: string;
    };
    /**
     * AccountTaskStatus
     * @enum {string}
     */
    AccountTaskStatus: AccountTaskStatus;
    /**
     * AccountTaskTag
     * @enum {string}
     */
    AccountTaskTag: AccountTaskTag;
    /** AccountTaskUpdateStatus */
    AccountTaskUpdateStatus: {
      status: components['schemas']['AccountTaskStatus'];
    };
    /** AccountingInformation */
    AccountingInformation: {
      method: components['schemas']['AccountingMethod'];
      period: components['schemas']['AccountingPeriod'];
      /** @default 12 */
      year_end_month: components['schemas']['AccountingYearEndMonthNumber'];
    };
    /**
     * AccountingMethod
     * @enum {string}
     */
    AccountingMethod: AccountingMethod;
    /**
     * AccountingPeriod
     * @enum {string}
     */
    AccountingPeriod: AccountingPeriod;
    /**
     * AccountingYearEndMonthNumber
     * @enum {integer}
     */
    AccountingYearEndMonthNumber: AccountingYearEndMonthNumber;
    /** AcknowledgementStats */
    AcknowledgementStats: {
      /** Signed */
      signed: number;
      /** Pending */
      pending: number;
      /** Outdated */
      outdated: number;
    };
    /** ActionField */
    ActionField: {
      /** Name */
      name: string;
      /** Description */
      description: string;
      /** Required */
      required: boolean;
      /** Type */
      type: string;
    };
    /**
     * ActionType
     * @enum {string}
     */
    ActionType: ActionType;
    /** ActivateSubscriptionRequest */
    ActivateSubscriptionRequest: {
      /** Stripe Session Id */
      stripe_session_id: string;
    };
    /** AddressAttribute */
    AddressAttribute: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: AddressAttributeType;
      /** Params */
      params?: null;
      /** Placeholder */
      placeholder?: null;
      /**
       * Validators
       * @default []
       */
      validators: components['schemas']['ValidatorType'][];
    };
    /** AdminAcceptInviteParams */
    AdminAcceptInviteParams: {
      /** Token */
      token: string;
      /** Password */
      password: string;
    };
    /** AdminAccountLoginBase */
    AdminAccountLoginBase: {
      /** Region Id */
      region_id?: number | null;
      /** Region Name */
      region_name?: string | null;
      /** Id */
      id?: string | null;
      /** Account Login Id Int */
      account_login_id_int?: number | null;
      /** Name */
      name: string;
      /** Login Url */
      login_url: string;
      /** Is Supported */
      is_supported: boolean;
      /** Agency Accounts */
      agency_accounts: string[];
      /** Otp Sender Email */
      otp_sender_email?: string | null;
      /** Otp Subject Line */
      otp_subject_line?: string | null;
      /** Otp Format */
      otp_format?: AdminAccountLoginBaseOtp_format | null;
    };
    /** AdminAccountLoginRef */
    AdminAccountLoginRef: {
      /** Id */
      id: number;
      /** Public Id */
      public_id: string;
      /** Name */
      name: string;
      /** Region Name */
      region_name: string;
    };
    /** AdminAccountLoginUpdate */
    AdminAccountLoginUpdate: {
      /** Region Id */
      region_id?: number | null;
      /** Region Name */
      region_name?: string | null;
      /** Id */
      id?: string | null;
      /** Account Login Id Int */
      account_login_id_int?: number | null;
      /** Name */
      name: string;
      /** Login Url */
      login_url: string;
      /** Is Supported */
      is_supported: boolean;
      /** Agency Accounts */
      agency_accounts: string[];
      /** Otp Sender Email */
      otp_sender_email?: string | null;
      /** Otp Subject Line */
      otp_subject_line?: string | null;
      /** Otp Format */
      otp_format?: AdminAccountLoginUpdateOtp_format | null;
      /** Reviewer Email */
      reviewer_email?: string | null;
      /** Pending Change Id */
      pending_change_id?: number | null;
    };
    /** AdminAccountLoginView */
    AdminAccountLoginView: {
      /** Region Id */
      region_id?: number | null;
      /** Region Name */
      region_name?: string | null;
      /** Id */
      id?: string | null;
      /** Account Login Id Int */
      account_login_id_int?: number | null;
      /** Name */
      name: string;
      /** Login Url */
      login_url: string;
      /** Is Supported */
      is_supported: boolean;
      /** Agency Accounts */
      agency_accounts: string[];
      /** Otp Sender Email */
      otp_sender_email?: string | null;
      /** Otp Subject Line */
      otp_subject_line?: string | null;
      /** Otp Format */
      otp_format?: AdminAccountLoginViewOtp_format | null;
      /** Reviewer Email */
      reviewer_email?: string | null;
      /** Pending Change Id */
      pending_change_id?: number | null;
    };
    /** AdminAgency */
    AdminAgency: {
      /** Id */
      id?: string | null;
      /** Region Id */
      region_id: number;
      /** Name */
      name: string;
      /** Url */
      url: string;
      /** Reviewer Email */
      reviewer_email?: string | null;
      /** Pending Change Id */
      pending_change_id?: number | null;
    };
    /** AdminAgencyAccount */
    AdminAgencyAccount: {
      /** Id */
      id: string;
      /** Name */
      name: string;
      /** Agency Id */
      agency_id: string;
      /** Attributes */
      attributes: number[];
      /** Reviewer Email */
      reviewer_email?: string | null;
      /** Pending Change Id */
      pending_change_id?: number | null;
    };
    /** AdminAgencyAccountCreateOrUpdate */
    AdminAgencyAccountCreateOrUpdate: {
      /** Id */
      id?: string | null;
      /** Name */
      name: string;
      /** Agency Id */
      agency_id: string;
      /** Attributes */
      attributes: number[];
      /** Reviewer Email */
      reviewer_email?: string | null;
      /** Pending Change Id */
      pending_change_id?: number | null;
    };
    /** AdminAgencyCreate */
    AdminAgencyCreate: {
      /** Id */
      id?: string | null;
      /** Region Id */
      region_id: number;
      /** Name */
      name: string;
      /** Url */
      url: string;
      /** Reviewer Email */
      reviewer_email?: string | null;
      /** Pending Change Id */
      pending_change_id?: number | null;
    };
    /** AdminAgencyUpdate */
    AdminAgencyUpdate: {
      /** Name */
      name: string;
      /** Url */
      url: string;
      /**
       * Idtype Ids
       * @default []
       */
      idtype_ids: number[];
      /** Reviewer Email */
      reviewer_email?: string | null;
      /** Pending Change Id */
      pending_change_id?: number | null;
    };
    /** AdminAlertETABreachedWorkflows */
    AdminAlertETABreachedWorkflows: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: AdminAlertETABreachedWorkflowsCommand_id;
      /** Legal Entity Id */
      legal_entity_id?: number | null;
      /** As Of Date */
      as_of_date?: string | null;
    };
    /** AdminAttributeShow */
    AdminAttributeShow: {
      /** Id */
      id: number;
      /** Public Id */
      public_id: string;
      /** Region Id */
      region_id?: number | null;
      /** Name */
      name: string;
      /** Description */
      description?: string | null;
      description_link?: components['schemas']['DescriptionLink'] | null;
      /** Is Required */
      is_required: boolean;
      /** Source */
      source:
        | components['schemas']['DatumAttribute']
        | components['schemas']['ModelAttribute']
        | components['schemas']['CriteriaDatumAttribute'];
      /** Type */
      type:
        | components['schemas']['AddressAttribute']
        | components['schemas']['NonUsAddressAttribute']
        | components['schemas']['CountrySelectAttribute']
        | components['schemas']['TextAttribute']
        | components['schemas']['BooleanAttribute']
        | components['schemas']['NumberAttribute']
        | components['schemas']['DateAttribute']
        | components['schemas']['TextAreaAttribute']
        | components['schemas']['FranchiseTaxEstimateAttribute']
        | components['schemas']['RadioAttribute-Output']
        | components['schemas']['MultiSelectAttribute-Output']
        | components['schemas']['ArrayAttribute']
        | components['schemas']['SelectAttribute-Output'];
      /** Is Generic */
      is_generic: boolean;
      /**
       * Is Editable
       * @default false
       */
      is_editable: boolean;
      /** Pending Change Ids */
      pending_change_ids?: number[] | null;
      /** Pending Change Id */
      pending_change_id?: number | null;
      /** Reviewer Email */
      reviewer_email?: string | null;
    };
    /** AdminBaseAttribute */
    'AdminBaseAttribute-Input': {
      /** Id */
      id: number;
      /** Public Id */
      public_id: string;
      /** Region Id */
      region_id?: number | null;
      /** Name */
      name: string;
      /** Description */
      description?: string | null;
      description_link?: components['schemas']['DescriptionLink'] | null;
      /** Is Required */
      is_required: boolean;
      /** Source */
      source:
        | components['schemas']['DatumAttribute']
        | components['schemas']['ModelAttribute']
        | components['schemas']['CriteriaDatumAttribute'];
      /** Type */
      type:
        | components['schemas']['AddressAttribute']
        | components['schemas']['NonUsAddressAttribute']
        | components['schemas']['CountrySelectAttribute']
        | components['schemas']['TextAttribute']
        | components['schemas']['BooleanAttribute']
        | components['schemas']['NumberAttribute']
        | components['schemas']['DateAttribute']
        | components['schemas']['TextAreaAttribute']
        | components['schemas']['FranchiseTaxEstimateAttribute']
        | components['schemas']['RadioAttribute-Input']
        | components['schemas']['MultiSelectAttribute-Input']
        | components['schemas']['ArrayAttribute']
        | components['schemas']['SelectAttribute-Input'];
      /** Is Generic */
      is_generic: boolean;
      /**
       * Is Editable
       * @default false
       */
      is_editable: boolean;
    };
    /** AdminBaseAttribute */
    'AdminBaseAttribute-Output': {
      /** Id */
      id: number;
      /** Public Id */
      public_id: string;
      /** Region Id */
      region_id?: number | null;
      /** Name */
      name: string;
      /** Description */
      description?: string | null;
      description_link?: components['schemas']['DescriptionLink'] | null;
      /** Is Required */
      is_required: boolean;
      /** Source */
      source:
        | components['schemas']['DatumAttribute']
        | components['schemas']['ModelAttribute']
        | components['schemas']['CriteriaDatumAttribute'];
      /** Type */
      type:
        | components['schemas']['AddressAttribute']
        | components['schemas']['NonUsAddressAttribute']
        | components['schemas']['CountrySelectAttribute']
        | components['schemas']['TextAttribute']
        | components['schemas']['BooleanAttribute']
        | components['schemas']['NumberAttribute']
        | components['schemas']['DateAttribute']
        | components['schemas']['TextAreaAttribute']
        | components['schemas']['FranchiseTaxEstimateAttribute']
        | components['schemas']['RadioAttribute-Output']
        | components['schemas']['MultiSelectAttribute-Output']
        | components['schemas']['ArrayAttribute']
        | components['schemas']['SelectAttribute-Output'];
      /** Is Generic */
      is_generic: boolean;
      /**
       * Is Editable
       * @default false
       */
      is_editable: boolean;
    };
    /** AdminBaseAttributeWithValue */
    AdminBaseAttributeWithValue: {
      /** Id */
      id: number;
      /** Public Id */
      public_id: string;
      /** Region Id */
      region_id?: number | null;
      /** Name */
      name: string;
      /** Description */
      description?: string | null;
      description_link?: components['schemas']['DescriptionLink'] | null;
      /** Is Required */
      is_required: boolean;
      /** Source */
      source:
        | components['schemas']['DatumAttribute']
        | components['schemas']['ModelAttribute']
        | components['schemas']['CriteriaDatumAttribute'];
      /** Type */
      type:
        | components['schemas']['AddressAttribute']
        | components['schemas']['NonUsAddressAttribute']
        | components['schemas']['CountrySelectAttribute']
        | components['schemas']['TextAttribute']
        | components['schemas']['BooleanAttribute']
        | components['schemas']['NumberAttribute']
        | components['schemas']['DateAttribute']
        | components['schemas']['TextAreaAttribute']
        | components['schemas']['FranchiseTaxEstimateAttribute']
        | components['schemas']['RadioAttribute-Output']
        | components['schemas']['MultiSelectAttribute-Output']
        | components['schemas']['ArrayAttribute']
        | components['schemas']['SelectAttribute-Output'];
      /** Is Generic */
      is_generic: boolean;
      /**
       * Is Editable
       * @default false
       */
      is_editable: boolean;
      /** Value */
      value: string | null;
    };
    /** AdminCommand */
    AdminCommand: {
      /** Id */
      id: string;
      /** Name */
      name: string;
    };
    /** AdminCommandAccountReport */
    AdminCommandAccountReport: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: AdminCommandAccountReportCommand_id;
    };
    /** AdminCommandAnalyzeDocuments */
    AdminCommandAnalyzeDocuments: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: AdminCommandAnalyzeDocumentsCommand_id;
      /** Openai Question */
      openai_question: string;
      /** Document Id */
      document_id?: string | null;
      /** Picture Base64 */
      picture_base64?: string | null;
    };
    /** AdminCommandBackfillHomeStates */
    AdminCommandBackfillHomeStates: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: AdminCommandBackfillHomeStatesCommand_id;
      /**
       * Dry Run
       * @default true
       */
      dry_run: boolean;
    };
    /** AdminCommandBulkInsertAgencyAccounts */
    AdminCommandBulkInsertAgencyAccounts: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: AdminCommandBulkInsertAgencyAccountsCommand_id;
      /** Csv Base64 */
      csv_base64: string;
    };
    /** AdminCommandComplianceChangeReport */
    AdminCommandComplianceChangeReport: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: AdminCommandComplianceChangeReportCommand_id;
    };
    /** AdminCommandConvertForm */
    AdminCommandConvertForm: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: AdminCommandConvertFormCommand_id;
      /** Tag Id */
      tag_id: number;
      /** Region Id */
      region_id?: number | null;
      /** Entity Type Id */
      entity_type_id?: number | null;
      /** Tax Class Id */
      tax_class_id?: number | null;
    };
    /** AdminCommandCreateCheckLoginWorkflows */
    AdminCommandCreateCheckLoginWorkflows: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: AdminCommandCreateCheckLoginWorkflowsCommand_id;
      /**
       * Dry Run
       * @default true
       */
      dry_run: boolean;
    };
    /** AdminCommandCreateLegalEntityAndUser */
    AdminCommandCreateLegalEntityAndUser: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: AdminCommandCreateLegalEntityAndUserCommand_id;
      /** Company Name */
      company_name: string;
      /** User Email */
      user_email: string;
      /** Password */
      password: string;
      /** Form Capture */
      form_capture: string;
    };
    /** AdminCommandCreateTrainingWorkflowInstances */
    AdminCommandCreateTrainingWorkflowInstances: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: AdminCommandCreateTrainingWorkflowInstancesCommand_id;
      /** User Id */
      user_id: number;
    };
    /** AdminCommandDataChecker */
    AdminCommandDataChecker: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: AdminCommandDataCheckerCommand_id;
      /** Legal Entity Id */
      legal_entity_id?: number | null;
    };
    /** AdminCommandDeleteInapplicableHomeForeignOnlyLegalEntityRequirements */
    AdminCommandDeleteInapplicableHomeForeignOnlyLegalEntityRequirements: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: AdminCommandDeleteInapplicableHomeForeignOnlyLegalEntityRequirementsCommand_id;
      /**
       * Dry Run
       * @default true
       */
      dry_run: boolean;
    };
    /** AdminCommandEmailroomUploadPdf */
    AdminCommandEmailroomUploadPdf: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: AdminCommandEmailroomUploadPdfCommand_id;
      /** Emailroom Id */
      emailroom_id: number;
      /** Pdf Base64 */
      pdf_base64: string;
    };
    /** AdminCommandExecResult */
    AdminCommandExecResult: {
      /** Id */
      id: string;
      /** Name */
      name: string;
      status: components['schemas']['CommandRunStatus'];
      /** Params */
      params: {
        [key: string]: unknown;
      };
      /** Output */
      output?: string | null;
      /**
       * Started At
       * Format: date-time
       */
      started_at: string;
      /** Ended At */
      ended_at: string | null;
      /** Started By User Id */
      started_by_user_id: number;
    };
    /** AdminCommandFetchUnredactedFormCapture */
    AdminCommandFetchUnredactedFormCapture: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: AdminCommandFetchUnredactedFormCaptureCommand_id;
      /** Legal Entity Id */
      legal_entity_id: number;
    };
    /** AdminCommandGenerateSEOContent */
    AdminCommandGenerateSEOContent: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: AdminCommandGenerateSEOContentCommand_id;
      content_type: components['schemas']['ContentType'];
      /** Regenerate Ai Content */
      regenerate_ai_content: boolean;
    };
    /** AdminCommandLegalEntityRequirementHealthCheck */
    AdminCommandLegalEntityRequirementHealthCheck: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: AdminCommandLegalEntityRequirementHealthCheckCommand_id;
      /** Legal Entity Id */
      legal_entity_id: number;
      /** Region Ids */
      region_ids?: number[] | null;
    };
    /** AdminCommandLoadHandbookRequirementsForUser */
    AdminCommandLoadHandbookRequirementsForUser: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: AdminCommandLoadHandbookRequirementsForUserCommand_id;
      /** Legal Entity Id */
      legal_entity_id: number;
    };
    /** AdminCommandLoadManagedRequirementOverrides */
    AdminCommandLoadManagedRequirementOverrides: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: AdminCommandLoadManagedRequirementOverridesCommand_id;
      /** Legal Entity Id */
      legal_entity_id: number;
      /** Managed Provider Id */
      managed_provider_id: number;
      /**
       * Effective Date
       * Format: date
       */
      effective_date: string;
    };
    /** AdminCommandLoadRegionalNavsData */
    AdminCommandLoadRegionalNavsData: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: AdminCommandLoadRegionalNavsDataCommand_id;
      /**
       * Skip Loading Sandbox
       * @default false
       */
      skip_loading_sandbox: boolean | null;
    };
    /** AdminCommandLoadRequirementsForUser */
    AdminCommandLoadRequirementsForUser: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: AdminCommandLoadRequirementsForUserCommand_id;
      /** Legal Entity Id */
      legal_entity_id: number;
      /** Region Ids */
      region_ids: number[];
      /** As Of Date */
      as_of_date?: string | null;
      /**
       * Modify Existing
       * @default false
       */
      modify_existing: boolean;
    };
    /** AdminCommandMailroomRotatePdf */
    AdminCommandMailroomRotatePdf: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: AdminCommandMailroomRotatePdfCommand_id;
      /** Mailroom Id */
      mailroom_id: number;
    };
    /** AdminCommandManageGoogleGroups */
    AdminCommandManageGoogleGroups: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: AdminCommandManageGoogleGroupsCommand_id;
      action: components['schemas']['ActionType'];
      /** Email */
      email: string;
      target_group_type: components['schemas']['TargetGroupType'];
      role?: components['schemas']['MemberRole'] | null;
    };
    /** AdminCommandOffboardLegalEntity */
    AdminCommandOffboardLegalEntity: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: AdminCommandOffboardLegalEntityCommand_id;
      /**
       * Dry Run
       * @default true
       */
      dry_run: boolean;
      /** Legal Entity Id */
      legal_entity_id: number;
    };
    /** AdminCommandPlatformBillingReport */
    AdminCommandPlatformBillingReport: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: AdminCommandPlatformBillingReportCommand_id;
      /** Platform Id */
      platform_id: number;
      /**
       * Start Date
       * Format: date
       */
      start_date: string;
      /**
       * End Date
       * Format: date
       */
      end_date: string;
    };
    /** AdminCommandRequirementsAndRemediationsReport */
    AdminCommandRequirementsAndRemediationsReport: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: AdminCommandRequirementsAndRemediationsReportCommand_id;
      /** Legal Entity Id */
      legal_entity_id: number;
      /**
       * Start Date
       * Format: date
       */
      start_date: string;
    };
    /** AdminCommandResetLegalEntityRegion */
    AdminCommandResetLegalEntityRegion: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: AdminCommandResetLegalEntityRegionCommand_id;
      /** Legal Entity Id */
      legal_entity_id: number;
      /** Region Id */
      region_id?: number | null;
    };
    /** AdminCommandSendAllSummaryEmails */
    AdminCommandSendAllSummaryEmails: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: AdminCommandSendAllSummaryEmailsCommand_id;
      /**
       * Pivot Date
       * Format: date
       */
      pivot_date: string;
      /**
       * Dry Run
       * @default false
       */
      dry_run: boolean;
    };
    /** AdminCommandSendSubscriptionEmail */
    AdminCommandSendSubscriptionEmail: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: AdminCommandSendSubscriptionEmailCommand_id;
      /** Legal Entity Id */
      legal_entity_id: number;
      subscription_plan_id: components['schemas']['SubscriptionPlanEnum'];
      /**
       * Dry Run
       * @default false
       */
      dry_run: boolean;
    };
    /** AdminCommandSendSummaryEmail */
    AdminCommandSendSummaryEmail: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: AdminCommandSendSummaryEmailCommand_id;
      /** Legal Entity Id */
      legal_entity_id: number;
      /**
       * Pivot Date
       * Format: date
       */
      pivot_date: string;
      /**
       * Allow Test Account
       * @default false
       */
      allow_test_account: boolean;
      /**
       * Dry Run
       * @default false
       */
      dry_run: boolean;
    };
    /** AdminCommandSimulateSchedule */
    AdminCommandSimulateSchedule: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: AdminCommandSimulateScheduleCommand_id;
      /** Schedule */
      schedule: {
        [key: string]: unknown;
      };
      /**
       * Is Home Region
       * @default false
       */
      is_home_region: boolean;
      /** Registration Date */
      registration_date?: string | null;
      /** Fiscal Year End */
      fiscal_year_end?: string | null;
      /** Start Date */
      start_date?: string | null;
      /** End Date */
      end_date?: string | null;
      /**
       * Show Detailed View
       * @default false
       */
      show_detailed_view: boolean;
      /** Iterations */
      iterations?: number | null;
    };
    /** AdminCommandSyncHubspotCustomerData */
    AdminCommandSyncHubspotCustomerData: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: AdminCommandSyncHubspotCustomerDataCommand_id;
      /** Dry Run */
      dry_run: boolean;
    };
    /** AdminCommandSyncLegalincOrderStatus */
    AdminCommandSyncLegalincOrderStatus: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: AdminCommandSyncLegalincOrderStatusCommand_id;
      /** Legal Entity Id */
      legal_entity_id?: number | null;
    };
    /** AdminCommandSyncMailRoom */
    AdminCommandSyncMailRoom: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: AdminCommandSyncMailRoomCommand_id;
      mailroom_provider: components['schemas']['MailRoomOptions'];
    };
    /** AdminCommandSyncPayroll */
    AdminCommandSyncPayroll: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: AdminCommandSyncPayrollCommand_id;
      /** Legal Entity Id */
      legal_entity_id: number;
    };
    /** AdminCommandSyncPayrollCSV */
    AdminCommandSyncPayrollCSV: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: AdminCommandSyncPayrollCSVCommand_id;
      /** Legal Entity Id */
      legal_entity_id: number;
      /** Csv Base64 */
      csv_base64: string;
    };
    /** AdminCommandUpdateSubscriptionBilling */
    AdminCommandUpdateSubscriptionBilling: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: AdminCommandUpdateSubscriptionBillingCommand_id;
      /** Dry Run */
      dry_run: boolean;
    };
    /** AdminCommandValidateComplianceEngineUrls */
    AdminCommandValidateComplianceEngineUrls: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: AdminCommandValidateComplianceEngineUrlsCommand_id;
      /** Region Ids */
      region_ids: number[];
      /** Validation Type */
      validation_type: string;
    };
    /** AdminCommandWorkflowFeesReport */
    AdminCommandWorkflowFeesReport: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: AdminCommandWorkflowFeesReportCommand_id;
      /** From Date */
      from_date?: string | null;
      /** To Date */
      to_date?: string | null;
      /** Recipient Email */
      recipient_email?: string | null;
    };
    /** AdminCommandWorkflowReport */
    AdminCommandWorkflowReport: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: AdminCommandWorkflowReportCommand_id;
      /**
       * Start Date
       * Format: date
       */
      start_date: string;
    };
    /** AdminCommandWriteConfigTableDumpsToS3 */
    AdminCommandWriteConfigTableDumpsToS3: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: AdminCommandWriteConfigTableDumpsToS3Command_id;
      /** Dry Run */
      dry_run: boolean;
    };
    /** AdminCreateAccountRequest */
    AdminCreateAccountRequest: {
      /** Name */
      name: string;
      /** Is Active */
      is_active: boolean;
      /** Is Pro */
      is_pro: boolean;
      /** Stripe Customer Id */
      stripe_customer_id?: string | null;
      /** Platform Id */
      platform_id?: number | null;
      /** Sso Organization Id */
      sso_organization_id?: string | null;
      /** Sso Connection Id */
      sso_connection_id?: string | null;
    };
    /** AdminCreateApiKey */
    AdminCreateApiKey: {
      /** Platform Id */
      platform_id: number;
    };
    /** AdminCreateFormAttributeRequest */
    AdminCreateFormAttributeRequest: {
      /** Form Id */
      form_id: string;
      /** Attribute Id */
      attribute_id: number;
      /** Is Required */
      is_required: boolean;
      /** Description Override */
      description_override?: string | null;
      /** Default Value Override */
      default_value_override?: string | null;
    };
    /** AdminCreateFormRequest */
    AdminCreateFormRequest: {
      /** Title */
      title?: string | null;
      /** Region Id */
      region_id?: number | null;
      /** Tag Id */
      tag_id?: number | null;
    };
    /** AdminCreateInviteRequest */
    AdminCreateInviteRequest: {
      /** Legal Entity Id */
      legal_entity_id: number;
      /** Email */
      email: string;
      role: components['schemas']['Role'];
      /**
       * Allow Multiple Accepts
       * @default false
       */
      allow_multiple_accepts: boolean;
    };
    /** AdminCreateLegalEntityAddress */
    AdminCreateLegalEntityAddress: {
      /** Address Line 1 */
      address_line_1: string;
      /** Address Line 2 */
      address_line_2?: string | null;
      /** City */
      city: string;
      /** Region */
      region: string;
      /** Country */
      country: string;
      /** Postal Code */
      postal_code: string;
    };
    /** AdminCreateLegalEntityPersonRequest */
    AdminCreateLegalEntityPersonRequest: {
      /** Legal Entity Id */
      legal_entity_id: number;
      legal_entity_address: components['schemas']['AdminCreateLegalEntityAddress'];
      /** First Name */
      first_name: string;
      /** Last Name */
      last_name: string;
      /** Email */
      email: string;
      /** Title */
      title: string;
      /** Phone Number */
      phone_number: string;
      identifier_type: components['schemas']['IdentifierType'];
      /** Identifier */
      identifier?: string | null;
      /** Birth Date */
      birth_date?: string | null;
      /** Start Date */
      start_date?: string | null;
      /** Ownership Start Date */
      ownership_start_date?: string | null;
      /** Ownership Percentage */
      ownership_percentage?: number | null;
      /** Is Married */
      is_married?: boolean | null;
      /** Spouse First Name */
      spouse_first_name?: string | null;
      /** Spouse Last Name */
      spouse_last_name?: string | null;
      /** Is Officer */
      is_officer: boolean;
      /** Is Owner */
      is_owner: boolean;
      /** Is Llc Member */
      is_llc_member: boolean;
      /** Is Llc Manager */
      is_llc_manager: boolean;
      /** Is Director */
      is_director: boolean;
      /** Is Active */
      is_active: boolean;
    };
    /** AdminCreateLegalEntityRegionRequest */
    AdminCreateLegalEntityRegionRequest: {
      /** Legal Entity Id */
      legal_entity_id: number;
      /** Region Id */
      region_id: number;
      /** Status */
      status: string;
      /**
       * Is Setup Complete
       * @default false
       */
      is_setup_complete: boolean;
      /**
       * Has Employees
       * @default false
       */
      has_employees: boolean;
      /**
       * Doing Business
       * @default false
       */
      doing_business: boolean;
    };
    /** AdminCreateLegalEntityRequest */
    AdminCreateLegalEntityRequest: {
      /** Name */
      name: string;
      /** Entity Type Id */
      entity_type_id: number;
      /** Tax Class Id */
      tax_class_id: number;
      /** Is Non Stock */
      is_non_stock?: boolean | null;
      /** Nonprofit Type */
      nonprofit_type?: string | null;
      /** Incorporation Region Id */
      incorporation_region_id?: number | null;
      /** Account Id */
      account_id?: number | null;
      /** Platform Id */
      platform_id?: number | null;
      /** Business Purpose */
      business_purpose?: string | null;
      /** Peo Provider Id */
      peo_provider_id?: number | null;
      subscription_plan: components['schemas']['SubscriptionPlanEnum'];
      /** Hubspot Company Id */
      hubspot_company_id?: string | null;
      /**
       * Is Handbook Enabled
       * @default false
       */
      is_handbook_enabled: boolean;
      /** Is Subscribed */
      is_subscribed: boolean;
      /** Is Test Account */
      is_test_account: boolean;
      /**
       * Create Empty Form
       * @default false
       */
      create_empty_form: boolean;
    };
    /** AdminCreateOrUpdatePlatformAndConfiguration */
    AdminCreateOrUpdatePlatformAndConfiguration: {
      /** Name */
      name: string;
      /** Managed Provider Override Slug */
      managed_provider_override_slug?: string | null;
      /** Is Payroll Setup Mandatory */
      is_payroll_setup_mandatory: boolean;
      /** Notification Category */
      notification_category: string;
      /** Branding Category */
      branding_category?: string | null;
      /** Exclude Requirement Categories */
      exclude_requirement_categories?: string[] | null;
      /** Exclude Requirement Tags */
      exclude_requirement_tags?: string[] | null;
    };
    /** AdminCreatePlatformResolution */
    AdminCreatePlatformResolution: {
      /** Platform Id */
      platform_id: number;
      /** Requirement Id */
      requirement_id: number;
      /** Url */
      url: string;
    };
    /** AdminCriteriaMeta */
    AdminCriteriaMeta: {
      /** Id */
      id: number;
      /** Region Id */
      region_id?: number | null;
      /** Entity Type Id */
      entity_type_id?: number | null;
      /** Entity Type */
      entity_type?: string | null;
      /** Tax Class Id */
      tax_class_id?: number | null;
      /** Tax Class */
      tax_class?: string | null;
      /** Single Requirement Id */
      single_requirement_id?: number | null;
      criteria_type: components['schemas']['CriteriaType'];
      /** Title */
      title?: string | null;
      /** Description */
      description: string;
      /** Summary */
      summary?: string | null;
    };
    /** AdminCriteriaMetaCreate */
    AdminCriteriaMetaCreate: {
      /**
       * Id
       * @default -1
       */
      id: number;
      /** Region Id */
      region_id?: number | null;
      /** Entity Type Id */
      entity_type_id?: number | null;
      /** Tax Class Id */
      tax_class_id?: number | null;
      criteria_type: components['schemas']['CriteriaType'];
      /** Title */
      title?: string | null;
      /** Description */
      description: string;
      /** Summary */
      summary: string;
    };
    /** AdminCriteriaMetaUpdate */
    AdminCriteriaMetaUpdate: {
      /** Id */
      id: number;
      /** Region Id */
      region_id?: number | null;
      /** Entity Type Id */
      entity_type_id?: number | null;
      /** Tax Class Id */
      tax_class_id?: number | null;
      criteria_type: components['schemas']['CriteriaType'];
      /** Title */
      title?: string | null;
      /** Description */
      description: string;
      /** Summary */
      summary: string;
    };
    /** AdminCriteriaScope */
    'AdminCriteriaScope-Input': {
      type: components['schemas']['CriteriaType'];
      location_scope: components['schemas']['LocationScope'];
      /** Location Name */
      location_name?: string | null;
      /** City Region */
      city_region?: string | null;
      /** City Name */
      city_name?: string | null;
      zip_code_group?: components['schemas']['AdminZipCodeGroup'] | null;
      /** Region Id */
      region_id?: number | null;
      attribute?: components['schemas']['AdminBaseAttribute-Input'] | null;
      /** Single Requirement Id */
      single_requirement_id?: number | null;
    };
    /** AdminCriteriaScope */
    'AdminCriteriaScope-Output': {
      type: components['schemas']['CriteriaType'];
      location_scope: components['schemas']['LocationScope'];
      /** Location Name */
      location_name?: string | null;
      /** City Region */
      city_region?: string | null;
      /** City Name */
      city_name?: string | null;
      zip_code_group?: components['schemas']['AdminZipCodeGroup'] | null;
      /** Region Id */
      region_id?: number | null;
      attribute?: components['schemas']['AdminBaseAttribute-Output'] | null;
      /** Single Requirement Id */
      single_requirement_id?: number | null;
    };
    /** AdminCriteriaType */
    AdminCriteriaType: {
      /** Id */
      id: string;
      /** Name */
      name: string;
    };
    /** AdminDatumCreate */
    AdminDatumCreate: {
      /** Legal Entity Id */
      legal_entity_id: number;
      /** Attribute Id */
      attribute_id: number;
      /** Value */
      value: string;
      /** Region Id */
      region_id?: number | null;
    };
    /** AdminDatumUpdate */
    AdminDatumUpdate: {
      /** Value */
      value: string;
    };
    /** AdminEmailRoomMail */
    AdminEmailRoomMail: {
      /** Id */
      id: number;
      /** Subject */
      subject: string;
      /** Legal Entity Id */
      legal_entity_id: number;
      /**
       * Received At
       * Format: date-time
       */
      received_at: string;
      source: components['schemas']['MailSource'];
      status: components['schemas']['MailroomEmailStatus'];
      /** Region Id */
      region_id?: number | null;
      /** Processed File Id */
      processed_file_id?: number | null;
      /** Agency Id */
      agency_id?: number | null;
      /** File Id */
      file_id?: number | null;
      /** Recipient */
      recipient: string;
      data: components['schemas']['EmailPieceMetadata'];
    };
    /** AdminEmailRoomMailList */
    AdminEmailRoomMailList: {
      /** Id */
      id: number;
      /** Subject */
      subject: string;
      /** Legal Entity Id */
      legal_entity_id: number;
      /**
       * Received At
       * Format: date-time
       */
      received_at: string;
      source: components['schemas']['MailSource'];
      status: components['schemas']['MailroomEmailStatus'];
      /** Region Id */
      region_id?: number | null;
      /** Processed File Id */
      processed_file_id?: number | null;
      /** Agency Id */
      agency_id?: number | null;
      /** File Id */
      file_id?: number | null;
    };
    /** AdminEmailRoomMailUpdate */
    AdminEmailRoomMailUpdate: {
      /** Id */
      id: number;
      /** Subject */
      subject: string;
      source: components['schemas']['MailSource'];
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      status: AdminEmailRoomMailUpdateStatus;
      /** Legal Entity Id */
      legal_entity_id: number;
      /** Agency Id */
      agency_id?: number | null;
      /** Processed File Id */
      processed_file_id: number;
      /** File Id */
      file_id: number;
    };
    /** AdminEmailroomBulkStatusUpdate */
    AdminEmailroomBulkStatusUpdate: {
      /** Ids */
      ids: number[];
      /**
       * Status
       * @enum {string}
       */
      status: AdminEmailroomBulkStatusUpdateStatus;
    };
    /** AdminEmailroomMailDeliver */
    AdminEmailroomMailDeliver: {
      /** Id */
      id: number;
      /** Subject */
      subject: string;
      source: components['schemas']['MailSource'];
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      status: AdminEmailroomMailDeliverStatus;
      /** Legal Entity Id */
      legal_entity_id: number;
      /** Agency Id */
      agency_id: number;
      /** Processed File Id */
      processed_file_id: number;
      /** File Id */
      file_id: number;
      /**
       * Deliver Silently
       * @default false
       */
      deliver_silently: boolean;
      /** Deliver File Id */
      deliver_file_id: number;
    };
    /** AdminFile */
    AdminFile: {
      /** Id */
      id: number;
      /** File Key */
      file_key: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      /** Download Url */
      download_url?: string | null;
    };
    /** AdminForm */
    AdminForm: {
      /** Id */
      id: string;
      /** Title */
      title: string | null;
      /** Region Id */
      region_id: number | null;
      /** Tag Id */
      tag_id: number | null;
    };
    /** AdminFormAttribute */
    AdminFormAttribute: {
      /** Id */
      id: string;
      /** Form Id */
      form_id: string;
      /** Display Name */
      display_name: string;
      /** Is Required */
      is_required: boolean;
      /** Send In Legalinc Notes */
      send_in_legalinc_notes: boolean;
      /** Attribute Id */
      attribute_id: number;
      /** Description Override */
      description_override: string | null;
      /** Default Value Override */
      default_value_override: string | null;
      /** Order */
      order: number;
      /** Required Sub Field Attribute Ids */
      required_sub_field_attribute_ids: number[];
      /** Additional Sub Field Form Attribute Ids */
      additional_sub_field_form_attribute_ids: string[];
      /** Dependencies */
      dependencies: components['schemas']['AdminFormAttributeDependency'][];
    };
    /** AdminFormAttributeDependency */
    AdminFormAttributeDependency: {
      /** Form Attribute Id */
      form_attribute_id: string;
      operator: components['schemas']['DependencyOperator'];
      /** Value */
      value: string | null;
    };
    /** AdminHandbookRef */
    AdminHandbookRef: {
      /** Id */
      id: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      /** Published At */
      published_at?: string | null;
    };
    /** AdminHandbookStats */
    AdminHandbookStats: {
      /** Num Customers */
      num_customers: number;
      /** Num Handbook Enabled */
      num_handbook_enabled: number;
      /** Num Draft Created */
      num_draft_created: number;
      /** Num Published */
      num_published: number;
      /** Num Handbook Users */
      num_handbook_users: number;
    };
    /** AdminLegalEntityAccountLogin */
    AdminLegalEntityAccountLogin: {
      /** Id */
      id: number;
      /** Legal Entity Id */
      legal_entity_id: number;
      /** Account Login Id */
      account_login_id: number;
      /** One Password Id */
      one_password_id: string;
      /** Is Active */
      is_active: boolean;
      /** Region Id */
      region_id: number;
      /** Working As Of */
      working_as_of?: string | null;
    };
    /** AdminLegalEntityAccountLoginCreate */
    AdminLegalEntityAccountLoginCreate: {
      /** Legal Entity Id */
      legal_entity_id: number;
      /** Account Login Id */
      account_login_id: string;
      /** One Password Id */
      one_password_id: string;
      /** Is Active */
      is_active: boolean;
    };
    /** AdminLegalEntityAccountLoginUpdate */
    AdminLegalEntityAccountLoginUpdate: {
      /** One Password Id */
      one_password_id: string;
      /** Is Active */
      is_active: boolean;
    };
    /** AdminLegalEntityDocumentEmailData */
    AdminLegalEntityDocumentEmailData: {
      /** Subject */
      subject: string;
      /** Body */
      body: string;
    };
    /** AdminLegalEntityDocumentType */
    AdminLegalEntityDocumentType: {
      /** Id */
      id?: number | null;
      /** Name */
      name: string;
    };
    /** AdminLegalEntityIntegrationEmail */
    AdminLegalEntityIntegrationEmail: {
      /** Id */
      id: number;
      /** Email Address */
      email_address: string;
      /** Legal Entity Id */
      legal_entity_id: number;
      /**
       * Is Default
       * @default false
       */
      is_default: boolean;
    };
    /** AdminLegalEntityIntegrationEmailCreate */
    AdminLegalEntityIntegrationEmailCreate: {
      /** Email Address */
      email_address: string;
      /** Legal Entity Id */
      legal_entity_id: number;
      /**
       * Is Default
       * @default false
       */
      is_default: boolean;
    };
    /** AdminLegalEntityPerson */
    AdminLegalEntityPerson: {
      /** Id */
      id: number;
      /** Public Id */
      public_id: string;
      /** Legal Entity Id */
      legal_entity_id: number;
      /** Personal Address Id */
      personal_address_id: number;
      /** First Name */
      first_name: string;
      /** Last Name */
      last_name: string;
      /** Email */
      email: string;
      /** Title */
      title: string;
      /** Phone Number */
      phone_number: string;
      /** Birth Date */
      birth_date?: string | null;
      /** Start Date */
      start_date?: string | null;
      /** Ownership Start Date */
      ownership_start_date?: string | null;
      /** Ownership Percentage */
      ownership_percentage?: number | null;
      /** Owner License Number */
      owner_license_number?: string | null;
      /** Percent Profit Distribution */
      percent_profit_distribution?: number | null;
      /** Is Married */
      is_married?: boolean | null;
      /** Spouse First Name */
      spouse_first_name?: string | null;
      /** Spouse Last Name */
      spouse_last_name?: string | null;
      /** Is Officer */
      is_officer: boolean;
      /** Is Owner */
      is_owner: boolean;
      /** Is Llc Member */
      is_llc_member: boolean;
      /** Is Llc Manager */
      is_llc_manager: boolean;
      /** Is Nonprofit Member */
      is_nonprofit_member: boolean;
      /** Is Nonprofit Trustee */
      is_nonprofit_trustee: boolean;
      /** Is Director */
      is_director: boolean;
      /** Is Partner */
      is_partner: boolean;
      /** Is Active */
      is_active: boolean;
      /**
       * Person Types
       * @default []
       */
      person_types: components['schemas']['PersonType'][] | null;
    };
    /** AdminLegalEntityRef */
    AdminLegalEntityRef: {
      /** Id */
      id: number;
      /** Name */
      name: string;
    };
    /** AdminLegalEntityRegionResponse */
    AdminLegalEntityRegionResponse: {
      /** Id */
      id: number;
      /** Legal Entity Id */
      legal_entity_id: number;
      /** Region Id */
      region_id: number;
      /** Status */
      status: string;
      /** Is Setup Complete */
      is_setup_complete: boolean;
    };
    /** AdminLegalEntityUserRequest */
    AdminLegalEntityUserRequest: {
      /** Legal Entity Id */
      legal_entity_id: number;
      /** User Id */
      user_id: number;
      /** Is Active */
      is_active: boolean;
    };
    /** AdminLegalIncDocument */
    AdminLegalIncDocument: {
      /** Id */
      id: number;
      /** Type */
      type: string;
      /** File Name */
      file_name: string;
      /** Download Url */
      download_url: string;
    };
    /** AdminLegalIncDocuments */
    AdminLegalIncDocuments: {
      /** Legal Entity Document Id */
      legal_entity_document_id: number;
      /** Legal Entity Document Name */
      legal_entity_document_name: string;
      /** Order Id */
      order_id: number;
      /**
       * Documents
       * @default []
       */
      documents: components['schemas']['AdminLegalIncDocument'][];
      /**
       * Eligible Documents
       * @default []
       */
      eligible_documents: components['schemas']['AdminLegalIncDocument'][];
    };
    /** AdminLegalincCompanyId */
    AdminLegalincCompanyId: {
      /** Company Id */
      company_id: number;
    };
    /** AdminListWorkflowInstance */
    AdminListWorkflowInstance: {
      /** Id */
      id: number;
      /** Legal Entity Id */
      legal_entity_id: number;
      /** Workflow Id */
      workflow_id: number;
      /** Region Id */
      region_id: number;
      /** Assigned User Id */
      assigned_user_id?: number | null;
      /** Current Step Name */
      current_step_name?: string | null;
      status: components['schemas']['WorkflowInstanceStatus'];
      /** Status Note */
      status_note?: string | null;
      /** Reminder Expiration Timestamp */
      reminder_expiration_timestamp?: number | null;
      /** Reminder Description */
      reminder_description?: string | null;
      /**
       * Created Date
       * Format: date-time
       */
      created_date: string;
      /** Updated Date */
      updated_date?: string | null;
      /** Submitted At */
      submitted_at?: string | null;
      /** Sla Met */
      sla_met?: boolean | null;
      /** External Estimated Min Date */
      external_estimated_min_date?: string | null;
      /** External Estimated Max Date */
      external_estimated_max_date?: string | null;
      /** Internal Estimated Date */
      internal_estimated_date?: string | null;
      /** Filing Year */
      filing_year?: number | null;
    };
    /** AdminLogin */
    AdminLogin: {
      /** Id */
      id: string;
      /** Title */
      title: string;
      /** Username */
      username: string;
      /** Password */
      password: string;
      /** Tags */
      tags: string[];
      /**
       * Security Question Entries
       * @default []
       */
      security_question_entries: components['schemas']['SecurityQuestionEntry'][];
    };
    /** AdminNewAttribute */
    AdminNewAttribute: {
      /**
       * Id
       * @default -1
       */
      id: number;
      /** Public Id */
      public_id: string;
      /** Region Id */
      region_id?: number | null;
      /** Name */
      name: string;
      /** Description */
      description?: string | null;
      description_link?: components['schemas']['DescriptionLink'] | null;
      /** Is Required */
      is_required: boolean;
      /** Source */
      source:
        | components['schemas']['DatumAttribute']
        | components['schemas']['ModelAttribute']
        | components['schemas']['CriteriaDatumAttribute'];
      /** Type */
      type:
        | components['schemas']['AddressAttribute']
        | components['schemas']['NonUsAddressAttribute']
        | components['schemas']['CountrySelectAttribute']
        | components['schemas']['TextAttribute']
        | components['schemas']['BooleanAttribute']
        | components['schemas']['NumberAttribute']
        | components['schemas']['DateAttribute']
        | components['schemas']['TextAreaAttribute']
        | components['schemas']['FranchiseTaxEstimateAttribute']
        | components['schemas']['RadioAttribute-Input']
        | components['schemas']['MultiSelectAttribute-Input']
        | components['schemas']['ArrayAttribute']
        | components['schemas']['SelectAttribute-Input'];
      /** Is Generic */
      is_generic: boolean;
      /**
       * Is Editable
       * @default false
       */
      is_editable: boolean;
      /** Reviewer Email */
      reviewer_email?: string | null;
      /** Pending Change Id */
      pending_change_id?: number | null;
    };
    /** AdminNotice */
    AdminNotice: {
      /** Id */
      id: number;
      /** Title */
      title: string;
      /** Region Id */
      region_id: number;
      /** File Id */
      file_id: number;
    };
    /** AdminNotification */
    AdminNotification: {
      /** Id */
      id: number;
      /** User Id */
      user_id: number;
      name: components['schemas']['NotificationName'];
      /** Data */
      data: {
        [key: string]: unknown;
      };
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
    };
    /** AdminPeoProvider */
    AdminPeoProvider: {
      /** Name */
      name: string;
    };
    /** AdminPlatformAndConfiguration */
    AdminPlatformAndConfiguration: {
      /** Id */
      id: number;
      /** Name */
      name: string;
      /** Public Id */
      public_id: string;
      /** Platform Configuration Id */
      platform_configuration_id?: number | null;
      /** Managed Provider Override Slug */
      managed_provider_override_slug?: string | null;
      /** Is Payroll Setup Mandatory */
      is_payroll_setup_mandatory?: boolean | null;
      /** Notification Category */
      notification_category?: string | null;
      /** Branding Category */
      branding_category?: string | null;
      /** Exclude Requirement Categories */
      exclude_requirement_categories?: string[] | null;
      /** Exclude Requirement Tags */
      exclude_requirement_tags?: string[] | null;
    };
    /** AdminPlatformRef */
    AdminPlatformRef: {
      /** Id */
      id: number;
      /** Name */
      name: string;
      /** Public Id */
      public_id: string;
    };
    /** AdminPlatformResolution */
    AdminPlatformResolution: {
      /** Id */
      id: number;
      /** Platform Id */
      platform_id: number;
      /** Requirement Id */
      requirement_id: number;
      /** Url */
      url: string;
    };
    /** AdminPolicy */
    AdminPolicy: {
      /** Pending Change Id */
      pending_change_id?: number | null;
      /** Title */
      title?: string | null;
      /** Policy Section Id */
      policy_section_id: string;
      /** Policy Category Id */
      policy_category_id?: string | null;
      policy_category?: components['schemas']['AdminPolicyCategory'] | null;
      policy_scope?: components['schemas']['AdminPolicyScope'] | null;
      /** Main Content */
      main_content: string;
      /** Full Details */
      full_details?: string | null;
      /**
       * Resources
       * @default []
       */
      resources: components['schemas']['PolicyResource'][];
      /** Order */
      order: number;
      /** Requirement Id */
      requirement_id?: number | null;
      /** Reviewer Email */
      reviewer_email?: string | null;
      /** Is Material Change */
      is_material_change?: boolean | null;
      /** Slug */
      slug: string;
      /** Id */
      id: string;
      /** Version */
      version: number;
      /** Last Material Change Version */
      last_material_change_version: number;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
    };
    /** AdminPolicyCategory */
    AdminPolicyCategory: {
      /** Id */
      id?: string | null;
      /** Name */
      name: string;
      /** Order */
      order: number;
      /** Policy Section Id */
      policy_section_id: string;
      /** Reviewer Email */
      reviewer_email?: string | null;
    };
    /** AdminPolicyCategoryCreate */
    AdminPolicyCategoryCreate: {
      /** Name */
      name: string;
      /** Policy Section Id */
      policy_section_id: string;
      /** Order */
      order: number;
      /** Reviewer Email */
      reviewer_email?: string | null;
      /** Id */
      id: string;
    };
    /** AdminPolicyCategoryUpdate */
    AdminPolicyCategoryUpdate: {
      /** Name */
      name: string;
      /** Policy Section Id */
      policy_section_id: string;
      /** Order */
      order: number;
      /** Reviewer Email */
      reviewer_email?: string | null;
    };
    /** AdminPolicyCreate */
    AdminPolicyCreate: {
      /** Pending Change Id */
      pending_change_id?: number | null;
      /** Title */
      title?: string | null;
      /** Policy Section Id */
      policy_section_id: string;
      /** Policy Category Id */
      policy_category_id?: string | null;
      policy_category?: components['schemas']['AdminPolicyCategory'] | null;
      policy_scope?: components['schemas']['AdminPolicyScope'] | null;
      /** Main Content */
      main_content: string;
      /** Full Details */
      full_details?: string | null;
      /**
       * Resources
       * @default []
       */
      resources: components['schemas']['PolicyResource'][];
      /** Order */
      order: number;
      /** Requirement Id */
      requirement_id?: number | null;
      /** Reviewer Email */
      reviewer_email?: string | null;
      /** Is Material Change */
      is_material_change?: boolean | null;
      /** Slug */
      slug: string;
    };
    /** AdminPolicyScope */
    AdminPolicyScope: {
      /** City Name */
      city_name?: string | null;
      /** Region Id */
      region_id?: number | null;
      region?: components['schemas']['AdminRegionRef'] | null;
      /** Id */
      id?: number | null;
      /** Zip Code Group Id */
      zip_code_group_id?: number | null;
    };
    /** AdminPolicySection */
    AdminPolicySection: {
      /** Id */
      id: string;
      /** Title */
      title: string;
      /** Description */
      description?: string | null;
      /** Order */
      order: number;
      /** Icon */
      icon: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
    };
    /** AdminPolicySectionCreate */
    AdminPolicySectionCreate: {
      /** Id */
      id: string;
      /** Title */
      title: string;
      /** Description */
      description?: string | null;
      /** Order */
      order: number;
      /** Icon */
      icon: string;
      /** Reviewer Email */
      reviewer_email?: string | null;
    };
    /** AdminPolicySectionUpdate */
    AdminPolicySectionUpdate: {
      /** Title */
      title: string;
      /** Description */
      description?: string | null;
      /** Order */
      order: number;
      /** Icon */
      icon: string;
      /** Reviewer Email */
      reviewer_email?: string | null;
    };
    /** AdminPolicyUpdate */
    AdminPolicyUpdate: {
      /** Pending Change Id */
      pending_change_id?: number | null;
      /** Title */
      title?: string | null;
      /** Policy Section Id */
      policy_section_id: string;
      /** Policy Category Id */
      policy_category_id?: string | null;
      policy_category?: components['schemas']['AdminPolicyCategory'] | null;
      policy_scope?: components['schemas']['AdminPolicyScope'] | null;
      /** Main Content */
      main_content: string;
      /** Full Details */
      full_details?: string | null;
      /**
       * Resources
       * @default []
       */
      resources: components['schemas']['PolicyResource'][];
      /** Order */
      order: number;
      /** Requirement Id */
      requirement_id?: number | null;
      /** Reviewer Email */
      reviewer_email?: string | null;
      /** Is Material Change */
      is_material_change?: boolean | null;
    };
    /** AdminQuestionTask */
    'AdminQuestionTask-Input': {
      /** Id */
      id: number;
      /** Legal Entity Id */
      legal_entity_id: number;
      scope?: components['schemas']['AdminCriteriaScope-Input'] | null;
      /** Is Setup Related */
      is_setup_related: boolean;
      /**
       * Needs Force Overwrite
       * @default false
       */
      needs_force_overwrite: boolean;
      /**
       * Force Overwrite
       * @default false
       */
      force_overwrite: boolean;
      /** Answer */
      answer: string | null;
      /** Region Ids */
      region_ids: number[];
    };
    /** AdminQuestionTask */
    'AdminQuestionTask-Output': {
      /** Id */
      id: number;
      /** Legal Entity Id */
      legal_entity_id: number;
      scope?: components['schemas']['AdminCriteriaScope-Output'] | null;
      /** Is Setup Related */
      is_setup_related: boolean;
      /**
       * Needs Force Overwrite
       * @default false
       */
      needs_force_overwrite: boolean;
      /**
       * Force Overwrite
       * @default false
       */
      force_overwrite: boolean;
      /** Answer */
      answer: string | null;
      /** Region Ids */
      region_ids: number[];
    };
    /** AdminReferralSourceCreate */
    AdminReferralSourceCreate: {
      /** Description */
      description: string;
      /** Partner Display Name */
      partner_display_name?: string | null;
      /** Discount Percent */
      discount_percent?: number | null;
      /** Is Active */
      is_active: boolean;
      /** Stripe Coupon Id */
      stripe_coupon_id?: number | null;
      /** Should Show Free Plan */
      should_show_free_plan: boolean;
      /** Should Show Basic Plan */
      should_show_basic_plan: boolean;
    };
    /** AdminReferralSourceUpdate */
    AdminReferralSourceUpdate: {
      /** Description */
      description: string;
      /** Partner Display Name */
      partner_display_name?: string | null;
      /** Discount Percent */
      discount_percent?: number | null;
      /** Is Active */
      is_active: boolean;
      /** Stripe Coupon Id */
      stripe_coupon_id?: number | null;
      /** Should Show Free Plan */
      should_show_free_plan: boolean;
      /** Should Show Basic Plan */
      should_show_basic_plan: boolean;
    };
    /** AdminRegionRef */
    AdminRegionRef: {
      /** Id */
      id: number;
      /** Code */
      code: string;
      /** Name */
      name: string;
    };
    /** AdminRegisteredAgent */
    AdminRegisteredAgent: {
      /** Id */
      id: number;
      /** Legal Entity Id */
      legal_entity_id: number;
      /** Legal Entity Region Id */
      legal_entity_region_id: number;
      /** Status */
      status: string;
      /** Legalinc Company Ids */
      legalinc_company_ids: components['schemas']['AdminLegalincCompanyId'][];
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
    };
    /** AdminRemediation */
    AdminRemediation: {
      /** Data Id */
      data_id?: string | null;
      /** Title */
      title: string;
      /** Description */
      description: string;
      /** Optional */
      optional: boolean;
      /** Order */
      order: number;
      /** Display */
      display: (
        | components['schemas']['DefaultDisplay']
        | components['schemas']['EmailDisplay']
        | components['schemas']['FaxDisplay']
        | components['schemas']['LinkDisplay']
        | components['schemas']['MailDisplay']
        | components['schemas']['PhoneDisplay']
      )[];
    };
    /** AdminRequirement */
    AdminRequirement: {
      /** Pending Change Id */
      pending_change_id?: number | null;
      /** Id */
      id: number;
      /** Requirement Id */
      requirement_id: number;
      /** Data Id */
      data_id: string;
      /** Title */
      title: string;
      category: components['schemas']['RequirementCategory'];
      /** Region Id */
      region_id: number;
      /** Entity Type Ids */
      entity_type_ids: number[];
      /** Tax Class Ids */
      tax_class_ids: number[];
      /** Tag Ids */
      tag_ids: number[];
      /** Remediations */
      remediations: components['schemas']['AdminRemediation'][];
      /** Schedule */
      schedule:
        | components['schemas']['ScheduleOneTime']
        | components['schemas']['ScheduleMultiYear']
        | components['schemas']['ScheduleNonReporting']
        | components['schemas']['ScheduleReporting']
        | components['schemas']['ScheduleReportingMulti-Output']
        | components['schemas']['ScheduleEmployeeHiring']
        | components['schemas']['ScheduleEmployeeTermination'];
      /** Is Automatable */
      is_automatable: boolean;
      /** Domestic Fee */
      domestic_fee?:
        | (
            | components['schemas']['FeeFixed']
            | components['schemas']['FeeRange']
            | components['schemas']['FeeVariable']
          )
        | null;
      /** Foreign Fee */
      foreign_fee?:
        | (
            | components['schemas']['FeeFixed']
            | components['schemas']['FeeRange']
            | components['schemas']['FeeVariable']
          )
        | null;
      /**
       * Criteria
       * @default []
       */
      criteria: (
        | components['schemas']['EmployeeCountCriteria']
        | components['schemas']['EmployeeCountPreviousYearCriteria']
        | components['schemas']['HasNonExemptEmployeesCriteria']
        | components['schemas']['PayrollAmountCriteria']
        | components['schemas']['HasEmployeesCriteria']
        | components['schemas']['DoingBusinessCriteria']
        | components['schemas']['SalesTaxNexusCriteria']
        | components['schemas']['BusinessIncomeTaxNexusCriteria']
        | components['schemas']['EstimatedTaxLiabilityCriteria']
        | components['schemas']['SingleRequirementCriteria']
        | components['schemas']['CharitableRegistrationNexusCriteria']
        | components['schemas']['PartnerNexusCriteria']
        | components['schemas']['ForeignQualificationCriteria']
        | components['schemas']['DateAttributeCriteria']
      )[];
      /** Summary */
      summary?: string | null;
      /** Description */
      description?: string | null;
      /** External Eta */
      external_eta?:
        | (
            | components['schemas']['ETARange']
            | components['schemas']['ETAFixed']
          )
        | null;
      /** Internal Eta */
      internal_eta?:
        | (
            | components['schemas']['ETARange']
            | components['schemas']['ETAFixed']
          )
        | null;
      /** Frequency Note */
      frequency_note?: string | null;
      /** Tax Rate Note */
      tax_rate_note?: string | null;
      /** General Notes */
      general_notes?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /** Retired On */
      retired_on?: string | null;
      /** Active As Of */
      active_as_of?: string | null;
      /** Produces Attributes */
      produces_attributes?: string[] | null;
      /** Consumes Attributes */
      consumes_attributes?: string[] | null;
      /** Trigger Attributes */
      trigger_attributes?: string[] | null;
      /** Guard Attributes */
      guard_attributes?: string[] | null;
      /** Pending Change Object Ids */
      pending_change_object_ids?: string[] | null;
      /** Resources */
      resources?: components['schemas']['AdminResourceLink'][] | null;
      /** Policy Id */
      policy_id?: string | null;
      /** Wizard Ids */
      wizard_ids?: string[] | null;
    };
    /** AdminRequirementCreate */
    'AdminRequirementCreate-Input': {
      /** Pending Change Id */
      pending_change_id?: number | null;
      /**
       * Id
       * @default -1
       */
      id: number;
      /**
       * Requirement Id
       * @default -1
       */
      requirement_id: number;
      /** Title */
      title: string;
      /** Data Id */
      data_id?: string;
      category: components['schemas']['RequirementCategory'];
      /** Description */
      description: string;
      /**
       * Entity Type Ids
       * @default []
       */
      entity_type_ids: number[];
      /**
       * Entity Types
       * @default []
       */
      entity_types: string[];
      /**
       * Tax Class Ids
       * @default []
       */
      tax_class_ids: number[];
      /**
       * Tax Classes
       * @default []
       */
      tax_classes: string[];
      /** Region Id */
      region_id: number;
      /** Region */
      region?: string | null;
      /** Active As Of */
      active_as_of?: string | null;
      /** Retired On */
      retired_on?: string | null;
      /** Resources */
      resources?: components['schemas']['AdminResourceLink'][] | null;
      /** Is Automatable */
      is_automatable?: boolean | null;
      /** Guard Attributes */
      guard_attributes?: string[] | null;
      /** Trigger Attributes */
      trigger_attributes?: string[] | null;
      /** Produces Attributes */
      produces_attributes?: string[] | null;
      /** Consumes Attributes */
      consumes_attributes?: string[] | null;
      /** Schedule */
      schedule:
        | components['schemas']['ScheduleOneTime']
        | components['schemas']['ScheduleMultiYear']
        | components['schemas']['ScheduleNonReporting']
        | components['schemas']['ScheduleReporting']
        | components['schemas']['ScheduleReportingMulti-Input']
        | components['schemas']['ScheduleEmployeeHiring']
        | components['schemas']['ScheduleEmployeeTermination'];
      /** Domestic Fee */
      domestic_fee?:
        | (
            | components['schemas']['FeeFixed']
            | components['schemas']['FeeRange']
            | components['schemas']['FeeVariable']
          )
        | null;
      /** Foreign Fee */
      foreign_fee?:
        | (
            | components['schemas']['FeeFixed']
            | components['schemas']['FeeRange']
            | components['schemas']['FeeVariable']
          )
        | null;
      /** External Eta */
      external_eta?:
        | (
            | components['schemas']['ETARange']
            | components['schemas']['ETAFixed']
          )
        | null;
      /** Internal Eta */
      internal_eta?:
        | (
            | components['schemas']['ETARange']
            | components['schemas']['ETAFixed']
          )
        | null;
      /** Remediations */
      remediations: components['schemas']['AdminRemediation'][];
      /**
       * Tag Ids
       * @default []
       */
      tag_ids: number[];
      /**
       * Tag Names
       * @default []
       */
      tag_names: string[];
      /**
       * Criteria
       * @default []
       */
      criteria: (
        | components['schemas']['EmployeeCountCriteria']
        | components['schemas']['EmployeeCountPreviousYearCriteria']
        | components['schemas']['HasNonExemptEmployeesCriteria']
        | components['schemas']['PayrollAmountCriteria']
        | components['schemas']['HasEmployeesCriteria']
        | components['schemas']['DoingBusinessCriteria']
        | components['schemas']['SalesTaxNexusCriteria']
        | components['schemas']['BusinessIncomeTaxNexusCriteria']
        | components['schemas']['EstimatedTaxLiabilityCriteria']
        | components['schemas']['SingleRequirementCriteria']
        | components['schemas']['CharitableRegistrationNexusCriteria']
        | components['schemas']['PartnerNexusCriteria']
        | components['schemas']['ForeignQualificationCriteria']
        | components['schemas']['DateAttributeCriteria']
      )[];
      /** Summary */
      summary?: string | null;
      /** Frequency Note */
      frequency_note?: string | null;
      /** Tax Rate Note */
      tax_rate_note?: string | null;
      /** General Notes */
      general_notes?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /** Reviewer Email */
      reviewer_email?: string | null;
      /** Policy Id */
      policy_id?: string | null;
    };
    /** AdminRequirementCreate */
    'AdminRequirementCreate-Output': {
      /** Pending Change Id */
      pending_change_id?: number | null;
      /**
       * Id
       * @default -1
       */
      id: number;
      /**
       * Requirement Id
       * @default -1
       */
      requirement_id: number;
      /** Title */
      title: string;
      /** Data Id */
      data_id?: string;
      category: components['schemas']['RequirementCategory'];
      /** Description */
      description: string;
      /**
       * Entity Type Ids
       * @default []
       */
      entity_type_ids: number[];
      /**
       * Entity Types
       * @default []
       */
      entity_types: string[];
      /**
       * Tax Class Ids
       * @default []
       */
      tax_class_ids: number[];
      /**
       * Tax Classes
       * @default []
       */
      tax_classes: string[];
      /** Region Id */
      region_id: number;
      /** Region */
      region?: string | null;
      /** Active As Of */
      active_as_of?: string | null;
      /** Retired On */
      retired_on?: string | null;
      /** Resources */
      resources?: components['schemas']['AdminResourceLink'][] | null;
      /** Is Automatable */
      is_automatable?: boolean | null;
      /** Guard Attributes */
      guard_attributes?: string[] | null;
      /** Trigger Attributes */
      trigger_attributes?: string[] | null;
      /** Produces Attributes */
      produces_attributes?: string[] | null;
      /** Consumes Attributes */
      consumes_attributes?: string[] | null;
      /** Schedule */
      schedule:
        | components['schemas']['ScheduleOneTime']
        | components['schemas']['ScheduleMultiYear']
        | components['schemas']['ScheduleNonReporting']
        | components['schemas']['ScheduleReporting']
        | components['schemas']['ScheduleReportingMulti-Output']
        | components['schemas']['ScheduleEmployeeHiring']
        | components['schemas']['ScheduleEmployeeTermination'];
      /** Domestic Fee */
      domestic_fee?:
        | (
            | components['schemas']['FeeFixed']
            | components['schemas']['FeeRange']
            | components['schemas']['FeeVariable']
          )
        | null;
      /** Foreign Fee */
      foreign_fee?:
        | (
            | components['schemas']['FeeFixed']
            | components['schemas']['FeeRange']
            | components['schemas']['FeeVariable']
          )
        | null;
      /** External Eta */
      external_eta?:
        | (
            | components['schemas']['ETARange']
            | components['schemas']['ETAFixed']
          )
        | null;
      /** Internal Eta */
      internal_eta?:
        | (
            | components['schemas']['ETARange']
            | components['schemas']['ETAFixed']
          )
        | null;
      /** Remediations */
      remediations: components['schemas']['AdminRemediation'][];
      /**
       * Tag Ids
       * @default []
       */
      tag_ids: number[];
      /**
       * Tag Names
       * @default []
       */
      tag_names: string[];
      /**
       * Criteria
       * @default []
       */
      criteria: (
        | components['schemas']['EmployeeCountCriteria']
        | components['schemas']['EmployeeCountPreviousYearCriteria']
        | components['schemas']['HasNonExemptEmployeesCriteria']
        | components['schemas']['PayrollAmountCriteria']
        | components['schemas']['HasEmployeesCriteria']
        | components['schemas']['DoingBusinessCriteria']
        | components['schemas']['SalesTaxNexusCriteria']
        | components['schemas']['BusinessIncomeTaxNexusCriteria']
        | components['schemas']['EstimatedTaxLiabilityCriteria']
        | components['schemas']['SingleRequirementCriteria']
        | components['schemas']['CharitableRegistrationNexusCriteria']
        | components['schemas']['PartnerNexusCriteria']
        | components['schemas']['ForeignQualificationCriteria']
        | components['schemas']['DateAttributeCriteria']
      )[];
      /** Summary */
      summary?: string | null;
      /** Frequency Note */
      frequency_note?: string | null;
      /** Tax Rate Note */
      tax_rate_note?: string | null;
      /** General Notes */
      general_notes?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /** Reviewer Email */
      reviewer_email?: string | null;
      /** Policy Id */
      policy_id?: string | null;
    };
    /** AdminRequirementRef */
    AdminRequirementRef: {
      /** Id */
      id: string;
      /** Requirement Id */
      requirement_id: number;
      /** Title */
      title: string;
    };
    /** AdminRequirementResponse */
    AdminRequirementResponse: {
      /** Id */
      id: number;
      /** Pending Change Object Ids */
      pending_change_object_ids?: string[] | null;
    };
    /** AdminRequirementSummaryTemplate */
    AdminRequirementSummaryTemplate: {
      /** Id */
      id: number;
      /** Public Id */
      public_id: string;
      /** Name */
      name: string;
      /** Text */
      text: string;
    };
    /** AdminRequirementSummaryTemplateCreate */
    AdminRequirementSummaryTemplateCreate: {
      /** Id */
      id?: string | null;
      /** Name */
      name: string;
      /** Text */
      text: string;
      /** Pending Change Id */
      pending_change_id?: number | null;
    };
    /** AdminRequirementUpdate */
    AdminRequirementUpdate: {
      /** Pending Change Id */
      pending_change_id?: number | null;
      /** Title */
      title: string;
      /** Description */
      description: string;
      category: components['schemas']['RequirementCategory'];
      /** Summary Template Id */
      summary_template_id?: number | null;
      /** Summary */
      summary?: string | null;
      /**
       * Entity Type Ids
       * @default []
       */
      entity_type_ids: number[];
      /**
       * Tax Class Ids
       * @default []
       */
      tax_class_ids: number[];
      /** Is Automatable */
      is_automatable: boolean;
      /** Active As Of */
      active_as_of?: string | null;
      /** Retired On */
      retired_on?: string | null;
      /** Resources */
      resources?: components['schemas']['AdminResourceLink'][] | null;
      /** Trigger Attributes */
      trigger_attributes?: string[] | null;
      /** Consumes Attributes */
      consumes_attributes?: string[] | null;
      /** Produces Attributes */
      produces_attributes?: string[] | null;
      /** Guard Attributes */
      guard_attributes?: string[] | null;
      /** Schedule */
      schedule:
        | components['schemas']['ScheduleOneTime']
        | components['schemas']['ScheduleMultiYear']
        | components['schemas']['ScheduleNonReporting']
        | components['schemas']['ScheduleReporting']
        | components['schemas']['ScheduleReportingMulti-Input']
        | components['schemas']['ScheduleEmployeeHiring']
        | components['schemas']['ScheduleEmployeeTermination'];
      /** Domestic Fee */
      domestic_fee?:
        | (
            | components['schemas']['FeeFixed']
            | components['schemas']['FeeRange']
            | components['schemas']['FeeVariable']
          )
        | null;
      /** Foreign Fee */
      foreign_fee?:
        | (
            | components['schemas']['FeeFixed']
            | components['schemas']['FeeRange']
            | components['schemas']['FeeVariable']
          )
        | null;
      /** External Eta */
      external_eta?:
        | (
            | components['schemas']['ETARange']
            | components['schemas']['ETAFixed']
          )
        | null;
      /** Internal Eta */
      internal_eta?:
        | (
            | components['schemas']['ETARange']
            | components['schemas']['ETAFixed']
          )
        | null;
      /** Remediations */
      remediations: components['schemas']['AdminRemediation'][];
      /**
       * Tag Ids
       * @default []
       */
      tag_ids: number[];
      /**
       * Criteria
       * @default []
       */
      criteria: (
        | components['schemas']['EmployeeCountCriteria']
        | components['schemas']['EmployeeCountPreviousYearCriteria']
        | components['schemas']['HasNonExemptEmployeesCriteria']
        | components['schemas']['PayrollAmountCriteria']
        | components['schemas']['HasEmployeesCriteria']
        | components['schemas']['DoingBusinessCriteria']
        | components['schemas']['SalesTaxNexusCriteria']
        | components['schemas']['BusinessIncomeTaxNexusCriteria']
        | components['schemas']['EstimatedTaxLiabilityCriteria']
        | components['schemas']['SingleRequirementCriteria']
        | components['schemas']['CharitableRegistrationNexusCriteria']
        | components['schemas']['PartnerNexusCriteria']
        | components['schemas']['ForeignQualificationCriteria']
        | components['schemas']['DateAttributeCriteria']
      )[];
      /** Reviewer Email */
      reviewer_email?: string | null;
      /** General Notes */
      general_notes?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /** Frequency Note */
      frequency_note?: string | null;
      /** Tax Rate Note */
      tax_rate_note?: string | null;
      /** Wizard Ids */
      wizard_ids?: string[] | null;
    };
    /** AdminResourceLink */
    AdminResourceLink: {
      /** Name */
      name: string;
      /**
       * Url
       * Format: uri
       */
      url: string;
      /**
       * Id
       * @default -1
       */
      id: number;
      /**
       * Order
       * @default 0
       */
      order: number;
    };
    /** AdminTag */
    AdminTag: {
      /** Id */
      id: number;
      /** Name */
      name: string;
    };
    /** AdminTagByName */
    AdminTagByName: {
      /** Id */
      id: string;
    };
    /** AdminTagCreate */
    AdminTagCreate: {
      /**
       * Id
       * @default -1
       */
      id: number;
      /** Name */
      name: string;
      /** Is Internal */
      is_internal: boolean;
    };
    /** AdminTask */
    AdminTask: {
      /** Id */
      id: number;
      /** Public Id */
      public_id: string;
      /** Legal Entity Id */
      legal_entity_id: number;
      /** Requirement Id */
      requirement_id: number;
      /** Managed Provider Id */
      managed_provider_id: number | null;
      /** Assigned User Id */
      assigned_user_id: number | null;
      status: components['schemas']['LegalEntityRequirementStatus'];
      /** Period Start Date */
      period_start_date: string | null;
      /** Created At */
      created_at: string;
      /** Period End Date */
      period_end_date: string | null;
      /** Due Date */
      due_date: string | null;
      /** Title */
      title: string;
      /** Schedule */
      schedule: string | null;
    };
    /** AdminTrainingWorkflowLegalEntity */
    AdminTrainingWorkflowLegalEntity: {
      /** Id */
      id: number;
      /** Workflow Id */
      workflow_id: number;
      /** Legal Entity Id */
      legal_entity_id: number;
    };
    /** AdminTrainingWorkflowLegalEntityCreate */
    AdminTrainingWorkflowLegalEntityCreate: {
      /** Workflow Id */
      workflow_id: number;
      /** Legal Entity Id */
      legal_entity_id: number;
    };
    /** AdminUpcomingLegislation */
    AdminUpcomingLegislation: {
      /** Id */
      id: number;
      /** Public Id */
      public_id: string;
      /** Title */
      title: string;
      /** Description */
      description: string;
      /** Region Id */
      region_id: number;
      /** Category */
      category: string;
      stage: components['schemas']['UpcomingLegislationStageEnum'];
      /** Effective Date */
      effective_date: string | null;
      /** Requirement Id */
      requirement_id: number | null;
      /** Alert Emails Sent */
      alert_emails_sent: boolean;
    };
    /** AdminUpdateApiKey */
    AdminUpdateApiKey: {
      /** Is Active */
      is_active: boolean;
    };
    /** AdminUpdateAttribute */
    AdminUpdateAttribute: {
      /**
       * Id
       * @default -1
       */
      id: number;
      /** Public Id */
      public_id: string;
      /** Region Id */
      region_id?: number | null;
      /** Name */
      name: string;
      /** Description */
      description?: string | null;
      description_link?: components['schemas']['DescriptionLink'] | null;
      /** Is Required */
      is_required: boolean;
      /** Source */
      source:
        | components['schemas']['DatumAttribute']
        | components['schemas']['ModelAttribute']
        | components['schemas']['CriteriaDatumAttribute'];
      /** Type */
      type:
        | components['schemas']['AddressAttribute']
        | components['schemas']['NonUsAddressAttribute']
        | components['schemas']['CountrySelectAttribute']
        | components['schemas']['TextAttribute']
        | components['schemas']['BooleanAttribute']
        | components['schemas']['NumberAttribute']
        | components['schemas']['DateAttribute']
        | components['schemas']['TextAreaAttribute']
        | components['schemas']['FranchiseTaxEstimateAttribute']
        | components['schemas']['RadioAttribute-Input']
        | components['schemas']['MultiSelectAttribute-Input']
        | components['schemas']['ArrayAttribute']
        | components['schemas']['SelectAttribute-Input'];
      /** Is Generic */
      is_generic: boolean;
      /**
       * Is Editable
       * @default false
       */
      is_editable: boolean;
      /** Reviewer Email */
      reviewer_email?: string | null;
      /** Pending Change Id */
      pending_change_id?: number | null;
    };
    /** AdminUpdateFormAttributeRequest */
    AdminUpdateFormAttributeRequest: {
      /** Is Required */
      is_required: boolean;
      /** Send In Legalinc Notes */
      send_in_legalinc_notes: boolean;
      /** Comes After Attribute Id */
      comes_after_attribute_id?: string | null;
      /** Description Override */
      description_override?: string | null;
      /** Default Value Override */
      default_value_override?: string | null;
      /** Dependencies */
      dependencies: components['schemas']['AdminFormAttributeDependency'][];
    };
    /** AdminUpdateFormRequest */
    AdminUpdateFormRequest: {
      /** Title */
      title?: string | null;
    };
    /** AdminUpdateInviteRequest */
    AdminUpdateInviteRequest: {
      /**
       * Expire Date
       * Format: date
       */
      expire_date: string;
      /** Is Accepted */
      is_accepted: boolean;
      /**
       * Allow Multiple Accepts
       * @default false
       */
      allow_multiple_accepts: boolean;
    };
    /** AdminUpdateLegalEntityRegionRequest */
    AdminUpdateLegalEntityRegionRequest: {
      /** Id */
      id: number;
      /** Legal Entity Id */
      legal_entity_id: number;
      /** Region Id */
      region_id: number;
      /** Status */
      status: string;
      /**
       * Is Setup Complete
       * @default false
       */
      is_setup_complete: boolean;
    };
    /** AdminUpdateLegalEntityRequest */
    AdminUpdateLegalEntityRequest: {
      /** Name */
      name: string;
      /** Account Id */
      account_id: number;
      /** Platform Id */
      platform_id?: number | null;
      /** Entity Type Id */
      entity_type_id: number;
      llc_managed_type?: components['schemas']['LLCManagedTypeEnum'] | null;
      /** Tax Class Id */
      tax_class_id: number;
      /** Is Non Stock */
      is_non_stock?: boolean | null;
      /** Nonprofit Type */
      nonprofit_type?: string | null;
      /** Incorporation Region Id */
      incorporation_region_id?: number | null;
      /** Incorporation Date */
      incorporation_date?: string | null;
      /** Physical Address Id */
      physical_address_id?: number | null;
      /** Mailing Address Id */
      mailing_address_id?: number | null;
      /** Is Test Account */
      is_test_account: boolean;
      /** Is Subscribed */
      is_subscribed: boolean;
      /** Is Business Profile Submitted */
      is_business_profile_submitted?: boolean | null;
      /** Is Active */
      is_active: boolean;
      /** Business Name */
      business_name?: string | null;
      /** Business Email */
      business_email?: string | null;
      /** Business Phone */
      business_phone?: string | null;
      /** Business Purpose */
      business_purpose?: string | null;
      /** Ein */
      ein?: string | null;
      /** Naics Code */
      naics_code?: string | null;
      accounting_method?: components['schemas']['AccountingMethod'] | null;
      accounting_period?: components['schemas']['AccountingPeriod'] | null;
      /** Accounting Year End */
      accounting_year_end?: string | null;
      /** Futa Liability Year */
      futa_liability_year?: number | null;
      /** Peo Provider Id */
      peo_provider_id?: number | null;
      /** President Id */
      president_id?: number | null;
      /** Secretary Id */
      secretary_id?: number | null;
      /** Treasurer Id */
      treasurer_id?: number | null;
      subscription_plan: components['schemas']['SubscriptionPlanEnum'];
      /** Hubspot Company Id */
      hubspot_company_id?: string | null;
      /** Primary Contact Id */
      primary_contact_id?: number | null;
      /** Submitter Id */
      submitter_id?: number | null;
      /**
       * Is Handbook Enabled
       * @default false
       */
      is_handbook_enabled: boolean;
    };
    /** AdminUpdateLegalEntityRequirementRequest */
    AdminUpdateLegalEntityRequirementRequest: {
      /** Id */
      id: number;
      /** Legal Entity Id */
      legal_entity_id: number;
      /** Requirement Id */
      requirement_id: number;
      /** Managed Provider Id */
      managed_provider_id?: number | null;
      /** Period Start Date */
      period_start_date?: string | null;
      /** Period End Date */
      period_end_date?: string | null;
      /** Due Date */
      due_date?: string | null;
      /** Status */
      status: string;
    };
    /** AdminUpdatePlatformResolution */
    AdminUpdatePlatformResolution: {
      /** Url */
      url: string;
    };
    /** AdminUpdateRegisteredAgentRequest */
    AdminUpdateRegisteredAgentRequest: {
      status: components['schemas']['RegisteredAgentStatus'];
      /** Legalinc Company Ids */
      legalinc_company_ids: components['schemas']['AdminLegalincCompanyId'][];
    };
    /** AdminUpsertLegalEntityAddressRequest */
    AdminUpsertLegalEntityAddressRequest: {
      /** Legal Entity Id */
      legal_entity_id: number;
      /** Address Line 1 */
      address_line_1: string;
      /** Address Line 2 */
      address_line_2?: string | null;
      /** City */
      city: string;
      /** Region */
      region: string;
      /** Country */
      country: string;
      /** Postal Code */
      postal_code: string;
    };
    /** AdminUser */
    AdminUser: {
      /** Id */
      id: number;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /** Email */
      email: string;
      /** First Name */
      first_name?: string | null;
      /** Last Name */
      last_name?: string | null;
      /** Is Active */
      is_active: boolean;
      role: components['schemas']['Role'];
      /** Legal Entity Id */
      legal_entity_id: number;
    };
    /** AdminUserUpdateRequest */
    AdminUserUpdateRequest: {
      /** Email */
      email: string;
      /** First Name */
      first_name?: string | null;
      /** Last Name */
      last_name?: string | null;
      /**
       * Is Active
       * @default true
       */
      is_active: boolean;
      /** @default user */
      role: components['schemas']['Role'];
    };
    /** AdminVerifyInviteParams */
    AdminVerifyInviteParams: {
      /** Token */
      token: string;
    };
    /** AdminWorkflow */
    AdminWorkflow: {
      /** Id */
      id: number;
      /** Name */
      name: string;
      /** Description */
      description: string;
      /** Is Disabled */
      is_disabled: boolean;
      /** Region Id */
      region_id?: number | null;
      region?:
        | components['schemas']['app__api__admin__workflows__AdminRegion']
        | null;
      /** Steps */
      steps: components['schemas']['AdminWorkflowStep'][];
      /**
       * Requirement Ids
       * @default []
       */
      requirement_ids: number[];
      /**
       * Tag Ids
       * @default []
       */
      tag_ids: number[];
      /**
       * Tags
       * @default []
       */
      tags: components['schemas']['AdminWorkflowTag'][];
    };
    /** AdminWorkflowInstance */
    AdminWorkflowInstance: {
      /** Id */
      id: number;
      /** Legal Entity Id */
      legal_entity_id: number;
      legal_entity: components['schemas']['app__api__admin__workflow_instances__AdminLegalEntity'];
      region: components['schemas']['app__api__admin__workflow_instances__AdminRegion'];
      workflow: components['schemas']['AdminWorkflow'];
      /**
       * Created Date
       * Format: date-time
       */
      created_date: string;
      /** Updated Date */
      updated_date?: string | null;
      /** Current Step Id */
      current_step_id?: number | null;
      /** Reminder Expiration Timestamp */
      reminder_expiration_timestamp?: number | null;
      /** Reminder Description */
      reminder_description?: string | null;
      status: components['schemas']['WorkflowInstanceStatus'];
      /** Status Note */
      status_note?: string | null;
      /** State */
      state?: {
        [key: string]: unknown;
      } | null;
      /** Assigned User Id */
      assigned_user_id?: number | null;
      /** Assigned User */
      assigned_user?: string | null;
      /** Blocks */
      blocks?: components['schemas']['AdminWorkflowInstanceBlock'][] | null;
      /**
       * Legal Entity Requirement Ids
       * @default []
       */
      legal_entity_requirement_ids: number[];
      /** External Estimated Min Date */
      external_estimated_min_date?: string | null;
      /** External Estimated Max Date */
      external_estimated_max_date?: string | null;
      /** Internal Estimated Date */
      internal_estimated_date?: string | null;
      /** Filing Year */
      filing_year?: number | null;
      /** Legalinc Order Id */
      legalinc_order_id?: number | null;
      /** Inhouse Passthrough Fees */
      inhouse_passthrough_fees?: number | null;
      /** Sla Met */
      sla_met?: boolean | null;
      /** Submitted At */
      submitted_at?: string | null;
      legalinc_documents?:
        | components['schemas']['AdminLegalIncDocuments']
        | null;
    };
    /** AdminWorkflowInstanceBlock */
    AdminWorkflowInstanceBlock: {
      /** Id */
      id: number;
      /** Workflow Instance Id */
      workflow_instance_id: number;
      reason: components['schemas']['WorkflowInstanceBlockReason'];
      /** Notes */
      notes: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /** Resolved At */
      resolved_at?: string | null;
      /** Is Resolved */
      is_resolved: boolean;
    };
    /** AdminWorkflowInstanceComment */
    AdminWorkflowInstanceComment: {
      /** Id */
      id: number;
      author: components['schemas']['AdminUser'];
      /** Workflow Instance Id */
      workflow_instance_id: number;
      /** Text */
      text: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
    };
    /** AdminWorkflowInstanceReminder */
    AdminWorkflowInstanceReminder: {
      /** Expiration */
      expiration: number;
      /** Description */
      description: string;
    };
    /** AdminWorkflowListMetadata */
    AdminWorkflowListMetadata: {
      /** Id */
      id: number;
      /** Name */
      name: string;
    };
    /** AdminWorkflowListMetadataResponse */
    AdminWorkflowListMetadataResponse: {
      /** Regions */
      regions: components['schemas']['app__api__admin__workflow_instances__AdminRegion'][];
      /** Tags */
      tags: components['schemas']['AdminWorkflowListMetadata'][];
      /** Legal Entities */
      legal_entities: components['schemas']['AdminWorkflowListMetadata'][];
      /** Users */
      users: components['schemas']['AdminWorkflowListMetadata'][];
      /** New Or Unassigned Count */
      new_or_unassigned_count: number;
    };
    /** AdminWorkflowRef */
    AdminWorkflowRef: {
      /** Id */
      id: number;
      /** Name */
      name: string;
    };
    /** AdminWorkflowStep */
    AdminWorkflowStep: {
      /** Id */
      id: number;
      /** Name */
      name: string;
      /** Description */
      description: string;
      /** Is Automatic */
      is_automatic: boolean;
      /** Requires Admin */
      requires_admin: boolean;
      /** Requires Review */
      requires_review: boolean;
      /** Submits To State */
      submits_to_state: boolean;
      /** Action */
      action?:
        | components['schemas']['WorkflowActionSubmitRegistrationApplicationManually']
        | components['schemas']['WorkflowActionAuditApplication']
        | components['schemas']['WorkflowActionSaveDatum']
        | components['schemas']['WorkflowActionSendEmail']
        | components['schemas']['WorkflowActionSendTemplatedEmail']
        | components['schemas']['WorkflowActionSetLinkedRequirementsDone']
        | components['schemas']['WorkflowActionUpdateRequirementStatus']
        | components['schemas']['WorkflowActionCreateCredential-Output']
        | components['schemas']['WorkflowActionRegisteredAgentTransfer']
        | components['schemas']['WorkflowActionSecretaryOfStateSearch']
        | components['schemas']['WorkflowActionLegalincOrderPoll']
        | components['schemas']['WorkflowActionLegalincSubmitAnnualReport']
        | components['schemas']['WorkflowActionLegalincSubmitForeignQualification']
        | components['schemas']['WorkflowActionUpdateCredentialActive']
        | components['schemas']['WorkflowActionSubmitCertificateOfGoodStanding']
        | components['schemas']['WorkflowActionMarkRegisteredAgentAsDone']
        | components['schemas']['WorkflowActionCalculateScore']
        | components['schemas']['WorkflowActionCreateAndSendStripeInvoice']
        | components['schemas']['WorkflowActionCreateIntegrationsEmail']
        | components['schemas']['WorkflowActionUploadLegalEntityDocument']
        | components['schemas']['WorkflowActionSendLegalEntityDocument']
        | components['schemas']['WorkflowActionCheckLegalEntityAccountLogin']
        | components['schemas']['WorkflowActionSaveFeePayment']
        | null;
      /** Order */
      order: number;
      /** Dependencies */
      dependencies: components['schemas']['AdminWorkflowStepDependency'][];
    };
    /** AdminWorkflowStepDependency */
    AdminWorkflowStepDependency: {
      /** Id */
      id: number;
      /** Attribute Id */
      attribute_id: number;
    };
    /** AdminWorkflowTag */
    AdminWorkflowTag: {
      /** Id */
      id: number;
      /** Name */
      name: string;
    };
    /** AdminZipCodeGroup */
    AdminZipCodeGroup: {
      /** Id */
      id: number;
      /** Label */
      label: string;
      /** Zip Codes */
      zip_codes: string[];
    };
    /** Agency */
    Agency: {
      /** Id */
      id: string;
      /** Name */
      name: string;
      /** Url */
      url: string;
      /** Agency Accounts */
      agency_accounts: components['schemas']['AgencyAccount'][];
    };
    /** AgencyAccount */
    AgencyAccount: {
      /** Id */
      id: number;
      /** Name */
      name: string;
      /** Attributes */
      attributes: components['schemas']['AgencyAccountAttribute'][];
      /** Logins */
      logins: components['schemas']['Login'][];
    };
    /** AgencyAccountAttribute */
    AgencyAccountAttribute: {
      /** Id */
      id: number;
      /** Public Id */
      public_id: string;
      /** Name */
      name: string;
      /** Description */
      description: string | null;
      /** Required */
      required: boolean;
      /** Value */
      value: string | null;
      /** Type */
      type: string;
    };
    /** AgencyRef */
    AgencyRef: {
      /** Id */
      id: string;
      /** Name */
      name: string;
      /** Url */
      url: string;
    };
    /** AllNoticeEnrollmentsResponse */
    AllNoticeEnrollmentsResponse: {
      /** Public Key */
      public_key: string;
      /** Enrolled Regions */
      enrolled_regions: components['schemas']['Region'][];
    };
    /** AnnualReportEstimateParams */
    AnnualReportEstimateParams: {
      /** Authorized Shares */
      authorized_shares: number;
      /** Issued Shares */
      issued_shares: number;
      /** Par Value */
      par_value: number;
      /** Gross Assets */
      gross_assets: number;
    };
    /** AnnualReportEstimateResult */
    AnnualReportEstimateResult: {
      /** Estimate */
      estimate: number;
    };
    /** ArrayAttribute */
    ArrayAttribute: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: ArrayAttributeType;
      /** @default {
       *       "hideAddAndDelete": false
       *     } */
      params: components['schemas']['ArrayParams'] | null;
      /** Placeholder */
      placeholder?: null;
      /**
       * Validators
       * @default []
       */
      validators: components['schemas']['ValidatorType'][];
    };
    /** ArrayParams */
    ArrayParams: {
      /**
       * Hideaddanddelete
       * @default false
       */
      hideAddAndDelete: boolean | null;
    };
    /** AssignWorkflowInstance */
    AssignWorkflowInstance: {
      /** User Id */
      user_id: number;
    };
    /** Attribute */
    Attribute: {
      /** Id */
      id: string;
      source: components['schemas']['DataSourceType'];
      /** Model Type */
      model_type?: string | null;
      /** Region Id */
      region_id?: string | null;
      /** Type */
      type: string;
      /** Name */
      name: string;
      /** Description */
      description?: string | null;
      /** Placeholder */
      placeholder?: string | null;
      /** Validators */
      validators: string[];
      /** Required */
      required: boolean;
    };
    /** AttributeCreateRequest */
    AttributeCreateRequest: {
      /** Public Id */
      public_id: string;
      /** Name */
      name: string;
      /** Description */
      description: string;
    };
    /** AttributePublicId */
    AttributePublicId: {
      /** Id */
      id: string;
      /** Region Id */
      region_id?: number | null;
      /** Name */
      name: string;
      /** Description */
      description?: string | null;
      description_link?: components['schemas']['DescriptionLink'] | null;
      /** Is Required */
      is_required: boolean;
      /** Source */
      source:
        | components['schemas']['DatumAttribute']
        | components['schemas']['ModelAttribute']
        | components['schemas']['CriteriaDatumAttribute'];
      /** Type */
      type:
        | components['schemas']['AddressAttribute']
        | components['schemas']['NonUsAddressAttribute']
        | components['schemas']['CountrySelectAttribute']
        | components['schemas']['TextAttribute']
        | components['schemas']['BooleanAttribute']
        | components['schemas']['NumberAttribute']
        | components['schemas']['DateAttribute']
        | components['schemas']['TextAreaAttribute']
        | components['schemas']['FranchiseTaxEstimateAttribute']
        | components['schemas']['RadioAttribute-Output']
        | components['schemas']['MultiSelectAttribute-Output']
        | components['schemas']['ArrayAttribute']
        | components['schemas']['SelectAttribute-Output'];
      /** Is Generic */
      is_generic: boolean;
      /**
       * Is Editable
       * @default false
       */
      is_editable: boolean;
      /** Pending Change Ids */
      pending_change_ids?: number[] | null;
      /** Reviewer Email */
      reviewer_email?: string | null;
    };
    /** AuthSSOResponse */
    AuthSSOResponse: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      token_type: AuthSSOResponseToken_type;
      /** Sso Redirect Url */
      sso_redirect_url: string;
    };
    /** AuthSessionResponse */
    AuthSessionResponse: {
      /** Access Token */
      access_token: string;
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      token_type: AuthSessionResponseToken_type;
      /** State */
      state?: {
        [key: string]: unknown;
      } | null;
    };
    /** AutomationActionRequiredNotificationTopic */
    AutomationActionRequiredNotificationTopic: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      code: AutomationActionRequiredNotificationTopicCode;
      /**
       * Title
       * @default Action required for automation
       */
      title: string;
      /**
       * Description
       * @default Sign documents and provide necessary information for automations in progress.
       */
      description: string;
      /**
       * Configurable
       * @default false
       */
      configurable: boolean;
      /**
       * Notification Names
       * @default [
       *       "automation_documents_for_signature",
       *       "automation_support"
       *     ]
       */
      notification_names: components['schemas']['NotificationName'][];
    };
    /** AutomationResponse */
    AutomationResponse: {
      /** Automation Type */
      automation_type?: string | null;
    };
    /** AutomationSessionRequest */
    AutomationSessionRequest: {
      /** Callback Url */
      callback_url: string;
    };
    /** AutomationSessionResponse */
    AutomationSessionResponse: {
      /** Automation Url */
      automation_url: string;
      /** Created At */
      created_at: string;
      /** Expires At */
      expires_at: string;
    };
    /** AutomationStatusUpdatesNotificationTopic */
    AutomationStatusUpdatesNotificationTopic: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      code: AutomationStatusUpdatesNotificationTopicCode;
      /**
       * Title
       * @default Automation status
       */
      title: string;
      /**
       * Description
       * @default Stay up-to-date on your automations, including when registrations are sent to a state agency.
       */
      description: string;
      /**
       * Configurable
       * @default true
       */
      configurable: boolean;
      /**
       * Notification Names
       * @default [
       *       "automation_request_received",
       *       "automation_request_submitted",
       *       "automation_request_completed"
       *     ]
       */
      notification_names: components['schemas']['NotificationName'][];
    };
    /** AutomationSubmission */
    AutomationSubmission: {
      form_submission: components['schemas']['FormSubmission'];
    };
    /** BaseHandbookLegalEntity */
    BaseHandbookLegalEntity: {
      /** Id */
      id: number;
      /** Name */
      name: string;
      draft_handbook?: components['schemas']['AdminHandbookRef'] | null;
      published_handbook?: components['schemas']['AdminHandbookRef'] | null;
    };
    /** BaseModel */
    BaseModel: Record<string, never>;
    /** Body_batch_patch_requirement_handler_api_requirements_batch_patch */
    Body_batch_patch_requirement_handler_api_requirements_batch_patch: {
      /** Patch */
      patch:
        | components['schemas']['RequirementPatchAssignOwner']
        | components['schemas']['RequirementPatchUnassignOwner'];
      /** Data Ids */
      data_ids: string[];
    };
    /** Body_custom_resolution_import_api_admin_platform_resolutions_import_post */
    Body_custom_resolution_import_api_admin_platform_resolutions_import_post: {
      /** Platform Id */
      platform_id?: string;
    };
    /** Body_login_api_token_post */
    Body_login_api_token_post: {
      /** Legal Entity Id */
      legal_entity_id?: string | null;
      /** Grant Type */
      grant_type?: string | null;
      /** Username */
      username: string;
      /** Password */
      password: string;
      /**
       * Scope
       * @default
       */
      scope: string;
      /** Client Id */
      client_id?: string | null;
      /** Client Secret */
      client_secret?: string | null;
    };
    /** Body_login_platform_user_api_platform_token_post */
    Body_login_platform_user_api_platform_token_post: {
      /** Token */
      token?: string;
    };
    /** Body_notice_create_api_admin_notices_post */
    Body_notice_create_api_admin_notices_post: {
      /** Title */
      title?: string;
      /** Region Id */
      region_id?: number;
    };
    /** Body_notice_update_api_admin_notices__notice_id__put */
    Body_notice_update_api_admin_notices__notice_id__put: {
      /** Title */
      title?: string;
      /** Region Id */
      region_id?: number;
    };
    /** Body_payroll_import_csv_api_payroll_import_csv_post */
    Body_payroll_import_csv_api_payroll_import_csv_post: {
      /** Legal Entity Public Id */
      legal_entity_public_id?: string;
    };
    /** Body_payroll_import_email_api_payroll_import_email_post */
    Body_payroll_import_email_api_payroll_import_email_post: {
      /** To */
      to?: string;
      /** Email */
      email?: string;
    };
    /** Body_signup_api_signup_post */
    Body_signup_api_signup_post: {
      /** Company Name */
      company_name: string;
      /** Password */
      password: string;
      /** Code */
      code?: string | null;
      /** Username */
      username: string;
    };
    /** Body_upload_document_api_guest_document_post */
    Body_upload_document_api_guest_document_post: {
      /** Token */
      token: string;
      /** Session Id */
      session_id: string;
    };
    /** BooleanAttribute */
    BooleanAttribute: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: BooleanAttributeType;
      /** Params */
      params?: null;
      /** Placeholder */
      placeholder?: boolean | null;
      /**
       * Validators
       * @default []
       */
      validators: components['schemas']['ValidatorType'][];
    };
    /** BulkPendingChangeRequest */
    BulkPendingChangeRequest: {
      /** Change Ids */
      change_ids: number[];
    };
    /** BulkQuestionTaskAnswer */
    BulkQuestionTaskAnswer: {
      /** Answers */
      answers: {
        [key: string]: string;
      };
    };
    /** BulkSetDatumParam */
    BulkSetDatumParam: {
      /** Attribute Id */
      attribute_id: string;
      /** Value */
      value: string | boolean;
      /** Region Code */
      region_code?: string | null;
    };
    /** Business */
    Business: {
      /** Id */
      id: string;
      /** Name */
      name: string;
      physical_address?: components['schemas']['app__public__Address'] | null;
      mailing_address?: components['schemas']['app__public__Address'] | null;
      /** Incorporation Country */
      incorporation_country: string;
      incorporation_region?: components['schemas']['Region'] | null;
      /**
       * Incorporation Date
       * Format: date
       */
      incorporation_date: string;
      /** Ownership Start Date */
      ownership_start_date?: string | null;
      /** Ownership Percentage */
      ownership_percentage?: number | null;
    };
    /** BusinessIncomeTaxNexusCriteria */
    BusinessIncomeTaxNexusCriteria: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: BusinessIncomeTaxNexusCriteriaType;
      /** Location Scope */
      location_scope:
        | components['schemas']['CriteriaLocationScopeRegion']
        | components['schemas']['CriteriaLocationScopeZip']
        | components['schemas']['CriteriaLocationScopeCity']
        | components['schemas']['CriteriaLocationScopeEntity'];
    };
    /** BusinessInformation */
    BusinessInformation: {
      legal_entity: components['schemas']['BusinessInformationLegalEntity'];
      /** Officers And Owners */
      officers_and_owners: (
        | components['schemas']['BusinessInformationPerson']
        | components['schemas']['BusinessInformationBusiness']
      )[];
      submitter: components['schemas']['BusinessInformationPerson'];
    };
    /** BusinessInformationBusiness */
    BusinessInformationBusiness: {
      /** Id */
      id: string;
      /** Name */
      name: string;
      physical_address?: components['schemas']['app__public__Address'] | null;
      mailing_address?: components['schemas']['app__public__Address'] | null;
      /** Incorporation Country */
      incorporation_country: string;
      incorporation_region?: components['schemas']['Region'] | null;
      /**
       * Incorporation Date
       * Format: date
       */
      incorporation_date: string;
      /** Ownership Start Date */
      ownership_start_date?: string | null;
      /** Ownership Percentage */
      ownership_percentage?: number | null;
      /**
       * Type
       * @default business
       * @constant
       */
      type: 'business';
      /** Fein */
      fein?: string | null;
    };
    /** BusinessInformationLegalEntity */
    BusinessInformationLegalEntity: {
      /** Name */
      name?: string | null;
      /** Email */
      email?: string | null;
      /** Phone */
      phone?: string | null;
      /** Fein */
      fein?: string | null;
      entity_type: components['schemas']['EntityTypeEnum'];
      tax_class: components['schemas']['TaxClassEnum'];
      incorporation_region?: components['schemas']['Region'] | null;
      /** Incorporation Date */
      incorporation_date?: string | null;
      business_address?: components['schemas']['app__public__Address'] | null;
      /** Integration Emails */
      integration_emails?: string[] | null;
      mailing_address?: components['schemas']['app__public__Address'] | null;
      /** Naics Code */
      naics_code?: string | null;
      /** Futa Liability Year */
      futa_liability_year?: number | null;
      /** Accounting Method */
      accounting_method?: string | null;
      /** Accounting Period */
      accounting_period?: string | null;
      /** Fiscal Year End */
      fiscal_year_end: string;
      llc_managed_type?: components['schemas']['LLCManagedTypeEnum'] | null;
      /** Nonprofit Type */
      nonprofit_type: string | null;
      /** Is Non Stock */
      is_non_stock: boolean | null;
    };
    /** BusinessInformationParams */
    BusinessInformationParams: {
      /**
       * Unredacted
       * @default false
       */
      unredacted: boolean;
    };
    /** BusinessInformationPerson */
    BusinessInformationPerson: {
      /** Id */
      id?: string | null;
      /** Email */
      email: string;
      /** First Name */
      first_name: string;
      /** Last Name */
      last_name: string;
      /** Title */
      title: string;
      /** Phone */
      phone: string;
      /** Birth Date */
      birth_date?: string | null;
      /** Ownership Percentage */
      ownership_percentage?: number | null;
      /** Ownership Start Date */
      ownership_start_date?: string | null;
      /** Owner License Number */
      owner_license_number?: string | null;
      /** Start Date */
      start_date?: string | null;
      address?: components['schemas']['app__public__Address'] | null;
      /** Is Married */
      is_married?: boolean | null;
      /** Spouse First Name */
      spouse_first_name?: string | null;
      /** Spouse Last Name */
      spouse_last_name?: string | null;
      /** Is Officer */
      is_officer: boolean;
      /** Is Owner */
      is_owner: boolean;
      /** Is Member */
      is_member: boolean;
      /** Is Manager */
      is_manager: boolean;
      /** Is Nonprofit Member */
      is_nonprofit_member: boolean;
      /** Is Nonprofit Trustee */
      is_nonprofit_trustee: boolean;
      /**
       * Type
       * @default person
       * @constant
       */
      type: 'person';
      identifier_type?: components['schemas']['IdentifierType'] | null;
      /** Identifier */
      identifier?: string | null;
    };
    /** BusinessProfileRequest */
    BusinessProfileRequest: {
      /** Data */
      data: {
        [key: string]: unknown;
      };
    };
    /** ChangeResponse */
    ChangeResponse: {
      /** Id */
      id: number;
    };
    /**
     * ChangeType
     * @enum {string}
     */
    ChangeType: ChangeType;
    /**
     * CharacterSet
     * @enum {string}
     */
    CharacterSet: CharacterSet;
    /** CharitableRegistrationNexusCriteria */
    CharitableRegistrationNexusCriteria: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: CharitableRegistrationNexusCriteriaType;
      /** Location Scope */
      location_scope:
        | components['schemas']['CriteriaLocationScopeRegion']
        | components['schemas']['CriteriaLocationScopeZip']
        | components['schemas']['CriteriaLocationScopeCity']
        | components['schemas']['CriteriaLocationScopeEntity'];
    };
    /** CheckoutResponse */
    CheckoutResponse: {
      /** Checkout Url */
      checkout_url: string;
    };
    /** CommandAlertMissingLegalincCompanies */
    CommandAlertMissingLegalincCompanies: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: CommandAlertMissingLegalincCompaniesCommand_id;
    };
    /** CommandAnnualReport */
    CommandAnnualReport: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: CommandAnnualReportCommand_id;
      /** Legal Entity Id */
      legal_entity_id: number;
      /** Region Id */
      region_id: number;
      submit_option: components['schemas']['SubmitOption'];
    };
    /** CommandCategorizePolicies */
    CommandCategorizePolicies: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: CommandCategorizePoliciesCommand_id;
      /** Policy Category Id */
      policy_category_id: string;
      /** Text */
      text: string;
      /**
       * Dry Run
       * @default false
       */
      dry_run: boolean;
      /** Reviewer Email */
      reviewer_email?: string | null;
    };
    /** CommandCertificateOfGoodStanding */
    CommandCertificateOfGoodStanding: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: CommandCertificateOfGoodStandingCommand_id;
      /** Legal Entity Id */
      legal_entity_id: number;
      /** Region Id */
      region_id: number;
      submit_option: components['schemas']['SubmitOption'];
    };
    /** CommandCheckForLegalincAddressesAsMailingAddress */
    CommandCheckForLegalincAddressesAsMailingAddress: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: CommandCheckForLegalincAddressesAsMailingAddressCommand_id;
      /** Legal Entity Id */
      legal_entity_id?: number | null;
    };
    /** CommandDeleteLegalEntityRequirementAndTriggers */
    CommandDeleteLegalEntityRequirementAndTriggers: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: CommandDeleteLegalEntityRequirementAndTriggersCommand_id;
      /** Legal Entity Requirement Id */
      legal_entity_requirement_id: number;
      /**
       * Dry Run
       * @default true
       */
      dry_run: boolean;
    };
    /** CommandForeignQualification */
    CommandForeignQualification: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: CommandForeignQualificationCommand_id;
      /** Legal Entity Id */
      legal_entity_id: number;
      /** Region Id */
      region_id: number;
      submit_option: components['schemas']['SubmitOption'];
    };
    /** CommandInsertHandbookUser */
    CommandInsertHandbookUser: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: CommandInsertHandbookUserCommand_id;
      /** Legal Entity Id */
      legal_entity_id: number;
      /** Region Id */
      region_id: number;
      /** City Name */
      city_name: string;
      /** Zip Code */
      zip_code: string;
      /** Email */
      email: string;
    };
    /** CommandMigrateEmployeeCount */
    CommandMigrateEmployeeCount: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: CommandMigrateEmployeeCountCommand_id;
      /**
       * Dry Run
       * @default true
       */
      dry_run: boolean;
    };
    /** CommandRegisteredAgentSubscription */
    CommandRegisteredAgentSubscription: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: CommandRegisteredAgentSubscriptionCommand_id;
      /** Legal Entity Id */
      legal_entity_id: number;
      /** Region Id */
      region_id: number;
      submit_option: components['schemas']['SubmitOption'];
    };
    /** CommandRegisteredAgentTransfer */
    CommandRegisteredAgentTransfer: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: CommandRegisteredAgentTransferCommand_id;
      /** Legal Entity Id */
      legal_entity_id: number;
      /** Region Id */
      region_id: number;
      submit_option: components['schemas']['SubmitOption'];
    };
    /** CommandResetHandbookLegalEntity */
    CommandResetHandbookLegalEntity: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: CommandResetHandbookLegalEntityCommand_id;
      /** Legal Entity Id */
      legal_entity_id: number;
    };
    /**
     * CommandRunStatus
     * @enum {string}
     */
    CommandRunStatus: CommandRunStatus;
    /** CommandUpdateLegalincCompanyForwardingContact */
    CommandUpdateLegalincCompanyForwardingContact: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: CommandUpdateLegalincCompanyForwardingContactCommand_id;
      /** Legal Entity Id */
      legal_entity_id?: number | null;
      submit_option: components['schemas']['SubmitOption'];
    };
    /** CommandUpsertHandbookUsers */
    CommandUpsertHandbookUsers: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: CommandUpsertHandbookUsersCommand_id;
      /** Legal Entity Id */
      legal_entity_id: number;
    };
    /** CompanyAccountMaintenanceAndUpdatesNotificationTopic */
    CompanyAccountMaintenanceAndUpdatesNotificationTopic: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      code: CompanyAccountMaintenanceAndUpdatesNotificationTopicCode;
      /**
       * Title
       * @default Account
       */
      title: string;
      /**
       * Description
       * @default Get notified about account updates and billing.
       */
      description: string;
      /**
       * Configurable
       * @default false
       */
      configurable: boolean;
      /**
       * Notification Names
       * @default [
       *       "new_user_added",
       *       "subscription_payment"
       *     ]
       */
      notification_names: components['schemas']['NotificationName'][];
    };
    /** ComplianceChange */
    ComplianceChange: {
      /** Id */
      id?: number | null;
      /** Author Id */
      author_id?: number | null;
      /** Author Email */
      author_email?: string | null;
      object_type: components['schemas']['ObjectType'];
      change_type: components['schemas']['ChangeType'];
      /** Object Id */
      object_id: string;
      /** Value */
      value:
        | components['schemas']['BaseModel']
        | components['schemas']['BaseModel'][]
        | {
            [key: string]: unknown;
          }[]
        | string[]
        | {
            [key: string]: unknown;
          }
        | string
        | number
        | null;
      /** Created At */
      created_at?: string | null;
      /** Reviewer Email */
      reviewer_email?: string | null;
    };
    /** ComplianceChangeComment */
    ComplianceChangeComment: {
      /** Id */
      id: number;
      /** Author Email */
      author_email: string;
      /** Comment */
      comment: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
    };
    /** ComplianceChangeDetails */
    ComplianceChangeDetails: {
      /** Id */
      id: number | null;
      /** Author Id */
      author_id: number | null;
      /** Object Id */
      object_id: string;
      change_type: components['schemas']['ChangeType'];
      object_type: components['schemas']['ObjectType'];
      /** Current Value */
      current_value:
        | components['schemas']['BaseModel']
        | components['schemas']['BaseModel'][]
        | {
            [key: string]: unknown;
          }[]
        | string[]
        | {
            [key: string]: unknown;
          }
        | string
        | number
        | null;
      /** Updated Value */
      updated_value:
        | components['schemas']['BaseModel']
        | components['schemas']['BaseModel'][]
        | {
            [key: string]: unknown;
          }[]
        | string[]
        | {
            [key: string]: unknown;
          }
        | string
        | number
        | null;
      /** Errors */
      errors: components['schemas']['ValidationError'][];
      /** Warnings */
      warnings: components['schemas']['ValidationWarning'][];
      /** Migrations */
      migrations: components['schemas']['PendingMigration'][];
    };
    /**
     * ComplianceChangeLogCategory
     * @enum {string}
     */
    ComplianceChangeLogCategory: ComplianceChangeLogCategory;
    /** ComplianceChangeLogDetails */
    ComplianceChangeLogDetails: {
      /** Id */
      id: number;
      /** Object Type */
      object_type: string;
      /** Object Id */
      object_id: string;
      /** Field Name */
      field_name: string;
      /** Old Value */
      old_value:
        | components['schemas']['BaseModel']
        | components['schemas']['BaseModel'][]
        | {
            [key: string]: unknown;
          }[]
        | string[]
        | {
            [key: string]: unknown;
          }
        | string
        | number
        | null;
      /** New Value */
      new_value:
        | components['schemas']['BaseModel']
        | components['schemas']['BaseModel'][]
        | {
            [key: string]: unknown;
          }[]
        | string[]
        | {
            [key: string]: unknown;
          }
        | string
        | number
        | null;
      /** Author Email */
      author_email: string;
      /** Approver Email */
      approver_email: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /** Applied At */
      applied_at?: string | null;
      category: components['schemas']['ComplianceChangeLogCategory'];
    };
    /** Connection */
    Connection: {
      /** Id */
      id: string;
      integration: components['schemas']['Integration'];
      creating_user?: components['schemas']['UserRef'] | null;
      /** Provider */
      provider: string;
      /** Provider Name */
      provider_name?: string | null;
      /** Is Disabled */
      is_disabled: boolean;
      /** Needs Auth */
      needs_auth: boolean;
    };
    /** ConnectionUpdateParams */
    ConnectionUpdateParams: {
      /** Is Disabled */
      is_disabled: boolean;
      /** Needs Auth */
      needs_auth: boolean;
    };
    /**
     * ContentType
     * @enum {string}
     */
    ContentType: ContentType;
    /** CountrySelectAttribute */
    CountrySelectAttribute: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: CountrySelectAttributeType;
      /** Params */
      params?: null;
      /** Placeholder */
      placeholder?: null;
      /**
       * Validators
       * @default []
       */
      validators: components['schemas']['ValidatorType'][];
    };
    /** CreateConnectionRequest */
    CreateConnectionRequest: {
      /** Integration Slug */
      integration_slug: string;
      /** Provider */
      provider?: string | null;
    };
    /** CreateImageResponse */
    CreateImageResponse: {
      /** Image Url */
      image_url: string;
    };
    /** CreateLegalEntityBusinessParams */
    CreateLegalEntityBusinessParams: {
      /** Name */
      name: string;
      /** Business Identifier */
      business_identifier: string;
      /** Incorporation Region */
      incorporation_region?: string | null;
      /**
       * Incorporation Country
       * @default US
       */
      incorporation_country: string;
      /**
       * Incorporation Date
       * Format: date
       */
      incorporation_date: string;
      physical_address: components['schemas']['LegalEntityAddressParams'];
      mailing_address?:
        | components['schemas']['LegalEntityAddressParams']
        | null;
      /**
       * Ownership Start Date
       * Format: date
       */
      ownership_start_date: string;
      /** Ownership Percentage */
      ownership_percentage: number;
    };
    /** CreateLegalEntityPerson */
    CreateLegalEntityPerson: {
      /** First Name */
      first_name: string;
      /** Last Name */
      last_name: string;
      /** Title */
      title: string;
      /** Email */
      email: string;
      /** Phone Number */
      phone_number?: string | null;
      personal_address: components['schemas']['app__api__legal_entity__Address'];
      /** Identifier Type */
      identifier_type: string;
      /** Identifier */
      identifier?: string | null;
      /** Birth Date */
      birth_date?: string | null;
      /** Start Date */
      start_date?: string | null;
      /** Ownership Start Date */
      ownership_start_date?: string | null;
      /** Ownership Percentage */
      ownership_percentage?: string | null;
      /** Owner License Number */
      owner_license_number?: string | null;
      /** Is Married */
      is_married?: boolean | null;
      /** Spouse First Name */
      spouse_first_name?: string | null;
      /** Spouse Last Name */
      spouse_last_name?: string | null;
      /** Is Officer */
      is_officer?: boolean | null;
      /** Is Owner */
      is_owner?: boolean | null;
    };
    /** CreateLegalEntityPersonParams */
    CreateLegalEntityPersonParams: {
      /** First Name */
      first_name: string;
      /** Last Name */
      last_name: string;
      /** Title */
      title: string;
      /** Email */
      email: string;
      /** Phone Number */
      phone_number: string;
      personal_address: components['schemas']['LegalEntityAddressParams'];
      /** Identifier Type */
      identifier_type: string;
      /** Identifier */
      identifier?: string | null;
      /** Birth Date */
      birth_date?: string | null;
      /** Start Date */
      start_date?: string | null;
      /** Ownership Start Date */
      ownership_start_date?: string | null;
      /** Ownership Percentage */
      ownership_percentage?: number | null;
      /** Owner License Number */
      owner_license_number?: string | null;
      /** Is Married */
      is_married?: boolean | null;
      /** Spouse First Name */
      spouse_first_name?: string | null;
      /** Spouse Last Name */
      spouse_last_name?: string | null;
      /** Is Officer */
      is_officer?: boolean | null;
      /** Is Owner */
      is_owner?: boolean | null;
      /** Is Director */
      is_director?: boolean | null;
      /** Is Llc Manager */
      is_llc_manager?: boolean | null;
      /** Is Llc Member */
      is_llc_member?: boolean | null;
    };
    /** CreateLegalEntityProfileRequest */
    CreateLegalEntityProfileRequest: {
      /** Business Name */
      business_name: string;
      business_address: components['schemas']['app__api__legal_entity__Address'];
      /** Mailing Address */
      mailing_address:
        | components['schemas']['app__api__legal_entity__Address']
        | components['schemas']['SameAsBusinessAddress'];
      accounting: components['schemas']['AccountingInformation'];
      /** Persons */
      persons: components['schemas']['CreateLegalEntityPerson'][];
      submitter_contact: components['schemas']['Submitter'];
    };
    /** CreateLocationRequest */
    CreateLocationRequest: {
      config?: components['schemas']['LocationConfig'] | null;
    };
    /** CreateLogin */
    CreateLogin: {
      /** Title */
      title: string;
      /** Username */
      username: string;
      /** Password */
      password?: string | null;
      password_generator?: components['schemas']['PasswordGenerator'] | null;
      /** Security Questions */
      security_questions?: string[] | null;
      /** Account Login Id */
      account_login_id: number;
    };
    /** CriteriaBusinessIncomeTaxNexus */
    CriteriaBusinessIncomeTaxNexus: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: CriteriaBusinessIncomeTaxNexusType;
      scope: components['schemas']['LocationScopeRegion'];
    };
    /** CriteriaCharitableRegistrationNexus */
    CriteriaCharitableRegistrationNexus: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: CriteriaCharitableRegistrationNexusType;
      scope: components['schemas']['LocationScopeRegion'];
    };
    /** CriteriaDatumAttribute */
    CriteriaDatumAttribute: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      source: CriteriaDatumAttributeSource;
      /** Model Type */
      model_type?: string | null;
    };
    /** CriteriaDoingBusiness */
    CriteriaDoingBusiness: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: CriteriaDoingBusinessType;
      scope: components['schemas']['LocationScopeRegion'];
    };
    /** CriteriaEmployeeCount */
    CriteriaEmployeeCount: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: CriteriaEmployeeCountType;
      /** Scope */
      scope:
        | components['schemas']['LocationScopeEntity']
        | components['schemas']['LocationScopeRegion']
        | components['schemas']['LocationScopeCity']
        | components['schemas']['LocationScopeZip'];
      date_range_type: components['schemas']['ThresholdDateRangeType'];
      /** Bounds */
      bounds:
        | components['schemas']['ThresholdBoundsGreaterThan']
        | components['schemas']['ThresholdBoundsOpenRange']
        | components['schemas']['ThresholdBoundsLessThan'];
    };
    /** CriteriaEstimatedTaxLiability */
    CriteriaEstimatedTaxLiability: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: CriteriaEstimatedTaxLiabilityType;
      scope: components['schemas']['LocationScopeRegion'];
    };
    /** CriteriaForeignQualificationDate */
    CriteriaForeignQualificationDate: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: CriteriaForeignQualificationDateType;
      scope: components['schemas']['LocationScopeRegion'];
      /** Attribute Id */
      attribute_id: string;
      /** @default {
       *       "type": "valid-date"
       *     } */
      bounds: components['schemas']['ThresholdBoundsValidDate'] | null;
    };
    /** CriteriaHasRegionEmployees */
    CriteriaHasRegionEmployees: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: CriteriaHasRegionEmployeesType;
    };
    /** CriteriaHasRegionPhysicalLocation */
    CriteriaHasRegionPhysicalLocation: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: CriteriaHasRegionPhysicalLocationType;
    };
    /** CriteriaLocationScopeCity */
    CriteriaLocationScopeCity: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: CriteriaLocationScopeCityType;
      /** City Name */
      city_name: string;
    };
    /** CriteriaLocationScopeEntity */
    CriteriaLocationScopeEntity: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: CriteriaLocationScopeEntityType;
    };
    /** CriteriaLocationScopeRegion */
    CriteriaLocationScopeRegion: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: CriteriaLocationScopeRegionType;
    };
    /** CriteriaLocationScopeZip */
    CriteriaLocationScopeZip: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: CriteriaLocationScopeZipType;
      /** Zip Codes */
      zip_codes: string[];
      /** Label */
      label: string;
    };
    /** CriteriaPartnerNexus */
    CriteriaPartnerNexus: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: CriteriaPartnerNexusType;
      scope: components['schemas']['LocationScopeRegion'];
    };
    /** CriteriaPayrollAmount */
    CriteriaPayrollAmount: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: CriteriaPayrollAmountType;
      /** Scope */
      scope:
        | components['schemas']['LocationScopeEntity']
        | components['schemas']['LocationScopeRegion']
        | components['schemas']['LocationScopeCity']
        | components['schemas']['LocationScopeZip'];
      /** Bounds */
      bounds:
        | components['schemas']['ThresholdBoundsGreaterThan']
        | components['schemas']['ThresholdBoundsOpenRange']
        | components['schemas']['ThresholdBoundsLessThan'];
    };
    /** CriteriaSalesTaxNexus */
    CriteriaSalesTaxNexus: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: CriteriaSalesTaxNexusType;
      scope: components['schemas']['LocationScopeRegion'];
    };
    /** CriteriaSingleRequirement */
    CriteriaSingleRequirement: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: CriteriaSingleRequirementType;
      /** Id */
      id?: string | null;
      /** Scope */
      scope:
        | components['schemas']['LocationScopeEntity']
        | components['schemas']['LocationScopeRegion']
        | components['schemas']['LocationScopeCity']
        | components['schemas']['LocationScopeZip'];
      /** Title */
      title: string;
      /** Description */
      description: string;
      /** Summary */
      summary: string;
    };
    /**
     * CriteriaType
     * @enum {string}
     */
    CriteriaType: CriteriaType;
    /** CustomBlanketPolicyCreate */
    CustomBlanketPolicyCreate: {
      /** Content */
      content: string;
    };
    /** CustomBlanketPolicyUpdate */
    CustomBlanketPolicyUpdate: {
      /** Content */
      content: string;
      /** Title */
      title?: string | null;
    };
    /** CustomPolicyCreate */
    CustomPolicyCreate: {
      /** Content */
      content: string;
      /** Title */
      title: string;
      /** Policy Section Id */
      policy_section_id: string;
    };
    /** CustomerPortalResponse */
    CustomerPortalResponse: {
      /** Customer Portal Url */
      customer_portal_url?: string | null;
    };
    /**
     * DataSourceType
     * @enum {string}
     */
    DataSourceType: DataSourceType;
    /** DateAttribute */
    DateAttribute: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: DateAttributeType;
      /** Params */
      params?: null;
      /** Placeholder */
      placeholder?: null;
      /**
       * Validators
       * @default []
       */
      validators: components['schemas']['ValidatorType'][];
    };
    /** DateAttributeCriteria */
    DateAttributeCriteria: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: DateAttributeCriteriaType;
      /** Date Attribute Id */
      date_attribute_id: string;
      /** Location Scope */
      location_scope:
        | components['schemas']['CriteriaLocationScopeRegion']
        | components['schemas']['CriteriaLocationScopeZip']
        | components['schemas']['CriteriaLocationScopeCity']
        | components['schemas']['CriteriaLocationScopeEntity'];
    };
    /** Datum */
    Datum: {
      attribute: components['schemas']['Attribute'];
      /** Value */
      value: string;
    };
    /** DatumAttribute */
    DatumAttribute: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      source: DatumAttributeSource;
      /** Model Type */
      model_type?: string | null;
    };
    /** DefaultDisplay */
    DefaultDisplay: {
      /**
       * Id
       * @default -1
       */
      id: number;
      /**
       * Order
       * @default 1
       */
      order: number;
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: DefaultDisplayType;
    };
    /**
     * DependencyOperator
     * @enum {string}
     */
    DependencyOperator: DependencyOperator;
    /** DescriptionLink */
    DescriptionLink: {
      /** Url */
      url?: string | null;
      /** Text */
      text?: string | null;
    };
    /** DoingBusinessCriteria */
    DoingBusinessCriteria: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: DoingBusinessCriteriaType;
      /** Location Scope */
      location_scope:
        | components['schemas']['CriteriaLocationScopeRegion']
        | components['schemas']['CriteriaLocationScopeZip']
        | components['schemas']['CriteriaLocationScopeCity']
        | components['schemas']['CriteriaLocationScopeEntity'];
    };
    /** ETAFixed */
    ETAFixed: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: ETAFixedType;
      /** Number Of Unit */
      number_of_unit: number;
      unit: components['schemas']['ETAUnit'];
    };
    /** ETARange */
    ETARange: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: ETARangeType;
      /** Min */
      min: number;
      /** Max */
      max: number;
      unit: components['schemas']['ETAUnit'];
    };
    /**
     * ETAUnit
     * @enum {string}
     */
    ETAUnit: ETAUnit;
    /** EmailDisplay */
    EmailDisplay: {
      /**
       * Id
       * @default -1
       */
      id: number;
      /**
       * Order
       * @default 1
       */
      order: number;
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: EmailDisplayType;
      /** Email */
      email: string;
    };
    /** EmailHeaders */
    EmailHeaders: {
      /** To */
      To: string;
      /** Date */
      Date: string;
      /** From */
      From: string;
      /** Subject */
      Subject: string;
      /** Replyto */
      ReplyTo?: string | null;
      /** Contenttype */
      ContentType: string;
      /** Deliveredto */
      DeliveredTo: string;
      /** Xoriginalsender */
      XOriginalSender?: string | null;
      /** Messageid */
      MessageID?: string | null;
    };
    /** EmailOtp */
    EmailOtp: {
      /** Email Otp Code */
      email_otp_code: string;
      /** Email Timestamp */
      email_timestamp: string;
    };
    /** EmailPieceMetadata */
    EmailPieceMetadata: {
      /** Piece Id */
      piece_id: string;
      /**
       * Received At
       * Format: date-time
       */
      received_at: string;
      headers: components['schemas']['EmailHeaders'];
      /** Labels */
      labels: string[];
    };
    /** EmbeddedSignupRequest */
    EmbeddedSignupRequest: {
      /** User Email */
      user_email: string;
      /** Business Name */
      business_name: string;
      entity_type: components['schemas']['EntityTypeEnum'];
      tax_classification: components['schemas']['TaxClassEnum'];
      /** Incorporation Location */
      incorporation_location: string;
      /**
       * Incorporation Date
       * Format: date
       */
      incorporation_date: string;
      /** Ein */
      ein?: string | null;
      llc_managed_type?: components['schemas']['LLCManagedTypeEnum'] | null;
      /** Business Purpose */
      business_purpose?: string | null;
      /** Business Phone */
      business_phone?: string | null;
      /** Business Email */
      business_email?: string | null;
      business_address?: components['schemas']['app__public__Address'] | null;
      mailing_address?: components['schemas']['app__public__Address'] | null;
      /** Naics Code */
      naics_code?: string | null;
      accounting_method?: components['schemas']['AccountingMethod'] | null;
      accounting_period?: components['schemas']['AccountingPeriod'] | null;
      accounting_year_end?:
        | components['schemas']['AccountingYearEndMonthNumber']
        | null;
      /** Futa Liability Year */
      futa_liability_year?: string | null;
      /** External Company Id */
      external_company_id?: string | null;
      /** Authorization Callback Url */
      authorization_callback_url?: string | null;
    };
    /** EmbeddedSignupResponse */
    EmbeddedSignupResponse: {
      /** Legal Entity Id */
      legal_entity_id: string;
      /**
       * Authorization Url
       * @description This is deprecated. Please see url field
       */
      authorization_url?: string | null;
      /**
       * Url
       * @description This is a session scoped URL that allows users to complete the signup process.
       */
      url?: string | null;
    };
    /** EmployeeAcknowledgementInfo */
    EmployeeAcknowledgementInfo: {
      /** Id */
      id: string;
      /** Email */
      email: string;
      /** Zip Code */
      zip_code: string;
      /** City Name */
      city_name: string;
      region: components['schemas']['Region'];
      status: components['schemas']['EmployeeAcknowledgementStatus'];
      /** Acknowledged At */
      acknowledged_at?: string | null;
      /** Reminded At */
      reminded_at?: string | null;
    };
    /**
     * EmployeeAcknowledgementStatus
     * @enum {string}
     */
    EmployeeAcknowledgementStatus: EmployeeAcknowledgementStatus;
    /** EmployeeCountCriteria */
    EmployeeCountCriteria: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: EmployeeCountCriteriaType;
      /** Bounds */
      bounds:
        | components['schemas']['GreaterThanBounds']
        | components['schemas']['LessThanBounds']
        | components['schemas']['RangeBounds'];
      /** Location Scope */
      location_scope:
        | components['schemas']['CriteriaLocationScopeRegion']
        | components['schemas']['CriteriaLocationScopeZip']
        | components['schemas']['CriteriaLocationScopeCity']
        | components['schemas']['CriteriaLocationScopeEntity'];
    };
    /** EmployeeCountPreviousYearCriteria */
    EmployeeCountPreviousYearCriteria: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: EmployeeCountPreviousYearCriteriaType;
      /** Bounds */
      bounds:
        | components['schemas']['GreaterThanBounds']
        | components['schemas']['LessThanBounds']
        | components['schemas']['RangeBounds'];
      /** Location Scope */
      location_scope:
        | components['schemas']['CriteriaLocationScopeRegion']
        | components['schemas']['CriteriaLocationScopeZip']
        | components['schemas']['CriteriaLocationScopeCity']
        | components['schemas']['CriteriaLocationScopeEntity'];
    };
    /** EmployeeHandbookResponse */
    EmployeeHandbookResponse: {
      /** Id */
      id: string;
      /** Is Current Draft */
      is_current_draft: boolean;
      /** Is Active */
      is_active: boolean;
      /** Is Publishable */
      is_publishable: boolean;
      /** Policy Instances */
      policy_instances: components['schemas']['PolicyInstance'][];
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      /** Published At */
      published_at?: string | null;
      /** Is Acknowledged */
      is_acknowledged: boolean;
    };
    /** EmployeeSignatureDownloadRequest */
    EmployeeSignatureDownloadRequest: {
      /** Handbook User Public Ids */
      handbook_user_public_ids: string[];
    };
    /**
     * EntityTypeEnum
     * @enum {string}
     */
    EntityTypeEnum: EntityTypeEnum;
    /** EstimatedTaxLiabilityCriteria */
    EstimatedTaxLiabilityCriteria: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: EstimatedTaxLiabilityCriteriaType;
      /** Location Scope */
      location_scope:
        | components['schemas']['CriteriaLocationScopeRegion']
        | components['schemas']['CriteriaLocationScopeZip']
        | components['schemas']['CriteriaLocationScopeCity']
        | components['schemas']['CriteriaLocationScopeEntity'];
    };
    /** FaxDisplay */
    FaxDisplay: {
      /**
       * Id
       * @default -1
       */
      id: number;
      /**
       * Order
       * @default 1
       */
      order: number;
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: FaxDisplayType;
      /** Number */
      number: string;
    };
    /** FeeFixed */
    FeeFixed: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: FeeFixedType;
      /** Amount */
      amount: string;
    };
    /** FeeRange */
    FeeRange: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: FeeRangeType;
      /** Min */
      min: string;
      /** Max */
      max: string;
    };
    /** FeeVariable */
    FeeVariable: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: FeeVariableType;
      /** Reason */
      reason: string;
    };
    /** Field */
    Field: {
      /** Name */
      name: string;
      /** Label */
      label: string;
      /** Description */
      description?: string | null;
      /** Component */
      component: {
        [key: string]: unknown;
      };
      /** Field Rules */
      field_rules: components['schemas']['app__attribute_forms__public__FieldRule'][];
      /** Required */
      required: string | null;
    };
    /** FieldRule */
    'FieldRule-Input': {
      /** Condition */
      condition:
        | components['schemas']['RuleConditionEquals']
        | components['schemas']['RuleConditionExists']
        | components['schemas']['RuleConditionNot-Input']
        | components['schemas']['RuleConditionAnd-Input']
        | components['schemas']['RuleConditionOr-Input']
        | components['schemas']['RuleConditionLowerBounds']
        | components['schemas']['RuleConditionUpperBounds'];
      /** Affected Fields */
      affected_fields: string[];
    };
    /** FirstTimeConfirmationsNotificationTopic */
    FirstTimeConfirmationsNotificationTopic: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      code: FirstTimeConfirmationsNotificationTopicCode;
      /**
       * Title
       * @default First-time confirmations
       */
      title: string;
      /**
       * Description
       * @default N/A
       */
      description: string;
      /**
       * Configurable
       * @default false
       */
      configurable: boolean;
      /**
       * Notification Names
       * @default [
       *       "payroll_connection",
       *       "subscription_confirmation",
       *       "signup_waitlist"
       *     ]
       */
      notification_names: components['schemas']['NotificationName'][];
    };
    /** FlatWorkflowInstance */
    FlatWorkflowInstance: {
      /** Id */
      id: number;
      /** Workflow Name */
      workflow_name: string | null;
      /** Legal Entity Name */
      legal_entity_name: string | null;
      status: components['schemas']['WorkflowInstanceStatus'];
      /** Reminder Expiration Timestamp */
      reminder_expiration_timestamp: number | null;
      /** Assigned User Name */
      assigned_user_name: string | null;
      /** Assigned User Id */
      assigned_user_id: number | null;
      /** Current Step Name */
      current_step_name: string | null;
      /** Created Date */
      created_date: string | null;
      /** Updated Date */
      updated_date: string | null;
      /** Override Region Code */
      override_region_code: string | null;
      /** State */
      state: {
        [key: string]: unknown;
      } | null;
      /** Legalinc Order Id */
      legalinc_order_id: number | null;
    };
    /** ForeignQualificationCriteria */
    ForeignQualificationCriteria: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: ForeignQualificationCriteriaType;
      /** Qualification Date Attribute Id */
      qualification_date_attribute_id: string;
      /** Location Scope */
      location_scope:
        | components['schemas']['CriteriaLocationScopeRegion']
        | components['schemas']['CriteriaLocationScopeZip']
        | components['schemas']['CriteriaLocationScopeCity']
        | components['schemas']['CriteriaLocationScopeEntity'];
    };
    /** FormAutomationResponse */
    FormAutomationResponse: {
      /** Forms */
      forms: components['schemas']['FormattedForm'][];
      /** Fee */
      fee?:
        | (
            | components['schemas']['FeeFixed']
            | components['schemas']['FeeRange']
            | components['schemas']['FeeVariable']
          )
        | null;
      eta?: components['schemas']['RequirementETA'] | null;
      /**
       * Allow Auto Submit
       * @default false
       */
      allow_auto_submit: boolean;
    };
    /** FormCaptureRequest */
    FormCaptureRequest: {
      /** Data */
      data: {
        [key: string]: unknown;
      };
    };
    /** FormCreation */
    FormCreation: {
      /** Name */
      name: string;
      /** Region Id */
      region_id: number;
      /** Tag Id */
      tag_id: number;
      /** Entity Type Id */
      entity_type_id?: number | null;
      /** Tax Class Id */
      tax_class_id?: number | null;
      /** Requirement Id */
      requirement_id?: number | null;
      /** Fields */
      fields: components['schemas']['FormSpecField-Input'][];
    };
    /** FormFields */
    FormFields: {
      /** Form Fields */
      form_fields: components['schemas']['Field'][];
    };
    /** FormSpec */
    'FormSpec-Input': {
      /** Name */
      name: string;
      /** Id */
      id: string;
      /** Fields */
      fields: components['schemas']['FormSpecField-Input'][];
    };
    /** FormSpec */
    'FormSpec-Output': {
      /** Name */
      name: string;
      /** Id */
      id: string;
      /** Fields */
      fields: components['schemas']['FormSpecField-Output'][];
    };
    /** FormSpecField */
    'FormSpecField-Input': {
      /** Name */
      name: string;
      /**
       * Is Required
       * @default false
       */
      is_required: boolean;
      /**
       * Is Editable
       * @default false
       */
      is_editable: boolean;
      /**
       * Send In Legalinc Order Notes
       * @default false
       */
      send_in_legalinc_order_notes: boolean;
      /**
       * Contents
       * @default []
       */
      contents: components['schemas']['FormSpecField-Input'][];
      /**
       * Rules
       * @default []
       */
      rules: components['schemas']['FieldRule-Input'][];
      /** Description */
      description?: string | null;
      /** Default Value */
      default_value?: string | null;
    };
    /** FormSpecField */
    'FormSpecField-Output': {
      /** Name */
      name: string;
      /**
       * Is Required
       * @default false
       */
      is_required: boolean;
      /**
       * Is Editable
       * @default false
       */
      is_editable: boolean;
      /**
       * Send In Legalinc Order Notes
       * @default false
       */
      send_in_legalinc_order_notes: boolean;
      /**
       * Contents
       * @default []
       */
      contents: components['schemas']['FormSpecField-Output'][];
      /**
       * Rules
       * @default []
       */
      rules: components['schemas']['app__attribute_forms__models__FieldRule-Output'][];
      /** Description */
      description?: string | null;
      /** Default Value */
      default_value?: string | null;
    };
    /** FormSubmission */
    FormSubmission: {
      /** Form Id */
      form_id?: string | null;
      /** Data */
      data: {
        [key: string]: unknown;
      };
    };
    /** FormattedForm */
    FormattedForm: {
      /** Id */
      id: string;
      /** Title */
      title: string;
      /**
       * Sections
       * @default []
       */
      sections: components['schemas']['FormFields'][];
      /**
       * Default Values
       * @default {}
       */
      default_values: {
        [key: string]: unknown;
      };
    };
    /** FranchiseTaxEstimateAttribute */
    FranchiseTaxEstimateAttribute: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: FranchiseTaxEstimateAttributeType;
      /** Params */
      params?: null;
      /** Placeholder */
      placeholder?: null;
      /**
       * Validators
       * @default []
       */
      validators: components['schemas']['ValidatorType'][];
    };
    /** GenerateLegalEntityRegionRequirementsParams */
    GenerateLegalEntityRegionRequirementsParams: {
      status?: components['schemas']['LegalEntityRegionStatus'] | null;
    };
    /** GenerateOperatorWorkflowPrompt */
    GenerateOperatorWorkflowPrompt: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      command_id: GenerateOperatorWorkflowPromptCommand_id;
      /** Workflow Id */
      workflow_id: number;
      /** Legal Entity Id */
      legal_entity_id: number;
    };
    /** GeneratePromptResponse */
    GeneratePromptResponse: {
      /** Prompt */
      prompt: string;
    };
    /** GetAccountsParameters */
    GetAccountsParameters: {
      /** Region Codes */
      region_codes: string[];
    };
    /** GetFormRequest */
    GetFormRequest: {
      /**
       * Show All Fields
       * @default false
       */
      show_all_fields: boolean;
    };
    /** GreaterThanBounds */
    GreaterThanBounds: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: GreaterThanBoundsType;
      /** Lower Bound */
      lower_bound: number;
    };
    /** Guest */
    Guest: {
      /** Id */
      id: string;
      /** Token */
      token: string;
      /** Email */
      email: string;
      /** Company Name */
      company_name: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
    };
    /** GuestDocument */
    GuestDocument: {
      /** Id */
      id: number;
      /** Public Id */
      public_id: string;
      /** Guest Id */
      guest_id: number;
      /** Stripe Session Id */
      stripe_session_id: string;
      /** Is Payment Complete */
      is_payment_complete: boolean;
      /** Document Full Url */
      document_full_url?: string | null;
      /** File Id */
      file_id?: number | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
    };
    /** GuestRequest */
    GuestRequest: {
      /** Email */
      email: string;
      /** Company Name */
      company_name: string;
    };
    /** GuestValidationRequest */
    GuestValidationRequest: {
      /** Token */
      token: string;
      /** Session Id */
      session_id: string;
    };
    /** GustoAuthorizeRequest */
    GustoAuthorizeRequest: {
      /** Authorization Code */
      authorization_code: string;
      /** Validation State */
      validation_state: string;
    };
    /** GustoAuthorizeResponse */
    GustoAuthorizeResponse: {
      /** Redirect Url */
      redirect_url: string;
    };
    /** GustoBeginAuthorizationRequest */
    GustoBeginAuthorizationRequest: {
      /** Authorization Token */
      authorization_token: string;
    };
    /** GustoOnboardRequest */
    GustoOnboardRequest: {
      /** Callback Url */
      callback_url: string;
    };
    /** HTTPValidationError */
    HTTPValidationError: {
      /** Detail */
      detail?: components['schemas']['ValidationError'][];
    };
    /** Handbook */
    Handbook: {
      /** Id */
      id: string;
      /** Is Current Draft */
      is_current_draft: boolean;
      /** Is Active */
      is_active: boolean;
      /** Is Publishable */
      is_publishable: boolean;
      /** Policy Instances */
      policy_instances: components['schemas']['PolicyInstance'][];
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      /** Published At */
      published_at?: string | null;
    };
    /** HandbookLegalEntity */
    HandbookLegalEntity: {
      /** Id */
      id: number;
      /** Name */
      name: string;
      draft_handbook?: components['schemas']['AdminHandbookRef'] | null;
      published_handbook?: components['schemas']['AdminHandbookRef'] | null;
      /** Active Handbook Users */
      active_handbook_users?: number | null;
      /** Active Employees */
      active_employees?: number | null;
    };
    /** HandbookLinkRequest */
    HandbookLinkRequest: {
      /** Email */
      email: string;
    };
    /** HandbookStats */
    HandbookStats: {
      /** Published */
      published: number;
    };
    /** HandbookUser */
    HandbookUser: {
      /** Id */
      id: string;
      /** Email */
      email: string;
      legal_entity: components['schemas']['LegalEntityRef'];
      /** Legal Notice Acknowledged At */
      legal_notice_acknowledged_at?: string | null;
    };
    /** HasEmployeesCriteria */
    HasEmployeesCriteria: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: HasEmployeesCriteriaType;
      /** Location Scope */
      location_scope:
        | components['schemas']['CriteriaLocationScopeRegion']
        | components['schemas']['CriteriaLocationScopeZip']
        | components['schemas']['CriteriaLocationScopeCity']
        | components['schemas']['CriteriaLocationScopeEntity'];
    };
    /** HasNonExemptEmployeesCriteria */
    HasNonExemptEmployeesCriteria: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: HasNonExemptEmployeesCriteriaType;
      /** Location Scope */
      location_scope:
        | components['schemas']['CriteriaLocationScopeRegion']
        | components['schemas']['CriteriaLocationScopeZip']
        | components['schemas']['CriteriaLocationScopeCity']
        | components['schemas']['CriteriaLocationScopeEntity'];
    };
    /** HostedSignupRequest */
    HostedSignupRequest: {
      /** Business Name */
      business_name: string;
      /** User Email */
      user_email: string;
      /** Callback Url */
      callback_url: string;
      /** Legal Entity Id */
      legal_entity_id?: string | null;
      business_information?:
        | components['schemas']['HostedSignupRequestBusinessInformation']
        | null;
      /** External Company Id */
      external_company_id?: string | null;
    };
    /** HostedSignupRequestBusinessInformation */
    HostedSignupRequestBusinessInformation: {
      /** Incorporation Region */
      incorporation_region?: string | null;
      entity_type?: components['schemas']['EntityTypeEnum'] | null;
      tax_classification?: components['schemas']['TaxClassEnum'] | null;
      llc_managed_type?: components['schemas']['LLCManagedTypeEnum'] | null;
      /** Business Name */
      business_name?: string | null;
      /** Business Purpose */
      business_purpose?: string | null;
      /** Ein */
      ein?: string | null;
      /** Incorporation Date */
      incorporation_date?: string | null;
      /** Naics Code */
      naics_code?: string | null;
      accounting_method?: components['schemas']['AccountingMethod'] | null;
      accounting_period?: components['schemas']['AccountingPeriod'] | null;
      accounting_year_end?:
        | components['schemas']['AccountingYearEndMonthNumber']
        | null;
      /** Futa Liability Year */
      futa_liability_year?: string | null;
    };
    /** HostedSignupResponse */
    HostedSignupResponse: {
      /**
       * Signup Url
       * @description This is a deprecated field, please use url
       */
      signup_url: string;
      /**
       * Url
       * @description This is a session scoped URL which allows users to completed the signup process.
       */
      url: string;
      /** Created At */
      created_at: string;
      /** Expires At */
      expires_at: string;
      /** Legal Entity Id */
      legal_entity_id: string;
    };
    /**
     * IdentifierType
     * @enum {string}
     */
    IdentifierType: IdentifierType;
    /** ImpersonatorTokenRequest */
    ImpersonatorTokenRequest: {
      /** Legal Entity Id */
      legal_entity_id: string;
    };
    /** Integration */
    Integration: {
      /** Id */
      id: string;
      /** Type */
      type: string;
      /** Name */
      name: string;
      /** Slug */
      slug: string;
    };
    /** InviteRequest */
    InviteRequest: {
      /** Email */
      email: string;
    };
    /** Invoice */
    Invoice: {
      /** Invoice Description */
      invoice_description: string;
      /** Memo */
      memo: string;
      /** Amount In Cents */
      amount_in_cents: number;
    };
    /** InvoiceResponse */
    InvoiceResponse: {
      /** Id */
      id: string;
    };
    /**
     * LLCManagedTypeEnum
     * @enum {string}
     */
    LLCManagedTypeEnum: LLCManagedTypeEnum;
    /** LeadContactRequest */
    LeadContactRequest: {
      /** Company Name */
      company_name: string;
      /** Email */
      email: string;
    };
    /** LegalEntity */
    LegalEntity: {
      /** Id */
      id: string;
      /** Name */
      name: string;
      entity_type: components['schemas']['EntityTypeEnum'];
      tax_class: components['schemas']['TaxClassEnum'];
      incorporation_region?: components['schemas']['Region'] | null;
      hq_region?: components['schemas']['Region'] | null;
      /** Regions */
      regions: components['schemas']['LegalEntityRegionRef'][];
      /** Employee Count */
      employee_count: number;
      /** Business Profile Submitted */
      business_profile_submitted: boolean;
      /** Is Subscribed */
      is_subscribed: boolean;
      subscription_plan?: components['schemas']['SubscriptionPlanEnum'] | null;
      /** Is Default */
      is_default: boolean;
      physical_address?: components['schemas']['app__public__Address'] | null;
      mailing_address?: components['schemas']['app__public__Address'] | null;
      platform?: components['schemas']['Platform'] | null;
      /** Notice Url */
      notice_url?: string | null;
      /** Allow Multiple Locations */
      allow_multiple_locations: boolean;
      /** Is Handbook Enabled */
      is_handbook_enabled: boolean;
      /** Is Handbook Present */
      is_handbook_present: boolean;
      /** Should Catch Basic Gate */
      should_catch_basic_gate: boolean;
    };
    /** LegalEntityAddressParams */
    LegalEntityAddressParams: {
      /** Address Line 1 */
      address_line_1: string;
      /** Address Line 2 */
      address_line_2?: string | null;
      /** City */
      city: string;
      /** State */
      state: string;
      /**
       * Country
       * @default United States
       */
      country: string;
      /** Postal Code */
      postal_code: string;
    };
    /** LegalEntityDocument */
    LegalEntityDocument: {
      /** Id */
      id: string;
      /** Document Type */
      document_type: string;
      /** Region Code */
      region_code: string;
      /**
       * Uploaded On
       * Format: date-time
       */
      uploaded_on: string;
      /** Document Url */
      document_url?: string | null;
      /** Is Requesting */
      is_requesting?: boolean | null;
      /** Uploaded By */
      uploaded_by?: string | null;
      /** Workflow Instance Id */
      workflow_instance_id?: number | null;
    };
    /** LegalEntityInformationResponse */
    LegalEntityInformationResponse: {
      physical_address?: components['schemas']['app__public__Address'] | null;
      mailing_address?: components['schemas']['app__public__Address'] | null;
    };
    /**
     * LegalEntityMailStatus
     * @enum {string}
     */
    LegalEntityMailStatus: LegalEntityMailStatus;
    /**
     * LegalEntityOwnerType
     * @enum {string}
     */
    LegalEntityOwnerType: LegalEntityOwnerType;
    /** LegalEntityRef */
    LegalEntityRef: {
      /** Id */
      id: string;
      /** Name */
      name: string;
      /** Is Default */
      is_default: boolean;
    };
    /** LegalEntityRegion */
    LegalEntityRegion: {
      /** Id */
      id: string;
      /** Name */
      name: string;
      /** Code */
      code: string;
      region: components['schemas']['Region'];
      /** Datums */
      datums: components['schemas']['Datum'][];
      /** Employee Count */
      employee_count: number;
      /** Status */
      status: string;
      /** Setup Form Submitted */
      setup_form_submitted: boolean;
      registered_agent?: components['schemas']['RegisteredAgent'] | null;
      region_navigator: components['schemas']['RegionNavigator'];
      /** Has Unique Navigator */
      has_unique_navigator: boolean;
      /**
       * Is Setup Complete
       * @default false
       */
      is_setup_complete: boolean;
      /** Has Employees */
      has_employees?: boolean | null;
      /** Has Physical Location */
      has_physical_location?: boolean | null;
    };
    /** LegalEntityRegionAddRequest */
    LegalEntityRegionAddRequest: {
      /** Region Code */
      region_code: string;
      /** @default entering */
      status: components['schemas']['LegalEntityRegionStatus'] | null;
    };
    /** LegalEntityRegionConfigurationParams */
    LegalEntityRegionConfigurationParams: {
      /** Has Employees */
      has_employees: boolean;
      /** Has Physical Location */
      has_physical_location: boolean;
    };
    /** LegalEntityRegionRef */
    LegalEntityRegionRef: {
      /** Id */
      id: string;
      /** Name */
      name: string;
      /** Code */
      code: string;
      region: components['schemas']['Region'];
      /** Employee Count */
      employee_count: number;
      /** Status */
      status: string;
      /** Setup Form Submitted */
      setup_form_submitted: boolean;
      /** Has Employees */
      has_employees?: boolean | null;
      /** Has Physical Location */
      has_physical_location?: boolean | null;
    };
    /** LegalEntityRegionSetupStatusUpdateResult */
    LegalEntityRegionSetupStatusUpdateResult: {
      /** Success */
      success: boolean;
    };
    /**
     * LegalEntityRegionStatus
     * @enum {string}
     */
    LegalEntityRegionStatus: LegalEntityRegionStatus;
    /** LegalEntityRegionUpdateParams */
    LegalEntityRegionUpdateParams: {
      /** Has Employees */
      has_employees: boolean;
    };
    /** LegalEntityRegionUpdateResult */
    LegalEntityRegionUpdateResult: {
      /** Success */
      success: boolean;
    };
    /**
     * LegalEntityRequirementStatus
     * @enum {string}
     */
    LegalEntityRequirementStatus: LegalEntityRequirementStatus;
    /** LegalEntityUser */
    LegalEntityUser: {
      /** Id */
      id: string;
      /** Email */
      email: string;
      /** First Name */
      first_name?: string | null;
      /** Last Name */
      last_name?: string | null;
      /**
       * Is Active
       * @default true
       */
      is_active: boolean;
    };
    /** LessThanBounds */
    LessThanBounds: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: LessThanBoundsType;
      /** Upper Bound */
      upper_bound: number;
    };
    /** LinkDisplay */
    LinkDisplay: {
      /**
       * Id
       * @default -1
       */
      id: number;
      /**
       * Order
       * @default 1
       */
      order: number;
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: LinkDisplayType;
      /** Url */
      url: string;
      /** Text */
      text?: string | null;
    };
    /** LocationConfig */
    LocationConfig: {
      /** Has Employees */
      has_employees?: boolean | null;
      /** Has Physical Location */
      has_physical_location?: boolean | null;
    };
    /** LocationRiskResponse */
    LocationRiskResponse: {
      /** Score */
      score: number;
    };
    /**
     * LocationScope
     * @enum {string}
     */
    LocationScope: LocationScope;
    /** LocationScopeCity */
    LocationScopeCity: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: LocationScopeCityType;
      /** City */
      city: string;
    };
    /** LocationScopeEntity */
    LocationScopeEntity: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: LocationScopeEntityType;
    };
    /** LocationScopeRegion */
    LocationScopeRegion: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: LocationScopeRegionType;
    };
    /** LocationScopeZip */
    LocationScopeZip: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: LocationScopeZipType;
      /** Zip Codes */
      zip_codes: string[];
      /** Label */
      label: string;
    };
    /** LocationSummary */
    LocationSummary: {
      /**
       * Is Assessment
       * @default false
       */
      is_assessment: boolean;
      /**
       * Is Setup
       * @default false
       */
      is_setup: boolean;
      /**
       * Has Unread Mail
       * @default false
       */
      has_unread_mail: boolean;
      /**
       * Has Setup Todo Tasks
       * @default false
       */
      has_setup_todo_tasks: boolean;
      /**
       * Wizards
       * @default []
       */
      wizards: string[];
    };
    /** Login */
    Login: {
      /** Username */
      username: string;
      /** Password */
      password: string;
      /**
       * Security Questions
       * @default []
       */
      security_questions: components['schemas']['SecurityQuestion'][];
      /** Account Name */
      account_name: string;
      /** Login Url */
      login_url: string;
      /** Is Active */
      is_active: boolean;
      /** Is Supported */
      is_supported: boolean;
      /** Is Otp Required */
      is_otp_required: boolean;
      /** Public Id */
      public_id: string;
      /** Is Email Otp */
      is_email_otp: boolean;
      /** Working As Of */
      working_as_of?: string | null;
    };
    /** LoginsSessionRequest */
    LoginsSessionRequest: {
      /** Callback Url */
      callback_url: string;
    };
    /**
     * MailClassification
     * @enum {string}
     */
    MailClassification: MailClassification;
    /** MailDisplay */
    MailDisplay: {
      /**
       * Id
       * @default -1
       */
      id: number;
      /**
       * Order
       * @default 1
       */
      order: number;
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: MailDisplayType;
      /** Address */
      address: string;
    };
    /** MailPatchUpdateAssignOwner */
    MailPatchUpdateAssignOwner: {
      /**
       * Operation
       * @default assign
       * @constant
       */
      operation: 'assign';
      /** User Id */
      user_id: string;
    };
    /** MailPatchUpdateReadState */
    MailPatchUpdateReadState: {
      /**
       * Operation
       * @default read_state
       * @constant
       */
      operation: 'read_state';
      /** Is Read */
      is_read: boolean;
    };
    /** MailPatchUpdateStatus */
    MailPatchUpdateStatus: {
      /**
       * Operation
       * @default status_update
       * @constant
       */
      operation: 'status_update';
      status: components['schemas']['LegalEntityMailStatus'];
    };
    /** MailPatchUpdateUnassignOwner */
    MailPatchUpdateUnassignOwner: {
      /**
       * Operation
       * @default unassign
       * @constant
       */
      operation: 'unassign';
    };
    /**
     * MailRoomOptions
     * @enum {string}
     */
    MailRoomOptions: MailRoomOptions;
    /**
     * MailSource
     * @enum {string}
     */
    MailSource: MailSource;
    /** MailSummary */
    MailSummary: {
      /** Id */
      id?: number | null;
      /** Title */
      title: string;
      /** Sender */
      sender: string;
      /** Recipient */
      recipient: string | null;
      /** Sent Date */
      sent_date: string | null;
      classification: components['schemas']['MailClassification'];
      /** Explanation */
      explanation: string;
    };
    /**
     * MailType
     * @enum {string}
     */
    MailType: MailType;
    /** MailroomAddresses */
    MailroomAddresses: {
      primary: components['schemas']['app__api__legal_entity__Address'];
      /** State Overrides */
      state_overrides: {
        [key: string]: components['schemas']['app__api__legal_entity__Address'];
      };
    };
    /**
     * MailroomEmailStatus
     * @enum {string}
     */
    MailroomEmailStatus: MailroomEmailStatus;
    /** MailroomMailDeliver */
    MailroomMailDeliver: {
      /**
       * Is Sop
       * @default false
       */
      is_sop: boolean;
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      status: MailroomMailDeliverStatus;
      /** Legal Entity Id */
      legal_entity_id: number;
      /** Region Id */
      region_id: number;
      /** Sender */
      sender: string;
      /**
       * Deliver Silently
       * @default false
       */
      deliver_silently: boolean;
      /** File Id */
      file_id?: number | null;
      /** Processed File Id */
      processed_file_id?: number | null;
      /** Deliver File Id */
      deliver_file_id?: number | null;
    };
    /** MailroomMailException */
    MailroomMailException: {
      /**
       * Is Sop
       * @default false
       */
      is_sop: boolean;
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      status: MailroomMailExceptionStatus;
    };
    /** MailroomMailPending */
    MailroomMailPending: {
      /**
       * Is Sop
       * @default false
       */
      is_sop: boolean;
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      status: MailroomMailPendingStatus;
    };
    /** MailroomMailSpam */
    MailroomMailSpam: {
      /**
       * Is Sop
       * @default false
       */
      is_sop: boolean;
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      status: MailroomMailSpamStatus;
    };
    /** MailroomMailUndeliverable */
    MailroomMailUndeliverable: {
      /**
       * Is Sop
       * @default false
       */
      is_sop: boolean;
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      status: MailroomMailUndeliverableStatus;
    };
    /** ManagedProvider */
    ManagedProvider: {
      /** Id */
      id: string;
      /** Name */
      name: string;
    };
    /** ManagedProviderCreate */
    ManagedProviderCreate: {
      /** Name */
      name: string;
      /** Public Id */
      public_id: string;
    };
    /** ManagedProviderRequirementCreate */
    ManagedProviderRequirementCreate: {
      /** Id */
      id?: number | null;
      /** Data Id */
      data_id: string;
      /** Requirement Title */
      requirement_title?: string | null;
      /** Managed Provider Id */
      managed_provider_id: number;
      /** Managed Provider Name */
      managed_provider_name?: string | null;
      /** Reviewer Email */
      reviewer_email?: string | null;
    };
    /**
     * MemberRole
     * @enum {string}
     */
    MemberRole: MemberRole;
    /** ModelAttribute */
    ModelAttribute: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      source: ModelAttributeSource;
      /** Model Type */
      model_type?: string | null;
    };
    /** MonthDay */
    MonthDay: {
      /** Month */
      month: number;
      /** Day */
      day: number;
    };
    /** MultiSelectAttribute */
    'MultiSelectAttribute-Input': {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: MultiSelectAttributeInputType;
      params: components['schemas']['MultiSelectParams'];
      /** Placeholder */
      placeholder?: null;
      /**
       * Validators
       * @default []
       */
      validators: components['schemas']['ValidatorType'][];
    };
    /** MultiSelectAttribute */
    'MultiSelectAttribute-Output': {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: MultiSelectAttributeOutputType;
      params: components['schemas']['MultiSelectParams'];
      /** Placeholder */
      placeholder?: null;
      /**
       * Validators
       * @default []
       */
      validators: components['schemas']['ValidatorType'][];
    };
    /** MultiSelectParams */
    MultiSelectParams: {
      /** Options */
      options: components['schemas']['Option'][];
    };
    /** NamedScheduleReporting */
    'NamedScheduleReporting-Input': {
      /** Name */
      name: string;
      schedule: components['schemas']['ScheduleReporting'];
    };
    /** NamedScheduleReporting */
    'NamedScheduleReporting-Output': {
      /** Name */
      name: string;
      schedule: components['schemas']['ScheduleReporting'];
    };
    /** NewAndUpcomingUpdatesNotificationTopic */
    NewAndUpcomingUpdatesNotificationTopic: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      code: NewAndUpcomingUpdatesNotificationTopicCode;
      /**
       * Title
       * @default New requirements
       */
      title: string;
      /**
       * Description
       * @default Learn about new compliance tasks as soon as they are identified.
       */
      description: string;
      /**
       * Configurable
       * @default true
       */
      configurable: boolean;
      /**
       * Notification Names
       * @default [
       *       "upcoming_legislation_alert",
       *       "new_payroll_region_detected_alert",
       *       "new_requirement_detected"
       *     ]
       */
      notification_names: components['schemas']['NotificationName'][];
    };
    /** NewAssignmentsToUserNotificationTopic */
    NewAssignmentsToUserNotificationTopic: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      code: NewAssignmentsToUserNotificationTopicCode;
      /**
       * Title
       * @default New assignments (to user)
       */
      title: string;
      /**
       * Description
       * @default N/A
       */
      description: string;
      /**
       * Configurable
       * @default false
       */
      configurable: boolean;
      /**
       * Notification Names
       * @default [
       *       "new_task",
       *       "new_assignment",
       *       "new_question_assignment",
       *       "mailroom_assignment"
       *     ]
       */
      notification_names: components['schemas']['NotificationName'][];
    };
    /** NewEmailNotificationTopic */
    NewEmailNotificationTopic: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      code: NewEmailNotificationTopicCode;
      /**
       * Title
       * @default State agency updates
       */
      title: string;
      /**
       * Description
       * @default Receive forwarded emails from state agencies, and notices about state legislation that affects you.
       */
      description: string;
      /**
       * Configurable
       * @default false
       */
      configurable: boolean;
      /**
       * Notification Names
       * @default [
       *       "state_email_notification",
       *       "updates_recent_legislation"
       *     ]
       */
      notification_names: components['schemas']['NotificationName'][];
    };
    /** NewMailNotificationTopic */
    NewMailNotificationTopic: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      code: NewMailNotificationTopicCode;
      /**
       * Title
       * @default Mailroom
       */
      title: string;
      /**
       * Description
       * @default Get notified of when you receive new mail for state and local agencies.
       */
      description: string;
      /**
       * Configurable
       * @default true
       */
      configurable: boolean;
      /**
       * Notification Names
       * @default [
       *       "new_mail"
       *     ]
       */
      notification_names: components['schemas']['NotificationName'][];
    };
    /** NonUsAddressAttribute */
    NonUsAddressAttribute: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: NonUsAddressAttributeType;
      /** Params */
      params?: null;
      /** Placeholder */
      placeholder?: null;
      /**
       * Validators
       * @default []
       */
      validators: components['schemas']['ValidatorType'][];
    };
    /** Notice */
    Notice: {
      /** Id */
      id: string;
      region: components['schemas']['Region'];
      /** Title */
      title: string;
      /** File Key */
      file_key: string;
    };
    /** NoticeEnrollmentResponse */
    NoticeEnrollmentResponse: {
      /** Public Key */
      public_key: string;
    };
    /** NoticesResponse */
    NoticesResponse: {
      /** Notices */
      notices: components['schemas']['Notice'][];
      /** Entity Name */
      entity_name: string;
    };
    /**
     * NotificationName
     * @enum {string}
     */
    NotificationName: NotificationName;
    /**
     * NotificationTopicEnum
     * @enum {string}
     */
    NotificationTopicEnum: NotificationTopicEnum;
    /** NotificationUserPreferencesListSubmission */
    NotificationUserPreferencesListSubmission: {
      /** Preferences */
      preferences: components['schemas']['NotificationUserPreferencesSubmission'][];
    };
    /** NotificationUserPreferencesPublic */
    NotificationUserPreferencesPublic: {
      /** Id */
      id: string | null;
      topic: components['schemas']['NotificationTopicEnum'];
      /** Enabled */
      enabled: boolean;
    };
    /** NotificationUserPreferencesSubmission */
    NotificationUserPreferencesSubmission: {
      topic: components['schemas']['NotificationTopicEnum'];
      /** Enabled */
      enabled: boolean;
    };
    /** NumberAttribute */
    NumberAttribute: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: NumberAttributeType;
      params: components['schemas']['NumberParams'];
      /** Placeholder */
      placeholder?: number | null;
      /**
       * Validators
       * @default []
       */
      validators: components['schemas']['ValidatorType'][];
    };
    /** NumberParams */
    NumberParams: {
      /** Min */
      min?: number | null;
      /** Max */
      max?: number | null;
      /** Step */
      step?: number | null;
    };
    /**
     * ObjectType
     * @enum {string}
     */
    ObjectType: ObjectType;
    /** OnboardingBasicRequest */
    OnboardingBasicRequest: {
      /** Hq Region */
      hq_region: string;
      /** Is Hiring Employees */
      is_hiring_employees: boolean;
    };
    /** Option */
    Option: {
      /** Name */
      name: string;
      /** Value */
      value: string;
    };
    /** Owner */
    Owner: {
      /** Id */
      id: string;
      type: components['schemas']['LegalEntityOwnerType'];
      /** Entity */
      entity:
        | components['schemas']['Business']
        | components['schemas']['Person'];
      /** Ownership Percentage */
      ownership_percentage?: number | null;
      /** Ownership Start Date */
      ownership_start_date?: string | null;
      /** Owner License Number */
      owner_license_number?: string | null;
    };
    /** PaginatedResponse[RequirementOverview] */
    PaginatedResponse_RequirementOverview_: {
      /**
       * Results Total
       * @default 0
       */
      results_total: number;
      /**
       * Current Page
       * @default 1
       */
      current_page: number;
      /**
       * Page Size
       * @default 20
       */
      page_size: number;
      /**
       * Results
       * @default []
       */
      results: components['schemas']['RequirementOverview'][];
    };
    /** PartnerNexusCriteria */
    PartnerNexusCriteria: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: PartnerNexusCriteriaType;
      /** Location Scope */
      location_scope:
        | components['schemas']['CriteriaLocationScopeRegion']
        | components['schemas']['CriteriaLocationScopeZip']
        | components['schemas']['CriteriaLocationScopeCity']
        | components['schemas']['CriteriaLocationScopeEntity'];
    };
    /** PasswordGenerator */
    PasswordGenerator: {
      /** Length */
      length: number;
      /** Character Sets */
      character_sets: components['schemas']['CharacterSet'][];
      /** Exclude Characters */
      exclude_characters: string;
    };
    /** PasswordGeneratorParams */
    PasswordGeneratorParams: {
      /** Length */
      length: number;
      /** Character Sets */
      character_sets: components['schemas']['CharacterSet'][];
      /** Exclude Characters */
      exclude_characters: string;
    };
    /** PayrollAmountCriteria */
    PayrollAmountCriteria: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: PayrollAmountCriteriaType;
      /** Bounds */
      bounds:
        | components['schemas']['GreaterThanBounds']
        | components['schemas']['LessThanBounds']
        | components['schemas']['RangeBounds'];
      /** Location Scope */
      location_scope:
        | components['schemas']['CriteriaLocationScopeRegion']
        | components['schemas']['CriteriaLocationScopeZip']
        | components['schemas']['CriteriaLocationScopeCity']
        | components['schemas']['CriteriaLocationScopeEntity'];
    };
    /** PendingChangeComment */
    PendingChangeComment: {
      /** Comment */
      comment: string;
    };
    /** PendingMigration */
    PendingMigration: {
      /** Message */
      message: string;
    };
    /**
     * PeopleSelectType
     * @enum {string}
     */
    PeopleSelectType: PeopleSelectType;
    /** Person */
    Person: {
      /** Id */
      id?: string | null;
      /** Email */
      email: string;
      /** First Name */
      first_name: string;
      /** Last Name */
      last_name: string;
      /** Title */
      title: string;
      /** Phone */
      phone: string;
      /** Birth Date */
      birth_date?: string | null;
      /** Ownership Percentage */
      ownership_percentage?: number | null;
      /** Ownership Start Date */
      ownership_start_date?: string | null;
      /** Owner License Number */
      owner_license_number?: string | null;
      /** Start Date */
      start_date?: string | null;
      address?: components['schemas']['app__public__Address'] | null;
      /** Is Married */
      is_married?: boolean | null;
      /** Spouse First Name */
      spouse_first_name?: string | null;
      /** Spouse Last Name */
      spouse_last_name?: string | null;
      /** Is Officer */
      is_officer: boolean;
      /** Is Owner */
      is_owner: boolean;
      /** Is Member */
      is_member: boolean;
      /** Is Manager */
      is_manager: boolean;
      /** Is Nonprofit Member */
      is_nonprofit_member: boolean;
      /** Is Nonprofit Trustee */
      is_nonprofit_trustee: boolean;
    };
    /**
     * PersonType
     * @enum {string}
     */
    PersonType: PersonType;
    /** PersonalAccountMaintenanceAndUpdatesNotificationTopic */
    PersonalAccountMaintenanceAndUpdatesNotificationTopic: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      code: PersonalAccountMaintenanceAndUpdatesNotificationTopicCode;
      /**
       * Title
       * @default Personal account
       */
      title: string;
      /**
       * Description
       * @default N/A
       */
      description: string;
      /**
       * Configurable
       * @default false
       */
      configurable: boolean;
      /**
       * Notification Names
       * @default [
       *       "email_verification",
       *       "password_reset"
       *     ]
       */
      notification_names: components['schemas']['NotificationName'][];
    };
    /** PhoneDisplay */
    PhoneDisplay: {
      /**
       * Id
       * @default -1
       */
      id: number;
      /**
       * Order
       * @default 1
       */
      order: number;
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: PhoneDisplayType;
      /** Phone */
      phone: string;
    };
    /** PlanResponse */
    PlanResponse: {
      /** Should Show Free Plan */
      should_show_free_plan: boolean;
      /** Should Show Basic Plan */
      should_show_basic_plan: boolean;
    };
    /** Platform */
    Platform: {
      /** Id */
      id: string;
      /** Name */
      name: string;
    };
    /** PlatformAccount */
    PlatformAccount: {
      /** Id */
      id: string;
      agency_account: components['schemas']['app__api__platform__accounts__models__PlatformAgencyAccount'];
      status: components['schemas']['PlatformAccountStatus'];
      /** Id Number */
      id_number: string;
      /** Has Tpa */
      has_tpa: boolean;
      /** Tax Rate Percent */
      tax_rate_percent?: number | null;
      /** Reporting Schedule */
      reporting_schedule?: string | null;
      /** Balance */
      balance?: number | null;
      /** History */
      history?: components['schemas']['PlatformAccountHistoryItem'][] | null;
      /** Notices */
      notices?: components['schemas']['PlatformAccountNotice'][] | null;
      account_login?: components['schemas']['PlatformAccountLogin'] | null;
    };
    /** PlatformAccountHistoryItem */
    PlatformAccountHistoryItem: {
      /**
       * Period Start Date
       * Format: date
       */
      period_start_date: string;
      /**
       * Period End Date
       * Format: date
       */
      period_end_date: string;
      /**
       * Payment Date
       * Format: date
       */
      payment_date: string;
      /**
       * Filing Date
       * Format: date
       */
      filing_date: string;
      /** Payment Amount */
      payment_amount: number;
      /** Amount Due */
      amount_due: number;
      /** Amount Applied */
      amount_applied: number;
      /** Raw Data */
      raw_data: {
        [key: string]: unknown;
      };
    };
    /** PlatformAccountLogin */
    PlatformAccountLogin: {
      /** Login Url */
      login_url: string;
      /** User Name */
      user_name: string;
      /** Two Factor Enabled */
      two_factor_enabled: boolean;
    };
    /** PlatformAccountNotice */
    PlatformAccountNotice: {
      mail_classification: components['schemas']['PlatformMailClassification'];
      /**
       * Received On
       * Format: date
       */
      received_on: string;
      /** Description */
      description: string;
      /** Summary */
      summary: string;
      /** Signed Url */
      signed_url: string;
    };
    /**
     * PlatformAccountStatus
     * @enum {string}
     */
    PlatformAccountStatus: PlatformAccountStatus;
    /** PlatformAgency */
    PlatformAgency: {
      /** Id */
      id: string;
      /** Name */
      name: string;
      /** Website */
      website: string;
    };
    /** PlatformAgencyAttributeAndValue */
    PlatformAgencyAttributeAndValue: {
      /** Name */
      name: string;
      /** Description */
      description: string | null;
      /** Value */
      value: string | null;
    };
    /** PlatformAuthenticateRequest */
    PlatformAuthenticateRequest: {
      /** Legal Entity Id */
      legal_entity_id: string;
    };
    /** PlatformConnectRequest */
    PlatformConnectRequest: {
      /** Legal Entity Id */
      legal_entity_id: string;
      /** Agency Account Id */
      agency_account_id: string;
    };
    /** PlatformConnectSession */
    PlatformConnectSession: {
      /** Connect Url */
      connect_url: string;
      connection: components['schemas']['PlatformConnection'];
    };
    /** PlatformConnection */
    PlatformConnection: {
      /** Id */
      id: string;
      status: components['schemas']['PlatformConnectionStatus'];
      account: components['schemas']['PlatformAccount'] | null;
    };
    /**
     * PlatformConnectionStatus
     * @enum {string}
     */
    PlatformConnectionStatus: PlatformConnectionStatus;
    /** PlatformLegalEntityAccountLogin */
    PlatformLegalEntityAccountLogin: {
      /**
       * Id
       * @description The identifier of this Account Login
       */
      id: string;
      /**
       * Name
       * @description The name of the Login
       */
      name: string;
      /**
       * Location Id
       * @description The location id the login belongs to
       */
      location_id: string;
      /**
       * Login Url
       * @description This field is deprecated, please use url.
       */
      login_url: string;
      /**
       * Url
       * @description The url pointing to the login page for this Login
       */
      url: string;
    };
    /** PlatformLegalEntityAccountLoginSessionResponse */
    PlatformLegalEntityAccountLoginSessionResponse: {
      /**
       * Created At
       * @description This is the time the `url` became accessible
       */
      created_at: string;
      /**
       * Expires At
       * @description This is the time after which the `url` will no longer accessible
       */
      expires_at: string;
      /**
       * Url
       * @description A temporary link the user must follow if they want to access the Login information (including passwords and user names)
       */
      url: string;
    };
    /** PlatformMail */
    PlatformMail: {
      /** Id */
      id: string;
      /** Location Id */
      location_id?: string | null;
      type: components['schemas']['MailType'];
      /**
       * Received
       * Format: date
       */
      received: string;
      /** Sender */
      sender?: string | null;
      /** File Url */
      file_url: string;
    };
    /**
     * PlatformMailClassification
     * @enum {string}
     */
    PlatformMailClassification: PlatformMailClassification;
    /** Policy */
    Policy: {
      /** Id */
      id: string;
      /** Slug */
      slug: string;
      /** Title */
      title?: string | null;
      policy_section: components['schemas']['PolicySection'];
      policy_scope?: components['schemas']['PolicyScope'] | null;
      policy_category?: components['schemas']['PolicyCategory'] | null;
      content: components['schemas']['PolicyContent'];
      /** Order */
      order: number;
      /** Version */
      version: number;
      /** Last Material Change Version */
      last_material_change_version: number;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      /**
       * Is Custom Policy
       * @default false
       */
      is_custom_policy: boolean;
    };
    /** PolicyAdoptRequest */
    PolicyAdoptRequest: {
      /** Policies */
      policies: string[];
    };
    /** PolicyCategory */
    PolicyCategory: {
      /** Id */
      id: string;
      /** Name */
      name: string;
      /** Order */
      order: number;
      /** Policy Section Id */
      policy_section_id: string;
    };
    /** PolicyContent */
    PolicyContent: {
      /** Main */
      main: components['schemas']['PolicyMainContent'][];
      /** Full Details */
      full_details?: string | null;
      /**
       * Resources
       * @default []
       */
      resources: components['schemas']['PolicyResource'][];
    };
    /** PolicyFormSubmission */
    PolicyFormSubmission: {
      /** Data */
      data: {
        [key: string]: unknown;
      };
    };
    /** PolicyInstance */
    PolicyInstance: {
      /** Id */
      id: number;
      /** Slug */
      slug: string;
      /** Title */
      title?: string | null;
      /** Policy Id */
      policy_id: string;
      policy_section: components['schemas']['PolicySection'];
      policy_scope?: components['schemas']['PolicyScope'] | null;
      policy_category?: components['schemas']['PolicyCategory'] | null;
      content: components['schemas']['PolicyContent'];
      /** Order */
      order: number;
      /** Policy Version */
      policy_version: number;
      /** Is Dirty */
      is_dirty: boolean;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Is Custom Policy
       * @default false
       */
      is_custom_policy: boolean;
      /** Attribute Values */
      attribute_values: {
        [key: string]: unknown;
      };
    };
    /** PolicyMainContent */
    PolicyMainContent: {
      /**
       * Type
       * @default markdown
       * @constant
       */
      type: 'markdown';
      /** Content */
      content: string;
    };
    /** PolicyResource */
    PolicyResource: {
      /** Title */
      title: string;
      /** Url */
      url: string;
    };
    /** PolicyScope */
    PolicyScope: {
      /** City Name */
      city_name?: string | null;
      /** Region Id */
      region_id?: number | null;
      region?: components['schemas']['Region'] | null;
      /** Id */
      id?: number | null;
      /** Zip Code Group Id */
      zip_code_group_id?: number | null;
      /** Zip Code Group Label */
      zip_code_group_label?: string | null;
      /** Zip Codes */
      zip_codes?: string[] | null;
    };
    /** PolicySection */
    PolicySection: {
      /** Id */
      id: string;
      /** Title */
      title: string;
      /** Description */
      description?: string | null;
      /** Order */
      order: number;
      /** Icon */
      icon: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
    };
    /** PolicySectionForm */
    PolicySectionForm: {
      policy: components['schemas']['Policy'];
      form: components['schemas']['FormattedForm'];
    };
    /** PromptRequest */
    PromptRequest: {
      /** Prompt */
      prompt: string;
    };
    /** PublicInvite */
    PublicInvite: {
      /** Id */
      id: string;
      /** Email */
      email?: string | null;
      /** Is Accepted */
      is_accepted: boolean;
    };
    /** QueryCalendarRequirementsParams */
    QueryCalendarRequirementsParams: {
      /**
       * Start Date
       * Format: date
       */
      start_date: string;
      /**
       * End Date
       * Format: date
       */
      end_date: string;
    };
    /** QueryRequirementsParams */
    QueryRequirementsParams: {
      /**
       * Start Date
       * Format: date
       */
      start_date: string;
      /**
       * End Date
       * Format: date
       */
      end_date: string;
      /** Requirement Id */
      requirement_id?: string | null;
      /** Region Codes */
      region_codes?: string[] | null;
      /** Tags */
      tags?: string[] | null;
      /**
       * Include Virtual
       * @default true
       */
      include_virtual: boolean;
      /** Employee Id */
      employee_id?: string | null;
    };
    /** QueryResponse */
    QueryResponse: {
      /** Data */
      data: components['schemas']['RequirementInstance'][];
    };
    /** QuestionTaskAnswer */
    QuestionTaskAnswer: {
      /** Answer */
      answer: string;
      /** Scoped Region Code */
      scoped_region_code?: string | null;
    };
    /** RadioAttribute */
    'RadioAttribute-Input': {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: RadioAttributeInputType;
      params: components['schemas']['RadioParams'];
      /** Placeholder */
      placeholder?: null;
      /**
       * Validators
       * @default []
       */
      validators: components['schemas']['ValidatorType'][];
    };
    /** RadioAttribute */
    'RadioAttribute-Output': {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: RadioAttributeOutputType;
      params: components['schemas']['RadioParams'];
      /** Placeholder */
      placeholder?: null;
      /**
       * Validators
       * @default []
       */
      validators: components['schemas']['ValidatorType'][];
    };
    /** RadioParams */
    RadioParams: {
      /** Options */
      options: components['schemas']['Option'][];
    };
    /** RangeBounds */
    RangeBounds: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: RangeBoundsType;
      /** Lower Bound */
      lower_bound: number;
      /** Upper Bound */
      upper_bound: number;
    };
    /**
     * RecipientType
     * @enum {string}
     */
    RecipientType: RecipientType;
    /** RecordType */
    RecordType: {
      /** Id */
      id: number;
      /** Public Id */
      public_id: string;
      /** Type */
      type: string;
    };
    /** RedeemTokenRequest */
    RedeemTokenRequest: {
      /** Token */
      token: string;
    };
    /** RedirectAutomationResponse */
    RedirectAutomationResponse: {
      /** Automation Url */
      automation_url: string;
      /** Fee */
      fee:
        | (
            | components['schemas']['FeeFixed']
            | components['schemas']['FeeRange']
            | components['schemas']['FeeVariable']
          )
        | null;
      eta: components['schemas']['RequirementETA'] | null;
    };
    /** ReferenceCheck */
    ReferenceCheck: {
      /** Datums */
      datums: {
        [key: string]: string | number;
      }[];
      /** Corporate Roles */
      corporate_roles: {
        [key: string]: string;
      }[];
      /** Submitter */
      submitter: boolean;
    };
    /** RefreshTokenRequest */
    RefreshTokenRequest: {
      /** Legal Entity Id */
      legal_entity_id?: string | null;
    };
    /** Region */
    Region: {
      /** Id */
      id: string;
      /** Name */
      name: string;
    };
    /** RegionNavigator */
    RegionNavigator: {
      /** Id */
      id: string;
      entity_type: components['schemas']['EntityTypeEnum'];
      tax_class: components['schemas']['TaxClassEnum'];
      /** Payroll Requirements */
      payroll_requirements: string[];
      /** Hr Requirements */
      hr_requirements: string[];
      /** Hr Benefits Requirements */
      hr_benefits_requirements: string[];
      /** Entity Tax Requirements */
      entity_tax_requirements: string[];
      /** Sales Tax Requirements */
      sales_tax_requirements: string[];
      /** Registration Requirements */
      registration_requirements: string[];
    };
    /** RegisteredAgent */
    RegisteredAgent: {
      /** Status */
      status: string;
    };
    /**
     * RegisteredAgentStatus
     * @enum {string}
     */
    RegisteredAgentStatus: RegisteredAgentStatus;
    /** RemediationInstance */
    RemediationInstance: {
      /** Id */
      id?: string | null;
      /** Data Id */
      data_id: string;
      /** Title */
      title: string;
      /** Description */
      description: string;
      /**
       * Optional
       * @default false
       */
      optional: boolean;
      /**
       * Order
       * @default 0
       */
      order: number;
      /** Display */
      display: (
        | components['schemas']['DefaultDisplay']
        | components['schemas']['EmailDisplay']
        | components['schemas']['FaxDisplay']
        | components['schemas']['LinkDisplay']
        | components['schemas']['MailDisplay']
        | components['schemas']['PhoneDisplay']
      )[];
      /** Is Done */
      is_done: boolean;
    };
    /** RemediationUpdateParams */
    RemediationUpdateParams: {
      /** Is Done */
      is_done: boolean;
    };
    /** RemediationUpdateResult */
    RemediationUpdateResult: {
      /** Success */
      success: boolean;
    };
    /** RenderTemplateResponse */
    RenderTemplateResponse: {
      /** Subject */
      subject: string;
      /** Template */
      template: string;
      /** Variables */
      variables: string[];
      /**
       * Attributes
       * @default []
       */
      attributes: components['schemas']['AdminBaseAttributeWithValue'][];
    };
    /** RequirementAttribute */
    RequirementAttribute: {
      attribute: components['schemas']['Attribute'];
      /**
       * Optional
       * @default false
       */
      optional: boolean;
    };
    /** RequirementBatchUpdateItem */
    RequirementBatchUpdateItem: {
      /** Id */
      id: string;
      status: components['schemas']['LegalEntityRequirementStatus'];
    };
    /** RequirementBatchUpdateParams */
    RequirementBatchUpdateParams: {
      /** Statuses */
      statuses: components['schemas']['RequirementBatchUpdateItem'][];
    };
    /**
     * RequirementCategory
     * @enum {string}
     */
    RequirementCategory: RequirementCategory;
    /** RequirementContextEmployee */
    RequirementContextEmployee: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      scope: RequirementContextEmployeeScope;
      /** Employee Id */
      employee_id: string;
      /** Message */
      message: string;
    };
    /** RequirementContextLegalEntity */
    RequirementContextLegalEntity: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      scope: RequirementContextLegalEntityScope;
      /** Legal Entity Id */
      legal_entity_id: string;
      /** Message */
      message: string;
    };
    /** RequirementETA */
    RequirementETA: {
      estimation: components['schemas']['ETARange'];
      /** Earliest Date */
      earliest_date: string | null;
      /** Latest Date */
      latest_date: string | null;
    };
    /** RequirementInstance */
    RequirementInstance: {
      /** Id */
      id?: string | null;
      /** Data Id */
      data_id: string;
      /** Region */
      region: string[];
      /** Title */
      title: string;
      /** Summary */
      summary?: string | null;
      /** Description */
      description: string;
      category: components['schemas']['RequirementCategory'];
      /** Schedule */
      schedule:
        | components['schemas']['ScheduleOneTime']
        | components['schemas']['ScheduleMultiYear']
        | components['schemas']['ScheduleNonReporting']
        | components['schemas']['ScheduleReporting']
        | components['schemas']['ScheduleReportingMulti-Output']
        | components['schemas']['ScheduleEmployeeHiring']
        | components['schemas']['ScheduleEmployeeTermination'];
      /** Resources */
      resources: components['schemas']['ResourceLink'][];
      assigned_user?: components['schemas']['UserRef'] | null;
      /** Remediations */
      remediations: components['schemas']['RemediationInstance'][];
      /** Due Date */
      due_date?: string | null;
      status: components['schemas']['RequirementStatus'];
      /** Is Virtual */
      is_virtual: boolean;
      /** Is Managed */
      is_managed: boolean;
      managed_provider?: components['schemas']['ManagedProvider'] | null;
      /** Agencies */
      agencies: components['schemas']['AgencyRef'][];
      /** Consumes */
      consumes: components['schemas']['RequirementAttribute'][];
      /** Produces */
      produces: components['schemas']['RequirementAttribute'][];
      /** Is Blocked */
      is_blocked: boolean;
      /** Unblocks */
      unblocks: components['schemas']['RequirementRef'][];
      /** Is Automatable */
      is_automatable: boolean;
      /** Domestic Fee */
      domestic_fee?:
        | (
            | components['schemas']['FeeFixed']
            | components['schemas']['FeeRange']
            | components['schemas']['FeeVariable']
          )
        | null;
      /** Foreign Fee */
      foreign_fee?:
        | (
            | components['schemas']['FeeFixed']
            | components['schemas']['FeeRange']
            | components['schemas']['FeeVariable']
          )
        | null;
      /**
       * Has Criteria
       * @default false
       */
      has_criteria: boolean;
      /** Criteria */
      criteria?:
        | (
            | components['schemas']['CriteriaEmployeeCount']
            | components['schemas']['CriteriaPayrollAmount']
            | components['schemas']['CriteriaHasRegionEmployees']
            | components['schemas']['CriteriaHasRegionPhysicalLocation']
            | components['schemas']['CriteriaForeignQualificationDate']
            | components['schemas']['CriteriaDoingBusiness']
            | components['schemas']['CriteriaBusinessIncomeTaxNexus']
            | components['schemas']['CriteriaSalesTaxNexus']
            | components['schemas']['CriteriaEstimatedTaxLiability']
            | components['schemas']['CriteriaSingleRequirement']
            | components['schemas']['CriteriaCharitableRegistrationNexus']
            | components['schemas']['CriteriaPartnerNexus']
          )[]
        | null;
      /** Is Criteria Satisfied */
      is_criteria_satisfied?: boolean | null;
      /**
       * Created At
       * Format: date
       */
      created_at: string;
      /** Requirement Context */
      requirement_context?:
        | (
            | components['schemas']['RequirementContextEmployee']
            | components['schemas']['RequirementContextLegalEntity']
          )
        | null;
      /** Tags */
      tags?: string[] | null;
      eta?: components['schemas']['RequirementETA'] | null;
      /** Frequency Note */
      frequency_note?: string | null;
      /** Tax Rate Note */
      tax_rate_note?: string | null;
      /** General Notes */
      general_notes?: string[] | null;
      /** Policy Instances */
      policy_instances: components['schemas']['PolicyInstance'][];
    };
    /** RequirementOverview */
    RequirementOverview: {
      /** Id */
      id?: string | null;
      /** Data Id */
      data_id: string;
      /** Region */
      region: string[];
      /** Title */
      title: string;
      category: components['schemas']['RequirementCategory'];
      /** Schedule */
      schedule:
        | components['schemas']['ScheduleOneTime']
        | components['schemas']['ScheduleMultiYear']
        | components['schemas']['ScheduleNonReporting']
        | components['schemas']['ScheduleReporting']
        | components['schemas']['ScheduleReportingMulti-Output']
        | components['schemas']['ScheduleEmployeeHiring']
        | components['schemas']['ScheduleEmployeeTermination'];
      assigned_user: components['schemas']['UserRef'] | null;
      /** Due Date */
      due_date?: string | null;
      status: components['schemas']['RequirementStatus'];
      /**
       * Is Virtual
       * @default false
       */
      is_virtual: boolean;
      /** Is Managed */
      is_managed: boolean;
      managed_provider: components['schemas']['ManagedProvider'] | null;
      /** Is Blocked */
      is_blocked: boolean;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /** Requirement Context */
      requirement_context:
        | (
            | components['schemas']['RequirementContextEmployee']
            | components['schemas']['RequirementContextLegalEntity']
          )
        | null;
    };
    /** RequirementPatchAssignOwner */
    RequirementPatchAssignOwner: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      operation: RequirementPatchAssignOwnerOperation;
      /** User Id */
      user_id: string;
    };
    /** RequirementPatchUnassignOwner */
    RequirementPatchUnassignOwner: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      operation: RequirementPatchUnassignOwnerOperation;
    };
    /** RequirementRef */
    RequirementRef: {
      /** Data Id */
      data_id: string;
      /** Title */
      title: string;
    };
    /**
     * RequirementStatus
     * @enum {string}
     */
    RequirementStatus: RequirementStatus;
    /** RequirementUpdateParams */
    RequirementUpdateParams: {
      status: components['schemas']['LegalEntityRequirementStatus'];
    };
    /** RequirementUpdateResult */
    RequirementUpdateResult: {
      /** Success */
      success: boolean;
    };
    /** ResourceLink */
    ResourceLink: {
      /** Name */
      name: string;
      /**
       * Url
       * Format: uri
       */
      url: string;
    };
    /**
     * Role
     * @enum {string}
     */
    Role: Role;
    /** RuleConditionAnd */
    'RuleConditionAnd-Input': {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: RuleConditionAndInputType;
      /** And Conditions */
      and_conditions: (
        | components['schemas']['RuleConditionEquals']
        | components['schemas']['RuleConditionExists']
        | components['schemas']['RuleConditionNot-Input']
        | components['schemas']['RuleConditionAnd-Input']
        | components['schemas']['RuleConditionOr-Input']
        | components['schemas']['RuleConditionLowerBounds']
        | components['schemas']['RuleConditionUpperBounds']
      )[];
    };
    /** RuleConditionAnd */
    'RuleConditionAnd-Output': {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: RuleConditionAndOutputType;
      /** And Conditions */
      and_conditions: (
        | components['schemas']['RuleConditionEquals']
        | components['schemas']['RuleConditionExists']
        | components['schemas']['RuleConditionNot-Output']
        | components['schemas']['RuleConditionAnd-Output']
        | components['schemas']['RuleConditionOr-Output']
        | components['schemas']['RuleConditionLowerBounds']
        | components['schemas']['RuleConditionUpperBounds']
      )[];
    };
    /** RuleConditionEquals */
    RuleConditionEquals: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: RuleConditionEqualsType;
      /** Value */
      value: string | number | boolean;
    };
    /** RuleConditionExists */
    RuleConditionExists: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: RuleConditionExistsType;
    };
    /** RuleConditionLowerBounds */
    RuleConditionLowerBounds: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: RuleConditionLowerBoundsType;
      /** Value */
      value: number;
    };
    /** RuleConditionNot */
    'RuleConditionNot-Input': {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: RuleConditionNotInputType;
      /** Not Condition */
      not_condition:
        | components['schemas']['RuleConditionEquals']
        | components['schemas']['RuleConditionExists']
        | components['schemas']['RuleConditionNot-Input']
        | components['schemas']['RuleConditionAnd-Input']
        | components['schemas']['RuleConditionOr-Input']
        | components['schemas']['RuleConditionLowerBounds']
        | components['schemas']['RuleConditionUpperBounds'];
    };
    /** RuleConditionNot */
    'RuleConditionNot-Output': {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: RuleConditionNotOutputType;
      /** Not Condition */
      not_condition:
        | components['schemas']['RuleConditionEquals']
        | components['schemas']['RuleConditionExists']
        | components['schemas']['RuleConditionNot-Output']
        | components['schemas']['RuleConditionAnd-Output']
        | components['schemas']['RuleConditionOr-Output']
        | components['schemas']['RuleConditionLowerBounds']
        | components['schemas']['RuleConditionUpperBounds'];
    };
    /** RuleConditionOr */
    'RuleConditionOr-Input': {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: RuleConditionOrInputType;
      /** Or Conditions */
      or_conditions: (
        | components['schemas']['RuleConditionEquals']
        | components['schemas']['RuleConditionExists']
        | components['schemas']['RuleConditionNot-Input']
        | components['schemas']['RuleConditionAnd-Input']
        | components['schemas']['RuleConditionOr-Input']
        | components['schemas']['RuleConditionLowerBounds']
        | components['schemas']['RuleConditionUpperBounds']
      )[];
    };
    /** RuleConditionOr */
    'RuleConditionOr-Output': {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: RuleConditionOrOutputType;
      /** Or Conditions */
      or_conditions: (
        | components['schemas']['RuleConditionEquals']
        | components['schemas']['RuleConditionExists']
        | components['schemas']['RuleConditionNot-Output']
        | components['schemas']['RuleConditionAnd-Output']
        | components['schemas']['RuleConditionOr-Output']
        | components['schemas']['RuleConditionLowerBounds']
        | components['schemas']['RuleConditionUpperBounds']
      )[];
    };
    /** RuleConditionUpperBounds */
    RuleConditionUpperBounds: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: RuleConditionUpperBoundsType;
      /** Value */
      value: number;
    };
    /** SSOAuthUrlRequest */
    SSOAuthUrlRequest: {
      /** Username */
      username: string;
      /** Legal Entity Id */
      legal_entity_id?: string | null;
      /** State */
      state?: {
        [key: string]: unknown;
      } | null;
    };
    /** SalesTaxNexusCriteria */
    SalesTaxNexusCriteria: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: SalesTaxNexusCriteriaType;
      /** Location Scope */
      location_scope:
        | components['schemas']['CriteriaLocationScopeRegion']
        | components['schemas']['CriteriaLocationScopeZip']
        | components['schemas']['CriteriaLocationScopeCity']
        | components['schemas']['CriteriaLocationScopeEntity'];
    };
    /** SameAsBusinessAddress */
    SameAsBusinessAddress: {
      /**
       * Is Business Address
       * @constant
       */
      is_business_address: true;
    };
    /** ScheduleDelayFirstOccurrenceMonthsBeforeDue */
    ScheduleDelayFirstOccurrenceMonthsBeforeDue: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      category: ScheduleDelayFirstOccurrenceMonthsBeforeDueCategory;
      /** Registration Date Attribute Id */
      registration_date_attribute_id: string;
      /** Months */
      months: number;
    };
    /** ScheduleDelayFirstOccurrenceNone */
    ScheduleDelayFirstOccurrenceNone: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      category: ScheduleDelayFirstOccurrenceNoneCategory;
    };
    /** ScheduleDelayFirstOccurrenceSameYear */
    ScheduleDelayFirstOccurrenceSameYear: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      category: ScheduleDelayFirstOccurrenceSameYearCategory;
      /** Registration Date Attribute Id */
      registration_date_attribute_id: string;
    };
    /** ScheduleDueDateCalculationEndOfMonth */
    ScheduleDueDateCalculationEndOfMonth: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      category: ScheduleDueDateCalculationEndOfMonthCategory;
      /**
       * Offset Months
       * @default 0
       */
      offset_months: number;
    };
    /** ScheduleDueDateCalculationMonthDay */
    ScheduleDueDateCalculationMonthDay: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      category: ScheduleDueDateCalculationMonthDayCategory;
      /**
       * Month
       * @default 0
       */
      month: number;
      /**
       * Day
       * @default 0
       */
      day: number;
    };
    /** ScheduleDueDateCalculationMonthDaySameYear */
    ScheduleDueDateCalculationMonthDaySameYear: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      category: ScheduleDueDateCalculationMonthDaySameYearCategory;
      /**
       * Month
       * @default 0
       */
      month: number;
      /**
       * Day
       * @default 0
       */
      day: number;
    };
    /** ScheduleDueDateCalculationNone */
    ScheduleDueDateCalculationNone: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      category: ScheduleDueDateCalculationNoneCategory;
    };
    /** ScheduleDueDateCalculationRelative */
    ScheduleDueDateCalculationRelative: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      category: ScheduleDueDateCalculationRelativeCategory;
      /**
       * Months
       * @default 0
       */
      months: number;
      /**
       * Days
       * @default 0
       */
      days: number;
    };
    /** ScheduleDueDateOffsetBeginningOfNextPeriodStartMonth */
    ScheduleDueDateOffsetBeginningOfNextPeriodStartMonth: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      category: ScheduleDueDateOffsetBeginningOfNextPeriodStartMonthCategory;
    };
    /** ScheduleDueDateOffsetDays */
    ScheduleDueDateOffsetDays: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      category: ScheduleDueDateOffsetDaysCategory;
      /** Days */
      days: number;
    };
    /** ScheduleDueDateOffsetDefault */
    ScheduleDueDateOffsetDefault: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      category: ScheduleDueDateOffsetDefaultCategory;
    };
    /** ScheduleDueDateOffsetEndOfAnniversaryMonth */
    ScheduleDueDateOffsetEndOfAnniversaryMonth: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      category: ScheduleDueDateOffsetEndOfAnniversaryMonthCategory;
    };
    /** ScheduleDueDateOffsetEndOfMonth */
    ScheduleDueDateOffsetEndOfMonth: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      category: ScheduleDueDateOffsetEndOfMonthCategory;
      /**
       * Offset Months
       * @default 0
       */
      offset_months: number;
    };
    /** ScheduleDueDateOffsetEndOfMonthPreviousToNextPeriodStartMonth */
    ScheduleDueDateOffsetEndOfMonthPreviousToNextPeriodStartMonth: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      category: ScheduleDueDateOffsetEndOfMonthPreviousToNextPeriodStartMonthCategory;
    };
    /** ScheduleDueDateOffsetEndOfNextMonth */
    ScheduleDueDateOffsetEndOfNextMonth: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      category: ScheduleDueDateOffsetEndOfNextMonthCategory;
    };
    /** ScheduleDueDateOffsetEndOfQuarter */
    ScheduleDueDateOffsetEndOfQuarter: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      category: ScheduleDueDateOffsetEndOfQuarterCategory;
    };
    /** ScheduleDueDateOffsetMonths */
    ScheduleDueDateOffsetMonths: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      category: ScheduleDueDateOffsetMonthsCategory;
      /** Months */
      months: number;
    };
    /** ScheduleDueDateOffsetNone */
    ScheduleDueDateOffsetNone: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      category: ScheduleDueDateOffsetNoneCategory;
    };
    /** ScheduleDueDateOffsetRelative */
    ScheduleDueDateOffsetRelative: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      category: ScheduleDueDateOffsetRelativeCategory;
      /**
       * Months
       * @default 0
       */
      months: number;
      /**
       * Days
       * @default 0
       */
      days: number;
    };
    /** ScheduleDueDateOffsetRelativeOnDateAttribute */
    ScheduleDueDateOffsetRelativeOnDateAttribute: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      category: ScheduleDueDateOffsetRelativeOnDateAttributeCategory;
      /** Attribute Id */
      attribute_id: string;
      /**
       * Months
       * @default 0
       */
      months: number;
      /**
       * Days
       * @default 0
       */
      days: number;
    };
    /** ScheduleDueDateOffsetRelativeOnDateAttributeEndOfMonth */
    ScheduleDueDateOffsetRelativeOnDateAttributeEndOfMonth: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      category: ScheduleDueDateOffsetRelativeOnDateAttributeEndOfMonthCategory;
      /** Attribute Id */
      attribute_id: string;
      /**
       * Months
       * @default 0
       */
      months: number;
      /**
       * Days
       * @default 0
       */
      days: number;
    };
    /** ScheduleDueDateOffsetRelativeOnDateAttributeFifteenthOfMonth */
    ScheduleDueDateOffsetRelativeOnDateAttributeFifteenthOfMonth: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      category: ScheduleDueDateOffsetRelativeOnDateAttributeFifteenthOfMonthCategory;
      /** Attribute Id */
      attribute_id: string;
      /**
       * Offset Months
       * @default 0
       */
      offset_months: number;
    };
    /** ScheduleDueDateOffsetYearlyEndOfMonth */
    ScheduleDueDateOffsetYearlyEndOfMonth: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      category: ScheduleDueDateOffsetYearlyEndOfMonthCategory;
      /** Month */
      month: number;
    };
    /** ScheduleDueDateOffsetYearlyOnDate */
    ScheduleDueDateOffsetYearlyOnDate: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      category: ScheduleDueDateOffsetYearlyOnDateCategory;
      /** Month */
      month: number;
      /** Day */
      day: number;
    };
    /** ScheduleDueDateOffsetYearlyOnDateAttribute */
    ScheduleDueDateOffsetYearlyOnDateAttribute: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      category: ScheduleDueDateOffsetYearlyOnDateAttributeCategory;
      /** Attribute Id */
      attribute_id: string;
    };
    /** ScheduleEmployeeHiring */
    ScheduleEmployeeHiring: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      category: ScheduleEmployeeHiringCategory;
      /** @default {
       *       "category": "relative",
       *       "months": 0,
       *       "days": 5
       *     } */
      due_date_offset: components['schemas']['ScheduleDueDateOffsetRelative'];
    };
    /** ScheduleEmployeeTermination */
    ScheduleEmployeeTermination: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      category: ScheduleEmployeeTerminationCategory;
      /** @default {
       *       "category": "relative",
       *       "months": 0,
       *       "days": 5
       *     } */
      due_date_offset: components['schemas']['ScheduleDueDateOffsetRelative'];
    };
    /** ScheduleMultiYear */
    ScheduleMultiYear: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      category: ScheduleMultiYearCategory;
      /** Frequency */
      frequency: number;
      /** Registration Date Attribute Id */
      registration_date_attribute_id?: string | null;
      /** Override Attribute Id */
      override_attribute_id?: string | null;
      recurrence: components['schemas']['ScheduleMultiYearRecurrence'];
      /**
       * Due Date Calculation
       * @default {
       *       "category": "none"
       *     }
       */
      due_date_calculation:
        | components['schemas']['ScheduleDueDateCalculationEndOfMonth']
        | components['schemas']['ScheduleDueDateCalculationMonthDay']
        | components['schemas']['ScheduleDueDateCalculationMonthDaySameYear']
        | components['schemas']['ScheduleDueDateCalculationNone']
        | components['schemas']['ScheduleDueDateCalculationRelative'];
      /**
       * First Occurrence
       * @default {
       *       "type": "none"
       *     }
       */
      first_occurrence:
        | components['schemas']['ScheduleMultiYearFirstOccurrenceNone']
        | components['schemas']['ScheduleMultiYearFirstOccurrenceRegistration'];
    };
    /** ScheduleMultiYearFirstOccurrenceNone */
    ScheduleMultiYearFirstOccurrenceNone: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: ScheduleMultiYearFirstOccurrenceNoneType;
    };
    /** ScheduleMultiYearFirstOccurrenceRegistration */
    ScheduleMultiYearFirstOccurrenceRegistration: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: ScheduleMultiYearFirstOccurrenceRegistrationType;
      /** Offset Years */
      offset_years: number;
      /** Override First Occurrence Year */
      override_first_occurrence_year?: number | null;
    };
    /**
     * ScheduleMultiYearRecurrence
     * @enum {string}
     */
    ScheduleMultiYearRecurrence: ScheduleMultiYearRecurrence;
    /** ScheduleNonReporting */
    ScheduleNonReporting: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      category: ScheduleNonReportingCategory;
      /** Month Days */
      month_days: components['schemas']['MonthDay'][];
      /**
       * Delay First Occurrence
       * @default {
       *       "category": "none"
       *     }
       */
      delay_first_occurrence:
        | components['schemas']['ScheduleDelayFirstOccurrenceNone']
        | components['schemas']['ScheduleDelayFirstOccurrenceSameYear']
        | components['schemas']['ScheduleDelayFirstOccurrenceMonthsBeforeDue'];
      /**
       * Use Fiscal Year
       * @default false
       */
      use_fiscal_year: boolean;
    };
    /** ScheduleOneTime */
    ScheduleOneTime: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      category: ScheduleOneTimeCategory;
      /** Due Date Offset */
      due_date_offset?:
        | (
            | components['schemas']['ScheduleDueDateOffsetBeginningOfNextPeriodStartMonth']
            | components['schemas']['ScheduleDueDateOffsetDays']
            | components['schemas']['ScheduleDueDateOffsetDefault']
            | components['schemas']['ScheduleDueDateOffsetEndOfAnniversaryMonth']
            | components['schemas']['ScheduleDueDateOffsetEndOfMonth']
            | components['schemas']['ScheduleDueDateOffsetEndOfMonthPreviousToNextPeriodStartMonth']
            | components['schemas']['ScheduleDueDateOffsetEndOfNextMonth']
            | components['schemas']['ScheduleDueDateOffsetEndOfQuarter']
            | components['schemas']['ScheduleDueDateOffsetMonths']
            | components['schemas']['ScheduleDueDateOffsetNone']
            | components['schemas']['ScheduleDueDateOffsetRelative']
            | components['schemas']['ScheduleDueDateOffsetYearlyEndOfMonth']
            | components['schemas']['ScheduleDueDateOffsetYearlyOnDate']
            | components['schemas']['ScheduleDueDateOffsetYearlyOnDateAttribute']
            | components['schemas']['ScheduleDueDateOffsetRelativeOnDateAttribute']
            | components['schemas']['ScheduleDueDateOffsetRelativeOnDateAttributeEndOfMonth']
            | components['schemas']['ScheduleDueDateOffsetRelativeOnDateAttributeFifteenthOfMonth']
          )
        | null;
    };
    /** SchedulePeriodOffsetDefault */
    SchedulePeriodOffsetDefault: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      category: SchedulePeriodOffsetDefaultCategory;
    };
    /** SchedulePeriodOffsetMonths */
    SchedulePeriodOffsetMonths: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      category: SchedulePeriodOffsetMonthsCategory;
      /** Months */
      months: number;
    };
    /** SchedulePeriodOffsetNone */
    SchedulePeriodOffsetNone: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      category: SchedulePeriodOffsetNoneCategory;
    };
    /** SchedulePeriodOffsetQuarterlyOnFiscalYear */
    SchedulePeriodOffsetQuarterlyOnFiscalYear: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      category: SchedulePeriodOffsetQuarterlyOnFiscalYearCategory;
    };
    /** SchedulePeriodOffsetRelative */
    SchedulePeriodOffsetRelative: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      category: SchedulePeriodOffsetRelativeCategory;
      /**
       * Months
       * @default 0
       */
      months: number;
      /**
       * Days
       * @default 0
       */
      days: number;
    };
    /** SchedulePeriodOffsetYearlyOnDate */
    SchedulePeriodOffsetYearlyOnDate: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      category: SchedulePeriodOffsetYearlyOnDateCategory;
      /** Month */
      month: number;
      /** Day */
      day: number;
    };
    /** SchedulePeriodOffsetYearlyOnDateAttribute */
    SchedulePeriodOffsetYearlyOnDateAttribute: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      category: SchedulePeriodOffsetYearlyOnDateAttributeCategory;
      /** Attribute Id */
      attribute_id: string;
      /** Override Attribute Id */
      override_attribute_id?: string | null;
    };
    /** SchedulePeriodOffsetYearlyOnFiscalYear */
    SchedulePeriodOffsetYearlyOnFiscalYear: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      category: SchedulePeriodOffsetYearlyOnFiscalYearCategory;
    };
    /**
     * ScheduleRecurrence
     * @enum {string}
     */
    ScheduleRecurrence: ScheduleRecurrence;
    /** ScheduleReporting */
    ScheduleReporting: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      category: ScheduleReportingCategory;
      recurrence: components['schemas']['ScheduleRecurrence'];
      /**
       * Delay First Occurrence
       * @default {
       *       "category": "none"
       *     }
       */
      delay_first_occurrence:
        | components['schemas']['ScheduleDelayFirstOccurrenceNone']
        | components['schemas']['ScheduleDelayFirstOccurrenceSameYear']
        | components['schemas']['ScheduleDelayFirstOccurrenceMonthsBeforeDue'];
      /**
       * Period Offset
       * @default {
       *       "category": "none"
       *     }
       */
      period_offset:
        | components['schemas']['SchedulePeriodOffsetDefault']
        | components['schemas']['SchedulePeriodOffsetQuarterlyOnFiscalYear']
        | components['schemas']['SchedulePeriodOffsetMonths']
        | components['schemas']['SchedulePeriodOffsetNone']
        | components['schemas']['SchedulePeriodOffsetRelative']
        | components['schemas']['SchedulePeriodOffsetYearlyOnDate']
        | components['schemas']['SchedulePeriodOffsetYearlyOnDateAttribute']
        | components['schemas']['SchedulePeriodOffsetYearlyOnFiscalYear'];
      /**
       * Due Date Offset
       * @default {
       *       "category": "none"
       *     }
       */
      due_date_offset:
        | components['schemas']['ScheduleDueDateOffsetBeginningOfNextPeriodStartMonth']
        | components['schemas']['ScheduleDueDateOffsetDays']
        | components['schemas']['ScheduleDueDateOffsetDefault']
        | components['schemas']['ScheduleDueDateOffsetEndOfAnniversaryMonth']
        | components['schemas']['ScheduleDueDateOffsetEndOfMonth']
        | components['schemas']['ScheduleDueDateOffsetEndOfMonthPreviousToNextPeriodStartMonth']
        | components['schemas']['ScheduleDueDateOffsetEndOfNextMonth']
        | components['schemas']['ScheduleDueDateOffsetEndOfQuarter']
        | components['schemas']['ScheduleDueDateOffsetMonths']
        | components['schemas']['ScheduleDueDateOffsetNone']
        | components['schemas']['ScheduleDueDateOffsetRelative']
        | components['schemas']['ScheduleDueDateOffsetYearlyEndOfMonth']
        | components['schemas']['ScheduleDueDateOffsetYearlyOnDate']
        | components['schemas']['ScheduleDueDateOffsetYearlyOnDateAttribute']
        | components['schemas']['ScheduleDueDateOffsetRelativeOnDateAttribute']
        | components['schemas']['ScheduleDueDateOffsetRelativeOnDateAttributeEndOfMonth']
        | components['schemas']['ScheduleDueDateOffsetRelativeOnDateAttributeFifteenthOfMonth'];
      /**
       * Due Date Nudge
       * @default false
       */
      due_date_nudge: boolean;
    };
    /** ScheduleReportingMulti */
    'ScheduleReportingMulti-Input': {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      category: ScheduleReportingMultiInputCategory;
      /** Options */
      options: components['schemas']['NamedScheduleReporting-Input'][];
      /** Default Option */
      default_option?: string | null;
      /** Attribute Id */
      attribute_id: string;
    };
    /** ScheduleReportingMulti */
    'ScheduleReportingMulti-Output': {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      category: ScheduleReportingMultiOutputCategory;
      /** Options */
      options: components['schemas']['NamedScheduleReporting-Output'][];
      /** Default Option */
      default_option?: string | null;
      /** Attribute Id */
      attribute_id: string;
    };
    /** SearchRequest */
    SearchRequest: {
      /** Query */
      query: string;
    };
    /** SearchResult */
    SearchResult: {
      /** Requirement Data Id */
      requirement_data_id: string;
      /** Term */
      term: string;
      /** Search Type */
      search_type: string;
    };
    /** SecurityQuestion */
    SecurityQuestion: {
      /** Question */
      question: string;
      /** Answer */
      answer: string;
    };
    /** SecurityQuestionEntry */
    SecurityQuestionEntry: {
      /** Question */
      question: string;
      /** Answer */
      answer: string;
    };
    /** SelectAttribute */
    'SelectAttribute-Input': {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: SelectAttributeInputType;
      /** Params */
      params:
        | components['schemas']['SelectParamsCustom']
        | components['schemas']['SelectParamsEntityTypes']
        | components['schemas']['SelectParamsTaxClassesCorp']
        | components['schemas']['SelectParamsTaxClassesLLC']
        | components['schemas']['SelectParamsRegions']
        | components['schemas']['SelectParamsCountries']
        | components['schemas']['SelectParamsLast10Years']
        | components['schemas']['SelectParamsPerson'];
      /** Placeholder */
      placeholder?: null;
      /**
       * Validators
       * @default []
       */
      validators: components['schemas']['ValidatorType'][];
    };
    /** SelectAttribute */
    'SelectAttribute-Output': {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: SelectAttributeOutputType;
      /** Params */
      params:
        | components['schemas']['SelectParamsCustom']
        | components['schemas']['SelectParamsEntityTypes']
        | components['schemas']['SelectParamsTaxClassesCorp']
        | components['schemas']['SelectParamsTaxClassesLLC']
        | components['schemas']['SelectParamsRegions']
        | components['schemas']['SelectParamsCountries']
        | components['schemas']['SelectParamsLast10Years']
        | components['schemas']['SelectParamsPerson'];
      /** Placeholder */
      placeholder?: null;
      /**
       * Validators
       * @default []
       */
      validators: components['schemas']['ValidatorType'][];
    };
    /** SelectParamsCountries */
    SelectParamsCountries: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      select_type: SelectParamsCountriesSelect_type;
    };
    /** SelectParamsCustom */
    SelectParamsCustom: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      select_type: SelectParamsCustomSelect_type;
      /** Options */
      options: components['schemas']['Option'][];
    };
    /** SelectParamsEntityTypes */
    SelectParamsEntityTypes: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      select_type: SelectParamsEntityTypesSelect_type;
    };
    /** SelectParamsLast10Years */
    SelectParamsLast10Years: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      select_type: SelectParamsLast10YearsSelect_type;
    };
    /** SelectParamsPerson */
    SelectParamsPerson: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      select_type: SelectParamsPersonSelect_type;
      people_select_type: components['schemas']['PeopleSelectType'];
    };
    /** SelectParamsRegions */
    SelectParamsRegions: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      select_type: SelectParamsRegionsSelect_type;
    };
    /** SelectParamsTaxClassesCorp */
    SelectParamsTaxClassesCorp: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      select_type: SelectParamsTaxClassesCorpSelect_type;
    };
    /** SelectParamsTaxClassesLLC */
    SelectParamsTaxClassesLLC: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      select_type: SelectParamsTaxClassesLLCSelect_type;
    };
    /** SetDatumParams */
    SetDatumParams: {
      /** Value */
      value: string;
    };
    /** SingleRequirementCriteria */
    SingleRequirementCriteria: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: SingleRequirementCriteriaType;
      /** Requirement Id */
      requirement_id?: string;
      /** Location Scope */
      location_scope:
        | components['schemas']['CriteriaLocationScopeRegion']
        | components['schemas']['CriteriaLocationScopeZip']
        | components['schemas']['CriteriaLocationScopeCity']
        | components['schemas']['CriteriaLocationScopeEntity'];
      /** Title */
      title: string;
      /** Description */
      description: string;
      /** Summary */
      summary: string;
    };
    /** Stats */
    Stats: {
      acknowledgements: components['schemas']['AcknowledgementStats'];
      handbooks: components['schemas']['HandbookStats'];
    };
    /**
     * SubmitOption
     * @enum {string}
     */
    SubmitOption: SubmitOption;
    /** SubmittedAtRow */
    SubmittedAtRow: {
      /**
       * Date
       * Format: date-time
       */
      date: string;
      /** Is Legalinc */
      is_legalinc: boolean;
      /** Sla Met */
      sla_met: boolean;
      /** Count */
      count: number;
      /** Assigned User */
      assigned_user: string | null;
      /** Tag */
      tag: string | null;
    };
    /** Submitter */
    Submitter: {
      /** First Name */
      first_name: string;
      /** Last Name */
      last_name: string;
      /** Title */
      title: string;
      /** Email */
      email: string;
      /** Phone Number */
      phone_number?: string | null;
      personal_address: components['schemas']['app__api__legal_entity__Address'];
    };
    /**
     * SubscriptionPlanEnum
     * @enum {string}
     */
    SubscriptionPlanEnum: SubscriptionPlanEnum;
    /** SuccessResponse */
    SuccessResponse: {
      /**
       * Success
       * @default true
       */
      success: boolean;
    };
    /** Summary */
    Summary: {
      entity_type: components['schemas']['EntityTypeEnum'];
      /** Payroll Provider */
      payroll_provider: string;
      /** Regions */
      regions: components['schemas']['SummaryRegion'][];
    };
    /** SummaryAgency */
    SummaryAgency: {
      /** Name */
      name: string;
    };
    /** SummaryParams */
    SummaryParams: {
      entity_type: components['schemas']['EntityTypeEnum'];
      /** Payroll Provider */
      payroll_provider: string;
      /** Region Codes */
      region_codes: string[];
      /** As Of Date */
      as_of_date?: string | null;
    };
    /** SummaryRegion */
    SummaryRegion: {
      /** Code */
      code: string;
      /** Name */
      name: string;
      /** Agencies */
      agencies: components['schemas']['SummaryAgency'][];
      /** Requirements */
      requirements: components['schemas']['SummaryRequirement'][];
    };
    /** SummaryRequirement */
    SummaryRequirement: {
      /** Title */
      title: string;
      /** Category */
      category: string;
      /** Instance Count */
      instance_count: number;
      /** Is Managed */
      is_managed: boolean;
      /** Schedule */
      schedule:
        | components['schemas']['ScheduleOneTime']
        | components['schemas']['ScheduleMultiYear']
        | components['schemas']['ScheduleNonReporting']
        | components['schemas']['ScheduleReporting']
        | components['schemas']['ScheduleReportingMulti-Output']
        | components['schemas']['ScheduleEmployeeHiring']
        | components['schemas']['ScheduleEmployeeTermination'];
    };
    /**
     * TagInstance
     * @enum {string}
     */
    TagInstance: TagInstance;
    /**
     * TargetGroupType
     * @enum {string}
     */
    TargetGroupType: TargetGroupType;
    /** Task */
    Task: {
      /** Id */
      id: string;
      /** Title */
      title: string;
      status: components['schemas']['TaskStatus'];
      assigned_user: components['schemas']['UserRef'] | null;
      /** Source */
      source:
        | components['schemas']['TaskRequirement']
        | components['schemas']['TaskQuestion']
        | components['schemas']['TaskBulkQuestion'];
    };
    /** TaskBulkQuestion */
    TaskBulkQuestion: {
      /**
       * Type
       * @default bulk-question
       * @constant
       */
      type: 'bulk-question';
      /** Description */
      description: string;
      form: components['schemas']['FormattedForm'];
    };
    /** TaskBulkQuestionRef */
    TaskBulkQuestionRef: {
      /**
       * Type
       * @default bulk-question
       * @constant
       */
      type: 'bulk-question';
      /** Question Task Ids */
      question_task_ids: string[];
      /** Is Setup Related */
      is_setup_related: boolean;
    };
    /**
     * TaskCategory
     * @enum {string}
     */
    TaskCategory: TaskCategory;
    /** TaskContextEmployee */
    TaskContextEmployee: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      scope: TaskContextEmployeeScope;
      /** Employee Id */
      employee_id: string;
    };
    /** TaskContextLegalEntity */
    TaskContextLegalEntity: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      scope: TaskContextLegalEntityScope;
      /** Legal Entity Id */
      legal_entity_id: string;
    };
    /**
     * TaskCreationReason
     * @enum {string}
     */
    TaskCreationReason: TaskCreationReason;
    /**
     * TaskDateFilter
     * @enum {string}
     */
    TaskDateFilter: TaskDateFilter;
    /**
     * TaskDefinitionType
     * @enum {string}
     */
    TaskDefinitionType: TaskDefinitionType;
    /** TaskManagedProvider */
    TaskManagedProvider: {
      /** Id */
      id: string;
      /** Name */
      name: string;
    };
    /**
     * TaskPriority
     * @enum {string}
     */
    TaskPriority: TaskPriority;
    /** TaskQuestion */
    TaskQuestion: {
      /**
       * Type
       * @default question
       * @constant
       */
      type: 'question';
      /** Locations */
      locations: components['schemas']['app__compliance__public__LocationRef'][];
      location_scope: components['schemas']['LocationScope'];
      /** Description */
      description?: string | null;
      form: components['schemas']['FormattedForm'];
      /** Answer */
      answer?: string | null;
      /** Is Setup Related */
      is_setup_related: boolean;
      /** Is Editable */
      is_editable: boolean;
    };
    /** TaskQuestionRef */
    TaskQuestionRef: {
      /**
       * Type
       * @default question
       * @constant
       */
      type: 'question';
      /** Locations */
      locations: components['schemas']['app__compliance__public__LocationRef'][];
      location_scope: components['schemas']['LocationScope'];
      criteria_type: components['schemas']['CriteriaType'];
      /** Answer */
      answer?: string | null;
      /**
       * Related Requirement Ids
       * @default []
       */
      related_requirement_ids: string[] | null;
      /** Is Setup Related */
      is_setup_related: boolean;
    };
    /** TaskRef */
    TaskRef: {
      /** Id */
      id: string;
      /** Title */
      title: string;
      status: components['schemas']['TaskStatus'];
      /** Source */
      source:
        | components['schemas']['TaskQuestionRef']
        | components['schemas']['TaskRequirementRef']
        | components['schemas']['TaskBulkQuestionRef'];
    };
    /** TaskRemediation */
    TaskRemediation: {
      /** Id */
      id: string;
      /** Title */
      title: string;
      /** Description */
      description: string;
      /** Order */
      order: number;
      /** Paths */
      paths: components['schemas']['TaskRemediationPath'][];
    };
    /** TaskRemediationPath */
    TaskRemediationPath: {
      /** Type */
      type: string;
      /** Value */
      value: string;
      /** Text */
      text?: string | null;
    };
    /** TaskRequirement */
    TaskRequirement: {
      /**
       * Type
       * @default requirement
       * @constant
       */
      type: 'requirement';
      /** Id */
      id: string;
      /** Context */
      context:
        | components['schemas']['TaskContextEmployee']
        | components['schemas']['TaskContextLegalEntity'];
      /** Requirement Id */
      requirement_id: string;
      /** Title */
      title: string;
      /** Summary */
      summary?: string | null;
      /** Description */
      description: string;
      /** Frequency Note */
      frequency_note?: string | null;
      /** Tax Rate Note */
      tax_rate_note?: string | null;
      /** General Notes */
      general_notes?: string[] | null;
      category: components['schemas']['TaskCategory'];
      /** Is Setup */
      is_setup: boolean;
      /** Is Automatable */
      is_automatable: boolean;
      /** Resources */
      resources: {
        [key: string]: string;
      }[];
      /** Tags */
      tags: string[];
      /** Remediations */
      remediations: components['schemas']['TaskRemediation'][];
      managed_provider: components['schemas']['TaskManagedProvider'] | null;
      /** Period Start Date */
      period_start_date: string | null;
      /** Period End Date */
      period_end_date: string | null;
      /** Due Date */
      due_date: string | null;
      /** Fee */
      fee:
        | (
            | components['schemas']['FeeFixed']
            | components['schemas']['FeeRange']
            | components['schemas']['FeeVariable']
          )
        | null;
      eta: components['schemas']['RequirementETA'] | null;
      location: components['schemas']['app__compliance__public__LocationRef'];
    };
    /** TaskRequirementRef */
    TaskRequirementRef: {
      /**
       * Type
       * @default requirement
       * @constant
       */
      type: 'requirement';
      /** Requirement Id */
      requirement_id: string;
      /** Due Date */
      due_date?: string | null;
      managed_provider: components['schemas']['TaskManagedProvider'] | null;
      location: components['schemas']['app__compliance__public__LocationRef'];
      /** Description */
      description: string;
      /** Summary */
      summary: string | null;
      /** Is Setup Related */
      is_setup_related: boolean;
      navigator_section?: components['schemas']['TaskCategory'] | null;
      creation_reason?: components['schemas']['TaskCreationReason'] | null;
    };
    /**
     * TaskStatus
     * @enum {string}
     */
    TaskStatus: TaskStatus;
    /** TaskStatusBatchUpdate */
    TaskStatusBatchUpdate: {
      /** Task Public Ids */
      task_public_ids: string[];
      status: components['schemas']['TaskStatus'];
      /**
       * Scoped To Single Location
       * @default false
       */
      scoped_to_single_location: boolean;
    };
    /** TaskStatusUpdate */
    TaskStatusUpdate: {
      status: components['schemas']['TaskStatus'];
      /**
       * Scoped To Single Location
       * @default false
       */
      scoped_to_single_location: boolean;
    };
    /**
     * TaskType
     * @enum {string}
     */
    TaskType: TaskType;
    /** TaskUpdate */
    TaskUpdate: {
      status?: components['schemas']['TaskStatus'] | null;
      /** Assigned User Id */
      assigned_user_id?: string | null;
    };
    /** TasksFilter */
    TasksFilter: {
      /** @default todo */
      status: components['schemas']['TasksFilterStatus'] | null;
      /** @default all */
      category: components['schemas']['TasksFilterCategory'] | null;
    };
    /**
     * TasksFilterCategory
     * @enum {string}
     */
    TasksFilterCategory: TasksFilterCategory;
    /** TasksFilterPreferenceUpdate */
    TasksFilterPreferenceUpdate: {
      status?: components['schemas']['TasksFilterStatus'] | null;
      category?: components['schemas']['TasksFilterCategory'] | null;
    };
    /**
     * TasksFilterStatus
     * @enum {string}
     */
    TasksFilterStatus: TasksFilterStatus;
    /** TasksRegionConfigurationResponse */
    TasksRegionConfigurationResponse: {
      /** Registered Agent */
      registered_agent?: string | null;
      /** Employees */
      employees?: string | null;
      /** Doing Business */
      doing_business?: string | null;
      /** Sales Tax Nexus */
      sales_tax_nexus?: string | null;
      /** Business Income Tax Nexus */
      business_income_tax_nexus?: string | null;
    };
    /** TasksSessionRequest */
    TasksSessionRequest: {
      /** Callback Url */
      callback_url: string;
    };
    /** TasksSessionResponse */
    TasksSessionResponse: {
      /** Url */
      url: string;
      /** Created At */
      created_at: string;
      /** Expires At */
      expires_at: string;
    };
    /**
     * TaxClassEnum
     * @description The IRS tax classification for an entity.
     *
     *     In some circumstances, a company can elect to be treated different
     *     from the entity type for tax purposes. For example, an LLC can
     *     elect to be taxed as a corporation.
     *     - Corp: taxed as a corporation, the default for C Corps
     *     - S Corp: election using IRS Form 2553
     *     - Partnership: taxed as a partnership, the default for LPs
     *     - Disregarded: taxes pass through to the members, default for LLCs
     *     - Tax Exempt: an entity that is recognized by the IRS as being exempt from paying federal income taxes on its earnings
     * @enum {string}
     */
    TaxClassEnum: TaxClassEnum;
    /** TemplateVariableValues */
    TemplateVariableValues: {
      /** Workflow Instance Id */
      workflow_instance_id: number;
      /**
       * Data
       * @default {}
       */
      data: {
        [key: string]: unknown;
      };
    };
    /** TextAreaAttribute */
    TextAreaAttribute: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: TextAreaAttributeType;
      /** Params */
      params?: null;
      /** Placeholder */
      placeholder?: string | null;
      /**
       * Validators
       * @default []
       */
      validators: components['schemas']['ValidatorType'][];
    };
    /** TextAttribute */
    TextAttribute: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: TextAttributeType;
      /** Params */
      params?: null;
      /** Placeholder */
      placeholder?: string | null;
      /**
       * Validators
       * @default []
       */
      validators: components['schemas']['ValidatorType'][];
    };
    /** ThresholdBoundsGreaterThan */
    ThresholdBoundsGreaterThan: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: ThresholdBoundsGreaterThanType;
      /** Lower Bound */
      lower_bound: number;
    };
    /** ThresholdBoundsLessThan */
    ThresholdBoundsLessThan: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: ThresholdBoundsLessThanType;
      /** Upper Bound */
      upper_bound: number;
    };
    /** ThresholdBoundsOpenRange */
    ThresholdBoundsOpenRange: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: ThresholdBoundsOpenRangeType;
      /** Lower Bound */
      lower_bound: number;
      /** Upper Bound */
      upper_bound: number;
    };
    /** ThresholdBoundsValidDate */
    ThresholdBoundsValidDate: {
      /**
       * Type
       * @default valid-date
       * @constant
       */
      type: 'valid-date';
    };
    /**
     * ThresholdDateRangeType
     * @enum {string}
     */
    ThresholdDateRangeType: ThresholdDateRangeType;
    /** UpcomingLegislation */
    UpcomingLegislation: {
      /** Id */
      id: string;
      /** Title */
      title: string;
      /** Description */
      description: string;
      region: components['schemas']['Region'];
      /** Category */
      category: string;
      stage: components['schemas']['UpcomingLegislationStageEnum'];
      /** Effective Date */
      effective_date?: string | null;
    };
    /** UpcomingLegislationRequest */
    UpcomingLegislationRequest: {
      /** Title */
      title: string;
      /** Description */
      description: string;
      /** Region Id */
      region_id: number;
      /** Category */
      category: string;
      stage: components['schemas']['UpcomingLegislationStageEnum'];
      /** Effective Date */
      effective_date?: string | null;
      /** Requirement Id */
      requirement_id?: number | null;
    };
    /**
     * UpcomingLegislationStageEnum
     * @enum {string}
     */
    UpcomingLegislationStageEnum: UpcomingLegislationStageEnum;
    /** UpdateLegalEntityBusinessParams */
    UpdateLegalEntityBusinessParams: {
      /** Name */
      name: string;
      /** Incorporation Country */
      incorporation_country: string;
      /** Incorporation Region */
      incorporation_region?: string | null;
      /**
       * Incorporation Date
       * Format: date
       */
      incorporation_date: string;
      /**
       * Ownership Start Date
       * Format: date
       */
      ownership_start_date: string;
      /** Ownership Percentage */
      ownership_percentage: number;
      physical_address: components['schemas']['LegalEntityAddressParams'];
      mailing_address?:
        | components['schemas']['LegalEntityAddressParams']
        | null;
    };
    /** UpdateLegalEntityInformationParams */
    UpdateLegalEntityInformationParams: {
      physical_address: components['schemas']['LegalEntityAddressParams'];
      mailing_address?:
        | components['schemas']['LegalEntityAddressParams']
        | null;
    };
    /** UpdateLegalEntityPersonParams */
    UpdateLegalEntityPersonParams: {
      /** First Name */
      first_name: string;
      /** Last Name */
      last_name: string;
      /** Title */
      title: string;
      /** Email */
      email: string;
      /** Phone Number */
      phone_number: string;
      personal_address: components['schemas']['LegalEntityAddressParams'];
      /** Birth Date */
      birth_date?: string | null;
      /** Start Date */
      start_date?: string | null;
      /** Ownership Start Date */
      ownership_start_date?: string | null;
      /** Ownership Percentage */
      ownership_percentage?: number | null;
      /** Owner License Number */
      owner_license_number?: string | null;
      /** Is Married */
      is_married?: boolean | null;
      /** Spouse First Name */
      spouse_first_name?: string | null;
      /** Spouse Last Name */
      spouse_last_name?: string | null;
      /** Is Officer */
      is_officer?: boolean | null;
      /** Is Owner */
      is_owner?: boolean | null;
      /** Is Director */
      is_director?: boolean | null;
      /** Is Llc Manager */
      is_llc_manager?: boolean | null;
      /** Is Llc Member */
      is_llc_member?: boolean | null;
    };
    /** UpdateLocationRequest */
    UpdateLocationRequest: {
      config?: components['schemas']['LocationConfig'] | null;
    };
    /** UpdateResponse */
    UpdateResponse: {
      /** Id */
      id: number;
    } & {
      [key: string]: unknown;
    };
    /** User */
    User: {
      /** Id */
      id: string;
      /** Email */
      email: string;
      /** First Name */
      first_name?: string | null;
      /** Last Name */
      last_name?: string | null;
      /**
       * Is Active
       * @default true
       */
      is_active: boolean;
      /** Role */
      role: string;
      legal_entity: components['schemas']['LegalEntity'];
      /** Legal Entities */
      legal_entities: components['schemas']['LegalEntityRef'][];
      /**
       * Is Platform User
       * @default false
       */
      is_platform_user: boolean;
      /**
       * Is Pro User
       * @default false
       */
      is_pro_user: boolean;
      /** @default {
       *       "tasks_filter": {
       *         "category": "all",
       *         "status": "todo"
       *       }
       *     } */
      user_preference: components['schemas']['UserPreference'] | null;
    };
    /** UserPreference */
    UserPreference: {
      /** @default {
       *       "status": "todo",
       *       "category": "all"
       *     } */
      tasks_filter: components['schemas']['TasksFilter'] | null;
    };
    /** UserRef */
    UserRef: {
      /** Id */
      id: string;
      /** First Name */
      first_name?: string | null;
      /** Last Name */
      last_name?: string | null;
      /** Email */
      email?: string | null;
    };
    /** UserUpdateRequest */
    UserUpdateRequest: {
      /** First Name */
      first_name: string;
      /** Last Name */
      last_name: string;
    };
    /** ValidationError */
    ValidationError: {
      /** Location */
      loc: (string | number)[];
      /** Message */
      msg: string;
      /** Error Type */
      type: string;
    };
    /** ValidationWarning */
    ValidationWarning: {
      /** Message */
      message: string;
    };
    /**
     * ValidatorType
     * @enum {string}
     */
    ValidatorType: ValidatorType;
    /** VerifyInviteRequest */
    VerifyInviteRequest: {
      /** Token */
      token: string;
    };
    /** VerifyInviteResponse */
    VerifyInviteResponse: {
      /** Legal Entity Name */
      legal_entity_name: string;
      /** Ask For Email */
      ask_for_email: boolean;
    };
    /** WeeklySummaryNotificationTopic */
    WeeklySummaryNotificationTopic: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      code: WeeklySummaryNotificationTopicCode;
      /**
       * Title
       * @default Weekly summary
       */
      title: string;
      /**
       * Description
       * @default Receive summary of upcoming tasks and reminders each week.
       */
      description: string;
      /**
       * Configurable
       * @default true
       */
      configurable: boolean;
      /**
       * Notification Names
       * @default [
       *       "weekly_summary_tasks",
       *       "upcoming_annual_report",
       *       "upcoming_due_dates"
       *     ]
       */
      notification_names: components['schemas']['NotificationName'][];
    };
    /** WizardConfig */
    WizardConfig: {
      /** Title */
      title: string;
      welcome: components['schemas']['WizardInterstitial'];
      conclusion: components['schemas']['WizardInterstitial'];
      /** Steps */
      steps: components['schemas']['WizardStep'][];
      current_step: components['schemas']['WizardStep'] | null;
      current_task: components['schemas']['TaskRef'] | null;
    };
    /** WizardInterstitial */
    WizardInterstitial: {
      /** Title */
      title: string;
      /** Body */
      body: string;
    };
    /** WizardStep */
    WizardStep: {
      /** Slug */
      slug: string;
      /** Title */
      title: string;
      interstitial?: components['schemas']['WizardInterstitial'] | null;
    };
    /** WorkflowActionAuditApplication */
    WorkflowActionAuditApplication: {
      /**
       * Name
       * @default review-application
       * @constant
       */
      name: 'review-application';
    };
    /** WorkflowActionCalculateScore */
    WorkflowActionCalculateScore: {
      /**
       * Name
       * @default calculate-score
       * @constant
       */
      name: 'calculate-score';
      /** Expected Data */
      expected_data: {
        [key: string]: unknown;
      };
    };
    /** WorkflowActionCheckLegalEntityAccountLogin */
    WorkflowActionCheckLegalEntityAccountLogin: {
      /**
       * Name
       * @default check-legal-entity-account-logins
       * @constant
       */
      name: 'check-legal-entity-account-logins';
    };
    /** WorkflowActionCreateAndSendStripeInvoice */
    WorkflowActionCreateAndSendStripeInvoice: {
      /**
       * Name
       * @default create-and-send-stripe-invoice
       * @constant
       */
      name: 'create-and-send-stripe-invoice';
      /** Invoice Amount */
      invoice_amount?: string | null;
    };
    /** WorkflowActionCreateCredential */
    'WorkflowActionCreateCredential-Input': {
      /**
       * Name
       * @default create-credential
       * @constant
       */
      name: 'create-credential';
      /** Registration Title */
      registration_title: string;
      /**
       * Use Password Generator
       * @default false
       */
      use_password_generator: boolean;
      password_generator_params?:
        | components['schemas']['PasswordGeneratorParams']
        | null;
      /**
       * Security Questions
       * @default []
       */
      security_questions: string[];
      /** Account Login Id */
      account_login_id: number;
    };
    /** WorkflowActionCreateCredential */
    'WorkflowActionCreateCredential-Output': {
      /**
       * Name
       * @default create-credential
       * @constant
       */
      name: 'create-credential';
      /** Registration Title */
      registration_title: string;
      /**
       * Use Password Generator
       * @default false
       */
      use_password_generator: boolean;
      password_generator_params?:
        | components['schemas']['PasswordGeneratorParams']
        | null;
      /**
       * Security Questions
       * @default []
       */
      security_questions: string[];
      /** Account Login Id */
      account_login_id: number;
    };
    /** WorkflowActionCreateIntegrationsEmail */
    WorkflowActionCreateIntegrationsEmail: {
      /**
       * Name
       * @default create-integrations-email
       * @constant
       */
      name: 'create-integrations-email';
    };
    /** WorkflowActionLegalincOrderPoll */
    WorkflowActionLegalincOrderPoll: {
      /**
       * Name
       * @default legal-inc-order-poll
       * @constant
       */
      name: 'legal-inc-order-poll';
    };
    /** WorkflowActionLegalincSubmitAnnualReport */
    WorkflowActionLegalincSubmitAnnualReport: {
      /**
       * Name
       * @default legalinc-submit-annual-report
       * @constant
       */
      name: 'legalinc-submit-annual-report';
    };
    /** WorkflowActionLegalincSubmitForeignQualification */
    WorkflowActionLegalincSubmitForeignQualification: {
      /**
       * Name
       * @default legalinc-submit-foreign-qualification
       * @constant
       */
      name: 'legalinc-submit-foreign-qualification';
    };
    /** WorkflowActionMarkRegisteredAgentAsDone */
    WorkflowActionMarkRegisteredAgentAsDone: {
      /**
       * Name
       * @default mark-registered-agent-as-done
       * @constant
       */
      name: 'mark-registered-agent-as-done';
    };
    /** WorkflowActionRegisteredAgentTransfer */
    WorkflowActionRegisteredAgentTransfer: {
      /**
       * Name
       * @default registered-agent-transfer
       * @constant
       */
      name: 'registered-agent-transfer';
    };
    /** WorkflowActionSaveDatum */
    WorkflowActionSaveDatum: {
      /**
       * Name
       * @default save-datum
       * @constant
       */
      name: 'save-datum';
      /** Attribute Ids */
      attribute_ids: number[];
      /**
       * Generate New Tasks
       * @default false
       */
      generate_new_tasks: boolean;
    };
    /** WorkflowActionSaveFeePayment */
    WorkflowActionSaveFeePayment: {
      /**
       * Name
       * @default save-fee-payment
       * @constant
       */
      name: 'save-fee-payment';
    };
    /** WorkflowActionSecretaryOfStateSearch */
    WorkflowActionSecretaryOfStateSearch: {
      /**
       * Name
       * @default secretary-of-state-search
       * @constant
       */
      name: 'secretary-of-state-search';
    };
    /** WorkflowActionSendEmail */
    WorkflowActionSendEmail: {
      /**
       * Name
       * @default send-email
       * @constant
       */
      name: 'send-email';
      recipient_type: components['schemas']['RecipientType'];
      /** Custom Recipient Ref */
      custom_recipient_ref?: string | null;
      /** Custom Fallback Recipient Ref */
      custom_fallback_recipient_ref?: string | null;
      /** Email Subject */
      email_subject: string;
      /** Email Body */
      email_body: string;
    };
    /** WorkflowActionSendLegalEntityDocument */
    WorkflowActionSendLegalEntityDocument: {
      /**
       * Name
       * @default send-workflow-completion-email
       * @constant
       */
      name: 'send-workflow-completion-email';
    };
    /** WorkflowActionSendTemplatedEmail */
    WorkflowActionSendTemplatedEmail: {
      /**
       * Name
       * @default send-templated-email
       * @constant
       */
      name: 'send-templated-email';
      recipient_type: components['schemas']['RecipientType'];
      /** Custom Recipient Ref */
      custom_recipient_ref?: string | null;
      /** Custom Fallback Recipient Ref */
      custom_fallback_recipient_ref?: string | null;
      /** Email Subject */
      email_subject: string;
      /** Email Template */
      email_template: string;
      /**
       * Attribute Ids
       * @default []
       */
      attribute_ids: number[];
    };
    /** WorkflowActionSetLinkedRequirementsDone */
    WorkflowActionSetLinkedRequirementsDone: {
      /**
       * Name
       * @default set-linked-requirements-done
       * @constant
       */
      name: 'set-linked-requirements-done';
    };
    /** WorkflowActionSubmitCertificateOfGoodStanding */
    WorkflowActionSubmitCertificateOfGoodStanding: {
      /**
       * Name
       * @default submit-certificate-of-good-standing
       * @constant
       */
      name: 'submit-certificate-of-good-standing';
    };
    /** WorkflowActionSubmitRegistrationApplicationManually */
    WorkflowActionSubmitRegistrationApplicationManually: {
      /**
       * Name
       * @default submit-registration-application-manually
       * @constant
       */
      name: 'submit-registration-application-manually';
      /** Account Login Id */
      account_login_id?: number | null;
      /** Should Show Security Questions */
      should_show_security_questions?: boolean | null;
    };
    /** WorkflowActionUpdateCredentialActive */
    WorkflowActionUpdateCredentialActive: {
      /**
       * Name
       * @default update-credential-active
       * @constant
       */
      name: 'update-credential-active';
      /** Account Login Id */
      account_login_id: number;
    };
    /** WorkflowActionUpdateRequirementStatus */
    WorkflowActionUpdateRequirementStatus: {
      /**
       * Name
       * @default update-requirement-status
       * @constant
       */
      name: 'update-requirement-status';
      /** Requirement Id */
      requirement_id: string;
      status: components['schemas']['LegalEntityRequirementStatus'];
    };
    /** WorkflowActionUploadLegalEntityDocument */
    WorkflowActionUploadLegalEntityDocument: {
      /**
       * Name
       * @default upload-legal-entity-document
       * @constant
       */
      name: 'upload-legal-entity-document';
      /** Legal Entity Document Type Id */
      legal_entity_document_type_id: number;
    };
    /** WorkflowAttributeCount */
    WorkflowAttributeCount: {
      /** Count */
      count: number;
    };
    /** WorkflowAttributeMutation */
    WorkflowAttributeMutation: {
      /**
       * Id
       * @default -1
       */
      id: number;
      /** Workflow Id */
      workflow_id: number;
      /** Attribute Id */
      attribute_id: number;
      /** Is Required */
      is_required: boolean;
      /** Order */
      order: number;
    };
    /** WorkflowAttributePublicModel */
    WorkflowAttributePublicModel: {
      /** Id */
      id: number;
      /** Workflow Id */
      workflow_id: number;
      /** Attribute Id */
      attribute_id: number;
      /** Is Required */
      is_required: boolean;
      /** Order */
      order: number;
      /** Created At */
      created_at?: string | null;
      /**
       * Pending Change Ids
       * @default []
       */
      pending_change_ids: number[];
    };
    /** WorkflowAttributeResponse */
    WorkflowAttributeResponse: {
      /** Id */
      id: number;
    };
    /** WorkflowCreate */
    WorkflowCreate: {
      /** Name */
      name: string;
      /** Description */
      description: string;
      /**
       * Is Disabled
       * @default false
       */
      is_disabled: boolean;
      /** Region Id */
      region_id?: number | null;
      /** Steps */
      steps?: components['schemas']['WorkflowStepCreate'][] | null;
      /** Template */
      template?:
        | components['schemas']['WorkflowTemplateRegistration']
        | components['schemas']['WorkflowTemplateEmpty']
        | null;
    };
    /** WorkflowCreateRequest */
    WorkflowCreateRequest: {
      /** Data Ids */
      data_ids: string[];
      /** Region Code */
      region_code: string;
    };
    /** WorkflowInstanceBlockCreate */
    WorkflowInstanceBlockCreate: {
      reason: components['schemas']['WorkflowInstanceBlockReason'];
      /**
       * Notes
       * @default
       */
      notes: string;
    };
    /**
     * WorkflowInstanceBlockReason
     * @enum {string}
     */
    WorkflowInstanceBlockReason: WorkflowInstanceBlockReason;
    /** WorkflowInstanceCommentCreate */
    WorkflowInstanceCommentCreate: {
      /** Text */
      text: string;
    };
    /** WorkflowInstanceCreate */
    WorkflowInstanceCreate: {
      /** Legal Entity Id */
      legal_entity_id: number;
      /** Workflow Id */
      workflow_id: number;
      /** Assigned User Id */
      assigned_user_id?: number | null;
      /** Region Id */
      region_id?: number | null;
    };
    /** WorkflowInstanceStaleLoginUpdate */
    WorkflowInstanceStaleLoginUpdate: {
      /**
       * Disable Login
       * @default false
       */
      disable_login: boolean;
      /** Updated Password */
      updated_password?: string | null;
    };
    /**
     * WorkflowInstanceStatus
     * @enum {string}
     */
    WorkflowInstanceStatus: WorkflowInstanceStatus;
    /** WorkflowInstanceUpdate */
    WorkflowInstanceUpdate: {
      status: components['schemas']['WorkflowInstanceStatus'];
      /** Status Note */
      status_note?: string | null;
      /** Assigned User Id */
      assigned_user_id?: number | null;
      /** Current Step Id */
      current_step_id?: number | null;
      /** Legalinc Order Id */
      legalinc_order_id?: number | null;
    };
    /** WorkflowNextStepRequest */
    WorkflowNextStepRequest: {
      /**
       * Data
       * @default {}
       */
      data: {
        [key: string]: string;
      };
    };
    /** WorkflowStepCreate */
    WorkflowStepCreate: {
      /** Name */
      name: string;
      /** Description */
      description: string;
      /**
       * Is Automatic
       * @default false
       */
      is_automatic: boolean;
      /**
       * Requires Admin
       * @default false
       */
      requires_admin: boolean;
      /**
       * Requires Review
       * @default false
       */
      requires_review: boolean;
      /**
       * Submits To State
       * @default false
       */
      submits_to_state: boolean;
      /** Action */
      action?:
        | components['schemas']['WorkflowActionSubmitRegistrationApplicationManually']
        | components['schemas']['WorkflowActionAuditApplication']
        | components['schemas']['WorkflowActionSaveDatum']
        | components['schemas']['WorkflowActionSendEmail']
        | components['schemas']['WorkflowActionSendTemplatedEmail']
        | components['schemas']['WorkflowActionSetLinkedRequirementsDone']
        | components['schemas']['WorkflowActionUpdateRequirementStatus']
        | components['schemas']['WorkflowActionCreateCredential-Input']
        | components['schemas']['WorkflowActionRegisteredAgentTransfer']
        | components['schemas']['WorkflowActionSecretaryOfStateSearch']
        | components['schemas']['WorkflowActionLegalincOrderPoll']
        | components['schemas']['WorkflowActionLegalincSubmitAnnualReport']
        | components['schemas']['WorkflowActionLegalincSubmitForeignQualification']
        | components['schemas']['WorkflowActionUpdateCredentialActive']
        | components['schemas']['WorkflowActionSubmitCertificateOfGoodStanding']
        | components['schemas']['WorkflowActionMarkRegisteredAgentAsDone']
        | components['schemas']['WorkflowActionCalculateScore']
        | components['schemas']['WorkflowActionCreateAndSendStripeInvoice']
        | components['schemas']['WorkflowActionCreateIntegrationsEmail']
        | components['schemas']['WorkflowActionUploadLegalEntityDocument']
        | components['schemas']['WorkflowActionSendLegalEntityDocument']
        | components['schemas']['WorkflowActionCheckLegalEntityAccountLogin']
        | components['schemas']['WorkflowActionSaveFeePayment']
        | null;
      /**
       * Dependencies
       * @default []
       */
      dependencies: components['schemas']['WorkflowStepDependencyCreate'][];
    };
    /** WorkflowStepDependencyCreate */
    WorkflowStepDependencyCreate: {
      /** Attribute Id */
      attribute_id: number;
    };
    /** WorkflowStepDependencyUpdate */
    WorkflowStepDependencyUpdate: {
      /** Id */
      id: number;
      /** Attribute Id */
      attribute_id: number;
    };
    /** WorkflowStepPromptOverrideCreate */
    WorkflowStepPromptOverrideCreate: {
      /** Workflow Step Id */
      workflow_step_id: number;
      /** Text */
      text: string;
    };
    /** WorkflowStepPromptOverrideCreateResponse */
    WorkflowStepPromptOverrideCreateResponse: {
      /** Status */
      status: string;
      /** Message */
      message: string;
    };
    /** WorkflowStepPromptOverrideViewModel */
    WorkflowStepPromptOverrideViewModel: {
      /** Overridetext */
      overrideText: string;
    };
    /** WorkflowStepUpdateCreate */
    WorkflowStepUpdateCreate: {
      /** Name */
      name: string;
      /** Description */
      description: string;
      /**
       * Is Automatic
       * @default false
       */
      is_automatic: boolean;
      /**
       * Requires Admin
       * @default false
       */
      requires_admin: boolean;
      /**
       * Requires Review
       * @default false
       */
      requires_review: boolean;
      /**
       * Submits To State
       * @default false
       */
      submits_to_state: boolean;
      /** Action */
      action?:
        | components['schemas']['WorkflowActionSubmitRegistrationApplicationManually']
        | components['schemas']['WorkflowActionAuditApplication']
        | components['schemas']['WorkflowActionSaveDatum']
        | components['schemas']['WorkflowActionSendEmail']
        | components['schemas']['WorkflowActionSendTemplatedEmail']
        | components['schemas']['WorkflowActionSetLinkedRequirementsDone']
        | components['schemas']['WorkflowActionUpdateRequirementStatus']
        | components['schemas']['WorkflowActionCreateCredential-Input']
        | components['schemas']['WorkflowActionRegisteredAgentTransfer']
        | components['schemas']['WorkflowActionSecretaryOfStateSearch']
        | components['schemas']['WorkflowActionLegalincOrderPoll']
        | components['schemas']['WorkflowActionLegalincSubmitAnnualReport']
        | components['schemas']['WorkflowActionLegalincSubmitForeignQualification']
        | components['schemas']['WorkflowActionUpdateCredentialActive']
        | components['schemas']['WorkflowActionSubmitCertificateOfGoodStanding']
        | components['schemas']['WorkflowActionMarkRegisteredAgentAsDone']
        | components['schemas']['WorkflowActionCalculateScore']
        | components['schemas']['WorkflowActionCreateAndSendStripeInvoice']
        | components['schemas']['WorkflowActionCreateIntegrationsEmail']
        | components['schemas']['WorkflowActionUploadLegalEntityDocument']
        | components['schemas']['WorkflowActionSendLegalEntityDocument']
        | components['schemas']['WorkflowActionCheckLegalEntityAccountLogin']
        | components['schemas']['WorkflowActionSaveFeePayment']
        | null;
      /**
       * Dependencies
       * @default []
       */
      dependencies: components['schemas']['WorkflowStepDependencyCreate'][];
    };
    /** WorkflowStepUpdateUpdate */
    WorkflowStepUpdateUpdate: {
      /** Id */
      id: number;
      /** Name */
      name: string;
      /** Description */
      description: string;
      /**
       * Is Automatic
       * @default false
       */
      is_automatic: boolean;
      /**
       * Requires Admin
       * @default false
       */
      requires_admin: boolean;
      /**
       * Requires Review
       * @default false
       */
      requires_review: boolean;
      /**
       * Submits To State
       * @default false
       */
      submits_to_state: boolean;
      /** Action */
      action?:
        | components['schemas']['WorkflowActionSubmitRegistrationApplicationManually']
        | components['schemas']['WorkflowActionAuditApplication']
        | components['schemas']['WorkflowActionSaveDatum']
        | components['schemas']['WorkflowActionSendEmail']
        | components['schemas']['WorkflowActionSendTemplatedEmail']
        | components['schemas']['WorkflowActionSetLinkedRequirementsDone']
        | components['schemas']['WorkflowActionUpdateRequirementStatus']
        | components['schemas']['WorkflowActionCreateCredential-Input']
        | components['schemas']['WorkflowActionRegisteredAgentTransfer']
        | components['schemas']['WorkflowActionSecretaryOfStateSearch']
        | components['schemas']['WorkflowActionLegalincOrderPoll']
        | components['schemas']['WorkflowActionLegalincSubmitAnnualReport']
        | components['schemas']['WorkflowActionLegalincSubmitForeignQualification']
        | components['schemas']['WorkflowActionUpdateCredentialActive']
        | components['schemas']['WorkflowActionSubmitCertificateOfGoodStanding']
        | components['schemas']['WorkflowActionMarkRegisteredAgentAsDone']
        | components['schemas']['WorkflowActionCalculateScore']
        | components['schemas']['WorkflowActionCreateAndSendStripeInvoice']
        | components['schemas']['WorkflowActionCreateIntegrationsEmail']
        | components['schemas']['WorkflowActionUploadLegalEntityDocument']
        | components['schemas']['WorkflowActionSendLegalEntityDocument']
        | components['schemas']['WorkflowActionCheckLegalEntityAccountLogin']
        | components['schemas']['WorkflowActionSaveFeePayment']
        | null;
      /**
       * Dependencies
       * @default []
       */
      dependencies: (
        | components['schemas']['WorkflowStepDependencyUpdate']
        | components['schemas']['WorkflowStepDependencyCreate']
      )[];
    };
    /** WorkflowTemplateEmpty */
    WorkflowTemplateEmpty: {
      /**
       * Name
       * @default empty
       * @constant
       */
      name: 'empty';
    };
    /** WorkflowTemplateRegistration */
    WorkflowTemplateRegistration: {
      /**
       * Name
       * @default registration
       * @constant
       */
      name: 'registration';
      /**
       * Create Agency Login First
       * @default false
       */
      create_agency_login_first: boolean;
      account_number_source: components['schemas']['WorkflowTemplateRegistrationAccountNumberSource'];
      /** Account Number Attribute Id */
      account_number_attribute_id: number;
    };
    /**
     * WorkflowTemplateRegistrationAccountNumberSource
     * @enum {string}
     */
    WorkflowTemplateRegistrationAccountNumberSource: WorkflowTemplateRegistrationAccountNumberSource;
    /** WorkflowUpdate */
    WorkflowUpdate: {
      /** Name */
      name: string;
      /** Description */
      description: string;
      /** Is Disabled */
      is_disabled: boolean;
      /** Steps */
      steps: (
        | components['schemas']['WorkflowStepUpdateUpdate']
        | components['schemas']['WorkflowStepUpdateCreate']
      )[];
      /** Requirement Ids */
      requirement_ids?: number[] | null;
      /** Tag Ids */
      tag_ids?: number[] | null;
    };
    /** CreateResponse */
    app__account_login__admin__input__CreateResponse: {
      /** Id */
      id: number;
    };
    /** AdminLegalEntity */
    app__api__admin__legal_entities__AdminLegalEntity: {
      /** Id */
      id: number;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /** Name */
      name: string;
      /** Account Id */
      account_id?: number | null;
      /** Ein */
      ein?: string | null;
      /** Naics Code */
      naics_code?: string | null;
      /** Entity Type Id */
      entity_type_id: number;
      /** Llc Managed Type */
      llc_managed_type?: string | null;
      /** Tax Class Id */
      tax_class_id: number;
      /** Is Non Stock */
      is_non_stock?: boolean | null;
      /** Nonprofit Type */
      nonprofit_type?: string | null;
      /** Incorporation Region Id */
      incorporation_region_id?: number | null;
      /** Incorporation Date */
      incorporation_date: string | null;
      /** Physical Address Id */
      physical_address_id?: number | null;
      /** Mailing Address Id */
      mailing_address_id?: number | null;
      /** Is Test Account */
      is_test_account: boolean;
      /** Is Subscribed */
      is_subscribed: boolean;
      /** Is Business Profile Submitted */
      is_business_profile_submitted?: boolean | null;
      /** Public Id */
      public_id?: string | null;
      /** Is Active */
      is_active: boolean;
      /** Business Name */
      business_name?: string | null;
      /** Business Email */
      business_email?: string | null;
      /** Business Phone */
      business_phone?: string | null;
      /** Business Purpose */
      business_purpose?: string | null;
      /** Billable Employees */
      billable_employees?: number | null;
      /** Peo Provider Id */
      peo_provider_id?: number | null;
      /** Platform Id */
      platform_id?: number | null;
      /** Notice Url */
      notice_url?: string | null;
      /** Hubspot Company Id */
      hubspot_company_id?: string | null;
      /** Primary Contact Id */
      primary_contact_id?: number | null;
      /** Accounting Method */
      accounting_method?: string | null;
      /** Accounting Period */
      accounting_period?: string | null;
      /** Accounting Year End */
      accounting_year_end?: string | null;
      /** Futa Liability Year */
      futa_liability_year?: number | null;
      /** Submitter Id */
      submitter_id?: number | null;
      /** President Id */
      president_id?: number | null;
      /** Secretary Id */
      secretary_id?: number | null;
      /** Treasurer Id */
      treasurer_id?: number | null;
      /** Subscription Plan */
      subscription_plan?: string | null;
      /** Is Handbook Enabled */
      is_handbook_enabled?: boolean | null;
      /** Stripe Customer Id */
      stripe_customer_id?: string | null;
    };
    /** Mail */
    app__api__admin__mailroom_mail__Mail: {
      /** Id */
      id: number;
      /** Source */
      source: string;
      /** Source Id */
      source_id: string;
      /** Data */
      data?: unknown;
      /** Status */
      status: string;
      /** Sender */
      sender?: string | null;
      /** Created At */
      created_at?: string | null;
      /** Delivered At */
      delivered_at?: string | null;
      /** Scan Received At */
      scan_received_at?: string | null;
      /** Legal Entity Id */
      legal_entity_id?: number | null;
      /** Legal Entity Region Id */
      legal_entity_region_id?: number | null;
      /** Region Id */
      region_id?: number | null;
      /** File Id */
      file_id?: number | null;
      /** Processed File Id */
      processed_file_id?: number | null;
      /**
       * Is Sop
       * @default false
       */
      is_sop: boolean;
    };
    /** AdminLegalEntity */
    app__api__admin__workflow_instances__AdminLegalEntity: {
      /** Id */
      id: number;
      /** Name */
      name: string;
      /** Business Name */
      business_name: string | null;
      /** Integrations Email */
      integrations_email?: string | null;
      /** Is Test Account */
      is_test_account: boolean;
      platform: components['schemas']['AdminPlatformRef'] | null;
      peo_provider?: components['schemas']['AdminPeoProvider'] | null;
      /** Hubspot Company Id */
      hubspot_company_id?: string | null;
    };
    /** AdminRegion */
    app__api__admin__workflow_instances__AdminRegion: {
      /** Id */
      id: number;
      /** Name */
      name: string;
      /** Code */
      code: string;
    };
    /** AdminRegion */
    app__api__admin__workflows__AdminRegion: {
      /** Id */
      id: number;
      /** Code */
      code: string;
    };
    /** Address */
    app__api__legal_entity__Address: {
      /** Country */
      country: string;
      /** Address Line 1 */
      address_line_1: string;
      /** Address Line 2 */
      address_line_2?: string | null;
      /** City */
      city: string;
      /** State */
      state?: string | null;
      /** Postal Code */
      postal_code?: string | null;
    };
    /** LocationRef */
    app__api__platform__account_locations__LocationRef: {
      /** Id */
      id: string;
      /** Code */
      code: string;
      /** Name */
      name: string;
    };
    /** PlatformAgencyAccount */
    app__api__platform__accounts__models__PlatformAgencyAccount: {
      /** Id */
      id: string;
      /** Agency Id */
      agency_id: string;
      /** Region */
      region: string;
      /** Name */
      name: string;
    };
    /** PlatformAgencyAccount */
    app__api__platform__models__PlatformAgencyAccount: {
      /** Location Id */
      location_id: string;
      /** Id */
      id: string;
      /** Name */
      name: string;
      agency: components['schemas']['PlatformAgency'];
      /** Data */
      data: components['schemas']['PlatformAgencyAttributeAndValue'][];
      /** Logins */
      logins: components['schemas']['PlatformLegalEntityAccountLogin'][];
    };
    /** CreateResponse */
    app__attribute__admin__api__CreateResponse: {
      /** Id */
      id: number;
    };
    /** FieldRule */
    'app__attribute_forms__models__FieldRule-Output': {
      /** Condition */
      condition:
        | components['schemas']['RuleConditionEquals']
        | components['schemas']['RuleConditionExists']
        | components['schemas']['RuleConditionNot-Output']
        | components['schemas']['RuleConditionAnd-Output']
        | components['schemas']['RuleConditionOr-Output']
        | components['schemas']['RuleConditionLowerBounds']
        | components['schemas']['RuleConditionUpperBounds'];
      /** Affected Fields */
      affected_fields: string[];
    };
    /** FieldRule */
    app__attribute_forms__public__FieldRule: {
      /** Target Field */
      target_field: string;
      /** Target Is In Array Field */
      target_is_in_array_field: boolean;
      /** Condition */
      condition: {
        [key: string]: unknown;
      };
    };
    /** CreateResponse */
    app__authoring__api__CreateResponse: {
      /**
       * Change Ids
       * @default []
       */
      change_ids: number[];
      /**
       * Prompt Response
       * @default
       */
      prompt_response: string;
      /** Error Message */
      error_message?: string | null;
    };
    /** LocationRef */
    app__compliance__public__LocationRef: {
      /** Id */
      id: string;
      /** Name */
      name: string;
    };
    /** CreateResponse */
    app__integration_email__admin__api__CreateResponse: {
      /** Id */
      id: number;
    };
    /** Mail */
    app__mail__public__Mail: {
      /** Id */
      id: string;
      /** Region Code */
      region_code?: string | null;
      source: components['schemas']['MailSource'];
      /** Source Id */
      source_id: string;
      type: components['schemas']['MailType'];
      /** Description */
      description: string;
      /** Sender */
      sender?: string | null;
      /**
       * Received At
       * Format: date
       */
      received_at: string;
      /** Url */
      url: string;
      /**
       * Is Read
       * @default false
       */
      is_read: boolean;
      assigned_user?: components['schemas']['UserRef'] | null;
      status: components['schemas']['LegalEntityMailStatus'];
      summary: components['schemas']['MailSummary'];
    };
    /** Address */
    app__public__Address: {
      /** Id */
      id?: string | null;
      /** Address Line 1 */
      address_line_1: string;
      /** Address Line 2 */
      address_line_2?: string | null;
      /** City */
      city: string;
      /** State */
      state: string;
      /** Country */
      country: string;
      /** Postal Code */
      postal_code: string;
    };
  };
  responses: never;
  parameters: never;
  requestBodies: never;
  headers: never;
  pathItems: never;
}
export type $defs = Record<string, never>;
export interface operations {
  stream_local_file_api_files__bucket___file__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        bucket: string;
        file: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  users_list_api_admin_users_get: {
    parameters: {
      query?: {
        filter?: string;
        range?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminUser'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  user_details_api_admin_users__user_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminUser'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  user_update_handler_api_admin_users__user_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_id: number;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminUserUpdateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminUser'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  user_impersonate_handler_api_admin_users__user_id__impersonate_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_id: number;
      };
      cookie?: {
        refresh_token?: string | null;
      };
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_connection_handler_api_admin_connections__connection_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        connection_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_connection_handler_api_admin_connections__connection_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        connection_id: number;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ConnectionUpdateParams'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_connection_handler_api_admin_connections__connection_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        connection_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  connections_list_api_admin_connections_get: {
    parameters: {
      query?: {
        filter?: string | null;
        range?: string | null;
        sort?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_integrations_handler_api_admin_integrations_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
    };
  };
  list_tags_handler_api_admin_tags_get: {
    parameters: {
      query?: {
        filter?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminTag'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_tag_handler_api_admin_tags_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminTagCreate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminTagCreate'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_tag_handler_api_admin_tags__tag_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        tag_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: number;
          };
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_tags_by_name_handler_api_admin_tags_by_name_get: {
    parameters: {
      query?: {
        filter?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminTagByName'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  command_executions_api_admin_commands_get: {
    parameters: {
      query?: {
        range?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminCommandExecResult'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  command_exec_api_admin_commands_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json':
          | components['schemas']['AdminCommandAccountReport']
          | components['schemas']['CommandAnnualReport']
          | components['schemas']['AdminCommandAnalyzeDocuments']
          | components['schemas']['AdminAlertETABreachedWorkflows']
          | components['schemas']['CommandCertificateOfGoodStanding']
          | components['schemas']['AdminCommandCreateLegalEntityAndUser']
          | components['schemas']['AdminCommandResetLegalEntityRegion']
          | components['schemas']['AdminCommandCreateTrainingWorkflowInstances']
          | components['schemas']['AdminCommandFetchUnredactedFormCapture']
          | components['schemas']['CommandForeignQualification']
          | components['schemas']['AdminCommandGenerateSEOContent']
          | components['schemas']['AdminCommandLoadManagedRequirementOverrides']
          | components['schemas']['AdminCommandLoadRegionalNavsData']
          | components['schemas']['AdminCommandLoadRequirementsForUser']
          | components['schemas']['AdminCommandLoadHandbookRequirementsForUser']
          | components['schemas']['AdminCommandLegalEntityRequirementHealthCheck']
          | components['schemas']['AdminCommandManageGoogleGroups']
          | components['schemas']['AdminCommandPlatformBillingReport']
          | components['schemas']['CommandRegisteredAgentSubscription']
          | components['schemas']['CommandRegisteredAgentTransfer']
          | components['schemas']['AdminCommandRequirementsAndRemediationsReport']
          | components['schemas']['AdminCommandSendAllSummaryEmails']
          | components['schemas']['AdminCommandSendSubscriptionEmail']
          | components['schemas']['AdminCommandSendSummaryEmail']
          | components['schemas']['AdminCommandSyncPayroll']
          | components['schemas']['AdminCommandSyncPayrollCSV']
          | components['schemas']['AdminCommandSyncLegalincOrderStatus']
          | components['schemas']['AdminCommandUpdateSubscriptionBilling']
          | components['schemas']['CommandResetHandbookLegalEntity']
          | components['schemas']['CommandUpsertHandbookUsers']
          | components['schemas']['CommandInsertHandbookUser']
          | components['schemas']['CommandMigrateEmployeeCount']
          | components['schemas']['CommandCategorizePolicies']
          | components['schemas']['AdminCommandValidateComplianceEngineUrls']
          | components['schemas']['AdminCommandSyncHubspotCustomerData']
          | components['schemas']['AdminCommandDeleteInapplicableHomeForeignOnlyLegalEntityRequirements']
          | components['schemas']['AdminCommandBackfillHomeStates']
          | components['schemas']['AdminCommandWorkflowReport']
          | components['schemas']['AdminCommandComplianceChangeReport']
          | components['schemas']['AdminCommandWriteConfigTableDumpsToS3']
          | components['schemas']['AdminCommandCreateCheckLoginWorkflows']
          | components['schemas']['AdminCommandOffboardLegalEntity']
          | components['schemas']['AdminCommandWorkflowFeesReport']
          | components['schemas']['AdminCommandSimulateSchedule']
          | components['schemas']['AdminCommandDataChecker']
          | components['schemas']['AdminCommandBulkInsertAgencyAccounts']
          | components['schemas']['CommandUpdateLegalincCompanyForwardingContact']
          | components['schemas']['CommandCheckForLegalincAddressesAsMailingAddress']
          | components['schemas']['AdminCommandMailroomRotatePdf']
          | components['schemas']['AdminCommandEmailroomUploadPdf']
          | components['schemas']['CommandAlertMissingLegalincCompanies']
          | components['schemas']['AdminCommandConvertForm']
          | components['schemas']['GenerateOperatorWorkflowPrompt']
          | components['schemas']['AdminCommandSyncMailRoom']
          | components['schemas']['CommandDeleteLegalEntityRequirementAndTriggers'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  command_list_api_admin_commands_all_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminCommand'][];
        };
      };
    };
  };
  command_show_api_admin_commands__command_run_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        command_run_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_legal_entity_refs_handler_api_admin_legal_entity_refs_get: {
    parameters: {
      query?: {
        range?: string;
        filter?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminLegalEntityRef'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_legal_entities_handler_api_admin_legal_entities_get: {
    parameters: {
      query?: {
        range?: string;
        filter?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['app__api__admin__legal_entities__AdminLegalEntity'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_legal_entity_handler_api_admin_legal_entities_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminCreateLegalEntityRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['app__api__admin__legal_entities__AdminLegalEntity'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_legal_entity_handler_api_admin_legal_entities__legal_entity_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        legal_entity_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['app__api__admin__legal_entities__AdminLegalEntity'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_legal_entity_handler_api_admin_legal_entities__legal_entity_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        legal_entity_id: number;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminUpdateLegalEntityRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['app__api__admin__legal_entities__AdminLegalEntity'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_legal_entity_business_information_handler_api_admin_legal_entities__legal_entity_id__business_information_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        legal_entity_id: number;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BusinessInformationParams'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BusinessInformation'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_legal_entity_integration_emails_api_admin_legal_entities__legal_entity_id__integration_emails_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        legal_entity_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': string[];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_legal_entity_integrations_email_handler_api_admin_legal_entities__legal_entity_id__generate_integrations_email_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        legal_entity_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': string | null;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_legal_entity_customer_success_user_api_admin_legal_entities__legal_entity_id__customer_success_user_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        legal_entity_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminUser'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  legal_entity_requirement_list_api_admin_legal_entity_requirements_get: {
    parameters: {
      query?: {
        filter?: string;
        range?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminTask'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  legal_entity_requirement_show_api_admin_legal_entity_requirements__task_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        task_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminTask'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  legal_entity_requirement_update_api_admin_legal_entity_requirements__task_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        task_id: number;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminUpdateLegalEntityRequirementRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminTask'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  legal_entity_regions_list_api_admin_legal_entity_regions_get: {
    parameters: {
      query?: {
        filter?: string;
        range?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  legal_entity_requirement_create_api_admin_legal_entity_regions_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminCreateLegalEntityRegionRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminLegalEntityRegionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  legal_entity_regions_show_api_admin_legal_entity_regions__legal_entity_region_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        legal_entity_region_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  legal_entity_requirement_update_api_admin_legal_entity_regions__legal_entity_region_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        legal_entity_region_id: number;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminUpdateLegalEntityRegionRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_record_type_api_admin_record_types__unique_field__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        unique_field: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RecordType'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  legal_entity_addresses_api_admin_legal_entity_addresses_get: {
    parameters: {
      query?: {
        filter?: string | null;
        range?: string | null;
        sort?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_legal_entity_address_handler_api_admin_legal_entity_addresses_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminUpsertLegalEntityAddressRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  legal_entity_address_show_api_admin_legal_entity_addresses__legal_entity_address_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        legal_entity_address_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  legal_entity_address_update_api_admin_legal_entity_addresses__legal_entity_address_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        legal_entity_address_id: number;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminUpsertLegalEntityAddressRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  legal_entity_persons_api_admin_legal_entity_persons_get: {
    parameters: {
      query?: {
        filter?: string | null;
        range?: string | null;
        sort?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_legal_entity_person_handler_api_admin_legal_entity_persons_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminCreateLegalEntityPersonRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  legal_entity_person_show_api_admin_legal_entity_persons__legal_entity_person_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        legal_entity_person_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  legal_entity_person_update_api_admin_legal_entity_persons__legal_entity_person_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        legal_entity_person_id: number;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminLegalEntityPerson'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  legal_entity_person_delete_api_admin_legal_entity_persons__legal_entity_person_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        legal_entity_person_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': null;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  legal_entity_person_reference_check_api_admin_legal_entity_persons__legal_entity_person_id__reference_check_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        legal_entity_person_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ReferenceCheck'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_legal_entity_users_api_admin_legal_entity_users_get: {
    parameters: {
      query?: {
        filter?: string;
        range?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  post_legal_entity_users_api_admin_legal_entity_users_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminLegalEntityUserRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_legal_entity_user_api_admin_legal_entity_users__legal_entity_user_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        legal_entity_user_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  put_legal_entity_users_api_admin_legal_entity_users__legal_entity_user_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        legal_entity_user_id: number;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminLegalEntityUserRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_regions_handler_api_admin_regions_get: {
    parameters: {
      query?: {
        filter?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_region_handler_api_admin_regions__region_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        region_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_region_by_code_handler_api_admin_regions_code__region_code__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        region_code: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  handle_get_requirement_ref_by_filtering_api_admin_requirements_refs_get: {
    parameters: {
      query?: {
        filter?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminRequirementRef'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  handle_list_requirements_to_review_api_admin_requirements_to_review_get: {
    parameters: {
      query?: {
        filter?: string | null;
        range?: string | null;
        sort?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminRequirement'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  handle_list_requirements_api_admin_requirements_get: {
    parameters: {
      query?: {
        filter?: string | null;
        range?: string | null;
        sort?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminRequirement'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  requirement_create_api_admin_requirements_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminRequirementCreate-Input'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminRequirementCreate-Output'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  handle_get_requirement_api_admin_requirements__requirement_id__get: {
    parameters: {
      query?: {
        pending_change_id?: number | null;
      };
      header?: never;
      path: {
        requirement_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminRequirement'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  handle_save_requirement_api_admin_requirements__requirement_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        requirement_id: number;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminRequirementUpdate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminRequirementResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  handle_get_pending_requirement_api_admin_requirements_pending__pending_change_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        pending_change_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminRequirement'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_requirement_summarry_templates_api_admin_requirement_summary_templates_get: {
    parameters: {
      query?: {
        filter?: string | null;
        range?: string | null;
        sort?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminRequirementSummaryTemplate'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_requirement_summary_template_api_admin_requirement_summary_templates_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminRequirementSummaryTemplateCreate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminRequirementSummaryTemplateCreate'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_requirement_summary_template_api_admin_requirement_summary_templates__summary_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        summary_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminRequirementSummaryTemplate'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_requirement_summary_template_api_admin_requirement_summary_templates__summary_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        summary_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_forms_handler_api_admin_form_files_get: {
    parameters: {
      query?: {
        filter?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['FormSpec-Output'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_form_handler_api_admin_form_files_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['FormCreation'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['FormSpec-Output'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_form_handler_api_admin_form_files__form_spec_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        form_spec_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['FormSpec-Output'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_form_handler_api_admin_form_files__form_spec_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        form_spec_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['FormSpec-Input'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['FormSpec-Output'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_registered_agents_handler_api_admin_registered_agent_transfers_get: {
    parameters: {
      query?: {
        filter?: string | null;
        range?: string | null;
        sort?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminRegisteredAgent'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_registered_agent_transfer_handler_api_admin_registered_agent_transfers__registered_agent_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        registered_agent_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminRegisteredAgent'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_registered_agent_handler_api_admin_registered_agent_transfers__registered_agent_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        registered_agent_id: number;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminUpdateRegisteredAgentRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminRegisteredAgent'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_invites_handler_api_admin_invites_get: {
    parameters: {
      query?: {
        filter?: string | null;
        range?: string | null;
        sort?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_invite_handler_api_admin_invites_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminCreateInviteRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_invite_handler_api_admin_invites__invite_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        invite_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_invite_handler_api_admin_invites__invite_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        invite_id: number;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminUpdateInviteRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  verify_invite_handler_api_admin_invites_verify_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminVerifyInviteParams'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  accept_invite_handler_api_admin_invites_accept_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminAcceptInviteParams'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_email_capture_handler_api_admin_email_captures_get: {
    parameters: {
      query?: {
        filter?: string | null;
        range?: string | null;
        sort?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_email_capture_handler_api_admin_email_captures__email_capture_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        email_capture_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_form_capture_handler_api_admin_form_captures_get: {
    parameters: {
      query?: {
        filter?: string | null;
        range?: string | null;
        sort?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_form_capture_handler_api_admin_form_captures__form_capture_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        form_capture_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_form_capture_by_legal_entity_handler_api_admin_form_captures_legal_entity__legal_entity_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        legal_entity_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_form_capture_by_workflow_instance_handler_api_admin_form_captures_workflow_instance__workflow_instance_id__get: {
    parameters: {
      query?: {
        unredacted?: boolean;
      };
      header?: never;
      path: {
        workflow_instance_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: unknown;
          };
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_guests_handler_api_admin_guests_get: {
    parameters: {
      query?: {
        filter?: string;
        range?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_guest_handler_api_admin_guests__guest_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        guest_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_guest_document_stream_download_handler_api_admin_guest_documents__document_id__download_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_guest_documents_handler_api_admin_guest_documents_get: {
    parameters: {
      query?: {
        filter?: string;
        range?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GuestDocument'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_guest_handler_api_admin_guest_documents__document_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GuestDocument'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_agencies_handler_to_review_api_admin_agencies_to_review_get: {
    parameters: {
      query?: {
        filter?: string;
        range?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: unknown;
          }[];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_agencies_handler_api_admin_agencies_get: {
    parameters: {
      query?: {
        filter?: string | null;
        range?: string | null;
        sort?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: unknown;
          }[];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_agency_handler_api_admin_agencies_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminAgencyCreate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminAgencyCreate'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_agencies_by_id_handler_api_admin_agencies_by_id_get: {
    parameters: {
      query?: {
        filter?: string | null;
        range?: string | null;
        sort?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: unknown;
          }[];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_agency_handler_api_admin_agencies__agency_public_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        agency_public_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminAgency'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_agency_handler_api_admin_agencies__agency_public_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        agency_public_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminAgencyUpdate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminAgency'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_agency_accounts_handler_api_admin_agency_accounts_get: {
    parameters: {
      query?: {
        filter?: string | null;
        range?: string | null;
        sort?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminAgencyAccount'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_agency_account_handler_api_admin_agency_accounts_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminAgencyAccountCreateOrUpdate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminAgencyAccountCreateOrUpdate'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_agency_accounts_handler_api_admin_agency_accounts__agency_account_public_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        agency_account_public_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminAgencyAccount'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_agency_handler_api_admin_agency_accounts__agency_account_public_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        agency_account_public_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminAgencyAccountCreateOrUpdate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminAgencyAccountCreateOrUpdate'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_login_api_admin_legal_entities__legal_entity_id__logins__account_login_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        legal_entity_id: number;
        account_login_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminLogin'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_login_api_admin_legal_entities__legal_entity_id__logins_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        legal_entity_id: number;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateLogin'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminLogin'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_attributes_api_admin_attributes_get: {
    parameters: {
      query?: {
        range?: string | null;
        filter?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminBaseAttribute-Output'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_attribute_api_admin_attributes_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminNewAttribute'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['app__attribute__admin__api__CreateResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_attributes_to_review_api_admin_attributes_to_review_get: {
    parameters: {
      query?: {
        range?: string | null;
        filter?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminBaseAttribute-Output'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_attributes_public_id_api_admin_attributes_public_id_get: {
    parameters: {
      query?: {
        range?: string | null;
        filter?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AttributePublicId'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_attribute_api_admin_attributes__attribute_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        attribute_id: number | string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminAttributeShow'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_attribute_api_admin_attributes__attribute_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        attribute_id: number | string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminUpdateAttribute'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_datums_handler_api_admin_datums_get: {
    parameters: {
      query?: {
        filter?: string;
        range?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_datum_handler_api_admin_datums_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminDatumCreate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_datum_handler_api_admin_datums__datum_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        datum_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_datum_handler_api_admin_datums__datum_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        datum_id: number;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminDatumUpdate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_bulk_datum_handler_api_admin_datums_bulk_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminDatumCreate'][];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_workflows_handler_api_admin_workflows_get: {
    parameters: {
      query?: {
        range?: string;
        filter?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminWorkflow'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_workflow_handler_api_admin_workflows_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['WorkflowCreate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminWorkflow'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_workflow_refs_handler_api_admin_workflow_refs_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminWorkflowRef'][];
        };
      };
    };
  };
  get_workflow_handler_api_admin_workflows__workflow_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminWorkflow'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_workflow_handler_api_admin_workflows__workflow_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_id: number;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['WorkflowUpdate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminWorkflow'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_workflow_step_rendered_template_api_admin_workflows__workflow_id___step_id__render_action_template_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_id: number;
        step_id: number;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['TemplateVariableValues'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RenderTemplateResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_all_tags_handler_api_admin_workflow_tags_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminWorkflowTag'][];
        };
      };
    };
  };
  get_workflow_template_data_types_handler_api_admin_workflow__workflow_id__template_data_types_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: unknown;
          };
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  generate_workflow_prompt_handler_api_admin_workflow__workflow_id__legal_entity__legal_entity_id__prompt_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_id: number;
        legal_entity_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GeneratePromptResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_workflow_step_prompt_override_api_admin_workflow_step_prompt_override_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['WorkflowStepPromptOverrideCreate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['WorkflowStepPromptOverrideCreateResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_workflow_prompt_overrides_handler_api_admin_workflow__workflow_id__prompt_overrides_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [
              key: string
            ]: components['schemas']['WorkflowStepPromptOverrideViewModel'];
          };
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_files_handler_with_url_api_admin_files_with_url_get: {
    parameters: {
      query?: {
        filter?: string;
        range?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminFile'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_files_handler_api_admin_files_get: {
    parameters: {
      query?: {
        filter?: string;
        range?: string;
        with_url?: boolean;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminFile'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_file_handler_api_admin_files__file_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        file_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminFile'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_all_legal_entities_api_admin_workflow_instances_legal_entities_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': string[];
        };
      };
    };
  };
  list_workflow_instances_flat_handler_api_admin_workflow_instances_get: {
    parameters: {
      query?: {
        filter?: string;
        range?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminListWorkflowInstance'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_workflow_instance_handler_api_admin_workflow_instances_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['WorkflowInstanceCreate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminWorkflowInstance'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_workflow_instances_handler_api_admin_workflow_app_workflow_instances_get: {
    parameters: {
      query?: {
        filter?: string;
        range?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['FlatWorkflowInstance'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_workflow_instance_metadata_handler_api_admin_workflow_app_workflow_instances_metadata_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminWorkflowListMetadataResponse'];
        };
      };
    };
  };
  get_workflow_instance_handler_api_admin_workflow_instances__workflow_instance_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_instance_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminWorkflowInstance'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_workflow_instance_handler_api_admin_workflow_instances__workflow_instance_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_instance_id: number;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['WorkflowInstanceUpdate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminWorkflowInstance'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_workflow_instance_mail_handler_api_admin_workflow_instances__workflow_instance_id__mail_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_instance_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['app__mail__public__Mail'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_legal_entity_mail_by_public_id_handler_api_admin_workflow_instances__workflow_instance_id__mail__mail_public_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_instance_id: number;
        mail_public_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_workflow_instance_start_handler_api_admin_workflow_instances__workflow_instance_id__start_put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_instance_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminWorkflowInstance'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_workflow_instance_block_handler_api_admin_workflow_instances__workflow_instance_id__block_put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_instance_id: number;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['WorkflowInstanceBlockCreate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminWorkflowInstance'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_workflow_instance_unblock_handler_api_admin_workflow_instances__workflow_instance_id__unblock_put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_instance_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminWorkflowInstance'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  assign_workflow_instance_api_admin_workflow_instances__workflow_instance_id__assign_put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_instance_id: number;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AssignWorkflowInstance'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminWorkflowInstance'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_workflow_instance_reminder_handler_api_admin_workflow_instances__workflow_instance_id__reminder_put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_instance_id: number;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminWorkflowInstanceReminder'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminWorkflowInstance'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_workflow_instance_next_step_handler_api_admin_workflow_instances__workflow_instance_id__next_step_put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_instance_id: number;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['WorkflowNextStepRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminWorkflowInstance'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_workflow_instance_next_step_handler_file_upload_api_admin_workflow_instances__workflow_instance_id__upload_file_post: {
    parameters: {
      query?: {
        advance_step?: boolean;
      };
      header?: never;
      path: {
        workflow_instance_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminWorkflowInstance'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_workflow_instance_previous_step_handler_api_admin_workflow_instances__workflow_instance_id__previous_step_put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_instance_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminWorkflowInstance'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_workflow_instance_skip_step_handler_api_admin_workflow_instances__workflow_instance_id__skip_step_put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_instance_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminWorkflowInstance'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_workflow_instance_cancel_handler_api_admin_workflow_instances__workflow_instance_id__cancel_put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_instance_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminWorkflowInstance'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_workflow_instance_set_state_handler_api_admin_workflow_instances__workflow_instance_id__state_put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_instance_id: number;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': {
          [key: string]: unknown;
        };
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminWorkflowInstance'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_workflow_instance_simulate_handler_api_admin_workflow_instances__workflow_instance_id__simulate_put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_instance_id: number;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': {
          [key: string]: unknown;
        };
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminWorkflowInstance'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_workflow_instance_comments_handler_api_admin_workflow_instances__workflow_instance_id__comments_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_instance_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminWorkflowInstanceComment'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_workflow_instance_comment_handler_api_admin_workflow_instances__workflow_instance_id__comments_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_instance_id: number;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['WorkflowInstanceCommentCreate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminWorkflowInstanceComment'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_workflow_legalinc_docs_api_admin_workflow_instances__workflow_instance_id__legalinc_docs__legal_entity_document_type_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_instance_id: number;
        legal_entity_document_type_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminLegalIncDocuments'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_workflow_instance_template_data_handler_api_admin_workflow_instances__workflow_instance_id__template_data_get: {
    parameters: {
      query?: {
        unredacted?: boolean;
      };
      header?: never;
      path: {
        workflow_instance_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: unknown;
          };
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_workflow_instance_stale_logins_api_admin_workflow_instances__workflow_instance_id__stale_logins_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_instance_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Login'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_workflow_instance_stale_logins_api_admin_workflow_instances__workflow_instance_id__stale_login__login_public_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_instance_id: number;
        login_public_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['WorkflowInstanceStaleLoginUpdate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Login'] | null;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_workflow_instance_stats_api_admin_workflow_instance_stats_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SubmittedAtRow'][] | null;
        };
      };
    };
  };
  managed_providers_list_api_admin_managed_providers_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
    };
  };
  managed_providers_create_api_admin_managed_providers_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ManagedProviderCreate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  managed_provider_requirement_api_admin_managed_provider_requirements__managed_provider_requirement_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        managed_provider_requirement_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_managed_provider_requirement_handler_api_admin_managed_provider_requirements__managed_provider_requirement_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        managed_provider_requirement_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': null;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  managed_provider_requirements_list_api_admin_managed_provider_requirements_get: {
    parameters: {
      query?: {
        filter?: string | null;
        range?: string | null;
        sort?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  managed_providers_create_api_admin_managed_provider_requirements_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ManagedProviderRequirementCreate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_entity_types_handler_api_admin_entity_types_get: {
    parameters: {
      query?: {
        filter?: string | null;
        range?: string | null;
        sort?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  show_entity_types_handler_api_admin_entity_types__entity_type_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        entity_type_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_tax_classes_handler_api_admin_tax_classes_get: {
    parameters: {
      query?: {
        filter?: string | null;
        range?: string | null;
        sort?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  show_tax_class_handler_api_admin_tax_classes__tax_class_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        tax_class_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_wizard_handler_api_admin_wizards_get: {
    parameters: {
      query?: {
        filter?: string | null;
        range?: string | null;
        sort?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_mailroom_mail_handler_api_admin_mailroom_mail_get: {
    parameters: {
      query?: {
        filter?: string | null;
        range?: string | null;
        sort?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['app__api__admin__mailroom_mail__Mail'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_mailroom_mail_handler_api_admin_mailroom_mail__mail_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        mail_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['app__api__admin__mailroom_mail__Mail'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_mailroom_mail_handler_api_admin_mailroom_mail__mail_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        mail_id: number;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json':
          | components['schemas']['MailroomMailDeliver']
          | components['schemas']['MailroomMailException']
          | components['schemas']['MailroomMailSpam']
          | components['schemas']['MailroomMailUndeliverable']
          | components['schemas']['MailroomMailPending'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['app__api__admin__mailroom_mail__Mail'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_mailroom_mail_scan_handler_api_admin_mailroom_mail__mail_id__scan__sequence_number__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        mail_id: number;
        sequence_number: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  notice_list_api_admin_notices_get: {
    parameters: {
      query?: {
        filter?: string | null;
        range?: string | null;
        sort?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminNotice'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  notice_create_api_admin_notices_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/x-www-form-urlencoded': components['schemas']['Body_notice_create_api_admin_notices_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminNotice'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  notice_details_api_admin_notices__notice_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        notice_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminNotice'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  notice_update_api_admin_notices__notice_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        notice_id: number;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/x-www-form-urlencoded': components['schemas']['Body_notice_update_api_admin_notices__notice_id__put'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminNotice'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_pending_changes_comments_api_admin_pending_changes__pending_compliance_change_id__comment_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        pending_compliance_change_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ComplianceChangeComment'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_changes_api_admin_pending_changes_get: {
    parameters: {
      query?: {
        range?: string | null;
        filter?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ComplianceChange'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  submit_prompt_api_admin_pending_changes_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['PromptRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['app__authoring__api__CreateResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_change_api_admin_pending_changes__change_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        change_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ComplianceChangeDetails'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_change_api_admin_pending_changes__change_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        change_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': null;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  apply_change_api_admin_pending_changes__change_id__apply_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        change_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': null;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  bulk_approve_change_api_admin_pending_changes_apply_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BulkPendingChangeRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': null;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  add_comment_api_admin_pending_changes__change_id__comment_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        change_id: number;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['PendingChangeComment'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ComplianceChangeComment'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_change_logs_api_admin_change_log_get: {
    parameters: {
      query?: {
        range?: string | null;
        filter?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ComplianceChangeLogDetails'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_history_change_logs_api_admin_history_changes_get: {
    parameters: {
      query?: {
        filter?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ComplianceChangeLogDetails'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_image_api_admin_images__image_name__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        image_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_image_api_admin_images_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CreateImageResponse'];
        };
      };
    };
  };
  list_account_logins_handler_api_admin_account_login_refs_get: {
    parameters: {
      query?: {
        filter?: string;
        range?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminAccountLoginRef'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_account_login_refs_handler_api_admin_account_logins_get: {
    parameters: {
      query?: {
        filter?: string;
        range?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminAccountLoginBase'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_account_login_handler_api_admin_account_logins_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AccountLoginCreateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['app__account_login__admin__input__CreateResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_account_login_handler_api_admin_account_logins__account_login_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        account_login_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminAccountLoginView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_account_login_handler_api_admin_account_logins__account_login_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        account_login_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminAccountLoginUpdate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminAccountLoginUpdate'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_legal_entity_account_logins_handler_api_admin_legal_entity_account_logins_get: {
    parameters: {
      query?: {
        filter?: string | null;
        range?: string | null;
        sort?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminLegalEntityAccountLogin'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_legal_entity_account_login_handler_api_admin_legal_entity_account_logins_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminLegalEntityAccountLoginCreate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_legal_entity_account_login_handler_api_admin_legal_entity_account_logins__legal_entity_account_login_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        legal_entity_account_login_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminLegalEntityAccountLogin'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_legal_entity_account_login_handler_api_admin_legal_entity_account_logins__legal_entity_account_login_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        legal_entity_account_login_id: number;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminLegalEntityAccountLoginUpdate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_legal_entity_account_login_handler_api_admin_legal_entity_account_logins__legal_entity_account_login_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        legal_entity_account_login_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': null;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_upcoming_legislation_handler_api_admin_upcoming_legislations_get: {
    parameters: {
      query?: {
        range?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminUpcomingLegislation'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_upcoming_legislation_handler_api_admin_upcoming_legislations_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpcomingLegislationRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminUpcomingLegislation'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_upcoming_legislation_handler_api_admin_upcoming_legislations__upcoming_legislation_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        upcoming_legislation_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminUpcomingLegislation'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_upcoming_legislation_handler_api_admin_upcoming_legislations__upcoming_legislation_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        upcoming_legislation_id: number;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpcomingLegislationRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminUpcomingLegislation'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_upcoming_legislation_handler_api_admin_upcoming_legislations__upcoming_legislation_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        upcoming_legislation_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': null;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_referrals_handler_api_admin_referrals_get: {
    parameters: {
      query?: {
        filter?: string | null;
        range?: string | null;
        sort?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_referral_sources_handler_api_admin_referral_sources_get: {
    parameters: {
      query?: {
        filter?: string | null;
        range?: string | null;
        sort?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_referral_source_handler_api_admin_referral_sources_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminReferralSourceCreate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_referral_source_handler_api_admin_referral_sources__referral_source_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        referral_source_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_referral_source_handler_api_admin_referral_sources__referral_source_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        referral_source_id: number;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminReferralSourceUpdate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_stripe_coupons_handler_api_admin_stripe_coupons_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
    };
  };
  get_stripe_coupon_handler_api_admin_stripe_coupons__stripe_coupon_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        stripe_coupon_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_stripe_invoice_api_admin_stripe_invoice__legal_entity_id__post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        legal_entity_id: number;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['Invoice'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InvoiceResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_training_workflow_legal_entities_handler_api_admin_training_workflow_legal_entities_get: {
    parameters: {
      query?: {
        filter?: string | null;
        range?: string | null;
        sort?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminTrainingWorkflowLegalEntity'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_idtype_handler_api_admin_training_workflow_legal_entities_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminTrainingWorkflowLegalEntityCreate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminTrainingWorkflowLegalEntity'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  remove_platform_legal_entity_association_api_admin_training_workflow_legal_entities__id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': null;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  platforms_list_api_admin_platforms_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminPlatformAndConfiguration'][];
        };
      };
    };
  };
  platform_create_api_admin_platforms_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminCreateOrUpdatePlatformAndConfiguration'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminPlatformAndConfiguration'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  platform_show_api_admin_platforms__platform_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        platform_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminPlatformAndConfiguration'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  platform_update_api_admin_platforms__platform_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        platform_id: number;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminCreateOrUpdatePlatformAndConfiguration'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminPlatformAndConfiguration'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  api_keys_list_api_admin_api_keys_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
    };
  };
  api_keys_create_api_admin_api_keys_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminCreateApiKey'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  api_keys_show_api_admin_api_keys__id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  api_keys_update_api_admin_api_keys__id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminUpdateApiKey'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_platform_resolutions_handler_api_admin_platform_resolutions_get: {
    parameters: {
      query?: {
        filter?: string | null;
        range?: string | null;
        sort?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminPlatformResolution'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_platform_resolution_handler_api_admin_platform_resolutions_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminCreatePlatformResolution'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  show_platform_resolution_handler_api_admin_platform_resolutions__platform_resolution_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        platform_resolution_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminPlatformResolution'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_platform_resolution_handler_api_admin_platform_resolutions__platform_resolution_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        platform_resolution_id: number;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminUpdatePlatformResolution'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  custom_resolution_import_api_admin_platform_resolutions_import_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/x-www-form-urlencoded': components['schemas']['Body_custom_resolution_import_api_admin_platform_resolutions_import_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_accounts_handler_api_admin_accounts_get: {
    parameters: {
      query?: {
        filter?: string | null;
        range?: string | null;
        sort?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_account_handler_api_admin_accounts_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminCreateAccountRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_account_handler_api_admin_accounts__account_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        account_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_account_handler_api_admin_accounts__account_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        account_id: number;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminCreateAccountRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  legal_entity_document_type_list_api_admin_legal_entity_document_types_get: {
    parameters: {
      query?: {
        range?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminLegalEntityDocumentType'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_legal_entity_document_type_api_admin_legal_entity_document_types_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminLegalEntityDocumentType'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminLegalEntityDocumentType'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_legal_entity_document_type_api_admin_legal_entity_document_types__legal_entity_document_type_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        legal_entity_document_type_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminLegalEntityDocumentType'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  legal_entity_document_type_update_api_admin_legal_entity_document_types__document_type_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_type_id: number;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminLegalEntityDocumentType'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminLegalEntityDocumentType'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  legal_entity_document_get_email_data_api_admin_legal_entity_documents_email__workflow_instance_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_instance_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminLegalEntityDocumentEmailData'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_policy_sections_api_admin_policy_sections_get: {
    parameters: {
      query?: {
        filter?: string | null;
        range?: string | null;
        sort?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminPolicySection'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_policy_section_api_admin_policy_sections_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminPolicySectionCreate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ChangeResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_policy_categories_api_admin_policy_categories_get: {
    parameters: {
      query?: {
        filter?: string | null;
        range?: string | null;
        sort?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminPolicyCategory'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_policy_category_api_admin_policy_categories_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminPolicyCategoryCreate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ChangeResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_policy_category_api_admin_policy_categories__public_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        public_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminPolicyCategory'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_policy_category_api_admin_policy_categories__public_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        public_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminPolicyCategoryUpdate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminPolicyCategory'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_policy_section_api_admin_policy_sections__public_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        public_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminPolicySection'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_policy_section_api_admin_policy_sections__public_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        public_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminPolicySectionUpdate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminPolicySection'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_policies_api_admin_policies_get: {
    parameters: {
      query?: {
        filter?: string | null;
        range?: string | null;
        sort?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminPolicy'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_policy_api_admin_policies_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminPolicyCreate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ChangeResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_policies_by_category_api_admin_policy_categories__public_category_id__policies_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        public_category_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminPolicy'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_policy_api_admin_policies__public_id__get: {
    parameters: {
      query?: {
        pending_change_id?: number | null;
      };
      header?: never;
      path: {
        public_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminPolicy'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_policy_api_admin_policies__public_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        public_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminPolicyUpdate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminPolicy'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_handbook_legal_entity_api_admin_handbook_legal_entities__legal_entity_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        legal_entity_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HandbookLegalEntity'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_handbook_legal_entities_api_admin_handbook_legal_entities_get: {
    parameters: {
      query?: {
        range?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BaseHandbookLegalEntity'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_stats_api_admin_handbook_stats_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminHandbookStats'];
        };
      };
    };
  };
  get_legal_entity_integration_email_api_admin_legal_entity_integration_emails__id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminLegalEntityIntegrationEmail'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_integration_email_api_admin_legal_entity_integration_emails_get: {
    parameters: {
      query?: {
        filter?: string | null;
        range?: string | null;
        sort?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminLegalEntityIntegrationEmail'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_integration_email_api_admin_legal_entity_integration_emails_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminLegalEntityIntegrationEmailCreate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['app__integration_email__admin__api__CreateResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_emailroom_email_api_admin_emailroom__mailroom_email_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        mailroom_email_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminEmailRoomMail'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_emailroom_email_api_admin_emailroom__mailroom_email_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        mailroom_email_id: number;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json':
          | components['schemas']['AdminEmailroomMailDeliver']
          | components['schemas']['AdminEmailRoomMailUpdate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UpdateResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_emailroom_emails_api_admin_emailroom_get: {
    parameters: {
      query?: {
        filter?: string | null;
        range?: string | null;
        sort?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminEmailRoomMailList'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  bulk_update_emailroom_email_status_api_admin_emailroom_bulk_status_change_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminEmailroomBulkStatusUpdate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_forms_api_admin_forms_get: {
    parameters: {
      query?: {
        range?: string | null;
        filter?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminForm'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_form_api_admin_forms_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminCreateFormRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ComplianceChange'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_form_api_admin_forms__form_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        form_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminForm'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_form_api_admin_forms__form_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        form_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminUpdateFormRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ComplianceChange'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_form_attributes_api_admin_form_attributes_get: {
    parameters: {
      query?: {
        range?: string | null;
        filter?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminFormAttribute'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_form_attribute_api_admin_form_attributes_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminCreateFormAttributeRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ComplianceChange'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_form_attribute_api_admin_form_attributes__form_attribute_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        form_attribute_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminFormAttribute'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_form_attribute_api_admin_form_attributes__form_attribute_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        form_attribute_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminUpdateFormAttributeRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_form_attribute_api_admin_form_attributes__form_attribute_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        form_attribute_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ComplianceChange'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_workflow_attributes_api_admin_workflow_attributes_get: {
    parameters: {
      query?: {
        filter?: string | null;
        range?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['WorkflowAttributePublicModel'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_workflow_attribute_api_admin_workflow_attributes_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['WorkflowAttributeMutation'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_workflow_attribute_api_admin_workflow_attributes__workflow_attribute_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_attribute_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['WorkflowAttributePublicModel'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_workflow_attribute_api_admin_workflow_attributes__workflow_attribute_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_attribute_id: number;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['WorkflowAttributeMutation'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['WorkflowAttributeResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  remove_workflow_attribute_api_admin_workflow_attributes__workflow_attribute_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_attribute_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  count_workflow_attributes_api_admin_workflow_attributes__workflow_id__count_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['WorkflowAttributeCount'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_zip_code_groups_handler_api_admin_zip_code_groups_get: {
    parameters: {
      query?: {
        filter?: string | null;
        range?: string | null;
        sort?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminZipCodeGroup'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_question_tasks_api_admin_question_tasks_get: {
    parameters: {
      query?: {
        filter?: string | null;
        range?: string | null;
        sort?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminQuestionTask-Output'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_question_task_api_admin_question_tasks__question_task_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        question_task_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminQuestionTask-Output'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  put_question_task_api_admin_question_tasks__question_task_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        question_task_id: number;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminQuestionTask-Input'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  handle_list_notifications_api_admin_notifications_get: {
    parameters: {
      query?: {
        filter?: string | null;
        range?: string | null;
        sort?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminNotification'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  handle_get_notification_api_admin_notifications__notification_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        notification_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminNotification'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  sso_login_api_sso_token_post: {
    parameters: {
      query: {
        code: string;
        state?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AuthSessionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  sso_test_callback_api_sso_test_callback_get: {
    parameters: {
      query: {
        code: string;
        state?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AuthSessionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  sso_auth_url_api_sso_auth_url_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SSOAuthUrlRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': string | null;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  login_api_token_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/x-www-form-urlencoded': components['schemas']['Body_login_api_token_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json':
            | components['schemas']['AuthSessionResponse']
            | components['schemas']['AuthSSOResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  login_platform_user_api_platform_token_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/x-www-form-urlencoded': components['schemas']['Body_login_platform_user_api_platform_token_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AuthSessionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  logout_api_logout_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: {
        refresh_token?: string | null;
      };
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  refresh_api_refresh_token_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: {
        refresh_token?: string | null;
      };
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['RefreshTokenRequest'] | null;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AuthSessionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  token_for_impersonator_api_impersonate_token_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ImpersonatorTokenRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AuthSessionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  refresh_platform_token_api_refresh_platform_token_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: {
        refresh_token?: string | null;
      };
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['RefreshTokenRequest'] | null;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AuthSessionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  signup_api_signup_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/x-www-form-urlencoded': components['schemas']['Body_signup_api_signup_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json':
            | components['schemas']['AuthSessionResponse']
            | components['schemas']['AuthSSOResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_users_api_users_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LegalEntityUser'][];
        };
      };
    };
  };
  user_update_handler_api_users_me_put: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UserUpdateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['User'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  current_user_api_users_me_post: {
    parameters: {
      query?: {
        selected_legal_entity_id?: number | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['User'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_regions_api_regions_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Region'][];
        };
      };
    };
  };
  get_region_api_regions__region_code__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        region_code: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Region'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_invites_handler_api_invites_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PublicInvite'][];
        };
      };
    };
  };
  verify_invite_handler_api_invites_verify_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['VerifyInviteRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['VerifyInviteResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  accept_invite_handler_api_invites_accept_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AcceptInviteRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AuthSessionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  send_invite_handler_api_invites_send_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['InviteRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  revoke_invite_api_invites__invite_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        invite_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_legal_entity_region_handler_api_legal_entity_locations_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LegalEntityRegionRef'][];
        };
      };
    };
  };
  add_legal_entity_location_handler_api_legal_entity_locations_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['LegalEntityRegionAddRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LegalEntityRegionRef'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_summary_for_location_api_legal_entity_locations_summary__region_code__get: {
    parameters: {
      query?: {
        end_date?: string | null;
      };
      header?: never;
      path: {
        region_code: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: components['schemas']['LocationSummary'];
          };
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_summary_for_all_locations_api_legal_entity_locations_summary_get: {
    parameters: {
      query?: {
        end_date?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: components['schemas']['LocationSummary'];
          };
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_legal_entity_region_handler_api_legal_entity_locations__region_code__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        region_code: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LegalEntityRegion'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_legal_entity_agencies_region_handler_api_legal_entity_locations__region_code__agencies_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        region_code: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Agency'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  patch_legal_entity_region_has_employees_handler_api_legal_entity_locations__region_code__has_employees_patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        region_code: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['LegalEntityRegionUpdateParams'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LegalEntityRegionUpdateResult'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  patch_legal_entity_region_configuration_handler_api_legal_entity_locations__region_code__configuration_patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        region_code: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['LegalEntityRegionConfigurationParams'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LegalEntityRegionUpdateResult'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_legal_entity_region_setup_complete_api_legal_entity_locations__region_code__setup_complete_put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        region_code: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LegalEntityRegionSetupStatusUpdateResult'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  certificate_of_good_standing_handler_api_legal_entity_locations__region_code__certificate_of_good_standing_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        region_code: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_location_risk_handler_api_legal_entity_locations__region_code__risk_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        region_code: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LocationRiskResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_legal_entity_mail_by_region_handler_api_legal_entity_locations__region_code__mail_get: {
    parameters: {
      query?: {
        start_date?: string | null;
        end_date?: string | null;
        hide_resolved?: boolean;
      };
      header?: never;
      path: {
        region_code: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['app__mail__public__Mail'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  calculate_annual_report_estimate_handler_api_legal_entity_locations__region_code__annual_report_estimate_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        region_code: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AnnualReportEstimateParams'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AnnualReportEstimateResult'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  generate_legal_entity_region_requirements_handler_api_legal_entity_locations__region_code__requirements_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        region_code: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['GenerateLegalEntityRegionRequirementsParams'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LegalEntityRegion'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_legal_entity_mailroom_address_handler_api_legal_entity_mailroom_address_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MailroomAddresses'];
        };
      };
    };
  };
  get_legal_entity_mail_handler_api_legal_entity_mail_get: {
    parameters: {
      query?: {
        start_date?: string | null;
        end_date?: string | null;
        hide_resolved?: boolean;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['app__mail__public__Mail'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_legal_entity_mail_by_public_id_handler_api_legal_entity_mail__mail_public_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        mail_public_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_legal_entity_mail_patch_handler_api_legal_entity_mail__mail_public_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        mail_public_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json':
          | components['schemas']['MailPatchUpdateReadState']
          | components['schemas']['MailPatchUpdateStatus']
          | components['schemas']['MailPatchUpdateAssignOwner']
          | components['schemas']['MailPatchUpdateUnassignOwner'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_legal_entity_profile_api_legal_entity_profile_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateLegalEntityProfileRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_legal_entity_submitter_handler_api_legal_entity_submitter_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Person'];
        };
      };
    };
  };
  update_legal_entity_submitter_handler_api_legal_entity_submitter__legal_entity_person_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        legal_entity_person_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Person'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_legal_entity_primary_contact_handler_api_legal_entity_primary_contact_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['User'];
        };
      };
    };
  };
  update_legal_entity_primary_contact_handler_api_legal_entity_primary_contact__user_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['User'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_legal_entity_people_handler_api_legal_entity_people_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Person'][];
        };
      };
    };
  };
  create_legal_entity_person_handler_api_legal_entity_people_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateLegalEntityPersonParams'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Person'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_legal_entity_businesses_handler_api_legal_entity_businesses_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Business'][];
        };
      };
    };
  };
  create_legal_entity_business_handler_api_legal_entity_businesses_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateLegalEntityBusinessParams'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Business'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_legal_entity_owners_handler_api_legal_entity_owners_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Owner'][];
        };
      };
    };
  };
  get_legal_entity_person_handler_api_legal_entity_person__legal_entity_person_public_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        legal_entity_person_public_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Person'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_legal_entity_person_handler_api_legal_entity_person__legal_entity_person_public_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        legal_entity_person_public_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateLegalEntityPersonParams'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Person'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_legal_entity_business_handler_api_legal_entity_business__legal_entity_business_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        legal_entity_business_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Business'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_legal_entity_business_handler_api_legal_entity_business__legal_entity_business_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        legal_entity_business_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateLegalEntityBusinessParams'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Business'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_legal_entity_information_handler_api_legal_entity_entity_information_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LegalEntityInformationResponse'];
        };
      };
    };
  };
  update_legal_entity_information_handler_api_legal_entity_entity_information_put: {
    parameters: {
      query?: {
        authenticate?: boolean;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateLegalEntityInformationParams'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LegalEntity'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_requirements_handler_api_requirements_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['QueryRequirementsParams'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['QueryResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_calendar_requirements_handler_api_requirements_calendar_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['QueryCalendarRequirementsParams'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['QueryResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_requirement_overviews_api_requirements_overviews_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PaginatedResponse_RequirementOverview_'];
        };
      };
    };
  };
  get_navigator_requirements_handler_api_requirements__region_code__navigator_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        region_code: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['QueryResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_requirement_handler_api_requirements__legal_entity_requirement_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        legal_entity_requirement_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RequirementUpdateParams'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RequirementUpdateResult'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_requirement_handler_api_requirements__legal_entity_requirement_id__post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        legal_entity_requirement_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RequirementInstance'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  patch_requirement_handler_api_requirements__legal_entity_requirement_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        legal_entity_requirement_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json':
          | components['schemas']['RequirementPatchAssignOwner']
          | components['schemas']['RequirementPatchUnassignOwner'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RequirementUpdateResult'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  automate_legal_entity_requirement_handler_api_requirements__legal_entity_requirement_public_id__automate_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        legal_entity_requirement_public_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AutomationResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  batch_update_requirements_handler_api_requirements__put: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RequirementBatchUpdateParams'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RequirementUpdateResult'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  batch_patch_requirement_handler_api_requirements_batch_patch: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['Body_batch_patch_requirement_handler_api_requirements_batch_patch'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RequirementUpdateResult'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_remediation_handler_api_requirements__legal_entity_requirement_id__remediation__legal_entity_remediation_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        legal_entity_requirement_id: string;
        legal_entity_remediation_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RemediationUpdateParams'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RemediationUpdateResult'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  gusto_authorize_confirm_api_connect_gusto_authorize_confirm_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['GustoAuthorizeRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GustoAuthorizeResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  gusto_authorize_api_connect_gusto_authorize_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['GustoBeginAuthorizationRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GustoAuthorizeResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  gusto_onboard_api_connect_gusto_onboard_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['GustoOnboardRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GustoAuthorizeResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_connections_api_connections_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Connection'][];
        };
      };
    };
  };
  create_connection_handler_api_connections_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateConnectionRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_form_capture_handler_api_form_captures_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['FormCaptureRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_form_capture_handler_api_form_captures__data_key__post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        data_key: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['FormCaptureRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_form_handler_api_form_captures_view__form_spec_id__post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        form_spec_id: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['GetFormRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['FormattedForm'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  save_form_handler_api_form_captures_save__form_spec_id__post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        form_spec_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['FormCaptureRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': null;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  preview_change_api_pending_changes__change_id__preview_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        change_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_search_results_api_search_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SearchRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchResult'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  set_datum_handler_api_datums__attribute_public_id__post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        attribute_public_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SetDatumParams'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Datum'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  bulk_set_datums_handler_api_datums_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BulkSetDatumParam'][];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Datum'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_lead_contact_api_public_compliance_check_lead_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['LeadContactRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_summary_handler_api_public_compliance_check_summary_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SummaryParams'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Summary'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_business_profile_handler_api_onboarding_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BusinessProfileRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json':
            | components['schemas']['LegalEntityRegionRef']
            | null;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  configure_business_profile_handler_api_onboarding_configure_business_profile_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json':
            | components['schemas']['LegalEntityRegionRef']
            | null;
        };
      };
    };
  };
  basic_legal_entity_region_and_requirements_handler_api_onboarding_basic_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['OnboardingBasicRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LegalEntityRegionRef'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_notices_api_notices_summary__public_key__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        public_key: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NoticesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_notices_file_api_notices_view__public_key___file_name__get: {
    parameters: {
      query?: {
        download?: boolean;
      };
      header?: never;
      path: {
        public_key: string;
        file_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  post_notice_enrollment_api_notices_enrollment__region_code___legal_entity_requirement_id__post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        region_code: string;
        legal_entity_requirement_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NoticeEnrollmentResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_notice_enrollment_api_notices_enrollment_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AllNoticeEnrollmentsResponse'];
        };
      };
    };
  };
  resend_verification_api_verify_resend_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
    };
  };
  get_checkout_link_api_subscription_checkout__plan_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        plan_id: components['schemas']['SubscriptionPlanEnum'];
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CheckoutResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  activate_subscription_api_subscription_activate__plan_id__post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        plan_id: components['schemas']['SubscriptionPlanEnum'];
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ActivateSubscriptionRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_plans_api_subscription_plans_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PlanResponse'];
        };
      };
    };
  };
  get_customer_portal_link_api_subscription_billing_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CustomerPortalResponse'];
        };
      };
    };
  };
  auto_start_workflow_handler_api_workflows_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['WorkflowCreateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_accounts_handler_api_accounts_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['GetAccountsParameters'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_otp_handler_api_accounts_otp__public_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        public_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_email_otp_handler_api_accounts_otp__public_id__email_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        public_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EmailOtp'] | null;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_upcoming_legislations_handler_api_legislation_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UpcomingLegislation'][];
        };
      };
    };
  };
  payroll_import_email_api_payroll_import_email_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/x-www-form-urlencoded': components['schemas']['Body_payroll_import_email_api_payroll_import_email_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  payroll_import_csv_api_payroll_import_csv_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/x-www-form-urlencoded': components['schemas']['Body_payroll_import_csv_api_payroll_import_csv_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_registered_agent_automation_api_automation_registered_agent_transfer__region_code__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        region_code: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['FormAutomationResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  submit_registered_agent_automation_api_automation_registered_agent_transfer__region_code__post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        region_code: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AutomationSubmission'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_automation_api_automation__legal_entity_requirement_public_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        legal_entity_requirement_public_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json':
            | components['schemas']['FormAutomationResponse']
            | components['schemas']['RedirectAutomationResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  automate_api_automation__legal_entity_requirement_public_id__post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        legal_entity_requirement_public_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AutomationSubmission'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_tasks_api_compliance_tasks_get: {
    parameters: {
      query?: {
        is_setup?: boolean | null;
        task_type?: components['schemas']['TaskType'] | null;
        date_filter?: components['schemas']['TaskDateFilter'] | null;
        end_date?: string | null;
        completed_start_time?: string | null;
        tags?: components['schemas']['TagInstance'][] | null;
        excluded_tags?: components['schemas']['TagInstance'][] | null;
        statuses?: components['schemas']['TaskStatus'][] | null;
        is_automation?: boolean | null;
        is_managed?: boolean | null;
        has_due_date?: boolean | null;
        categories?: components['schemas']['TaskCategory'][] | null;
        region_id?: string | null;
        requirement_id?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TaskRef'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_tasks_region_configuration_api_compliance_tasks__region_code__configuration_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        region_code: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TasksRegionConfigurationResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_task_api_compliance_tasks__task_public_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        task_public_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Task'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  patch_task_api_compliance_tasks__task_public_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        task_public_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['TaskUpdate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Task'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_requirement_task_batch_status_api_compliance_tasks_batch_status_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['TaskStatusBatchUpdate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TaskRef'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_tasks_filter_preference_api_compliance_tasks_filter_preference_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['TasksFilterPreferenceUpdate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TasksFilter'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_requirement_task_status_api_compliance_tasks__task_public_id__status_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        task_public_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['TaskStatusUpdate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TaskRef'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  answer_bulk_question_task_api_compliance_bulk_tasks__task_public_id__answer_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        task_public_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BulkQuestionTaskAnswer'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TaskRef'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  answer_question_task_api_compliance_tasks__task_public_id__answer_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        task_public_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['QuestionTaskAnswer'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TaskRef'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_policy_instances_for_task_api_compliance_tasks__task_public_id__policy_instances_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        task_public_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PolicyInstance'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_tasks_for_wizard_api_wizard__wizard_slug__step__wizard_step_slug__get: {
    parameters: {
      query?: {
        region_id?: string | null;
      };
      header?: never;
      path: {
        wizard_slug: string;
        wizard_step_slug: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TaskRef'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_wizard_config_api_wizard__wizard_slug__config_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        wizard_slug: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['WizardConfig'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  request_access_to_handbook_api_handbook_request_access_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
    };
  };
  refresh_platform_token_api_handbook_auth_refresh_token_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: {
        refresh_token?: string | null;
      };
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AuthSessionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  redeem_handbook_login_token_api_handbook_auth_redeem_token_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RedeemTokenRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AuthSessionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  resend_handbook_link_api_handbook_auth_resend_link_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RedeemTokenRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SuccessResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  request_handbook_link_api_handbook_auth_email_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['HandbookLinkRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SuccessResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  logout_api_handbook_auth_logout_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: {
        refresh_token?: string | null;
      };
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_policies_api_handbook_policies_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Policy'][];
        };
      };
    };
  };
  create_custom_policy_in_section_api_handbook_policies_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CustomPolicyCreate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Policy'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_policy_sections_api_handbook_policy_sections_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PolicySection'][];
        };
      };
    };
  };
  create_policy_in_category_api_handbook_policy_categories__category_id__policies_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        category_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CustomBlanketPolicyCreate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Policy'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_custom_policy_api_handbook_policies__policy_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        policy_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CustomBlanketPolicyUpdate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Policy'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_policy_form_api_handbook_policies__policy_id__form_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        policy_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['FormattedForm'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  submit_policy_form_api_handbook_policies__policy_id__form_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        policy_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['PolicyFormSubmission'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_policy_forms_for_policy_section_api_handbook_policy_section__policy_section_public_id__forms_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        policy_section_public_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PolicySectionForm'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  adopt_policy_api_handbook_policies__policy_id__adopt_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        policy_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  adopt_policies_api_handbook_policies_adopt_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['PolicyAdoptRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  adopt_section_policies_api_handbook_policy_section__policy_section_public_id__adopt_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        policy_section_public_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_policy_section_attribute_values_api_handbook_policy_section__policy_section_public_id__attribute_values_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        policy_section_public_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: {
              [key: string]: unknown;
            };
          };
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_draft_api_handbook_draft_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Handbook'];
        };
      };
    };
  };
  create_draft_api_handbook_draft_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Handbook'];
        };
      };
    };
  };
  get_published_handbook_api_handbook_published_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Handbook'];
        };
      };
    };
  };
  publish_handbook_api_handbook_publish_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Handbook'];
        };
      };
    };
  };
  handbook_stats_api_handbook_stats_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Stats'];
        };
      };
    };
  };
  get_handbook_employee_acknowledgements_api_handbook_employees_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EmployeeAcknowledgementInfo'][];
        };
      };
    };
  };
  send_reminder_api_handbook_employees__employee_id__reminder_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        employee_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  download_signature_api_handbook_employees__employee_id__download_signature_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        employee_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  download_signatures_api_handbook_employees_download_signatures_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['EmployeeSignatureDownloadRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  send_employees_signature_reminder_api_handbook_employees_send_employees_signature_reminder_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
    };
  };
  get_preview_handbook_api_handbook_preview_get: {
    parameters: {
      query?: {
        region?: string | null;
        city_name?: string | null;
        zip_code?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EmployeeHandbookResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_handbook_has_pending_changes_api_handbook_has_pending_changes_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': boolean;
        };
      };
    };
  };
  get_latest_handbook_api_handbook_latest_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EmployeeHandbookResponse'];
        };
      };
    };
  };
  acknowledge_handbook_api_handbook__handbook_id__acknowledge_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        handbook_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  acknowledge_tos_api_handbook_acknowledge_legal_notice_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
    };
  };
  get_handbook_user_api_handbook_users_me_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HandbookUser'];
        };
      };
    };
  };
  list_documents_api_documents_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LegalEntityDocument'][];
        };
      };
    };
  };
  get_document_local_api_documents_from_local__path__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        path: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_document_from_request_api_documents_get_from_request__workflow_document_share_public_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_document_share_public_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json':
            | components['schemas']['LegalEntityDocument']
            | null;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_download_url_api_documents_download__document_public_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_public_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  embedded_signup_handler_accounts_signup_post: {
    parameters: {
      query?: never;
      header?: {
        authorization?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['EmbeddedSignupRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EmbeddedSignupResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  Create_Hosted_Signup_Session_accounts_signup_sessions_post: {
    parameters: {
      query?: never;
      header?: {
        authorization?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['HostedSignupRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HostedSignupResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  account_authenticate_accounts_auth_post: {
    parameters: {
      query?: never;
      header?: {
        authorization?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['PlatformAuthenticateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AuthSessionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_locations_handler_locations_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AccountLegalEntityLocationRef'][];
        };
      };
    };
  };
  add_location_handler_locations__location_public_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        location_public_id: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json':
          | components['schemas']['CreateLocationRequest']
          | null;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AccountLegalEntityLocation'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_location_handler_locations__region_platform_public_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        region_platform_public_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateLocationRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AccountLegalEntityLocation'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_tasks_handler_tasks_get: {
    parameters: {
      query?: {
        definition_id?: string | null;
        start_date?: string | null;
        end_date?: string | null;
        include_managed?: boolean | null;
        status?: components['schemas']['AccountTaskStatus'][] | null;
        /** @description Tags are filtering criteria for tasks. When multiple tags are passed, tasks associated with at least one of the tags are returned. */
        tags?: components['schemas']['AccountTaskTag'][] | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AccountTask'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_location_tasks_handler_locations__region_platform_public_id__tasks_get: {
    parameters: {
      query?: {
        definition_id?: string | null;
        start_date?: string | null;
        end_date?: string | null;
        include_managed?: boolean | null;
        status?: components['schemas']['AccountTaskStatus'][] | null;
      };
      header?: never;
      path: {
        region_platform_public_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AccountTask'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_task_handler_tasks__task_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        task_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AccountTask'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  patch_task_handler_tasks__task_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        task_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AccountTaskUpdateStatus'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AccountTask'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  automate_task_handler_tasks__task_id__automate_sessions_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        task_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AutomationSessionRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AutomationSessionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  hosted_task_tasks_sessions_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['TasksSessionRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TasksSessionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_legal_entity_handler_legal_entity_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AccountLegalEntity'];
        };
      };
    };
  };
  list_account_logins_for_location_locations__location_public_id__logins_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        location_public_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PlatformLegalEntityAccountLogin'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_account_logins_logins_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PlatformLegalEntityAccountLogin'][];
        };
      };
    };
  };
  make_account_login_hosted_url_logins__legal_entity_account_login_public_id__sessions_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        legal_entity_account_login_public_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['LoginsSessionRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PlatformLegalEntityAccountLoginSessionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_legal_entity_mail_handler_mail_get: {
    parameters: {
      query?: {
        start_date?: string | null;
        end_date?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PlatformMail'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_legal_entity_mail_handler_for_location_locations__region_platform_public_id__mail_get: {
    parameters: {
      query?: {
        start_date?: string | null;
        end_date?: string | null;
      };
      header?: never;
      path: {
        region_platform_public_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PlatformMail'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_agency_accounts_for_legal_entity_agency_accounts_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['app__api__platform__models__PlatformAgencyAccount'][];
        };
      };
    };
  };
  get_agency_accounts_for_legal_entity_and_location_locations__region_platform_public_id__agency_accounts_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        region_platform_public_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['app__api__platform__models__PlatformAgencyAccount'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_connection_handler_accounts_connect_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['PlatformConnectRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PlatformConnectSession'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_connection_handler_accounts_connections__connection_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        connection_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PlatformConnection'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  cancel_connection_handler_accounts_connections__connection_id__cancel_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        connection_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PlatformConnection'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_guest_details_api_guest_validate_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['GuestValidationRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Guest'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  register_guest_api_guest_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['GuestRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CheckoutResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  upload_document_api_guest_document_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/x-www-form-urlencoded': components['schemas']['Body_upload_document_api_guest_document_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_notification_topics_api_notifications_topics_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': (
            | components['schemas']['PersonalAccountMaintenanceAndUpdatesNotificationTopic']
            | components['schemas']['FirstTimeConfirmationsNotificationTopic']
            | components['schemas']['NewAssignmentsToUserNotificationTopic']
            | components['schemas']['CompanyAccountMaintenanceAndUpdatesNotificationTopic']
            | components['schemas']['AutomationActionRequiredNotificationTopic']
            | components['schemas']['AutomationStatusUpdatesNotificationTopic']
            | components['schemas']['WeeklySummaryNotificationTopic']
            | components['schemas']['NewMailNotificationTopic']
            | components['schemas']['NewEmailNotificationTopic']
            | components['schemas']['NewAndUpcomingUpdatesNotificationTopic']
          )[];
        };
      };
    };
  };
  list_notification_user_preferences_api_notifications_user_preferences_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotificationUserPreferencesPublic'][];
        };
      };
    };
  };
  save_notification_user_preferences_api_notifications_user_preferences_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['NotificationUserPreferencesListSubmission'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  handle_list_criteria_meta_api_admin_criteria_meta_get: {
    parameters: {
      query?: {
        filter?: string | null;
        range?: string | null;
        sort?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminCriteriaMeta'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  handle_post_criteria_meta_api_admin_criteria_meta_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminCriteriaMetaCreate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminCriteriaMetaCreate'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  handle_get_criteria_meta_api_admin_criteria_meta__criteria_meta_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        criteria_meta_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminCriteriaMeta'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  handle_put_criteria_meta_api_admin_criteria_meta__criteria_meta_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminCriteriaMetaUpdate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminCriteriaMetaUpdate'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  handle_delete_criteria_meta_api_admin_criteria_meta__criteria_meta_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        criteria_meta_id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': number;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  handle_list_criteria_types_api_admin_criteria_types_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminCriteriaType'][];
        };
      };
    };
  };
}
export enum AccountLoginCreateRequestOtp_format {
  default = 'default',
  alphanumeric = 'alphanumeric',
  Value8_digit_numeric = '8-digit-numeric',
}
export enum AccountTaskResolutionActionType {
  action = 'action',
}
export enum AccountTaskResolutionAutomateType {
  automate = 'automate',
}
export enum AccountTaskResolutionManualType {
  manual = 'manual',
}
export enum AccountTaskResolutionRedirectType {
  redirect = 'redirect',
}
export enum AccountTaskStatus {
  todo = 'todo',
  dismissed = 'dismissed',
  in_progress = 'in-progress',
  done = 'done',
}
export enum AccountTaskTag {
  certificate_of_good_standing = 'certificate-of-good-standing',
  charity_registration = 'charity-registration',
  charity_registration_renewal = 'charity-registration-renewal',
  employee_final_wage_payment = 'employee-final-wage-payment',
  employee_new_hire_reporting = 'employee-new-hire-reporting',
  employee_onboarding = 'employee-onboarding',
  employee_termination = 'employee-termination',
  exemption = 'exemption',
  foreign_qualification = 'foreign-qualification',
  initial_statement = 'initial-statement',
  local_business_setup = 'local-business-setup',
  local_payroll_setup = 'local-payroll-setup',
  newspaper_publication = 'newspaper-publication',
  notices = 'notices',
  payroll_setup = 'payroll-setup',
  registered_agent = 'registered-agent',
  sos_report = 'sos-report',
  setup = 'setup',
}
export enum AccountingMethod {
  accrual = 'accrual',
  cash = 'cash',
}
export enum AccountingPeriod {
  fiscal = 'fiscal',
  calendar = 'calendar',
}
export enum AccountingYearEndMonthNumber {
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
  Value7 = 7,
  Value8 = 8,
  Value9 = 9,
  Value10 = 10,
  Value11 = 11,
  Value12 = 12,
}
export enum ActionType {
  add_to_group = 'add_to_group',
  remove_from_group = 'remove_from_group',
}
export enum AddressAttributeType {
  address = 'address',
}
export enum AdminAccountLoginBaseOtp_format {
  default = 'default',
  alphanumeric = 'alphanumeric',
  Value8_digit_numeric = '8-digit-numeric',
}
export enum AdminAccountLoginUpdateOtp_format {
  default = 'default',
  alphanumeric = 'alphanumeric',
  Value8_digit_numeric = '8-digit-numeric',
}
export enum AdminAccountLoginViewOtp_format {
  default = 'default',
  alphanumeric = 'alphanumeric',
  Value8_digit_numeric = '8-digit-numeric',
}
export enum AdminAlertETABreachedWorkflowsCommand_id {
  alert_eta_breached_workflows = 'alert_eta_breached_workflows',
}
export enum AdminCommandAccountReportCommand_id {
  account_report = 'account_report',
}
export enum AdminCommandAnalyzeDocumentsCommand_id {
  analyze_documents = 'analyze_documents',
}
export enum AdminCommandBackfillHomeStatesCommand_id {
  backfill_home_states = 'backfill_home_states',
}
export enum AdminCommandBulkInsertAgencyAccountsCommand_id {
  bulk_insert_agency_accounts = 'bulk_insert_agency_accounts',
}
export enum AdminCommandComplianceChangeReportCommand_id {
  compliance_change_report = 'compliance_change_report',
}
export enum AdminCommandConvertFormCommand_id {
  convert_form = 'convert_form',
}
export enum AdminCommandCreateCheckLoginWorkflowsCommand_id {
  create_check_login_workflows = 'create_check_login_workflows',
}
export enum AdminCommandCreateLegalEntityAndUserCommand_id {
  create_legal_entity_and_user = 'create_legal_entity_and_user',
}
export enum AdminCommandCreateTrainingWorkflowInstancesCommand_id {
  create_training_workflow_instances = 'create_training_workflow_instances',
}
export enum AdminCommandDataCheckerCommand_id {
  data_checker = 'data_checker',
}
export enum AdminCommandDeleteInapplicableHomeForeignOnlyLegalEntityRequirementsCommand_id {
  delete_inapplicable_home_foreign_only_legal_entity_requirements = 'delete_inapplicable_home_foreign_only_legal_entity_requirements',
}
export enum AdminCommandEmailroomUploadPdfCommand_id {
  emailroom_upload_pdf = 'emailroom_upload_pdf',
}
export enum AdminCommandFetchUnredactedFormCaptureCommand_id {
  fetch_unredacted_form_capture = 'fetch_unredacted_form_capture',
}
export enum AdminCommandGenerateSEOContentCommand_id {
  generate_seo_content = 'generate_seo_content',
}
export enum AdminCommandLegalEntityRequirementHealthCheckCommand_id {
  legal_entity_requirement_health_check = 'legal_entity_requirement_health_check',
}
export enum AdminCommandLoadHandbookRequirementsForUserCommand_id {
  load_handbook_requirements_for_user = 'load_handbook_requirements_for_user',
}
export enum AdminCommandLoadManagedRequirementOverridesCommand_id {
  load_managed_requirement_overrides = 'load_managed_requirement_overrides',
}
export enum AdminCommandLoadRegionalNavsDataCommand_id {
  load_regional_navs_data = 'load_regional_navs_data',
}
export enum AdminCommandLoadRequirementsForUserCommand_id {
  load_requirements_for_user = 'load_requirements_for_user',
}
export enum AdminCommandMailroomRotatePdfCommand_id {
  mailroom_rotate_pdf = 'mailroom_rotate_pdf',
}
export enum AdminCommandManageGoogleGroupsCommand_id {
  manage_google_groups = 'manage_google_groups',
}
export enum AdminCommandOffboardLegalEntityCommand_id {
  offboard_legal_entity = 'offboard_legal_entity',
}
export enum AdminCommandPlatformBillingReportCommand_id {
  platform_billing_report = 'platform_billing_report',
}
export enum AdminCommandRequirementsAndRemediationsReportCommand_id {
  requirements_and_remediations_report = 'requirements_and_remediations_report',
}
export enum AdminCommandResetLegalEntityRegionCommand_id {
  reset_legal_entity_region = 'reset_legal_entity_region',
}
export enum AdminCommandSendAllSummaryEmailsCommand_id {
  send_all_summary_emails = 'send_all_summary_emails',
}
export enum AdminCommandSendSubscriptionEmailCommand_id {
  send_subscription_email = 'send_subscription_email',
}
export enum AdminCommandSendSummaryEmailCommand_id {
  send_summary_email = 'send_summary_email',
}
export enum AdminCommandSimulateScheduleCommand_id {
  simulate_schedule = 'simulate_schedule',
}
export enum AdminCommandSyncHubspotCustomerDataCommand_id {
  sync_hubspot_customer_data = 'sync_hubspot_customer_data',
}
export enum AdminCommandSyncLegalincOrderStatusCommand_id {
  sync_legalinc_order_status = 'sync_legalinc_order_status',
}
export enum AdminCommandSyncMailRoomCommand_id {
  sync_mailroom = 'sync_mailroom',
}
export enum AdminCommandSyncPayrollCommand_id {
  sync_payroll = 'sync_payroll',
}
export enum AdminCommandSyncPayrollCSVCommand_id {
  sync_payroll_csv = 'sync_payroll_csv',
}
export enum AdminCommandUpdateSubscriptionBillingCommand_id {
  update_subscription_billing = 'update_subscription_billing',
}
export enum AdminCommandValidateComplianceEngineUrlsCommand_id {
  validate_compliance_engine_urls = 'validate_compliance_engine_urls',
}
export enum AdminCommandWorkflowFeesReportCommand_id {
  workflow_fees_report = 'workflow_fees_report',
}
export enum AdminCommandWorkflowReportCommand_id {
  workflow_report = 'workflow_report',
}
export enum AdminCommandWriteConfigTableDumpsToS3Command_id {
  write_config_table_dumps_to_s3 = 'write_config_table_dumps_to_s3',
}
export enum AdminEmailRoomMailUpdateStatus {
  new = 'new',
  undeliverable = 'undeliverable',
  spam = 'spam',
}
export enum AdminEmailroomBulkStatusUpdateStatus {
  spam = 'spam',
  undeliverable = 'undeliverable',
}
export enum AdminEmailroomMailDeliverStatus {
  delivered = 'delivered',
}
export enum ArrayAttributeType {
  array = 'array',
}
export enum AuthSSOResponseToken_type {
  sso = 'sso',
}
export enum AuthSessionResponseToken_type {
  bearer = 'bearer',
}
export enum AutomationActionRequiredNotificationTopicCode {
  automation_action_required = 'automation_action_required',
}
export enum AutomationStatusUpdatesNotificationTopicCode {
  automation_status_updates = 'automation_status_updates',
}
export enum BooleanAttributeType {
  boolean = 'boolean',
}
export enum BusinessIncomeTaxNexusCriteriaType {
  business_income_tax_nexus = 'business-income-tax-nexus',
}
export enum ChangeType {
  attribute_description = 'attribute-description',
  attribute_description_link = 'attribute-description-link',
  attribute_is_generic = 'attribute-is-generic',
  attribute_is_editable = 'attribute-is-editable',
  attribute_name = 'attribute-name',
  attribute_placeholder = 'attribute-placeholder',
  attribute_region_id = 'attribute-region-id',
  attribute_validator_add = 'attribute-validator-add',
  attribute_validator_remove = 'attribute-validator-remove',
  attribute_type_change = 'attribute-type-change',
  attribute_type_add_option = 'attribute-type-add-option',
  attribute_type_remove_option = 'attribute-type-remove-option',
  attribute_type_set_max = 'attribute-type-set-max',
  attribute_type_set_min = 'attribute-type-set-min',
  attribute_type_set_step = 'attribute-type-set-step',
  attribute_create = 'attribute-create',
  attribute_public_id = 'attribute-public-id',
  agency_name = 'agency-name',
  agency_url = 'agency-url',
  agency_account_agency_name = 'agency-account-agency-name',
  agency_account_name = 'agency-account-name',
  agency_account_attribute_add = 'agency-account-attribute-add',
  agency_account_attribute_remove = 'agency-account-attribute-remove',
  account_login_otp_format = 'account-login-otp-format',
  account_login_otp_sender_email = 'account-login-otp-sender-email',
  account_login_otp_subject_line = 'account-login-otp-subject-line',
  account_login_name = 'account-login-name',
  account_login_url = 'account-login-url',
  account_login_agency_account_add = 'account-login-agency-account-add',
  account_login_agency_account_remove = 'account-login-agency-account-remove',
  account_login_is_supported = 'account-login-is-supported',
  account_login_create = 'account-login-create',
  agency_create = 'agency-create',
  agency_account_create = 'agency-account-create',
  criteria_meta_add = 'criteria-meta-add',
  criteria_meta_remove = 'criteria-meta-remove',
  criteria_meta_title = 'criteria-meta-title',
  criteria_meta_criteria_type = 'criteria-meta-criteria-type',
  criteria_meta_description = 'criteria-meta-description',
  criteria_meta_summary = 'criteria-meta-summary',
  criteria_meta_region = 'criteria-meta-region',
  form_attribute_add = 'form-attribute-add',
  form_attribute_remove = 'form-attribute-remove',
  form_attribute_update_required = 'form-attribute-update-required',
  form_attribute_update_description = 'form-attribute-update-description',
  form_attribute_update_default_value = 'form-attribute-update-default-value',
  form_attribute_update_order = 'form-attribute-update-order',
  form_attribute_update_send_in_legal_inc_notes = 'form-attribute-update-send-in-legal-inc-notes',
  form_attribute_dependency_add = 'form-attribute-dependency-add',
  form_attribute_dependency_remove = 'form-attribute-dependency-remove',
  form_attribute_additional_field_add = 'form-attribute-additional-field-add',
  form_create = 'form-create',
  form_update_title = 'form-update-title',
  managed_provider_requirement_create = 'managed-provider-requirement-create',
  managed_provider_requirement_delete = 'managed-provider-requirement-delete',
  policy_section_create = 'policy-section-create',
  policy_section_title = 'policy-section-title',
  policy_section_description = 'policy-section-description',
  policy_section_icon = 'policy-section-icon',
  policy_section_order = 'policy-section-order',
  policy_category_create = 'policy-category-create',
  policy_category_name = 'policy-category-name',
  policy_category_order = 'policy-category-order',
  policy_category_section = 'policy-category-section',
  policy_update_category = 'policy-update-category',
  policy_create = 'policy-create',
  policy_edit = 'policy-edit',
  policy_add_requirement = 'policy-add-requirement',
  workflow_attribute_add = 'workflow-attribute-add',
  workflow_attribute_remove = 'workflow-attribute-remove',
  workflow_attribute_is_required = 'workflow-attribute-is-required',
  workflow_attribute_order = 'workflow-attribute-order',
  requirement_criteria_add = 'requirement-criteria-add',
  requirement_criteria_remove = 'requirement-criteria-remove',
  requirement_title = 'requirement-title',
  requirement_new_coverage = 'requirement-new-coverage',
  requirement_description = 'requirement-description',
  requirement_frequency_note_update = 'requirement-frequency-note-update',
  requirement_tax_rate_note_update = 'requirement-tax-rate-note-update',
  requirement_general_rate_note_update = 'requirement-general-rate-note-update',
  requirement_summary = 'requirement-summary',
  requirement_category = 'requirement-category',
  requirement_is_automatable = 'requirement-is-automatable',
  requirement_entity_type_add = 'requirement-entity-type-add',
  requirement_entity_type_remove = 'requirement-entity-type-remove',
  requirement_active_as_of = 'requirement-active-as-of',
  requirement_retired_on = 'requirement-retired-on',
  requirement_resource_add = 'requirement-resource-add',
  requirement_resource_update = 'requirement-resource-update',
  requirement_resource_remove = 'requirement-resource-remove',
  requirement_trigger_add = 'requirement-trigger-add',
  requirement_trigger_remove = 'requirement-trigger-remove',
  requirement_guard_add = 'requirement-guard-add',
  requirement_guard_remove = 'requirement-guard-remove',
  requirement_consumer_add = 'requirement-consumer-add',
  requirement_consumer_remove = 'requirement-consumer-remove',
  requirement_producer_add = 'requirement-producer-add',
  requirement_producer_remove = 'requirement-producer-remove',
  requirement_schedule = 'requirement-schedule',
  requirement_domestic_fee = 'requirement-domestic-fee',
  requirement_foreign_fee = 'requirement-foreign-fee',
  requirement_internal_eta = 'requirement-internal-eta',
  requirement_external_eta = 'requirement-external-eta',
  requirement_tax_class_add = 'requirement-tax_class-add',
  requirement_tax_class_remove = 'requirement-tax-class-remove',
  requirement_remediation_add = 'requirement-remediation-add',
  requirement_remediation_remove = 'requirement-remediation-remove',
  requirement_remediation_title = 'requirement-remediation-title',
  requirement_remediation_description = 'requirement-remediation-description',
  requirement_tag_add = 'requirement-tag-add',
  requirement_tag_remove = 'requirement-tag-remove',
  requirement_create = 'requirement-create',
  requirement_remediation_display_update = 'requirement-remediation-display-update',
  requirement_remediation_order = 'requirement-remediation-order',
  requirement_summary_template_create = 'requirement-summary-template-create',
  requirement_summary_template_remove = 'requirement-summary-template-remove',
  tag_create = 'tag-create',
  tag_remove = 'tag-remove',
  region_add = 'region-add',
}
export enum CharacterSet {
  LETTERS = 'LETTERS',
  DIGITS = 'DIGITS',
  SYMBOLS = 'SYMBOLS',
}
export enum CharitableRegistrationNexusCriteriaType {
  charitable_registration_nexus = 'charitable-registration-nexus',
}
export enum CommandAlertMissingLegalincCompaniesCommand_id {
  alert_missing_legalinc_companies = 'alert_missing_legalinc_companies',
}
export enum CommandAnnualReportCommand_id {
  annual_report = 'annual_report',
}
export enum CommandCategorizePoliciesCommand_id {
  categorize_policies = 'categorize_policies',
}
export enum CommandCertificateOfGoodStandingCommand_id {
  certificate_of_good_standing = 'certificate_of_good_standing',
}
export enum CommandCheckForLegalincAddressesAsMailingAddressCommand_id {
  check_for_legalinc_addresses_as_mailing_address = 'check_for_legalinc_addresses_as_mailing_address',
}
export enum CommandDeleteLegalEntityRequirementAndTriggersCommand_id {
  delete_legal_entity_requirement_and_triggers = 'delete_legal_entity_requirement_and_triggers',
}
export enum CommandForeignQualificationCommand_id {
  foreign_qualification = 'foreign_qualification',
}
export enum CommandInsertHandbookUserCommand_id {
  insert_handbook_user = 'insert_handbook_user',
}
export enum CommandMigrateEmployeeCountCommand_id {
  migrate_employee_count = 'migrate_employee_count',
}
export enum CommandRegisteredAgentSubscriptionCommand_id {
  registered_agent_subscription = 'registered_agent_subscription',
}
export enum CommandRegisteredAgentTransferCommand_id {
  registered_agent_transfer = 'registered_agent_transfer',
}
export enum CommandResetHandbookLegalEntityCommand_id {
  reset_handbook_legal_entity = 'reset_handbook_legal_entity',
}
export enum CommandRunStatus {
  running = 'running',
  success = 'success',
  error = 'error',
}
export enum CommandUpdateLegalincCompanyForwardingContactCommand_id {
  update_legalinc_company_forwarding_contact = 'update_legalinc_company_forwarding_contact',
}
export enum CommandUpsertHandbookUsersCommand_id {
  upsert_handbook_users = 'upsert_handbook_users',
}
export enum CompanyAccountMaintenanceAndUpdatesNotificationTopicCode {
  company_account_maintenance_and_updates = 'company_account_maintenance_and_updates',
}
export enum ComplianceChangeLogCategory {
  Pending = 'Pending',
  Approved = 'Approved',
}
export enum ContentType {
  payroll_registration = 'payroll_registration',
  local_payroll = 'local_payroll',
  foreign_qualification = 'foreign_qualification',
  annual_report = 'annual_report',
  agency = 'agency',
  sales_tax = 'sales_tax',
  handbook = 'handbook',
  all = 'all',
}
export enum CountrySelectAttributeType {
  countrySelect = 'countrySelect',
}
export enum CriteriaBusinessIncomeTaxNexusType {
  business_income_tax_nexus = 'business-income-tax-nexus',
}
export enum CriteriaCharitableRegistrationNexusType {
  charitable_registration_nexus = 'charitable-registration-nexus',
}
export enum CriteriaDatumAttributeSource {
  criteria_datum = 'criteria_datum',
}
export enum CriteriaDoingBusinessType {
  doing_business = 'doing-business',
}
export enum CriteriaEmployeeCountType {
  employee_count = 'employee-count',
}
export enum CriteriaEstimatedTaxLiabilityType {
  estimated_tax_liability = 'estimated-tax-liability',
}
export enum CriteriaForeignQualificationDateType {
  foreign_qualification_date = 'foreign-qualification-date',
}
export enum CriteriaHasRegionEmployeesType {
  region_has_employees = 'region-has-employees',
}
export enum CriteriaHasRegionPhysicalLocationType {
  region_has_physical_location = 'region-has-physical-location',
}
export enum CriteriaLocationScopeCityType {
  city = 'city',
}
export enum CriteriaLocationScopeEntityType {
  entity = 'entity',
}
export enum CriteriaLocationScopeRegionType {
  region = 'region',
}
export enum CriteriaLocationScopeZipType {
  zip = 'zip',
}
export enum CriteriaPartnerNexusType {
  partner_nexus = 'partner-nexus',
}
export enum CriteriaPayrollAmountType {
  payroll_amount = 'payroll-amount',
}
export enum CriteriaSalesTaxNexusType {
  sales_tax_nexus = 'sales-tax-nexus',
}
export enum CriteriaSingleRequirementType {
  single_requirement = 'single-requirement',
}
export enum CriteriaType {
  has_employees = 'has-employees',
  employee_count = 'employee-count',
  employee_count_previous_year = 'employee-count-previous-year',
  has_non_exempt_employees = 'has-non-exempt-employees',
  employee_terminated = 'employee-terminated',
  payroll_amount = 'payroll-amount',
  has_physical_location = 'has-physical-location',
  foreign_qualification_date = 'foreign-qualification-date',
  date_attribute = 'date-attribute',
  doing_business = 'doing-business',
  business_income_tax_nexus = 'business-income-tax-nexus',
  sales_tax_nexus = 'sales-tax-nexus',
  estimated_tax_liability = 'estimated-tax-liability',
  single_requirement = 'single-requirement',
  charitable_registration_nexus = 'charitable-registration-nexus',
  partner_nexus = 'partner-nexus',
}
export enum DataSourceType {
  datum = 'datum',
  model = 'model',
  criteria_datum = 'criteria_datum',
}
export enum DateAttributeType {
  date = 'date',
}
export enum DateAttributeCriteriaType {
  date_attribute = 'date-attribute',
}
export enum DatumAttributeSource {
  datum = 'datum',
}
export enum DefaultDisplayType {
  default = 'default',
}
export enum DependencyOperator {
  exists = 'exists',
  not_exists = 'not_exists',
  equals = 'equals',
  not_equals = 'not_equals',
  less_than = 'less_than',
  greater_than = 'greater_than',
  any = 'any',
}
export enum DoingBusinessCriteriaType {
  doing_business = 'doing-business',
}
export enum ETAFixedType {
  fixed = 'fixed',
}
export enum ETARangeType {
  range = 'range',
}
export enum ETAUnit {
  hour = 'hour',
  day = 'day',
  week = 'week',
  month = 'month',
}
export enum EmailDisplayType {
  email = 'email',
}
export enum EmployeeAcknowledgementStatus {
  signed = 'signed',
  pending = 'pending',
  outdated = 'outdated',
}
export enum EmployeeCountCriteriaType {
  employee_count = 'employee-count',
}
export enum EmployeeCountPreviousYearCriteriaType {
  employee_count_previous_year = 'employee-count-previous-year',
}
export enum EntityTypeEnum {
  unset = 'unset',
  c_corp = 'c_corp',
  p_corp = 'p_corp',
  llc = 'llc',
  llp = 'llp',
  lp = 'lp',
  gp = 'gp',
}
export enum EstimatedTaxLiabilityCriteriaType {
  estimated_tax_liability = 'estimated-tax-liability',
}
export enum FaxDisplayType {
  fax = 'fax',
}
export enum FeeFixedType {
  fixed = 'fixed',
}
export enum FeeRangeType {
  range = 'range',
}
export enum FeeVariableType {
  variable = 'variable',
}
export enum FirstTimeConfirmationsNotificationTopicCode {
  first_time_confirmations = 'first_time_confirmations',
}
export enum ForeignQualificationCriteriaType {
  foreign_qualification_date = 'foreign-qualification-date',
}
export enum FranchiseTaxEstimateAttributeType {
  deFranchiseTaxEstimate = 'deFranchiseTaxEstimate',
}
export enum GenerateOperatorWorkflowPromptCommand_id {
  generate_operator_workflow_prompt = 'generate_operator_workflow_prompt',
}
export enum GreaterThanBoundsType {
  greater_than = 'greater-than',
}
export enum HasEmployeesCriteriaType {
  has_employees = 'has-employees',
}
export enum HasNonExemptEmployeesCriteriaType {
  has_non_exempt_employees = 'has-non-exempt-employees',
}
export enum IdentifierType {
  does_not_have = 'does_not_have',
  itin = 'itin',
  ssn = 'ssn',
}
export enum LLCManagedTypeEnum {
  member_managed = 'member_managed',
  manager_managed = 'manager_managed',
}
export enum LegalEntityMailStatus {
  unresolved = 'unresolved',
  resolved = 'resolved',
}
export enum LegalEntityOwnerType {
  business = 'business',
  person = 'person',
}
export enum LegalEntityRegionStatus {
  pending = 'pending',
  entering = 'entering',
  maintaining = 'maintaining',
  exiting = 'exiting',
}
export enum LegalEntityRequirementStatus {
  todo = 'todo',
  done = 'done',
  deferred = 'deferred',
  in_progress = 'in-progress',
  skipped = 'skipped',
}
export enum LessThanBoundsType {
  less_than = 'less-than',
}
export enum LinkDisplayType {
  link = 'link',
}
export enum LocationScope {
  entity = 'entity',
  region = 'region',
  zip = 'zip',
  city = 'city',
}
export enum LocationScopeCityType {
  city = 'city',
}
export enum LocationScopeEntityType {
  entity = 'entity',
}
export enum LocationScopeRegionType {
  region = 'region',
}
export enum LocationScopeZipType {
  zip = 'zip',
}
export enum MailClassification {
  penalty = 'penalty',
  underpayment = 'underpayment',
  tax_rate_change = 'tax_rate_change',
  other = 'other',
}
export enum MailDisplayType {
  mail = 'mail',
}
export enum MailRoomOptions {
  legalinc = 'legalinc',
  earthclassmail = 'earthclassmail',
}
export enum MailSource {
  legalinc = 'legalinc',
  earth_class_mail = 'earth-class-mail',
  mailroom = 'mailroom',
  emailroom_gmail = 'emailroom-gmail',
}
export enum MailType {
  registered_agent = 'registered-agent',
  external_mail = 'external-mail',
}
export enum MailroomEmailStatus {
  new = 'new',
  delivered = 'delivered',
  undeliverable = 'undeliverable',
  spam = 'spam',
}
export enum MailroomMailDeliverStatus {
  delivered = 'delivered',
}
export enum MailroomMailExceptionStatus {
  exception = 'exception',
}
export enum MailroomMailPendingStatus {
  pending_scan = 'pending_scan',
}
export enum MailroomMailSpamStatus {
  spam = 'spam',
}
export enum MailroomMailUndeliverableStatus {
  undeliverable = 'undeliverable',
}
export enum MemberRole {
  OWNER = 'OWNER',
  MEMBER = 'MEMBER',
}
export enum ModelAttributeSource {
  model = 'model',
}
export enum MultiSelectAttributeInputType {
  multiSelect = 'multiSelect',
}
export enum MultiSelectAttributeOutputType {
  multiSelect = 'multiSelect',
}
export enum NewAndUpcomingUpdatesNotificationTopicCode {
  new_and_upcoming_updates = 'new_and_upcoming_updates',
}
export enum NewAssignmentsToUserNotificationTopicCode {
  new_assignments_to_user = 'new_assignments_to_user',
}
export enum NewEmailNotificationTopicCode {
  new_email = 'new_email',
}
export enum NewMailNotificationTopicCode {
  new_mail = 'new_mail',
}
export enum NonUsAddressAttributeType {
  nonUsAddress = 'nonUsAddress',
}
export enum NotificationName {
  new_assignment = 'new_assignment',
  new_question_assignment = 'new_question_assignment',
  email_verification = 'email_verification',
  mailroom_assignment = 'mailroom_assignment',
  new_mail = 'new_mail',
  new_payroll_region_detected_alert = 'new_payroll_region_detected_alert',
  payroll_connection = 'payroll_connection',
  subscription_billing = 'subscription_billing',
  upcoming_annual_report = 'upcoming_annual_report',
  upcoming_legislation_alert = 'upcoming_legislation_alert',
  weekly_summary_tasks = 'weekly_summary_tasks',
  workflow_completion_annual_report = 'workflow_completion_annual_report',
  workflow_completion_certificate_of_good_standing = 'workflow_completion_certificate_of_good_standing',
  workflow_completion_foreign_qualification = 'workflow_completion_foreign_qualification',
  workflow_completion_payroll = 'workflow_completion_payroll',
  agent_invite = 'agent_invite',
  automation_documents_for_signature = 'automation_documents_for_signature',
  automation_request_completed = 'automation_request_completed',
  automation_request_received = 'automation_request_received',
  automation_request_submitted = 'automation_request_submitted',
  automation_support = 'automation_support',
  new_requirement_detected = 'new_requirement_detected',
  new_task = 'new_task',
  new_user_added = 'new_user_added',
  password_reset = 'password_reset',
  signup_waitlist = 'signup_waitlist',
  state_email_notification = 'state_email_notification',
  subscription_confirmation = 'subscription_confirmation',
  subscription_payment = 'subscription_payment',
  upcoming_due_dates = 'upcoming_due_dates',
  updates_recent_legislation = 'updates_recent_legislation',
}
export enum NotificationTopicEnum {
  personal_account_maintenance_and_updates = 'personal_account_maintenance_and_updates',
  first_time_confirmations = 'first_time_confirmations',
  new_assignments_to_user = 'new_assignments_to_user',
  company_account_maintenance_and_updates = 'company_account_maintenance_and_updates',
  automation_action_required = 'automation_action_required',
  automation_status_updates = 'automation_status_updates',
  weekly_summary = 'weekly_summary',
  new_mail = 'new_mail',
  new_email = 'new_email',
  new_and_upcoming_updates = 'new_and_upcoming_updates',
}
export enum NumberAttributeType {
  number = 'number',
}
export enum ObjectType {
  attribute = 'attribute',
  account_login = 'account_login',
  agency = 'agency',
  agency_account = 'agency_account',
  criteria_meta = 'criteria_meta',
  policy_section = 'policy_section',
  policy_category = 'policy_category',
  managed_provider_requirement = 'managed_provider_requirement',
  policy = 'policy',
  workflow = 'workflow',
  requirement = 'requirement',
  requirement_template = 'requirement-template',
  tag = 'tag',
  form = 'form',
  form_attribute = 'form-attribute',
  region = 'region',
}
export enum PartnerNexusCriteriaType {
  partner_nexus = 'partner-nexus',
}
export enum PayrollAmountCriteriaType {
  payroll_amount = 'payroll-amount',
}
export enum PeopleSelectType {
  officers = 'officers',
  corporate_officers = 'corporate_officers',
  owners = 'owners',
  officers_and_owners = 'officers_and_owners',
  directors = 'directors',
  members = 'members',
  managers = 'managers',
  members_and_managers = 'members_and_managers',
  partners = 'partners',
}
export enum PersonType {
  Officer = 'Officer',
  Owner = 'Owner',
  Director = 'Director',
  LLC_Member = 'LLC Member',
  LLC_Manager = 'LLC Manager',
  NP_Member = 'NP Member',
  NP_Trustee = 'NP Trustee',
  Submitter = 'Submitter',
}
export enum PersonalAccountMaintenanceAndUpdatesNotificationTopicCode {
  personal_account_maintenance_and_updates = 'personal_account_maintenance_and_updates',
}
export enum PhoneDisplayType {
  phone = 'phone',
}
export enum PlatformAccountStatus {
  active = 'active',
  exception = 'exception',
  closed = 'closed',
}
export enum PlatformConnectionStatus {
  pending = 'pending',
  authenticating = 'authenticating',
  registering = 'registering',
  connected = 'connected',
  disconnected = 'disconnected',
  canceled = 'canceled',
}
export enum PlatformMailClassification {
  penalty = 'penalty',
  underpayment = 'underpayment',
  tax_rate_change = 'tax_rate_change',
  other = 'other',
}
export enum RadioAttributeInputType {
  radio = 'radio',
}
export enum RadioAttributeOutputType {
  radio = 'radio',
}
export enum RangeBoundsType {
  range = 'range',
}
export enum RecipientType {
  all_users = 'all_users',
  submitter = 'submitter',
  custom = 'custom',
}
export enum RegisteredAgentStatus {
  in_progress = 'in-progress',
  exception = 'exception',
  canceled = 'canceled',
  done = 'done',
}
export enum RequirementCategory {
  payroll = 'payroll',
  payroll_setup = 'payroll-setup',
  registration = 'registration',
  registration_maintenance = 'registration-maintenance',
  hr = 'hr',
  insurance = 'insurance',
  insurance_setup = 'insurance-setup',
  tax = 'tax',
  tax_setup = 'tax-setup',
  sales_tax = 'sales-tax',
}
export enum RequirementContextEmployeeScope {
  employee = 'employee',
}
export enum RequirementContextLegalEntityScope {
  legal_entity = 'legal-entity',
}
export enum RequirementPatchAssignOwnerOperation {
  assign = 'assign',
}
export enum RequirementPatchUnassignOwnerOperation {
  unassign = 'unassign',
}
export enum RequirementStatus {
  deferred = 'deferred',
  done = 'done',
  todo = 'todo',
  in_progress = 'in-progress',
  skipped = 'skipped',
}
export enum Role {
  admin = 'admin',
  agent = 'agent',
  user = 'user',
  developer = 'developer',
  agent_lead = 'agent_lead',
  analyst = 'analyst',
  tool = 'tool',
}
export enum RuleConditionAndInputType {
  and = 'and',
}
export enum RuleConditionAndOutputType {
  and = 'and',
}
export enum RuleConditionEqualsType {
  equals = 'equals',
}
export enum RuleConditionExistsType {
  exists = 'exists',
}
export enum RuleConditionLowerBoundsType {
  lower_bounds = 'lower_bounds',
}
export enum RuleConditionNotInputType {
  not = 'not',
}
export enum RuleConditionNotOutputType {
  not = 'not',
}
export enum RuleConditionOrInputType {
  or = 'or',
}
export enum RuleConditionOrOutputType {
  or = 'or',
}
export enum RuleConditionUpperBoundsType {
  upper_bounds = 'upper_bounds',
}
export enum SalesTaxNexusCriteriaType {
  sales_tax_nexus = 'sales-tax-nexus',
}
export enum ScheduleDelayFirstOccurrenceMonthsBeforeDueCategory {
  months_before_due = 'months-before-due',
}
export enum ScheduleDelayFirstOccurrenceNoneCategory {
  none = 'none',
}
export enum ScheduleDelayFirstOccurrenceSameYearCategory {
  same_year = 'same-year',
}
export enum ScheduleDueDateCalculationEndOfMonthCategory {
  end_of_month = 'end-of-month',
}
export enum ScheduleDueDateCalculationMonthDayCategory {
  month_day = 'month-day',
}
export enum ScheduleDueDateCalculationMonthDaySameYearCategory {
  month_day_same_year = 'month-day-same-year',
}
export enum ScheduleDueDateCalculationNoneCategory {
  none = 'none',
}
export enum ScheduleDueDateCalculationRelativeCategory {
  relative = 'relative',
}
export enum ScheduleDueDateOffsetBeginningOfNextPeriodStartMonthCategory {
  beginning_of_next_period_start_month = 'beginning-of-next-period-start-month',
}
export enum ScheduleDueDateOffsetDaysCategory {
  days = 'days',
}
export enum ScheduleDueDateOffsetDefaultCategory {
  default = 'default',
}
export enum ScheduleDueDateOffsetEndOfAnniversaryMonthCategory {
  end_of_anniversary_month = 'end-of-anniversary-month',
}
export enum ScheduleDueDateOffsetEndOfMonthCategory {
  end_of_month = 'end-of-month',
}
export enum ScheduleDueDateOffsetEndOfMonthPreviousToNextPeriodStartMonthCategory {
  end_of_month_previous_to_next_period_start_month = 'end-of-month-previous-to-next-period-start-month',
}
export enum ScheduleDueDateOffsetEndOfNextMonthCategory {
  end_of_next_month = 'end-of-next-month',
}
export enum ScheduleDueDateOffsetEndOfQuarterCategory {
  end_of_quarter = 'end-of-quarter',
}
export enum ScheduleDueDateOffsetMonthsCategory {
  months = 'months',
}
export enum ScheduleDueDateOffsetNoneCategory {
  none = 'none',
}
export enum ScheduleDueDateOffsetRelativeCategory {
  relative = 'relative',
}
export enum ScheduleDueDateOffsetRelativeOnDateAttributeCategory {
  relative_on_date_attribute = 'relative-on-date-attribute',
}
export enum ScheduleDueDateOffsetRelativeOnDateAttributeEndOfMonthCategory {
  relative_on_date_attribute_end_of_month = 'relative-on-date-attribute-end-of-month',
}
export enum ScheduleDueDateOffsetRelativeOnDateAttributeFifteenthOfMonthCategory {
  relative_on_date_attribute_fifteenth_of_month = 'relative-on-date-attribute-fifteenth-of-month',
}
export enum ScheduleDueDateOffsetYearlyEndOfMonthCategory {
  yearly_end_of_month = 'yearly-end-of-month',
}
export enum ScheduleDueDateOffsetYearlyOnDateCategory {
  yearly_on_date = 'yearly-on-date',
}
export enum ScheduleDueDateOffsetYearlyOnDateAttributeCategory {
  yearly_on_date_attribute = 'yearly-on-date-attribute',
}
export enum ScheduleEmployeeHiringCategory {
  hiring = 'hiring',
}
export enum ScheduleEmployeeTerminationCategory {
  termination = 'termination',
}
export enum ScheduleMultiYearCategory {
  multi_year = 'multi-year',
}
export enum ScheduleMultiYearFirstOccurrenceNoneType {
  none = 'none',
}
export enum ScheduleMultiYearFirstOccurrenceRegistrationType {
  registration = 'registration',
}
export enum ScheduleMultiYearRecurrence {
  year_ending_with_one = 'year-ending-with-one',
  year_ending_with_five_or_zero = 'year-ending-with-five-or-zero',
  registration = 'registration',
  fiscal = 'fiscal',
  even = 'even',
  odd = 'odd',
}
export enum ScheduleNonReportingCategory {
  non_reporting = 'non-reporting',
}
export enum ScheduleOneTimeCategory {
  one_time = 'one-time',
}
export enum SchedulePeriodOffsetDefaultCategory {
  default = 'default',
}
export enum SchedulePeriodOffsetMonthsCategory {
  months = 'months',
}
export enum SchedulePeriodOffsetNoneCategory {
  none = 'none',
}
export enum SchedulePeriodOffsetQuarterlyOnFiscalYearCategory {
  quarterly_on_fiscal_year = 'quarterly-on-fiscal-year',
}
export enum SchedulePeriodOffsetRelativeCategory {
  relative = 'relative',
}
export enum SchedulePeriodOffsetYearlyOnDateCategory {
  yearly_on_date = 'yearly-on-date',
}
export enum SchedulePeriodOffsetYearlyOnDateAttributeCategory {
  yearly_on_date_attribute = 'yearly-on-date-attribute',
}
export enum SchedulePeriodOffsetYearlyOnFiscalYearCategory {
  yearly_on_fiscal_year = 'yearly-on-fiscal-year',
}
export enum ScheduleRecurrence {
  monthly = 'monthly',
  quarterly = 'quarterly',
  annual = 'annual',
}
export enum ScheduleReportingCategory {
  reporting = 'reporting',
}
export enum ScheduleReportingMultiInputCategory {
  reporting_multi = 'reporting-multi',
}
export enum ScheduleReportingMultiOutputCategory {
  reporting_multi = 'reporting-multi',
}
export enum SelectAttributeInputType {
  select = 'select',
}
export enum SelectAttributeOutputType {
  select = 'select',
}
export enum SelectParamsCountriesSelect_type {
  country = 'country',
}
export enum SelectParamsCustomSelect_type {
  custom = 'custom',
}
export enum SelectParamsEntityTypesSelect_type {
  entity_type = 'entity_type',
}
export enum SelectParamsLast10YearsSelect_type {
  last_10_years = 'last_10_years',
}
export enum SelectParamsPersonSelect_type {
  person = 'person',
}
export enum SelectParamsRegionsSelect_type {
  region = 'region',
}
export enum SelectParamsTaxClassesCorpSelect_type {
  tax_class_corp = 'tax_class_corp',
}
export enum SelectParamsTaxClassesLLCSelect_type {
  tax_class_llc = 'tax_class_llc',
}
export enum SingleRequirementCriteriaType {
  single_requirement = 'single-requirement',
}
export enum SubmitOption {
  prod = 'prod',
  test = 'test',
  dry_run = 'dry_run',
}
export enum SubscriptionPlanEnum {
  standard = 'standard',
  advanced = 'advanced',
  essential = 'essential',
  basic = 'basic',
  basic_2024 = 'basic_2024',
  free = 'free',
  start_up = 'start_up',
  scale_up = 'scale_up',
  plus = 'plus',
  legacy = 'legacy',
  per_account = 'per_account',
  per_account_unlimited = 'per_account_unlimited',
  enterprise = 'enterprise',
  plus_2024 = 'plus_2024',
}
export enum TagInstance {
  certificate_of_good_standing = 'certificate-of-good-standing',
  charity_registration = 'charity-registration',
  charity_registration_renewal = 'charity-registration-renewal',
  employee_final_wage_payment = 'employee-final-wage-payment',
  employee_new_hire_reporting = 'employee-new-hire-reporting',
  employee_onboarding = 'employee-onboarding',
  employee_termination = 'employee-termination',
  exemption = 'exemption',
  foreign_qualification = 'foreign-qualification',
  foreign_state_only = 'foreign-state-only',
  handbook = 'handbook',
  home_state_only = 'home-state-only',
  initial_statement = 'initial-statement',
  local_business_setup = 'local-business-setup',
  local_payroll_setup = 'local-payroll-setup',
  newspaper_publication = 'newspaper-publication',
  notices = 'notices',
  payroll_setup = 'payroll-setup',
  registered_agent = 'registered-agent',
  sos_report = 'sos-report',
  check_account_logins = 'check-account-logins',
  setup = 'setup',
}
export enum TargetGroupType {
  ops_integrations_group = 'ops_integrations_group',
  all_integrations = 'all_integrations',
}
export enum TaskCategory {
  hr = 'hr',
  insurance = 'insurance',
  payroll = 'payroll',
  registration = 'registration',
  registration_maintenance = 'registration-maintenance',
  tax = 'tax',
  sales_tax = 'sales-tax',
}
export enum TaskContextEmployeeScope {
  employee = 'employee',
}
export enum TaskContextLegalEntityScope {
  legal_entity = 'legal-entity',
}
export enum TaskCreationReason {
  policy_update = 'policy_update',
  attribute_update = 'attribute_update',
}
export enum TaskDateFilter {
  upcoming = 'upcoming',
  overdue = 'overdue',
}
export enum TaskDefinitionType {
  requirement = 'requirement',
  data_collection = 'data-collection',
  criteria_collection = 'criteria-collection',
}
export enum TaskPriority {
  high = 'high',
  medium = 'medium',
  low = 'low',
}
export enum TaskStatus {
  todo = 'todo',
  deferred = 'deferred',
  in_progress = 'in-progress',
  done = 'done',
}
export enum TaskType {
  requirement = 'requirement',
  question = 'question',
  bulk_question = 'bulk-question',
}
export enum TasksFilterCategory {
  all = 'all',
  payroll = 'payroll',
  hr = 'hr',
  registration = 'registration',
  tax = 'tax',
}
export enum TasksFilterStatus {
  todo = 'todo',
  overdue = 'overdue',
  done = 'done',
  automated = 'automated',
  managed = 'managed',
}
export enum TaxClassEnum {
  unset = 'unset',
  corp = 'corp',
  s_corp = 's_corp',
  partnership = 'partnership',
  disregarded = 'disregarded',
  tax_exempt = 'tax_exempt',
}
export enum TextAreaAttributeType {
  textArea = 'textArea',
}
export enum TextAttributeType {
  text = 'text',
}
export enum ThresholdBoundsGreaterThanType {
  greater_than = 'greater-than',
}
export enum ThresholdBoundsLessThanType {
  less_than = 'less-than',
}
export enum ThresholdBoundsOpenRangeType {
  range = 'range',
}
export enum ThresholdDateRangeType {
  current = 'current',
  previous = 'previous',
  terminated = 'terminated',
}
export enum UpcomingLegislationStageEnum {
  detected = 'detected',
  updated = 'updated',
  finalized = 'finalized',
  vetoed = 'vetoed',
}
export enum ValidatorType {
  ssn_pattern = 'ssn_pattern',
  itin_pattern = 'itin_pattern',
  ein_pattern = 'ein_pattern',
  email_pattern = 'email_pattern',
  phone_pattern = 'phone_pattern',
  naics_pattern = 'naics_pattern',
  date_pattern = 'date_pattern',
  array_has_officer = 'array_has_officer',
  array_has_owner = 'array_has_owner',
  array_has_director = 'array_has_director',
  array_has_one_submitter = 'array_has_one_submitter',
  array_has_president = 'array_has_president',
  array_has_secretary = 'array_has_secretary',
  array_has_treasurer = 'array_has_treasurer',
  array_has_at_least_one_corporate_role = 'array_has_at_least_one_corporate_role',
  array_has_many_partners = 'array_has_many_partners',
  array_has_at_least_one_member_or_manager = 'array_has_at_least_one_member_or_manager',
}
export enum WeeklySummaryNotificationTopicCode {
  weekly_summary = 'weekly_summary',
}
export enum WorkflowInstanceBlockReason {
  no_steps = 'no_steps',
  step_execution_error = 'step_execution_error',
  inaccurate_data = 'inaccurate_data',
  state_exception = 'state_exception',
  account_already_exists = 'account_already_exists',
  delinquent = 'delinquent',
  legal_inc_exception = 'legal_inc_exception',
  awaiting_user_response = 'awaiting_user_response',
  other = 'other',
}
export enum WorkflowInstanceStatus {
  new = 'new',
  in_progress = 'in-progress',
  polling = 'polling',
  blocked = 'blocked',
  canceled = 'canceled',
  done = 'done',
  active = 'active',
  new_or_unassigned = 'new-or-unassigned',
}
export enum WorkflowTemplateRegistrationAccountNumberSource {
  immediate = 'immediate',
  email = 'email',
  poll = 'poll',
  call = 'call',
}
